import { Autocomplete, Avatar, Backdrop, Badge, Box, Button, Card, CardHeader, Checkbox, Chip, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Alert, Divider, FormControlLabel, Grid, IconButton, List, ListItem, ListItemIcon, ListItemText, Menu, MenuItem, Paper, Stack, Switch, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, TextField, Tooltip, Typography, Radio, RadioGroup } from "@material-ui/core";
import Page from '../../components/Page';
import { capitalCase, sentenceCase } from "change-case";
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import lockOpenFill from '@iconify/icons-ph/lock-open-fill';
import editFill from '@iconify/icons-eva/edit-fill';
import plusFill from '@iconify/icons-eva/plus-fill';
import RequestProgressModal from "src/components/RequestProgressModal";
//materail
import * as Yup from 'yup';
import { Form, FormikProvider, useFormik } from 'formik';
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';
import HeaderBreadcrumbs from "src/components/HeaderBreadcrumbs";
import Label from "src/components/Label";
import { useLocation, useNavigate, useParams } from "react-router";

import ViewRequest from "src/components/_dashboard/official-request/ViewRequest";
import React, { forwardRef, useEffect, useMemo, useRef, useState } from "react";
import PublicMsgBoard from "src/components/_dashboard/official-request/PublicMsgBoard";
import RequestTabUpdates from 'src/components/_dashboard/user/account/RequestTabUpdates'
import PublicMessageBoard from 'src/components/_dashboard/user/profile/PublicMessageBoard.js'
import RequestUpdates from "src/components/_dashboard/official-request/RequestUpdates";
import PaymentRequest from "src/components/_dashboard/official-request/PaymentRequest";
import { AddCircle, BlockOutlined, Delete, KeyboardBackspaceOutlined, Print, LocationOn, Add, Remove, CenterFocusStrong, NoteAdd, AddCircleOutlined } from "@material-ui/icons";
import Modal from "src/components/_dashboard/blog/ProjectModel";
import Icon from "@iconify/react";
import Scrollbar from "src/components/Scrollbar";
import axios from "axios";
import { currentFacilityId, FacilityTypes, REST_API, REST_API_END_POINT, SEND_EMAIL, UNITS } from "src/constants/Defaultvalues";
import moment from "moment";
import { PATH_DASHBOARD } from "src/routes/paths";
import { useSnackbar } from "notistack";
import { LoadingButton, MobileDatePicker, MobileDateRangePicker } from "@material-ui/lab";
import { useCallback } from "react";
import { UploadAvatar, UploadMultiFile } from "src/components/upload";
import AddClients from "src/components/_dashboard/official-request/AddClients";
import AddProposal from "src/components/_dashboard/official-request/AddProposal";
import ConfirmationPopup from "src/components/_dashboard/official-request/ConfirmationPopup";
import ReactToPrint from 'react-to-print'
import { storage } from '../../firebase/firebase'
import { getDownloadURL, ref as imageref, uploadBytesResumable } from 'firebase/storage';
import { Link } from "react-router-dom";
import { empty } from "src/Helpers/Common";
import Locations from "src/components/_dashboard/official-request/Locations";
import Workflow from "src/components/_dashboard/general-analytics/RfqForm";
import { AccountNotifications } from '../../components/_dashboard/user/account'
import { set } from "lodash";
import Proposals from "src/components/_dashboard/official-request/Proposals";
import useCompanyProfile from "src/hooks/useCompanyProfile";
import LoadingScreen from "src/components/LoadingScreen";
import PrintableContent from './printPreview';
import { red } from "@material-ui/core/colors";
import AnimatedButton from "src/components/animate/AnimatedButton";
import { MapControlScale } from "src/components/map";
import RouteMap from "src/components/_dashboard/official-request/RouteMap";
import RouteMapInstall from "src/components/_dashboard/official-request/RouteMapInstalls";
import SalesOrderInstallationReportView from "src/components/_dashboard/official-request/SalesOrderInstallationReportView";
import JobNotesMessageBoard from "src/components/_dashboard/user/profile/JobNotesMessageBoard";
import JobNoteWindow from 'src/components/_dashboard/chat/JobNoteWindow';
import { supabase } from '../../supabase/supabaseClient';
import AVALARALOGO from 'src/assets/Avalara_Logo.png';

const RowResultStyle = styled(TableRow)(({ theme }) => ({
  '& td': {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  }
}));
const MAX_CHARACTERS = 35;
// const getStatusColorAndLabel = (status,installationStatus,allInstallationCompleted,accepted,min_payment_status,project_category,billing_type,installationCompleteStatus) => {
// console.log('project_categoryproject_category',project_category)
//   switch (status) {
//     case 0:
//       return { color: 'error', label: 'Status: Removed' };
//     case 1:
//       return { color: 'warning', label: 'Status: Draft' };
//     case 2:
//       return { color: 'info', label: 'Status: Open' };
//     case 3:
//       // return { color: 'primary', label: 'Status: Accepted' }; // Evaluating
//       // return { color: `${min_payment_status==0? 'warning' :'primary'}`, label: `Status: ${min_payment_status==1? 'Approved and Paid' :'Approved & Awaiting for Payment'}` }
//       return { color: 
//         `${project_category == 'No Charge'? "primary" 
//           : min_payment_status==0? 'warning' :'primary'}`,
//            label: `Status: ${
//        ( project_category == 'No Charge' || billing_type==0)
//           ? 'Approved'
//           : min_payment_status == 1
//           ? 'Approved and Paid'
//           : 'Approved and Payment Due'
//       }` }
//     case 4:
//       // return { color: empty(accepted) ? 'warning' : 'success', label: empty(accepted) ? 'Installation completed & Awaiting approval' : !empty(allInstallationCompleted) ? 'Completed & Accepted' : !empty(installationStatus) ? 'Status: Installation' : 'Status: In Production' }; // return { color: 'primary', label: 'Status: Converted to Job' };
//       return { color: (empty(accepted) && !empty(allInstallationCompleted)) ? 'warning' : 'success', label: (empty(accepted) && !empty(allInstallationCompleted)) ? 'Installation completed & Awaiting approval' : (!empty(accepted) && !empty(allInstallationCompleted)) ? 'Completed' : !empty(installationStatus) ? 'Status: Installation' : 'Status: In Production' }; // return { color: 'primary', label: 'Status: Converted to Job' };
//     case 5:
//       return { color: 'warning', label: 'Status: Closed' };
//     case 6:
//       return { color: 'error', label: 'Status: Rejected' };
//     default:
//       return { color: 'default', label: 'Status: Open' };
//   }
// };


const catalogBuildOrderOptionsArray = [
  { id: 1, name: 'Inhouse',},
  { id: 2, name: 'Traffic Catalog', },
  { id: 3, name: 'Sub Contract', },
]


const markupTypes = [
  { id: 1, name: 'Wholesale Markup' },
  { id: 2, name: 'Retail Markup' }
]

const marketingAdjustmentType = [
  { id: 1, name: '%' },
  { id: 2, name: '$' },
  // { id: 3, name: '¢' }
];

const catalogTypes = [
  { id: 'in_stock', label: 'In Stock',inhouse:4,isTrafficCatalog:false },
  { id: 'client_owned', label: 'Client Owned',inhouse:5 ,isTrafficCatalog:false},
  { id: 'traffic', label: 'Traffic',inhouse:1 ,isTrafficCatalog:true}
]

// Catalog types for split orders (all types + All option)
const splitOrderCatalogTypes = [
  { id: 'all', label: 'All',inhouse:null ,isTrafficCatalog:null},
  { id: 'in_stock', label: 'In Stock',inhouse:4,isTrafficCatalog:false },
  { id: 'client_owned', label: 'Client Owned',inhouse:5 ,isTrafficCatalog:false},
  { id: 'traffic', label: 'Traffic',inhouse:1 ,isTrafficCatalog:true},
  { id: 'production_catalog', label: 'Production Catalog',inhouse:1 ,isTrafficCatalog:false},
  { id: 'split_catalog', label: 'Split Catalog',inhouse:6 ,isTrafficCatalog:false}
]

export default function ViewofficialRequest({popupOn,idOfProject,isEditSalesOrder,closeView,setRenderCards,renderCards,onDataChange, openServiceNote,setOpenServiceNote,}) {
  const { COMPANY_LOGO, COMPANY_NAME } = useCompanyProfile()
  const theme = useTheme()
  const { id:ids } = useParams()
  const id =popupOn ? idOfProject :ids
  const user = JSON.parse(localStorage.getItem('user'))
  let isClient =user?.isClient

  let userType = isClient ? 3 : user.user_type
  let userId = user.user_id

  if(user.added_by_client && user.parent_user_type && user.parent_id) {
    userId = user.parent_id
    userType = 3 //user.parent_user_type
  }
  const location = useLocation();
  const isFromProjects = location.state?.fromProjects || false;
  const isFromDashboard = location.state?.newTab || false;
  const edit = popupOn ? isEditSalesOrder : !!(location.state && !isFromProjects);
  let editState = (userType == 3 || userType !== 1 || isFromDashboard) ? false : !!(location.state && !isFromProjects);  
  // const edit = false
  console.log('useruservuser',user)
  console.log('popupOn=isEditSalesOrder===',isEditSalesOrder,editState,isFromDashboard)
  console.log('popupOn=state===',useLocation().state)

  const componentRef = useRef();
  const productInputValueRef = useRef(''); // Track product autocomplete input value for production builds
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar();
  const [currentRFQData, setCurrentRFQdata] = useState({})
  console.log('currentRFQData', currentRFQData)
  const [openEdit, setOpenEdit] = useState(false)
  const [showServices, setShowServices] = useState(true)
  const [selectedProducts, setSelectedProducts] = useState([])
  const [initialServiceCostInProductFormula, setInitialServiceCostInProductFormula] = useState(0)
  const [markupType, setMarkupType] = useState();
  const [clientApprove , setClientApprove] = useState()
  const [designs, setDesigns] = useState([])
  const [details, setDetails] = useState(null)
  
  // State for change detection
  const [initialProducts, setInitialProducts] = useState([])
  const [initialServices, setInitialServices] = useState([])
  const [initialMaterials, setInitialMaterials] = useState([])
  const [initialRfpProducts, setInitialRfpProducts] = useState([])
  const [initialRfpServices, setInitialRfpServices] = useState([])
  const [showChangesDialog, setShowChangesDialog] = useState(false)
  const [pendingSubmission, setPendingSubmission] = useState(null)
  const [detectedChanges, setDetectedChanges] = useState([])
  console.log('setDetails+++++++++++++++++', details)
  const [skills, setSkill] = useState(null)
  const [workflow, setWorkFlow] = useState(null)
  const [allProducts, setAllproducts] = useState(null)
  const [invoice, setInvoice] = useState(null)
  const [open, setIsOpen] = useState(false)
  const [totalsum, setTotalSum] = useState(0);
  const [rfqSubTotal, setRFQSubTotal] = useState(0);
  const [DiscountTotal, setDiscountTotal] = useState(0);
  const [totalWholesalePrice, setTotalWholesalePrice] = useState(0);
  const [totalRetailPrice, setTotalRetailPrice] = useState(0);
  const [totalProductFormula, setTotalProductFormula] = useState(0);
  const [addClient, setAddClient] = useState(false)
  const [addVendor, setAddVendor] = useState(false)
  const [addProposal, setAddProposal] = useState(false)
  const [openInvoice, setOpenInvoice] = useState(false)
  const [requestAccept, setRequestAccept] = useState(false)
  const [requestReject, setRequestReject] = useState(false)
  const [allClients, setAllClients] = useState(null)
  const [allClientsEdit, setAllClientsEdit] = useState(null)
  const [currentDate, setCurrentDate] = useState(moment().format('YYYY-MM-DD'));
  const [currentTab, setCurrentTab] = useState(user.isVendor ? 'Details' : 'Sales Order Details')
  const [openPreview, setOpenPreview] = useState(false)
  const [openConvertToRFQ, setOpenConvertToRFQ] = useState(false)
  const [openDuplicate,setOpenDuplicate] = useState(false)
  const [avatarUrl, setAvatarUrl] = useState([])
  const [openDelete, setOpenDelete] = useState(false)
  const [reOpen, setReopen] = useState(false)
  const [confirmInvoice, setConfirmInvoice] = useState(false)
  const [convertToRFQ, setConvertToRFQ] = useState(false)
  const [invoiceReject, setRejectInvoice] = useState(false)
  // const [reqAcceptClient,setReqAcceptClient] = useState(false)
  const [reason, setReason] = useState('')
  const [acceptedClients, setAcceptedClients] = useState(null)
  const [jobNoteMembers, setJobNoteMembers] = useState(null)
  console.log('accccccccccccc',acceptedClients)
  const [updates, setUpdates] = useState(null)
  const [isSaving, setIsSaving] = useState(false)
  const [previewData, setPreviewData] = useState({})
  const [locationStates, setLocationStates] = useState({});
  const [serviceOnlyLocationStates, setServiceOnlyLocationStates] = useState({});
  const [payments, setPayments] = useState(null)
  const [projectTypes, setProjectTypes] = useState([]);
  const [projectCategories, setProjectCategories] = useState([]);
  const [noChargeType, setNoChargeType] = useState([]);
  const [isCommunityLoading, setIsCommunityLoading] = useState(false);
  const [communities, setCommunities] = useState([]);
  const [refresh, setRefresh] = useState(false)
  const [refreshData, setRefreshData] = useState(false)
  const ref = useRef()
  const [openWorkflow, setWorkflowOpen] = useState(false)
  const [manual, setManual] = useState(false)
  const [signAgreements, setSignAgreements] = useState(null)
  const [portfolio, setPortfolio] = useState(null)
  const [customTemplate, setCustomTemplate] = useState(null)
  const [questionnaireTemplate, setQuestionnaireTemplate] = useState(null)
  const [allDataEmpty, setDataEmpty] = useState(true)
  const [proposalData, setProposalData] = useState(null)
  const [teamMembers, setTeamMember] = useState([])
  const [customerData, setCustomerData] = useState([])
  const [labourCostServices, setLabourCostServices] = useState([])
  const [designersList, setDesignersList] = useState([])
  console.log('designersList', designersList)
  const [selectedServices, setSelectedServices] = useState([]);
  const [labourInstallService, setLabourInstallService] = useState([]);
  const [invoiceSelectedServices, setInvoiceSelectedServices] = useState([]);
  console.log('invoiceSelectedServices', invoiceSelectedServices)
  const [filteredServices, setFilteredServices] = useState([])
  const [requestServices, setRequestServices] = useState([])
  const [loading, setLoading] = useState(false)
  const [loadingEdit, setLoadingEdit] = useState(false)
  const [budget, setBudget] = useState(0)
  const [totalMarkupPercentage, setTotalMarkupPercentage] = useState(0)
  const [totalMarkupAmount, setTotalMarkupAmount] = useState(0)
  const printableContentRef = useRef();
  const [additionalSelectedServices, setAdditionalSelectedServices] = useState([]);
  console.log('additionalSelectedServices----', additionalSelectedServices)
  const [isLoadingInvoice, setIsLoadingInvoice] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [catalogBuildOrderOptions, setCatalogBuildOrderOptions] = useState(catalogBuildOrderOptionsArray);
  localStorage.setItem('requestId', id ? id : null)
  const [openHoldPopup, setOpenHoldPopup] = useState(false);
  console.log('setOpenHoldPopup', openHoldPopup)
  const [holdReason, setHoldReason] = useState('');
  const [isSubmittingHold, setIsSubmittingHold] = useState(false);
  const [holdReasonError, setHoldReasonError] = useState('');


  const explodedPermissions = user?.exploded_permissions
  const hasMarkupPermission = explodedPermissions?.some(permission => ['View Markup'].includes(permission)) ? true : false
  const hasDiscountPermission = explodedPermissions?.some(permission => ['Manage Discount'].includes(permission)) ? false : true
  const [showWarning, setShowWarning] = useState(selectedServices.map(() => false));
  const [allLocationSame, setAllLocationSame] = useState(false)
  const [allServiceLocationSame, setAllServiceLocationSame] = useState(true)
  const [allRfpServiceLocationSame, setAllRfpServiceLocationSame] = useState(true)
  const [allRfpProductsLocationSame, setAllRfpProductsLocationSame] = useState(true)
  const [indexCounter, setIndexCounter] = useState(0)
  const [serviceIndexCounter, setServiceIndexCounter] = useState(0)
  const [totalLabourCost, setTotalLabourCost] = useState(0)
  const [totalProductLabourCost, setTotalProductLabourCost] = useState(0)
  const [totalProductInstallCost, setTotalProductInstallCost] = useState(0)
  const [checkLength,setCheckLength]= useState(false)
  let productFormulaCost = 0
  const [rfps, setRfps] = useState([]); // List of RFPs
  const [selectedRfp, setSelectedRfp] = useState(null); // Selected RFP
  const [openModal, setOpenModal] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const [rfpServices, setRfpServices] = useState([]);
  const [rfpProducts, setRfpProducts] = useState([]);
  const [cart, setCart] = useState([]);
  const [cartService, setCartService] = useState([]);
  const [rfpServicesEdit, setRfpServicesEdit] = useState([]);
  const [rfpLocationStates, setRfpLocationStates] = useState({});
  const [rfpServiceLocationStates, setRfpServiceLocationStates] = useState({});
  const [selectedMaterials, setSelectedMaterials] = useState([]);
  console.log('selectedMaterials++++++++++++++++++', selectedMaterials)
  const [materials, setAllMaterials] = useState([]);
  const [openProductNote, setOpenProductNote] = useState({});
  const [isSavingNote, setIsSavingNote] = useState(false);
  const [currentNote, setCurrentNote] = useState('');

  // Create local state for service notes if not provided as props
  const [localOpenServiceNote, setLocalOpenServiceNote] = useState({})
  const [localCurrentNote, setLocalCurrentNote] = useState('')
  const [localIsSavingNote, setLocalIsSavingNote] = useState(false)

  // Use provided props or fall back to local state
  const serviceNoteState = openServiceNote !== undefined ? openServiceNote : localOpenServiceNote
  const setServiceNoteState = setOpenServiceNote !== undefined ? setOpenServiceNote : setLocalOpenServiceNote
  const serviceCurrentNote = currentNote || localCurrentNote
  const setServiceCurrentNote = setCurrentNote || setLocalCurrentNote
  const serviceIsSavingNote = isSavingNote || localIsSavingNote
  const setServiceIsSavingNote = setIsSavingNote || setLocalIsSavingNote
  const [taxAmount, setTaxAmount] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [selectedTaxCategory,setSelectedTaxCategory]=  useState(null);
  const [taxCategories,setTaxCategories]=  useState([]);
  const [data, setData] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [singleLocationCard,setSingleLocationCard] = useState(false)
  // const [backupProducts, setBackupProducts] = useState([]);
console.log('taxAmounttttt',taxAmount)
  const [openMakeTaskDialog,setOpenMakeTaskDialog] = useState(false)
  const [showMakeTaskErrorDialog,setShowMakeTaskErrorDialog] = useState(false)
  const [confirmMakeTask,setConfirmMakeTask] = useState(false)

  const [openDialog, setOpenDialog] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [formDatas, setFormDatas] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [noCharge, setNoCharge] = useState(false);
  
  const [mapServices,setMapServices]=  useState([]);
  const [mapServicesLoading, setMapServicesLoading] = useState(false);

  // Progress Modal States
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [progressRequestData, setProgressRequestData] = useState(null);
  const [socketReady, setSocketReady] = useState(false);
  const [progressHeading, setProgressHeading] = useState("Processing Sales Order");
  const [selectedMapserviceProducts, setSelectedMapserviceProducts] = useState([]);
    const [progress, setProgress] = useState(null)
    const [openDialogPartial,setOpenDialogPartial] = useState(false);
    const [openDialogNoStock,setOpenDialogNoStock] = useState(false);
    const [isUploading,setIsUploading] = useState(false)
    const [pendingProject, setPendingProject] = useState(null);
    const [stockType, setStockType] = useState(1);
    const [pendingMaterial, setPendingMaterial] = useState(null);
    const [partialProducts, setPartialProducts] = useState([]);
    const [finishedProducts, setFinishedProducts] = useState([]);
    const [convertionUnit, setConvertionUnit] = useState(0);
    const [pendingAutocompleteMaterials, setPendingAutocompleteMaterials] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isMember, setIsMember] = useState(false);
    const [produtFormulaMaterial,setProductFormulaMaterial] = useState([])
    const [incomingSplitMarkup,setIncomingSplitMarkup] = useState(0)
    const [splitPercentage,setSplitPerscentage] = useState(0)
    const [splitManagementSettings,setSplitManagementSettings] = useState([])
    const [isSplitOrder,setIsSplitOrder] = useState(false)
    const [selectedSplitOrderSettings,setSelectedSplitOrderSettings] = useState([])

    
    const [installCost, setInstallCost] = useState(0);

    const [openChangeJobTypeDialog, setOpenChangeJobTypeDialog] = useState(false);
    const [pendingJobType, setPendingJobType] = useState(null);

        const closeDialog=()=>{
      setOpenDialogPartial(false);
    }
    const closeDialogNoStock=()=>{
      setOpenDialogNoStock(false);
    }
    const openDialogs = (partialLen, finishedLen) => {
      if (details?.isReview == 2 && !empty(details?.allInstallationCompleted)) {
        if (partialLen > 0 || finishedLen > 0) {
          setOpenDialogPartial(true);
        } else {
          setOpenDialogNoStock(true);
        }
      } else {
        setOpenDialogPartial(true);
      }
    };
      const handleMaterialStockCheck = async (material) => {
        setPendingMaterial(material);
        setStockType(1); // default to Finished
        setConvertionUnit(0);
        setPartialProducts([]);
        setFinishedProducts([]);
  
        // if (material.inhouse !== 1) {
        //   enqueueSnackbar('Only inhouse materials can be stocked', { variant: 'warning' });
        //   return;
        // }
  
        try {
          const res = await axios.post(`${REST_API_END_POINT}product/get-partial-finished-products-stock-by-unit`, { editId: material?.id });
          
          const partial = res.data?.results?.filter(item => item?.partial == 1) || [];
          const finished = res.data?.results?.filter(item => item?.partial == 0) || [];

          // update state
          setPartialProducts(partial);
          setFinishedProducts(finished);

          openDialogs(partial?.length, finished?.length);
        } catch (err) {
          console.error(err);
          setPartialProducts([]);
          setFinishedProducts([]);
          openDialogs(0, 0);
        }
      };
  // const handleSubmitPopUp = () => {
  //   if (!pendingMaterial) return;
  
  //   if (stockType === 2 && !convertionUnit) {
  //     enqueueSnackbar('Please choose a conversion unit', { variant: 'error' });
  //     return;
  //   }
  
  //   console.log('selectedMaterials', selectedMaterials)
  //   console.log('selectedMaterials', pendingMaterial)
  //  const alreadyAdded = selectedMaterials.some(
  //   (item) =>
  //     item.product_id === pendingMaterial.id &&
  //     item.stock_type === stockType &&
  //     (stockType === 1 || item.convertion_unit === convertionUnit)
  // );
  
  //   if (alreadyAdded) {
  //     enqueueSnackbar('Material Already Added', { variant: 'error' });
  //     return;
  //   }
  
  //   let initial_max_price = 0;  
  //   let unit = 4;
  //   let quantity = 1;
    
  //   if (stockType === 1) {
  //     console.log("qqqqqqqqqqqqqqqqqqq",pendingMaterial);
  //     initial_max_price = pendingMaterial.max_price || pendingMaterial.special_price;
  //     unit = pendingMaterial.unit || 4;
  //     console.log("qqqqqqqqqqqqqqqqqqq",initial_max_price);
  //   } else {
  //     console.log("qqqqqqqqqqqqqqqqqqq",partialProducts);
  //     const selectedUnitData = partialProducts.find(p => p.partial_unit === convertionUnit);
  //     if (!selectedUnitData || selectedUnitData.total_qty <= 0) {
  //       return enqueueSnackbar('No Partial Stock Available', { variant: 'error' });
  //     }
  //     initial_max_price = selectedUnitData.max_unit_cost || 0;
  //     unit = selectedUnitData.partial_unit || 4;
  //     console.log("qqqqqqqqqqqqqqqqqqq",initial_max_price);
  //   }
  // // let price = initial_max_price;
  // // let stock_type = stockType
  // // let convertion_unit = convertionUnit
  //   const newMaterial = {
  //     ...pendingMaterial,
  //     quantity: 1,
  //     price : initial_max_price,
  //     unit,
  //     stock_type: stockType,
  //     convertion_unit: convertionUnit,
  //     initial_max_price
  //   };
  //   console.log("newMaterial============",newMaterial);
    
    
    
  // const filteredPrevious = pendingAutocompleteMaterials.filter(
  //   (m) =>
  //     !(
  //       m.id === pendingMaterial.id &&
  //       m.stock_type === stockType &&
  //       (stockType === 1 || m.convertion_unit === convertionUnit)
  //     )
  // );
  //   const finalMaterialList = [...filteredPrevious, newMaterial];
  //   const additionalRows = selectedMaterials.filter(item => item.isAdditionalProduct === true);
  //   // const finalMaterialList = [
  //   //   ...pendingAutocompleteMaterials.filter(m => m.id !== pendingMaterial.id),
  //   //   newMaterial
  //   // ];
  // const uniqueMaterials = [...finalMaterialList, ...additionalRows].filter(
  //   (item, index, self) =>
  //     index === self.findIndex(t =>
  //       t.product_id === item.product_id &&
  //       t.stock_type === item.stock_type &&
  //       (t.stock_type === 1 || t.convertion_unit === item.convertion_unit)
  //     )
  // );
  
  // setPendingAutocompleteMaterials(finalMaterialList);
  // setFieldValue('additionalMaterials', finalMaterialList);
  // handleMaterial(finalMaterialList);
  // setSelectedMaterials(uniqueMaterials);


  // setPendingMaterial(null);
  // setPartialProducts([]);
  // setFinishedProducts([]);
  // setStockType(1);
  // setConvertionUnit(0);
  // closeDialog();
  // };
// const handleSubmitPopUp = () => {
//   if (!pendingMaterial) return;

//   if (stockType === 2 && !convertionUnit) {
//     enqueueSnackbar('Please choose a conversion unit', { variant: 'error' });
//     return;
//   }

//   const normalizedId = pendingMaterial.product_id || pendingMaterial.id;

//   const alreadyAdded = selectedMaterials.some(
//     (item) =>
//       (item.product_id || item.id) === normalizedId &&
//       item.stock_type === stockType &&
//       (stockType === 1 || item.convertion_unit === convertionUnit)
//   );

//   if (alreadyAdded) {
//     enqueueSnackbar('Material Already Added', { variant: 'error' });
//     return;
//   }

//   let initial_max_price = 0;
//   let unit = 4;

//   if (stockType === 1) {
//     initial_max_price = pendingMaterial.max_price || pendingMaterial.special_price;
//     unit = pendingMaterial.unit || 4;
//   } else {
//     const selectedUnitData = partialProducts.find(p => p.partial_unit === convertionUnit);
//     if (!selectedUnitData || selectedUnitData.total_qty <= 0) {
//       enqueueSnackbar('No Partial Stock Available', { variant: 'error' });
//       return;
//     }
//     initial_max_price = selectedUnitData.max_unit_cost || 0;
//     unit = selectedUnitData.partial_unit || 4;
//   }

//   const existingIndexIds = selectedMaterials.map(item => item.newIndexId || 0);
//   const maxIndexId = existingIndexIds.length > 0 ? Math.max(...existingIndexIds) : 0;

//   const newMaterial = {
//     ...pendingMaterial,
//     product_id: normalizedId,
//     quantity: 1,
//     price: initial_max_price,
//     unit,
//     stock_type: stockType,
//     convertion_unit: convertionUnit || 0,
//     initial_max_price,
//     newIndexId: maxIndexId + 1
//   };

//   console.log('newMaterial=========',newMaterial )
//     const normalizedPrev = pendingAutocompleteMaterials.map(m => ({
//     ...m,
//     product_id: m.product_id || m.id
//   }));
//   // ✅ Clean previous entries: same material + any stock_type match
//   const filteredPrevious = normalizedPrev.filter(
//     (m) =>
//       !(
//         m.product_id === normalizedId &&
//         m.stock_type === stockType &&
//         (stockType === 1 || m.convertion_unit === convertionUnit)
//       )
//   );
//  console.log('newMaterial=========1',filteredPrevious )
//   const finalMaterialList = [...filteredPrevious, newMaterial];
//   const additionalRows = selectedMaterials.filter(item =>
//   item.isAdditionalProduct === true &&
//   !(
//     (item.product_id || item.id) === newMaterial.product_id &&
//     item.stock_type === newMaterial.stock_type &&
//     (item.stock_type === 1 || item.convertion_unit === newMaterial.convertion_unit)
//   )
// );

//  console.log('newMaterial=========1',additionalRows)
//   // ✅ Ensure no exact duplicates in final list
// const dedupedMap = new Map();

// [...finalMaterialList, ...additionalRows].forEach((item) => {
//   const key = `${item.product_id || item.id}-${item.stock_type}-${item.stock_type === 2 ? item.convertion_unit : 0}`;
//   if (!dedupedMap.has(key)) {
//     dedupedMap.set(key, item);
//   }
// });

// const uniqueMaterials = Array.from(dedupedMap.values());

//  console.log('newMaterial=========1',finalMaterialList)
//  console.log('newMaterial=========1',uniqueMaterials)
//   // setPendingAutocompleteMaterials(finalMaterialList);
//   // setFieldValue('additionalMaterials', finalMaterialList);
//   // handleMaterial(finalMaterialList);
//   // setSelectedMaterials(uniqueMaterials);
//     setPendingAutocompleteMaterials(uniqueMaterials);
//   setFieldValue('additionalMaterials', uniqueMaterials);
//   handleMaterial(uniqueMaterials);
//   setSelectedMaterials(uniqueMaterials);

//   setPendingMaterial(null);
//   setPartialProducts([]);
//   setFinishedProducts([]);
//   setStockType(1);
//   setConvertionUnit(0);
//   closeDialog();
// };

// Function to detect changes in sales order data
const detectChanges = () => {
  const changes = [];
  
  console.log('🔍 Detecting changes...');
  console.log('📦 Current products:', selectedProducts.length, selectedProducts);
  console.log('📦 Initial products:', initialProducts.length, initialProducts);
  console.log('🔧 Current services (all):', additionalSelectedServices.length, additionalSelectedServices);
  console.log('🔧 Current services (recipe_id=null):', additionalSelectedServices.filter(s => s.recipe_id === null).length);
  console.log('🔧 Initial services (all):', initialServices.length, initialServices);
  console.log('🔧 Initial services (recipe_id=null):', initialServices.filter(s => s.recipe_id === null).length);
  console.log('🧱 Current materials:', selectedMaterials.length, selectedMaterials);
  console.log('🧱 Initial materials:', initialMaterials.length, initialMaterials);
  console.log('🛒 Current RFP services (all):', cartService.length, cartService);
  console.log('🛒 Current RFP services (recipe_id=null):', cartService.filter(s => s.recipe_id === null).length);
  console.log('🛒 Initial RFP services (all):', initialRfpServices.length, initialRfpServices);
  console.log('🛒 Initial RFP services (recipe_id=null):', initialRfpServices.filter(s => s.recipe_id === null).length);
  
  // Check products length
  if (selectedProducts.length !== initialProducts.length) {
    changes.push(`Products count changed from ${initialProducts.length} to ${selectedProducts.length}`);
  }
  
  // Check services length (only count services with recipe_id = null)
  const currentServicesCount = additionalSelectedServices.filter(service => service.recipe_id === null || !service.recipe_id).length;
  const initialServicesCount = initialServices.filter(service => service.recipe_id === null || !service.recipe_id).length;
  if (currentServicesCount !== initialServicesCount) {
    changes.push(`Services count changed from ${initialServicesCount} to ${currentServicesCount}`);
  }
  
  // Check materials length
  if (selectedMaterials.length !== initialMaterials.length) {
    changes.push(`Materials count changed from ${initialMaterials.length} to ${selectedMaterials.length}`);
  }
  
  // Check RFP products length
  if (cart.length !== initialRfpProducts.length) {
    changes.push(`RFP Products count changed from ${initialRfpProducts.length} to ${cart.length}`);
  }
  
  // Check RFP services length (only count services with recipe_id = null)
  const currentRfpServicesCount = cartService.filter(service => service.recipe_id === null).length;
  const initialRfpServicesCount = initialRfpServices.filter(service => service.recipe_id === null).length;
  if (currentRfpServicesCount !== initialRfpServicesCount) {
    changes.push(`RFP Services count changed from ${initialRfpServicesCount} to ${currentRfpServicesCount}`);
  }
  
  // Always check individual items for quantity changes, regardless of length changes
  // Check products
  const minProductsLength = Math.min(selectedProducts.length, initialProducts.length);
  for (let i = 0; i < minProductsLength; i++) {
    const current = selectedProducts[i];
    const initial = initialProducts[i];
    
    if (current && initial) {
      // Check if it's the same product by ID
      const currentId = current.id || current.product_id;
      const initialId = initial.id || initial.product_id;
      
      if (currentId === initialId) {
        // Same product, check quantity
        console.log(`🔍 Comparing product "${current.name || current.product_name}":`, {
          currentQty: current.locationQuantity,
          initialQty: initial.locationQuantity,
          isDifferent: current.locationQuantity !== initial.locationQuantity
        });
        if (current.locationQuantity !== initial.locationQuantity) {
          changes.push(`Product "${current.name || current.product_name}" quantity changed from ${initial.locationQuantity} to ${current.locationQuantity}`);
        }
      }
    }
  }
  
  // Check services (only those with recipe_id = null)
  const currentServicesFiltered = additionalSelectedServices.filter(service => service.recipe_id === null);
  const initialServicesFiltered = initialServices.filter(service => service.recipe_id === null);
  const minServicesLength = Math.min(currentServicesFiltered.length, initialServicesFiltered.length);
  
  for (let i = 0; i < minServicesLength; i++) {
    const current = currentServicesFiltered[i];
    const initial = initialServicesFiltered[i];
    
    if (current && initial) {
      if (current.id === initial.id) {
        if (current.quantity !== initial.quantity) {
          changes.push(`Service "${current.name}" quantity changed from ${initial.quantity} to ${current.quantity}`);
        }
      }
    }
  }
  
  // Check materials
  const minMaterialsLength = Math.min(selectedMaterials.length, initialMaterials.length);
  for (let i = 0; i < minMaterialsLength; i++) {
    const current = selectedMaterials[i];
    const initial = initialMaterials[i];
    
    if (current && initial) {
      const currentId = current.id || current.product_id;
      const initialId = initial.id || initial.product_id;
      
      if (currentId === initialId) {
        if (current.quantity !== initial.quantity) {
          changes.push(`Material "${current.name || current.product_name}" quantity changed from ${initial.quantity} to ${current.quantity}`);
        }
      }
    }
  }
  
  // Check RFP products
  const minRfpProductsLength = Math.min(cart.length, initialRfpProducts.length);
  for (let i = 0; i < minRfpProductsLength; i++) {
    const current = cart[i];
    const initial = initialRfpProducts[i];
    
    if (current && initial) {
      const currentId = current.id || current.product_id;
      const initialId = initial.id || initial.product_id;
      
      if (currentId === initialId) {
        if (current.quantity !== initial.quantity) {
          changes.push(`RFP Product "${current.name || current.product_name}" quantity changed from ${initial.quantity} to ${current.quantity}`);
        }
      }
    }
  }
  
  // Check RFP services (only those with recipe_id = null)
  const currentRfpServicesFiltered = cartService.filter(service => service.recipe_id === null);
  const initialRfpServicesFiltered = initialRfpServices.filter(service => service.recipe_id === null);
  const minRfpServicesLength = Math.min(currentRfpServicesFiltered.length, initialRfpServicesFiltered.length);
  
  for (let i = 0; i < minRfpServicesLength; i++) {
    const current = currentRfpServicesFiltered[i];
    const initial = initialRfpServicesFiltered[i];
    
    if (current && initial) {
      if (current.id === initial.id) {
        if (current.quantity !== initial.quantity) {
          changes.push(`RFP Service "${current.name}" quantity changed from ${initial.quantity} to ${current.quantity}`);
        }
      }
    }
  }
  
  console.log('✅ Detected changes:', changes);
  return changes;
};

// Helpers (no change to detectChanges)
const sectionFromMessage = (msg = '') => {
  // Collapse ALL RFP-related changes into one bucket
  if (/\bRFP\b/i.test(msg)) return 'Proposals';

  // Non-RFP buckets
  if (/Materials?/i.test(msg)) return 'Materials';
  if (/\bProducts?\b/i.test(msg)) return 'Products';
  if (/\bServices?\b/i.test(msg)) return 'Services';
  return null;
};

const getChangedSectionNames = () => {
  const msgs = detectChanges() // <-- your existing function
  const sections = new Set(
    msgs
      .map(sectionFromMessage)
      .filter(Boolean)
  )
  return Array.from(sections)
}


const handleSubmitPopUp = () => {
  if (!pendingMaterial) return;

  if (stockType === 2 && !convertionUnit) {
    enqueueSnackbar('Please choose a conversion unit', { variant: 'error' });
    return;
  }

  const normalizedId = pendingMaterial.product_id || pendingMaterial.id;

  console.log('🔹 Selected stock type:', stockType);
  console.log('🔹 Conversion unit:', convertionUnit);

  // const alreadyAdded = selectedMaterials.some(
  //   (item) =>
  //     (item.product_id || item.id) === normalizedId &&
  //     item.stock_type === stockType &&
  //     (stockType === 1 || item.convertion_unit === convertionUnit)
  // );
  const alreadyAdded = selectedMaterials.some((item) => {
  const sameProduct = (item.product_id || item.id) === normalizedId;
  const sameStock = item.stock_type === stockType;

  if (!sameProduct || !sameStock) return false;

  // ❌ Prevent Finished duplicate
  if (stockType === 1) return true;

  // ❌ Prevent *any* other Partial for same product
  if (stockType === 2) return true;

  return false;
});


  if (alreadyAdded) {
    enqueueSnackbar('Material Already Added', { variant: 'error' });
    console.warn('❌ Duplicate detected. Skipping...');
    return;
  }

  let initial_max_price = 0;
  let unit = 4;
  let partial_qty = 0

  if (stockType === 1) {
    initial_max_price = pendingMaterial.max_price || pendingMaterial.special_price;
    unit = pendingMaterial.unit || 4;
    console.log("qqqqqqqqqqqqqqqqqqq1",initial_max_price);
  } else {
    const selectedUnitData = partialProducts.find(p => p.partial_unit === convertionUnit);
    if (!selectedUnitData || selectedUnitData.total_qty <= 0) {
      enqueueSnackbar('No Partial Stock Available', { variant: 'error' });
      return;
    }
    initial_max_price = selectedUnitData.max_unit_cost || 0;
    unit = selectedUnitData.partial_unit || 4;
    partial_qty = selectedUnitData?.total_qty
  }

  const existingIndexIds = selectedMaterials.map(item => item.newIndexId || 0);
  const maxIndexId = existingIndexIds.length > 0 ? Math.max(...existingIndexIds) : 0;

  const newMaterial = {
    ...pendingMaterial,
    product_id: normalizedId,
    quantity: 1,
    price: initial_max_price,
    unit,
    partial_stock: partial_qty,
    stock_type: stockType,
    convertion_unit: convertionUnit || 0,
    initial_max_price,
    newIndexId: maxIndexId + 1
  };

  console.log('✅ New Material:', newMaterial);

  const combined = [...selectedMaterials.filter(item => !item.isAdditionalProduct), newMaterial];

  // 🔁 De-duplicate by (product_id + stock_type + convertion_unit)
  const uniqueKey = (item) =>
    `${item.product_id || item.id}-${item.stock_type}-${item.stock_type === 2 ? item.convertion_unit : 0}`;

  const dedupedMap = new Map();
  combined.forEach((item) => dedupedMap.set(uniqueKey(item), item));
  const uniqueMaterials = Array.from(dedupedMap.values());

  // ✅ Merge back additional rows
  const additionalRows = selectedMaterials.filter(item => item.isAdditionalProduct === true);
  const finalList = [...uniqueMaterials, ...additionalRows];

  console.log('📦 Final Material List:', finalList);

  setPendingAutocompleteMaterials(finalList);
  setFieldValue('additionalMaterials', finalList);
  handleMaterial(finalList);
  setSelectedMaterials(finalList);

  // Reset dialog state
  setPendingMaterial(null);
  setPartialProducts([]);
  setFinishedProducts([]);
  setStockType(1);
  setConvertionUnit(0);
  closeDialog();
  closeDialogNoStock();
};





    

  const accessPublicMessageBoard =  explodedPermissions?.some((permission) => ['Access Sales Order Client Message Board'].includes(permission))



    const getStatusColorAndLabel = (
      status,
      installationStatus,
      allInstallationCompleted,
      accepted,
      min_payment_status,
      job_category_name,
      billing_type,
      installationCompleteStatus,
      noServiceNoTask,
      proj_status,
      partial_install
    ) => {

  console.log('installationCompleteStatus',details?.installationCompleteStatus,installationCompleteStatus)

  console.log('billing_type', billing_type)

  console.log('details?.project_category', details?.project_category)

  let CommunityJob = false
      let CompletedStatus =
  (installationCompleteStatus == 1 || details?.installationCompleteStatus == 1)
    ? 'Installs'
    : (installationCompleteStatus == 2 || details?.installationCompleteStatus == 2)
    ? 'Pick up'
    :  (installationCompleteStatus == 3 || details?.installationCompleteStatus == 3) ? 'Shipping' :''
      switch (status) {
        case 1:
          // return { color: 'warning', label: 'Status: Draft' }
          return { color: 'warning', label: details?.hold === 1 ? 'Status: Hold' : 'Status: Draft' }
        case 2:
          // return { color: 'info', label: 'Status: Open' }
           return { color: details?.hold === 1 ?'warning' : 'info', label: details?.hold === 1 ? 'Status: Hold' : 'Status: Open' }
        case 3:
          return {
            color: `${
              details?.hold === 1 ?'warning' :
              details?.project_category == 13
                ? 'primary'
                : min_payment_status == 0
                ? 'warning'
                : 'primary'
            }`,
            label: `Status: ${
              details?.hold === 1 ? 'Hold' :
              details?.project_category == 13 || billing_type == 0
                ? 'Approved'
                : min_payment_status == 1
                ? 'Approved and Paid'
                : 'Approved and Payment Due'
            }`,
          }
        // return { color: `${min_payment_status==0? 'warning' :'primary'}`, label: `Status: ${min_payment_status==1? 'Approved and Paid' :'Approved & Awaiting for Payment'}` }
        case 4:
          // return { color: 'success', label: !empty(allInstallationCompleted) ? 'Completed' : (!empty(installationStatus) ? 'Status: Installation' : 'Status: In Production') }
          return {
            color: details?.hold==1 ? 'warning' : (noServiceNoTask == 1 && proj_status == 3 && details?.project_category !== 12) ? 'success' :
              empty(accepted) && !empty(allInstallationCompleted)
                ? 'warning'
                : 'success',
            label: details?.hold==1 ? 'Hold' : (noServiceNoTask == 1 && proj_status == 3 && details?.project_category !== 12) ? 'No Service No Task' :
             details?.isReview ==2 && (!empty(allInstallationCompleted)) ? "Awaiting Review" :
              empty(accepted) && (!empty(allInstallationCompleted))
                ? `${CompletedStatus} completed & Awaiting approval`
                : (job_category_name === 'Build Order' && status === 4 && accepted === 1) ? 'Completed' 
                : !empty(accepted) && (!empty(allInstallationCompleted))
                ? `${CompletedStatus} completed & Approved`
                : !empty(installationStatus)
                ? partial_install == 1 ? 'Status: Partial Install' :proj_status !=3 ? `Status: In-Production` :`Status: ${CompletedStatus}`
                : CommunityJob ? `${CompletedStatus} completed & Approved` : `Status: In-Production`,
          } // return { color: 'primary', label: 'Status: Converted to Job' };
        case 5:
          return { color: 'warning', label: 'Status: Closed' }
        case 6:
          return { color: 'error', label: 'Status: Rejected' }
           case 10:
        return { color: 'success', label: 'Completed -No Service No Task' }
        default:
          return { color: 'default', label: 'Status: Open' }
      }
    }
  

  console.log('allRfpServiceLocationSame',allRfpServiceLocationSame)
  const fetchDetails = async () => {
    try {
      const res = await axios.post(`${REST_API_END_POINT}settings/get-companyProfile-details`);
      if (res.data.status === 1) {
        setData(...res.data.data);
      }
    } catch (error) {
      console.log('get-companyProfile-details error : ', error);
    }
  };

  const updatePaymentFromQb =async(ids)=>{
    try {
      let user = JSON.parse(localStorage.getItem('user'))
      // console.log('useruseruseruser',user)
     
      
      let admin_email = user.email
      let company_name= user.company_name
      let username = user.person_name
      let user_role = user.user_role
      const response= await axios.post(`${REST_API_END_POINT}sales-order/update-payment-from-qb`,{userId,allId:ids,admin_email,company_name,username,user_role})
    // if(response.data.details.success > 0){
    //   // fetchAllRequest()
    // }
    } catch (error) {
      console.log("error",error)
    }
  }

  useEffect(() => {
    fetchDetails();
    if(id){
      let ids =[id]
      updatePaymentFromQb(ids)
    }

  }, [id]);


    const handleSalesOrderTabCount = async () => {
      try {
        const response = await axios.post(`${REST_API}webservice/sales-order/reduce-tabs-count`, {
          userId,
          request_id:id,
        });
        
      } catch (error) {
        console.error("Error reducing sales order count:", error);
      }
    };

    const handleDuplicateSalesOrder = async () => {
      try {
        // 🚀 PROGRESS TRACKING: Show progress modal and make API call
        const requestData = {
          userId,
          request_id: id,
          userType,
          socketId: null // Will be set by the progress modal
        };

        setProgressHeading("Duplicating Sales Order");
        setProgressRequestData(requestData);
        setShowProgressModal(true);
        
        // Wait for socket connection to establish and stabilize
        await new Promise(resolve => setTimeout(resolve, 2000));
        
        // Additional wait if socket is not ready yet
        if (!socketReady) {
            console.log('[PROGRESS-MODAL] ⏳ Waiting for socket connection...');
            await new Promise(resolve => setTimeout(resolve, 1000));
        }
        
        const response = await axios.post(`${REST_API}webservice/duplicate-request`, requestData);

        if(response?.data?.status === 1){
        enqueueSnackbar(response?.data?.message, { variant: 'success' });
          if(popupOn){
          closeView()
          localStorage.removeItem('salesOrderProjectId');
          localStorage.removeItem('salesOrderProjectName');
          localStorage.removeItem('isEditSalesOrder');
          localStorage.removeItem('salesOrderOpenPopup',);
          setRenderCards(!renderCards)
          onDataChange()
        }else{
          navigate(PATH_DASHBOARD.official.root)
        }
        }
      } catch (error) {
        console.error("Error duplicating sales order:", error);
        enqueueSnackbar('Error duplicating sales order:', { variant: 'error' });
      }
    };
  
    useEffect(() => {
      handleSalesOrderTabCount()
    }, [])

  const handleOpenNote = (indexId, note) => {
    setCurrentNote(note || '');
    setOpenProductNote((prev) => ({ ...prev, [indexId]: true }));
  };

  const handleCloseNote = (indexId) => {
    setOpenProductNote((prev) => ({ ...prev, [indexId]: false }));
    setCurrentNote('');
  };

  const handleNoteChange = (event) => {
    const newNote = event.target.value;
    if (newNote.length <= MAX_CHARACTERS) {
      setCurrentNote(newNote);
    }
  };

  const handleSaveNote = (indexId) => {
    setIsSavingNote(true);
    setTimeout(() => {
      setSelectedProducts((prev) =>
        prev.map((product) =>
          product.indexId === indexId ? { ...product, product_notes: currentNote } : product
        )
      );
      setIsSavingNote(false);
      handleCloseNote(indexId);
    }, 100);
  };

      // Service notes handlers
      const handleOpenServiceNote = (indexId, note) => {
        setServiceCurrentNote(note || '');
        setServiceNoteState((prev) => ({ ...prev, [indexId]: true }));
    };

    const handleCloseServiceNote = (indexId) => {
        setServiceNoteState((prev) => ({ ...prev, [indexId]: false }));
        setServiceCurrentNote('');
    };

    const handleServiceNoteChange = (event) => {
        const newNote = event.target.value;
        if (newNote.length <= MAX_CHARACTERS) {
            setServiceCurrentNote(newNote);
        }
    };

    const handleSaveServiceNote = (indexId) => {
        setServiceIsSavingNote(true);
        setTimeout(() => {
            // Update selectedServices
            setSelectedServices((prev) =>
                prev.map((service) =>
                    service.indexId === indexId ? { ...service, service_notes: serviceCurrentNote } : service
                )
            );
            // Update additionalSelectedServices
            setAdditionalSelectedServices((prev) =>
                prev.map((service) =>
                    service.indexId === indexId ? { ...service, service_notes: serviceCurrentNote } : service
                )
            );
            // Update cartService
            setCartService((prev) =>
                prev.map((service) =>
                    service.indexId === indexId ? { ...service, service_notes: serviceCurrentNote } : service
                )
            );
            setServiceIsSavingNote(false);
            handleCloseServiceNote(indexId);
        }, 100);
    };

  const handleRfpSelect = (event, value) => {
    setSelectedRfp(value);
    setRfpServices(value?.services?.filter(service => !isInCartService(service)) || []);
    setRfpProducts(value?.products?.filter(product => !isInCart(product)) || []);
    if (!empty(value)) {
      setOpenModal(true);
    }

  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  // const addToCart = (item) => {
  //   // Extract project/community address
  //   const { address: projAddress = '', city: projCity = '', state: projState = '', zip: projZip = '' } = values?.community || {};
  //   const communityAddress = { address: projAddress, city: projCity, state: projState, zip: projZip };
  
  //   if (tabIndex === 0) {
  //     // Adding to RFP Services
  //     const newService = assignDefaultLocation(cartService, item, allRfpServiceLocationSame, communityAddress);
  //     setCartService([...cartService, newService]);
  
  //     if (allRfpServiceLocationSame) {
  //       const commonLocation = cartService[0]?.location?.[0] || {
  //         address: '',
  //         city: '',
  //         state: '',
  //         zip: '',
  //       };
  
  //       setCartService((prevServices) =>
  //         prevServices.map((service) => ({
  //           ...service,
  //           location: service.location ? service.location.map(() => ({ ...commonLocation })) : [{ ...commonLocation }],
  //         }))
  //       );
  //     }
  //   } else {
  //     // Adding to RFP Products
  //     const newProduct = assignDefaultLocation(cart, item, allRfpProductsLocationSame, communityAddress);
  //     setCart([...cart, newProduct]);
  
  //     if (allRfpProductsLocationSame) {
  //       const commonLocation = cart[0]?.location?.[0] || {
  //         address: '',
  //         city: '',
  //         state: '',
  //         zip: '',
  //       };
  
  //       setCart((prevProducts) =>
  //         prevProducts.map((product) => ({
  //           ...product,
  //           location: product.location ? product.location.map(() => ({ ...commonLocation })) : [{ ...commonLocation }],
  //         }))
  //       );
  //     }
  //   }
  
  //   // Close modal and reset form fields
  //   setOpenModal(false);
  //   setSelectedRfp(null);
  //   setFieldValue('rfp', null);
  // };
  
  const addToCart = (item) => {
    // Extract project/community address
    const { address: projAddress = '', city: projCity = '', state: projState = '', zip: projZip = '' } = values?.community || {};
    const communityAddress = { address: projAddress, city: projCity, state: projState, zip: projZip };

    const locationQuantity = item.location_quantity || 1; // Ensure a default value of 1

    if (tabIndex === 1) {
        // ✅ Adding to RFP Services
        const newService = assignDefaultLocation(cartService, item, allRfpServiceLocationSame, communityAddress, locationQuantity);
        setCartService([...cartService, newService]);

        if (allRfpServiceLocationSame) {
            setCartService((prevServices) =>
                prevServices.map((service) => ({
                    ...service,
                    location: Array.from({ length: locationQuantity }, () => ({ ...communityAddress })),
                }))
            );
        }
    } else {
        // ✅ Adding to RFP Products
        const newProduct = assignDefaultLocation(cart, item, item.allRfpProductsLocationSame, communityAddress, locationQuantity);
        setCart([...cart, newProduct]);

        if (item.allRfpProductsLocationSame) {
            setCart((prevProducts) =>
                prevProducts.map((product) => ({
                    ...product,
                    location: Array.from({ length: locationQuantity }, () => ({ ...communityAddress })),
                }))
            );
        }
    }

    // ✅ Close modal and reset form fields
    setOpenModal(false);
    setSelectedRfp(null);
    setFieldValue('rfp', null);
  };


  const assignDefaultLocation = (existingItems, newItem, allLocationsSame, communityAddress) => {
    let assignedLocation = [];
  
    if (allLocationsSame && existingItems.length > 0) {
      // Use the first item's location as the common location
      const commonLocation = existingItems[0]?.location?.[0] || {
        address: '',
        city: '',
        state: '',
        zip: '',
      };
      assignedLocation = [{ ...commonLocation }];
    } else if (
      communityAddress.address &&
      communityAddress.city &&
      communityAddress.state &&
      communityAddress.zip
    ) {
      // Use the community address as the default location
      assignedLocation = [
        {
          id: 0,
          address: communityAddress.address,
          city: communityAddress.city,
          state: communityAddress.state,
          zip: communityAddress.zip,
        },
      ];
    } else {
      // Default to an empty location
      assignedLocation = [
        {
          id: 0,
          address: '',
          city: '',
          state: '',
          zip: '',
        },
      ];
    }
  
    return {
      ...newItem,
      location: assignedLocation,
    };
  };
  
  // const handleMaterial = (newValue) => {
  //   setSelectedMaterials((prevMaterials) => {
  //     const additionals = prevMaterials?.filter(item => item.isAdditionalProduct == true);
  //     const baseIndex = prevMaterials?.filter(item => !item.isAdditionalProduct)?.length || 0;
  //     const updatedNewValue = newValue.map((item, idx) => ({
  //       ...item,
  //       newIndexId: baseIndex + 1,
  //       quantity:item.quantity ?? 1,
  //     }));
  //     return [...updatedNewValue, ...additionals];
  //   });
  // };
const handleMaterial = (newValue) => {
  const cleaned = newValue.filter((item, index, self) =>
    index === self.findIndex(t =>
      (t.product_id || t.id) === (item.product_id || item.id) &&
      t.stock_type === item.stock_type &&
      (t.stock_type === 1 || t.convertion_unit === item.convertion_unit)
    )
  );
  

  const baseIndex = cleaned.length > 0 ? Math.max(...cleaned.map(item => item.newIndexId || 0)) : 0;

  const updatedNewValue = cleaned.map((item, idx) => ({
    ...item,
    newIndexId: baseIndex + idx + 1,
    quantity: item.quantity ?? 1,
  }));

  const additionals = selectedMaterials?.filter(item => item.isAdditionalProduct === true);
  setSelectedMaterials([...updatedNewValue, ...additionals]);
};


  // const handleDeleteMaterial = (id, indexId) => {
  //   const updatedMaterials = selectedMaterials?.filter((data) => {
  //     if (data?.isAdditionalProduct) {
  //       return data?.newIndexId !== indexId;
  //     }
  //     return data?.id !== id;
  //   });
    
  //   setSelectedMaterials(updatedMaterials);
  //   };
const handleDeleteMaterial = (productId, stockType, convertionUnit = 0) => {
  const updatedMaterials = selectedMaterials.filter((data) => {
    const currentId = data.product_id || data.id;
    const isSameMaterial =
      currentId === productId &&
      data.stock_type === stockType &&
      (stockType === 1 || data.convertion_unit === convertionUnit);

    return !isSameMaterial;
  });

  setSelectedMaterials(updatedMaterials);
  setPendingAutocompleteMaterials(updatedMaterials);
  setFieldValue('additionalMaterials', updatedMaterials);
  handleMaterial(updatedMaterials);
};

  console.log("######################Cart", cart);
  console.log("######################Cart Service", cartService);
  const isInCart = (item) => {
    return cart.some(cartItem => cartItem.product_id === item.product_id);
  };
  const isInCartService = (item) => {
    return cartService.some(cartItem => cartItem.labour_cost_service_id
      === item.labour_cost_service_id);
  };
  const closeModal = () => {
    setOpenModal(false);
    setFieldValue('rfp',null)
  };
  const handleDeleteRFPProduct = (productId) => {
    setCheckLength(!checkLength)
    setCart(prevCart => prevCart.filter(item => item.product_id !== productId));
  };
  const handleDeleteRFPService = (productId) => {
    setCheckLength(!checkLength)
    console.log("######################Cartde", productId);
    setCartService(prevCart => prevCart.filter(item => item.labour_cost_service_id !== productId));
  };
  const VALUE = [
    { id: 1, value: 'Sl No.' },
    { id: 2, value: 'Products' },
    { id: 3, value: 'Note' },
    // { id: 4, value: 'Product formula cost (Material cost + Service cost with markup)' },
    { id: 5, value: 'Product formula cost' },
    { id: 16, value: 'Split Markup' },
    { id: 6, value: markupType ? ((markupType == 2 && hasMarkupPermission) ? 'Retail Price Each' : null) : null },
    { id: 7, value: markupType ? ((markupType == 1 && hasMarkupPermission) ? 'Retail Price Each' : null) : null },
    // { id: 14, value: hasMarkupPermission ? 'SPMA' : null },
    // { id: 8, value: hasMarkupPermission ? 'Markup (%)' : null },
    { id: 9, value: 'Unit' },
    { id: 10, value: 'Quantity' },
    { id: 11, value: 'Location' },
    // { id: 11, value: 'Marketing Adjustment Type' },
    // { id: 12, value: 'Marketing Adjustment' },
    // { id: 12, value: 'Discount' },
    { id: 13, value: 'Subtotal' },
    { id: 14, value: 'Product Total' },
    { id: 15, value: '' }
  ];

  const VALUEPreview = [
    { id: 0, value: 'Sl No.' },
    { id: 1, value: 'Products & Notes' },
    // { id: 2, value: 'Product formula cost (Material cost + Service cost with markup)' },
    { id: 3, value: markupType ? ((markupType == 2 && hasMarkupPermission) ? 'Retail Price Each' : null) : null },
    { id: 4, value: markupType ? ((markupType == 1 && hasMarkupPermission) ? 'Retail Price Each' : null) : null },
    // { id: 14, value: hasMarkupPermission ? 'SPMA' : null },
    // { id: 5, value: hasMarkupPermission ? 'Markup (%)' : null },
    { id: 6, value: 'Unit' },
    { id: 7, value: 'Quantity' },
    // { id: 11, value: 'Marketing Adjustment Type' },
    // { id: 8, value: 'Marketing Adjustment' },
    // { id: 8, value: 'Discount' },
    { id: 9, value: 'Subtotal' },
    { id: 11, value: 'Product Total' },
    { id: 10, value: '' }
  ]

  const VALUE_SERVICES = [
    { id: 0, value: 'Product Sl No.' },
    { id: 1, value: 'Service Name' },
    { id: 2, value: 'Note' },
    { id: 3, value: 'Markup (%)' },
    { id: 4, value: 'Cost (Hourly)' },
    { id: 5, value: 'Markup Cost (Hourly)' },
    { id: 6, value: 'Hours' },
    // { id: 7, value: 'Make As Task' },
    // { id: 8, value: 'Make Install Card' },
    { id: 9, value: 'Location' },
    { id: 10, value: 'Product Formula Cost'},
    { id: 11, value: 'Additional Cost' },
    { id: 12, value: 'Total cost' },
    { id: 13, value: '' }
  ];

    const PREVIEW_VALUE_SERVICES = [
    { id: 0, value: 'Product Sl No.' },
    { id: 1, value: 'Service Name' },
    { id: 2, value: 'Note' },
    { id: 3, value: 'Markup (%)' },
    { id: 4, value: 'Cost (Hourly)' },
    { id: 5, value: 'Markup Cost (Hourly)' },
    { id: 6, value: 'Hours' },
    // { id: 7, value: 'Make As Task' },
    // { id: 8, value: 'Make Install Card' },
    // { id: 9, value: 'Location' },
    { id: 10, value: 'Product Formula Cost'},
    { id: 11, value: 'Additional Cost' },
    { id: 12, value: 'Total cost' },
    { id: 13, value: '' }
  ];

  const VALUE_TIME = [
    { id: 1, value: 'Sl No.' },
    { id: 2, value: 'Products' },
    { id: 3, value: 'Note' },
    { id: 4, value: 'Retail Price Each'},
    // { id: 14, value: 'SPMA' },
    { id: 5, value: 'Unit' },
    { id: 6, value: 'Quantity' },
    { id: 7, value: 'Location' },
    // { id: 11, value: 'Marketing Adjustment Type' },
    // { id: 8, value: 'Marketing Adjustment' },
    { id: 9, value: 'Subtotal' },
    { id: 10, value: '' }
  ];
  const VALUE_TIME_Preview = [
    { id: 1, value: 'Sl No.' },
    { id: 2, value: 'Products' },
    // { id: 3, value: 'Note' },
    { id: 4, value: 'Retail Price Each'},
    // { id: 14, value: 'SPMA' },
    { id: 5, value: 'Unit' },
    { id: 6, value: 'Quantity' },
    // { id: 7, value: 'Location' },
    // { id: 11, value: 'Marketing Adjustment Type' },
    // { id: 8, value: 'Marketing Adjustment' },
    { id: 9, value: 'Subtotal' },
    { id: 11, value: 'Product Total' },
    { id: 10, value: '' }
  ];
  const VALUE_MATERIAL=[
    {id: 0, value: 'Material'},
    {id: 9, value: 'Stock Type'},
    {id: 1, value: 'Unit Price'},
    {id: 2, value: 'Markup (%)'},
    {id: 3, value: 'Markup Cost (Unit)' },
    {id: 4, value: 'Quantity'},
    {id: 5, value: 'Product Formula Cost'},
    {id: 6, value: 'Total'},
    {id: 7, value: '' }
  ]
  const VALUE_RFP_Product = [
    { id: 0, value: 'Name' },
    { id: 1, value: 'Mark Up (%)' },
    { id: 2, value: 'Cost ' },
    { id: 3, value: 'Retail Price Each' },
    { id: 4, value: 'Unit' },
    { id: 5, value: 'Quantity' },
    // { id: 6, value: 'Product Formula Cost'},
    { id: 7, value: 'Total' },
    // { id: 8, value: 'Make As Task' },
    // { id: 9, value: 'Make Install Card' },
    { id: 10, value: 'Location' },
    { id: 11, value: '' }
  ]
  const handleChangeTab = (event, newValue) => {
    setCurrentTab(newValue)
    // setRefresh(true)
    console.log('tab--newValuenewValue--',newValue)
    if(newValue == 'Locations and Notes'){
      // setRefresh(!refresh);
      fetchRequestDetails();
    }
    if(newValue == "Sales Order Details"){
      if(popupOn){
        setRenderCards(!renderCards)
      }
    }
  }
  const HandleClickmenu = () => {
    setAddClient(true)
  }
  const fetchTaxCategory = async () => {
    try{
        const response = await axios.post(`${REST_API_END_POINT}product/get-tax-category`)
        if(response.data.status === 1){
            setTaxCategories(response.data.taxResult);
        }else{
          setTaxCategories([])
        }
    }catch(error){
        console.log("Error - ",error);
        setTaxCategories([])
    }
  }

  //add clients
  const fetchAllRequestClients = async () => {

    try {
      const res = await axios.post(`${REST_API}webservice/request/fetch-all-clients-request`, { requestId: id })

      await setAllClients(res.data.data)
    } catch (error) {
      console.log(error, 'Error in fetching all clients')
    }
  }

  useEffect(() => {
    fetchAllRequestClients()
  }, [addClient])
  const NewUserSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    description: Yup.string().required('Description is required'),
    //  avatarUrl: Yup.mixed().required('Image is required'),
    // skills:userType!=3 && Yup.array().min(1, 'Skill is required'),
    // workflow:userType!=3 && Yup.array().min(1, 'Workflow is required'),
    start: Yup.mixed().required('Start Date is required'),
    end: Yup.date()
      .nullable()
      .transform((value, originalValue) => {
        return originalValue ? new Date(originalValue * 1000) : null;
      })
      .when('start', (start, schema) => {
        return start
          ? schema.min(
            start,
            'Installation Date must be greater than the Start Date'
          )
          : schema;
      }),
    products: userType == 1 && Yup.array(),
    //.min(1, 'At least one product is required')
    // services:userType!=3 && Yup.array().min(1, 'At least one service is required'), 
    markup_type: userType != 3 && Yup.object().nullable().required('Please select the markup type'),
    project_type: userType != 3 && Yup.object().nullable().required('Job Class is required'),
    project_category: userType != 3 && Yup.object().nullable().required('Job Type is required'),
    map_service: Yup.mixed().when('project_category', {
      is: (project_category) => userType !== 3 && project_category?.id == 14,
      then: Yup.object().nullable().required('Please select the map service'),
      otherwise: Yup.mixed().nullable(),
    }),
    community: userType != 3 && Yup.object().nullable().required('Project is required'),
  });
  //
  const LabelStyle = styled(Typography)(({ theme }) => ({
    ...theme.typography.subtitle2,
    // color: theme.palette.text.secondary,
    //   marginBottom: theme.spacing(1)
  }));
  const LabelStyleHead = styled(Typography)(({ theme }) => ({
    ...theme.typography.h5,
    // color: theme.palette.text.secondary,
  }))
  //delete official request 
  const handleDeleteRFQ = async () => {
    try {
      setLoadingDelete(true);
      const data = { request_id: id,request:true,userId }
      const res = await axios.post(`${REST_API}webservice/delete-request/id`, data)

      if (res.data.data == true) {
        enqueueSnackbar('Delete success', { variant: 'success' });
        // 
        if(popupOn){
          closeView()
          localStorage.removeItem('salesOrderProjectId');
          localStorage.removeItem('salesOrderProjectName');
          localStorage.removeItem('isEditSalesOrder');
          localStorage.removeItem('salesOrderOpenPopup',);
          setRenderCards(!renderCards)
          onDataChange()
        }else{
          navigate(PATH_DASHBOARD.official.root)
        }
      }
    } catch (error) {
      console.log(error, 'Error in deleting the order')
    } finally {
      setLoadingDelete(false);
    }

  }
  //fetch request details
  const fetchRequestDetails = async () => {
    try {
      setLoadingEdit(true)
      const res = await axios.post(`${REST_API}webservice/view-request`, { request_id: id, userId, userType });
      res.data;
      setTeamMember(res.data.team)
      setCustomerData(res.data.customerData)
      setTaxAmount(res.data.customerData?.tax_amount || 0)
      setAvatarUrl(res.data.attachments)
      setDetails(res.data?.data[0])
      setLabourCostServices(res.data.labourCostServices)
      setDesignersList(res.data.projectMembers)
      setFilteredServices(res.data.labourCostServices)
      setRequestServices(res.data.requestServices?.filter(row => row.rfp === 0))
      setRfpServicesEdit(res.data.requestServices?.filter(row => row.rfp === 1))
      setClientApprove(res.data?.data[0]?.client_approve)
      // setIsSingleCard(res.data?.data[0]?.is_single_card)
      // setSingleLocationCard(res.data?.data[0]?.is_single_card === 1);
      console.log("setDetailssetDetailssetDetails",res.data.data)
      setRfps(res.data.allProposals)
      setMarkupType(res.data?.data[0]?.markup_type)
      setDesigns(res.data?.attachments)
      setSkill(res.data.skill)
      setWorkFlow(res.data.workflows)
      // setAllproducts(res.data.products)
      let currentInstallationProductData = res?.data?.products
      currentInstallationProductData = currentInstallationProductData?.filter(row=>row.inhouse!==6)
      let otherInstallationProductData = res?.data?.otherInstallationProducts
      let combinedProducts = [...(currentInstallationProductData || []), ...(otherInstallationProductData || [])];
      setAllproducts(combinedProducts)
      let incomingSplitMarkup = res?.data?.currentFacilitySplitManagementSettings?.find(setting => setting?.is_default)?.incoming_percentage
      setIncomingSplitMarkup(incomingSplitMarkup)
      setSplitManagementSettings(res?.data?.otherInstallationSplitManagementSettings)

      let filteredValue = res.data?.data[0].facility_type; // e.g. "2,3,4"

      const selectedData = String(filteredValue)  
        .split(",")                               
        .map(v => v.trim())                     
        .map(id => res?.data?.otherInstallationSplitManagementSettings?.find(s => s?.id == id)) 
        .filter(Boolean);                        
      
      setSelectedSplitOrderSettings(res?.data?.otherInstallationSplitManagementSettings);
      console.log('selectedData11212121212 1',selectedData)
      // setAllMaterials(res.data.materials)   15-01-25 previos
      if (editState) {
        setOpenEdit(true)
        console.log('truetruetruetrue==editState',editState)
      }
      //new
      const allMatData = Array.isArray(res.data.materials) 
      ? res.data.materials.map((material) => ({
          ...material,
          markup: Number(material.retail_price || 0), 
        }))
      : [];
      console.log('allMatData---2',allMatData)
      setAllMaterials(allMatData?.filter(item=>item.isAdditionalProduct == 0))
      
      setAcceptedClients(res.data.requestAcceptedPartners)
      setJobNoteMembers(res?.data?.jobNoteMembers || res.data.team || [])
      setUpdates(res.data.updates)
      setPayments(res.data.payments)
      setCustomTemplate(res.data.fieldTemplates)
      setQuestionnaireTemplate(res.data.QuestionTemplates)
      setSignAgreements(res.data.signAgrementData)
      setDataEmpty(res.data.allDataEmpty)
      setPortfolio(res.data.portfolio)
      setRefresh(false)
      setProposalData(res.data.requestProposals)
      if(res.data?.data[0].project_category == 13){
        setNoCharge(true)
      }
      // if (res.data?.data[0]?.is_single_card === 1) {
      //   setSelectedProducts((prev) =>
      //     prev.map((p) => ({
      //       ...p,
      //       locationQuantity: 1,
      //       locations: p.addresses?.length ? [p.addresses[0]] : [
      //         {
      //           id: 0,
      //           address: '',
      //           city: '',
      //           state: '',
      //           zip: '',
      //         },
      //       ],
      //     }))
      //   );
      
      //   setSelectedServices((prev) =>
      //     prev.map((service) => ({
      //       ...service,
      //       locationQuantity: 1,
      //       quantity: (
      //         service.previousQty * 1 * (service.qtyData || 1)
      //       )?.toFixed(2),
      //     }))
      //   );
      // }    

      // if (res.data?.data[0]?.is_single_card === 1) {
      //   setSelectedProducts((prev) =>
      //     prev.map((p) => ({
      //       ...p,
      //       location: p.location?.length > 0
      //         ? [p.location[0]]  // Keep only the first address
      //         : [{
      //             id: 0,
      //             address: '',
      //             city: '',
      //             state: '',
      //             zip: '',
      //           }],
      //     }))
      //   );
      // }
      
      
      // if (res.data?.data[0]?.is_location === 1) {
      //   setAllLocationSame(true)
      // }
      // if(res.data?.data[0]?.is_service_location ==1 || res.data?.data[0]?.is_service_location !=0) {
      //   conosle.log('if is_service_location',res.data?.data[0]?.is_service_location)
      //   setAllServiceLocationSame(true)
      // }else{
      //   conosle.log('else is_service_location',res.data?.data[0]?.is_service_location)
      //   setAllServiceLocationSame(false)

      // }

      // if(res.data?.data[0]?.is_rfp_service_location == 1){
      //   setAllRfpServiceLocationSame(true)
      // }else{
      //   setAllRfpServiceLocationSame(false)

      // }
      // if(res.data?.data[0]?.is_rfp_product_location == 1){
      //   setAllRfpProductsLocationSame(true)
      // }else{
      //   setAllRfpProductsLocationSame(false)
      // }

      // setTimeout(()=>{
      //   setLoading(false)
      // },2000)

      setIsSplitOrder(res.data?.data[0]?.is_split_order)

    } catch (error) {
      console.error('Error fetching request details:', error);
    } 
    finally {
      setLoadingEdit(false)
    }
  };
  //fetch request details
  const fetchRequestDetailsNew = async () => {
    try {
      setLoading(true)
      const res = await axios.post(`${REST_API}webservice/view-request-new`,
        { request_id: id, userId, userType });
      setTeamMember(res.data.team)
      setCustomerData(res.data.customerData)
      setAvatarUrl(res.data.attachments)
      setDetails(res.data?.data[0])
      setDesigns(res.data?.attachments)
      setAcceptedClients(res.data.requestAcceptedPartners)
      setUpdates(res.data.updates)
      setPayments(res.data.payments)
      setJobNoteMembers(res?.data?.jobNoteMembers)
      // setRefresh(false)
      // setTimeout(()=>{
      //   setLoading(false)
      // },2000)
    } catch (error) {
      console.error('Error fetching request details:', error);
    } finally {
      setLoading(false)
    }
  };

  const fetchAllCommunityByClient = async (clientId) => {
    setIsCommunityLoading(true);
    try {
      clientId = clientId.id
      const res = await axios.post(`${REST_API}webservice/rfq/get-community-by-client`, { clientId })
      let data = res.data?.community
      await setCommunities(data)
    } catch (error) {
      console.log(error, 'Error in fetching all clients');
      setCommunities([]);
    } finally {
      setIsCommunityLoading(false)
    }
  }

  const fetchAllMapServices = async () => {
    setMapServicesLoading(true);
    try {
      const res = await axios.post(`${REST_API}webservice/route/fetch-routes-with-locations`,{ requestId : id })
      let data = res.data?.routeData
      if(data){
        const newData = data?.filter((i) => i.locations != null)
        if(newData){
          setMapServices(newData);
        }else{
          setMapServices([]);
        }
      }else{
        setMapServices([]);
      }
    } catch (error) {
      setMapServices([]);
      console.log(error, 'Error in fetching map services');
    }finally {
      setMapServicesLoading(false)
    }
  }

  const fetchAllClients = async () => {
    try {
      const res = await axios.post(`${REST_API}webservice/clients/getAllClients`, { userType, userId,order:true })
      let data = res.data?.customer
      await setAllClientsEdit(data)
    } catch (error) {
      console.log(error, 'Error in fetching all clients', error)
    }
  }

  useEffect(() => {
    console.log('id=outside=3==',id)
    fetchRequestDetailsNew()
    fetchRequestDetails()
    fetchTaxCategory()
    fetchAllMapServices()
    fetchAllClients()

    // setFieldValue('markup_type', markupTypes[1])
    setMarkupType(markupTypes[1]?.id)
  }, [id, refresh])
  console.log('reqqqqqqqqqqqqqqqqqqq details',details)
  console.log('reqqqqqqqqqqqqqqqqqqq invoice',invoice)
  useEffect(() => {
   
    try {
      axios.post(`${REST_API_END_POINT}project/get-data-for-add-project`, {
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if (response.data.status === 1) {
          setProjectTypes(response.data.projectTypes)
          setProjectCategories(response.data.projectCategories)
          setNoChargeType(response.data.noChargeType)
          // setCommunities(response.data.community)

        }
      }).catch((error) => {
        console.error(error);
      })
    }
    catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [])
  //rfq product detais
  const fetchOrderProductDetails = async () => {
    try {
      setLoadingEdit(true)
      let orderId = details?.id;
      if (orderId && (orderId != 'undefined')) {
        const res = await axios.post(`${REST_API}webservice/get-customer-order-product/${orderId}`);
        const invoiceData = res.data.data
        console.log("res.data.datares.data.datares.data.data",res.data.data)
        let jobcostTotal = 0
        let jobcostServiceTotal = 0
        if(invoiceData?.jobcost_product && invoiceData?.jobcost_product?.length > 0){
          jobcostTotal = invoiceData?.jobcost_product?.reduce((sum, product) => {
            return sum + (product.total || 0);
          }, 0);
        }
        if(invoiceData?.jobcost_service && invoiceData?.jobcost_service?.length > 0){
          jobcostServiceTotal = invoiceData?.jobcost_service?.filter(it=>it.total_cost == 0)?.reduce((sum, product) => {
            return sum + (parseFloat(product.total_service_cost) || 0);
          }, 0);
        }
        const total = invoiceData?.total || 0;
        const extraDiscount = parseFloat(invoice?.extra_discount) || 0;
        const taxAmount = parseFloat(invoice?.tax_amount) || 0;
        const totalPaidAmount = details?.totalPaidAmount || 0;

        // let grandTotal = (total + (jobcostTotal || 0) + (jobcostServiceTotal || 0)) - extraDiscount + taxAmount;
        // const grandTotal = details?.allInstallationCompleted ? invoiceData?.total : invoiceData?.grandTotal || 0;
        const grandTotal = details?.project_category == 12 ? invoiceData?.total : invoiceData?.grandTotal || 0;
        let balanceDue = grandTotal - totalPaidAmount;

        const updatedInvoiceData = {
          ...invoiceData,
          jobcostTotal,
          jobcostServiceTotal,
          grandTotal : grandTotal || invoiceData?.total,
          newBalanceDue : balanceDue
        };
        console.log('updatedInvoiceData===',updatedInvoiceData)
        setInvoice(updatedInvoiceData);


        const rfqServicesData = updatedInvoiceData?.cust_product?.flatMap(product => {
          console.log('product1234', product)
          return product.services.map(service => ({
            ...service,
            productIndex: product.product_index,
            product_id: product.product_id,
            qtyData: product.quantity,
            locationQuantity: product.locationQuantity || 1,
            productName :product?.product_name
    
          }));
        });
        let labourInstallData =rfqServicesData?.filter(item =>item.labour_cost_service_id == 10)
        setLabourInstallService(labourInstallData)

        setCommunities(res.data.community)

        let rfqCommunity = res.data.community?.find(com => details.community === com.id)

        if(rfqCommunity){
          const { address, city, state, zip } = rfqCommunity;
          setAdditionalSelectedServices((prevServices) =>
            prevServices.map((service) => {
              const updatedAddresses = service.addresses.map((loc) => ({
                ...loc,
                address: address || loc.address,
                city: city || loc.city,
                state: state || loc.state,
                zip: zip || loc.zip,
              }));
              return { ...service, makeAsTask: service?.makeAsTask_lcs, makeInstallCard: service?.makeInstallCard_lcs, addresses: updatedAddresses };
            })
          );
        }

        return res.data;
      }
    } catch (error) {
      console.error('Error fetching request details:', error);
      throw error;
    }
    finally{
      setLoadingEdit(false)
    }
  };

  // useEffect(()=>{

    
  //   let rfqCommunity = communities?.find(com => details.community === com.id)
  //   console.log("additionalSelectedServicesrfqCommunity",rfqCommunity)
  //   console.log("additionalSelectedServicesadditionalSelectedServices",additionalSelectedServices)

  //   if(rfqCommunity){
  //     const { address, city, state, zip } = rfqCommunity;
  //     setAdditionalSelectedServices((prevServices) =>
  //       prevServices.map((service) => {
  //         const updatedAddresses = service.addresses.map((loc) => ({
  //           ...loc,
  //           address: address || loc.address,
  //           city: city || loc.city,
  //           state: state || loc.state,
  //           zip: zip || loc.zip,
  //         }));
  //         return { ...service, addresses: updatedAddresses };
  //       })
  //     );
  //   }

  //   assignProjectAgain()

  // },[communities,details,loadingEdit])

  const assignProjectAgain = (rfqCommunity, shouldCallAssignProject, shouldCallAssignProjectRFP) => {
    console.log('New Value:', rfqCommunity);
    const { address, city, state, zip } = rfqCommunity;
    if (shouldCallAssignProject) {
      setAdditionalSelectedServices((prevServices) =>
        prevServices.map((service) => {
          const updatedAddresses = service.addresses?.map((loc) => ({
            ...loc,
            address: address ?? loc.address,
            city: city ?? loc.city,
            state: state ?? loc.state,
            zip: zip ?? loc.zip,
          })) ?? []; // Ensures addresses is never undefined
  
          return { ...service, addresses: updatedAddresses };
        })
      );
    }
    if (shouldCallAssignProjectRFP) {
      setCartService((prevServices) =>
        prevServices.map((service) => {
          const updatedAddresses = service.addresses?.map((loc) => ({
            ...loc,
            address: address ?? loc.address,
            city: city ?? loc.city,
            state: state ?? loc.state,
            zip: zip ?? loc.zip,
          })) ?? []; 
  
          return { ...service, addresses: updatedAddresses };
        })
      );
    }
  };

  const handleSendEmail = async () => {
    try {
      let orderId = details?.id;
      const res = await axios.post(`${REST_API}webservice/settings/send-mail`, { id: orderId, allInstallationCompleted:details?.allInstallationCompleted || null });

      if (res.data.status === 1) {
        enqueueSnackbar('Email send successfully', { variant: 'success' });
        setOpenInvoice(false)
      }
      return res.data;
    } catch (error) {
      console.error('Error fetching request details:', error);
      throw error;
    }
  };
  const fetchRequestServicesDetails = async () => {
    try {
      let orderId = details?.id;
      const res = await axios.post(`${REST_API}webservice/get-request-services/${orderId}`);
      setInvoice(res.data.data);
      return res.data.data;
    } catch (error) {
      console.error('Error fetching request details:', error);
      throw error;
    }
  };


  const addingInitialdataRFQ = async () => {
    setLoadingEdit(true)
    try {
      if (openEdit) {
        let servicesArray = details?.services?.split(',')?.map(Number);
        let workflowSet = details?.workflows?.split(',')?.map(Number);
        const newInvoiceData = await fetchOrderProductDetails();
        const invoiceData = newInvoiceData?.data
        const communityData = newInvoiceData?.community
        const rfqTaxCategory = taxCategories?.find(cat => invoiceData.tax_category === cat.id) || null
        setSelectedTaxCategory(rfqTaxCategory)
        // let rfqSkill = skills?.filter((row) => row.id == details?.services);
        // let rfqSkill = skills.filter(skill => servicesArray.includes(skill.id));
        // let rfqWorkFlow = workflow?.filter(skill => workflowSet?.includes(skill.id));
        let rfqProjectType = projectTypes?.find(type => details.project_type === type.id)
        let rfqCustomerData = allClientsEdit?.find(cat => cat?.id === customerData?.customer_id)
        let rfqProjectcategory = projectCategories?.find(cat => details.project_category === cat.id)
        let rfqNOChargeTypes = noChargeType?.find(cat => details.no_charge_type === cat.id)
        let rfqMarkupType = markupTypes?.find(cat => details?.markup_type === cat.id)
        let rfqMapServices = mapServices?.find(cat=>details?.map_service === cat.id)   
        let rfqCommunity = communityData?.find(com => details.community === com.id)

        // rfqProduct = invoiceData?.cust_product.filter((row) => {
        //   return allProducts.filter(data => data.id == row.product_id)
        // })
        let rfqProduct = [];
        // if(rfqProjectcategory?.name == 'Time & Material'){
        //   rfqProduct = invoiceData?.cust_product?.filter((newItem)=>(newItem.material != 1 && newItem.rfp != 1))?.map((row) => {
        //       return {
        //         ...row,
        //         indexId: row.product_index,
        //         retail_price: row.product_retail_price || row.retail_price || 0,
        //         price:row.product_price || row.price || 0,
        //         expected_cost:0,
        //         expected_total_service_cost:0,
        //         expected_service_cost:0,
        //         expected_material_cost:0,
        //         markAdjType:row.markAdjType

        //       };
        //   }).filter(item => item !== undefined);
        // }else{
          rfqProduct = invoiceData?.cust_product?.filter((row) => row.rfp === 0 && row.material===0)?.map((row) => {
            // let match = allProducts?.find(data => data.id == row.product_id);
            let match = allProducts?.find(
              (data) =>
                data.id == row.product_id &&
                data.facility_id == row.facility_id // ✅ also check facility_id
            );
            console.log('row---------', row)
            if (match) {
              // If a match is found, return a new object with data from allProducts and quantity from invoiceData?.cust_product
              return {
                ...match,
                indexId: row.product_index,
                product_notes: row.product_notes,
                discount: row.discount,
                adjustment: row.adjustment,
                install_cost: row.install_cost,
                quantity: row.quantity,
                location: row.location,
                allLocationSame:row.allLocationSame == 1 ? true : false,
                locationQuantity: row.locationQuantity,
                markAdjType:row.markAdjType,
                fromMapServices : row.map_service == 1 ? true : false,
                is_single_card : row.is_single_card == 1 ? true : false,
                // product_install_cost : row.install_cost || match.install_cost,
                max_price_mi_id:row.materialInvId || null,
                split_percentage: row.split_percentage,
                incoming_split_percentage: row.incoming_split_percentage,
                outgoing_split_percentage: row.split_percentage,
                facility_id: row.facility_id,
              };
            } return undefined;
          }).filter(item => item !== undefined);
        // }

        console.log("####################RFQ", rfqProduct);
        console.log("invoiceData----", invoiceData);

        const highestIndexId = rfqProduct?.reduce((max, product) => {
          return typeof product.indexId === 'number' && product.indexId > max ? product.indexId : max;
        }, 0);

        setIndexCounter(highestIndexId);
        const filteredData = rfqProduct?.filter(item=>item?.fromMapServices == true)
        setSelectedMapserviceProducts(filteredData || [])
        setSelectedProducts(rfqProduct || [])
        


        // let rfpProduct = invoiceData?.cust_product.filter((row) => row.rfp === 1 && row.material===0)
        let rfpProduct = invoiceData?.cust_product.filter((row) => row.rfp === 1)
        console.log('rfpProduct---', rfpProduct)
        let materialsData = invoiceData?.cust_product.filter(row => row.material === 1 && row.rfp === 0);
        console.log('materialsData+++++++++++++++++++++++++++++', materialsData)

        let rfpProductUpdated = rfpProduct?.map(item => ({
          ...item,
          allRfpProductsLocationSame:item.allLocationSame == 1 ? true : false,
        }))
        console.log('rfpProduct---rfpProductUpdated', rfpProductUpdated)

        let materialsWithPrices = materialsData.map((material,index) => {
          let matchedMaterial = materials.find(item => item.id === material.product_id);
          console.log('materialsData+++++++++++++++++++++++++++++', matchedMaterial)
          console.log('materialsData+++++++++++++++++++++++++++++', material)
            const price = material.stock_type === 2
                    ? material.product_price
                    : (matchedMaterial ? matchedMaterial.max_price : material.product_price);
          // let price = material.product_price;
          console.log('materialsData+++++++++++++++++++++++++++++', price)
          return {
            ...material,
            newIndexId: index + 1,
            price,
            inhouse : matchedMaterial ? matchedMaterial.inhouse : 1,
            product_description:matchedMaterial ? matchedMaterial.description : material.description,
          };
        });
        setSelectedMaterials(materialsWithPrices)
        setCart(rfpProductUpdated);
        
        // Store initial data for change detection
        setInitialProducts(rfqProduct || []);
        setInitialMaterials(materialsWithPrices || []);
        setInitialRfpProducts(rfpProductUpdated || []);
        // const rfpServices = rfpServicesEdit?.filter(item => item?.recipe_id === null && item?.rfp === 1);
        const rfpServices = rfpServicesEdit?.filter(item => item?.recipe_id === null && item?.rfp === 1)?.map(serviceItem => ({
          ...serviceItem,
          location: [
            {
              address: serviceItem.address,
              city: serviceItem.city,
              state: serviceItem.state,
              zip: serviceItem.zip,
            }
          ],
        }));

        
        setCartService(rfpServices)
        console.log("####################rfpProduct", rfpProduct);
        console.log("####################rfpServices", rfpServices);



        // const serviceIdArray = details?.labour_cost_services?.split(',')?.map(Number);
        // const rfqServices = invoiceData?.cust_product?.map((row)=>
        //   labourCostServices?.find(data => data.id == row.id)
        // )
        //   const rfqServices = invoiceData?.cust_product?.map(product => {
        //     const productServices = product.services?.map(service => {
        //         const serviceData = labourCostServices.find(data => data.id === service.id);
        //         return serviceData;
        //     });

        //     // Return an object containing product details along with its services
        //     return productServices;
        // });
        const rfqServicesData = invoiceData?.cust_product?.flatMap(product => {
          console.log('product123', product)
          return product.services.map(service => ({
            ...service,
            productIndex: product.product_index,
            product_id: product.product_id,
            qtyData: product.quantity,
            fromMapServices : product.map_service == 1 ? true : false,
            locationQuantity: product.locationQuantity || 0
          }));
        });
        console.log("##################rfqServiceData", rfqServicesData);
        console.log("##################labourCostServices", labourCostServices);
        console.log("##################filteredServices", filteredServices);
        await setSelectedServices(rfqServicesData || [])
        
        // Store initial services for change detection
        setInitialServices(requestServices || []);
        setInitialRfpServices(rfpServices || []);

        const filteredServicesNew = rfqServicesData.length === 0
          ? labourCostServices
          : labourCostServices.filter((service) => !rfqServicesData.find((selectedService) => selectedService.labour_cost_service_id === service.id));
        // setFilteredServices(filteredServicesNew);

        const additionalServices = requestServices?.filter(item => item?.recipe_id === null);
        const additionalServicesData = additionalServices || [];
        let newIndexCounter = serviceIndexCounter
        const updatedServicesData = additionalServicesData?.map((serviceItem, index) => {
          newIndexCounter = newIndexCounter + 1
          setServiceIndexCounter(newIndexCounter);
          console.log('newIndexCounter-------',newIndexCounter)
          return {
            ...serviceItem,
            indexId:newIndexCounter,
            newIndexId:index+1,
            productId : serviceItem.labour_cost_service_id,
            makeAsTask: serviceItem?.makeAsTask_lcs, 
            makeInstallCard: serviceItem?.makeInstallCard_lcs,
            addresses: [
              {
                address: serviceItem.address,
                city: serviceItem.city,
                state: serviceItem.state,
                zip: serviceItem.zip,
              }
            ]
          };
        });
        console.log('updatedServicesData----',updatedServicesData);
        
        setAdditionalSelectedServices(updatedServicesData);

        const shouldCallAssignProject = (updatedServicesData ?? []).some((service) =>
          (service.addresses ?? []).some((loc) =>
            loc.address == null || loc.city == null || loc.state == null || loc.zip == null
          )
        );
        
        const shouldCallAssignProjectRFP = (rfpServices ?? []).some((service) =>
          (service.addresses ?? []).some((loc) =>
            loc.address == null || loc.city == null || loc.state == null || loc.zip == null
          )
        );
        
        if(rfqCommunity && (shouldCallAssignProject || shouldCallAssignProjectRFP)){
          assignProjectAgain(rfqCommunity, shouldCallAssignProject, shouldCallAssignProjectRFP);
        }
      
        setCurrentRFQdata({
          name: details?.name,
          description: details?.description,
          notes: details?.notes,

          // skills: rfqSkill,
          // workflow: rfqWorkFlow,
          client:rfqCustomerData,
          project_category: rfqProjectcategory,
          catalog_type : details?.catalog_type,
          no_charge_type: rfqNOChargeTypes,
          markup_type: rfqMarkupType,
          community: rfqCommunity,
          map_service: rfqMapServices,
          project_type: rfqProjectType,
          start: details?.submission_deadline,
          end: details?.participation_ends,
          installation_start_date: details?.installation_start_date,
          installation_end_date: details?.installation_end_date,
          labour_cost: details?.labour_cost,
          budget: invoiceData?.budget || 0,
          products: rfqProduct || null,
          services: additionalServicesData || null,
          invoice_discount: invoiceData?.extra_discount,
          welcome_message: details?.welcome_message == 1 ? true : false || null,
          total: invoiceData?.total,
          taxAmount: invoiceData?.taxAmount || 0,
          tax: invoiceData?.tax,
          draft: details?.status == 1 ? true : false || null,
          sub_total: invoiceData?.sub_total,
          order_id: invoiceData?.id,
          subject: details?.subject || null,
          email_content: details?.email_content || null,
          estimate_id:details?.estimate_id,
          // avatarUrl:details?.thumbnail||null,
          facility_type: typeof details?.facility_type === 'string' && details.facility_type
          ? details.facility_type.split(',').map(id => 
              FacilityTypes.find(type => type.id == id.trim())
            ).filter(Boolean)
          : Array.isArray(details?.facility_type) 
            ? details.facility_type 
            : [],
        });
      }
    } catch (error) {
      console.error('Error adding initial data for Sales Order:', error);
    } finally {
      setTimeout(() => {
        setLoadingEdit(false)
      }, 3000);
    }
  };

  useEffect(() => {
    if (details) {
      fetchOrderProductDetails();
    
 if(details?.is_service_location ==1 || details?.is_service_location !=0) {
      setAllServiceLocationSame(true)
    }else{
      setAllServiceLocationSame(false)
    }

    if(details?.is_rfp_service_location == 1){
      setAllRfpServiceLocationSame(true)
    }else{
      setAllRfpServiceLocationSame(false)
    }
    if(details?.is_rfp_product_location == 1){
      setAllRfpProductsLocationSame(true)
    }else{
      setAllRfpProductsLocationSame(false)
    }
   
  }
  }, [details]);

  useEffect(() => {
    setLoadingEdit(true)
    addingInitialdataRFQ();
    setTimeout(() => {
      setLoadingEdit(false)
    }, 3000)
  }, [openEdit]);

    
  useEffect(() => {
    if (Array.isArray(jobNoteMembers) && user?.user_id) {
      const found = jobNoteMembers?.some(member => member.user_id === user.user_id);
      setIsMember(found);
    }
  }, [jobNoteMembers, user?.user_id]);

  // The below useEffect is used for fetching the invoice details only
  useEffect(() => {
    fetchOrderProductDetails();
    console.log('requestServices--', requestServices);

    const rfqServicesData = invoice?.cust_product?.flatMap(product => {
      console.log('product1234', product)
      return product.services.map(service => ({
        ...service,
        productIndex: product.product_index,
        product_id: product.product_id,
        qtyData: product.quantity,
        locationQuantity: product.locationQuantity || 1,
        productName :product?.product_name

      }));
    });
    let labourInstallData =rfqServicesData?.filter(item =>item.labour_cost_service_id == 10)
    setLabourInstallService(labourInstallData)
    console.log("##################rfqInvoiceServiceData", rfqServicesData);
    const newrfqServicesData = rfqServicesData?.filter(item => {
      const newQty = parseFloat((item.prQty * item.qtyData * item.locationQuantity)?.toFixed(2));
      console.log('rfqInvoiceServiceDatanewQty-----------', newQty);
      console.log('rfqInvoiceServiceDataitem.qty-----------', item.qty);
      return newQty !== item.qty;
    }).map(item => {
      const newQty = item.prQty * item.qtyData * item.locationQuantity;
      let quantityDifference = 0;
      if(details?.job_category_name === 'Time & Material'){
        quantityDifference = 0;
      }else{
        quantityDifference = item.qty - newQty;
      }
      return {
        ...item,
        quantity: quantityDifference,
        quantityDifference: quantityDifference,
        total_cost: item.unit_cost * quantityDifference
      };
    });

    console.log('newrfqServicesData-------', newrfqServicesData);

    setInvoiceSelectedServices(newrfqServicesData || [])

    const additionalServices = requestServices?.filter(item => item?.recipe_id === null);
    const additionalServicesData = additionalServices || [];
    const updatedServicesData = additionalServicesData?.map((serviceItem)=>{
      return{
        ...serviceItem,
        productId : serviceItem.labour_cost_service_id,
        makeAsTask: serviceItem?.makeAsTask_lcs, 
        makeInstallCard: serviceItem?.makeInstallCard_lcs,
        addresses: [
          {
            address: serviceItem.address,
            city: serviceItem.city,
            state: serviceItem.state,
            zip: serviceItem.zip,
          }
        ]
      }
    })
    console.log('updatedServicesData----',updatedServicesData);
    setAdditionalSelectedServices(updatedServicesData);
    const rfpServices = rfpServicesEdit?.filter(item => item?.recipe_id === null && item?.rfp === 1);
   
    setCartService(rfpServices)
  }, [openInvoice]);



  const invoiceDate = moment.unix(details?.timestamp).format('MM/DD/YYYY')

  //edit rfq
  const handleEditClick = () => {
    // setOpenEdit(!openEdit)
    setOpenEdit(true)

  }
  const handleDeleteMenu = () => {
    setOpenDelete(!openDelete)
  }
  const handleReopen = () => {
    setReopen(!reOpen)
  }

  const addNewProductRow = () => {
    const newIndexCounter = indexCounter + 1
    setIndexCounter(newIndexCounter)
    const { address: projAddress = '', city: projCity = '', state: projState = '', zip: projZip = '' } = values?.community || {};
    // Auto-populate addresses from the selected Project
    const newAddresses = [{
      id: 0,
      address: projAddress,
      city: projCity,
      state: projState,
      zip: projZip
    }];
  
    setSelectedProducts((prevProducts) => {
    // if (allLocationSame && prevProducts.length > 0) {
    //     const commonAddress = { ...prevProducts[0].addresses[0] } || {
    //     address: '',
    //     city: '',
    //     state: '',
    //     zip: '',
    //     };
    //     newAddresses[0] = commonAddress;
    // }
    return [
    ...prevProducts,
    { 
        indexId: newIndexCounter, 
        name: '', 
        quantity: 1, 
        price: 0,
        retail_price:0, 
        adjustment:0,
        unit:4,
        locationQuantity: 1, 
        expected_total_service_cost:0,
        expected_service_cost:0,
        expected_material_cost:0,
        discount: 0 ,
        allLocationSame: true,
        service:[],
        isAdditionalProduct:true,
        location: newAddresses,
        is_single_card:values?.project_category?.id !==14 ? true : false
    },
    ]});
  };

  // const addNewServiceRow = () => {
  //   const { address: projAddress = '', city: projCity = '', state: projState = '', zip: projZip = '' } = values?.community || {};
  //   // Auto-populate addresses from the selected Project
  //   const newAddresses = [{
  //     id: 0,
  //     address: projAddress,
  //     city: projCity,
  //     state: projState,
  //     zip: projZip
  //   }];

  //   setAdditionalSelectedServices((prevServices) => {
  //     return [
  //       ...prevServices,
  //       {  
  //         id:null,
  //         newIndexId: prevServices?.length + 1,
  //         name: '', 
  //         avatarUrl: null,
  //         quantity: 1, 
  //         cost: 0,
  //         markup: 0, 
  //         workflow: null,
  //         originalMarkup: 0, 
  //         service_type: null,
  //         total_cost:0,
  //         product_total:0,
  //         allLocationSame: true,
  //         isAdditionalProduct:true,
  //         addresses: newAddresses,
  //       }
  //     ]
  //   });
  // };

  const addNewServiceRow = () => {
    const {
      address: projAddress = '',
      city: projCity = '',
      state: projState = '',
      zip: projZip = ''
    } = values?.community || {};
  
    const newAddresses = [{
      id: 0,
      address: projAddress,
      city: projCity,
      state: projState,
      zip: projZip
    }];
  
    setAdditionalSelectedServices((prevServices) => {
      const maxId = prevServices.reduce(
        (max, item) => Math.max(max, item.newIndexId || 0),
        0
      );
  
      return [
        ...prevServices,
        {
          id: null,
          newIndexId: maxId + 1,
          // newIndexId: prevServices?.length + 1,
          name: '',
          avatarUrl: null,
          quantity: 1,
          cost: 0,
          markup: 0,
          workflow: null,
          originalMarkup: 0,
          service_type: null,
          total_cost: 0,
          product_total: 0,
          allLocationSame: true,
          isAdditionalProduct: true,
          addresses: newAddresses,
        }
      ];
    });
  };

  
  // const addNewMaterialRow = () => {
  //   setSelectedMaterials((prevProducts) => {
  //   return [
  //   ...prevProducts,
  //   { 
  //     newIndexId: prevProducts?.length + 1,
  //     quantity: 1, 
  //     allLocationSame: true,
  //     isAdditionalProduct:true,
  //     description: '',
  //     finishedProductQty: 0,
  //     markUpCost: 0,
  //     markup: 0,
  //     material_types: 1,
  //     max_price: null,
  //     max_value: 10,
  //     meterial: 1,
  //     min_value: 1,
  //     name: '',
  //     partial: 0,
  //     partialProductQty: 0,
  //     pf_retail_markup: null,
  //     price: 0,
  //     recipe_id: null,
  //     retail_price: 0,
  //     special_price: 0,
  //     tags: '',
  //     tax: null,
  //     tax_category: 0,
  //     total_qty: 0,
  //     twilio_field_value_sid: null,
  //     unit: 4,
  //     unit_qty: 0,
  //     vendor_id: '',
  //     vpt_number: '',
  //     workflow: null,
  //   },
  //   ]});
  // };

  const addNewMaterialRow = () => {
    setSelectedMaterials((prevProducts) => {
      const maxId = prevProducts.reduce(
        (max, item) => Math.max(max, item.newIndexId || 0),
        0
      );
  
      return [
        ...prevProducts,
        {
          newIndexId: maxId + 1,
          // newIndexId: prevProducts?.length + 1,
          quantity: 1,
          allLocationSame: true,
          isAdditionalProduct: true,
          description: '',
          finishedProductQty: 0,
          markUpCost: 0,
          markup: 0,
          material_types: 1,
          max_price: null,
          max_value: 10,
          meterial: 1,
          min_value: 1,
          name: '',
          partial: 0,
          partialProductQty: 0,
          pf_retail_markup: null,
          price: 0,
          product_price:0,
          recipe_id: null,
          retail_price: 0,
          special_price: 0,
          tags: '',
          tax: null,
          tax_category: 0,
          total_qty: 0,
          twilio_field_value_sid: null,
          unit: 4,
          unit_qty: 0,
          vendor_id: '',
          vpt_number: '',
          product_retail_price:0,
          workflow: null,
        }
      ];
    });
  };
  

  // const handleProduct = (value) => {
  
  //   // Extract community address from Formik's values
  //   const { address: projAddress = '', city: projCity = '', state: projState = '', zip: projZip = '' } = values?.community || {};
  //   const communityAddress = { address: projAddress, city: projCity, state: projState, zip: projZip };
  
  //   setSelectedProducts((prevProducts) => {
  
  //     // Determine common address if allLocationSame is enabled
  //     const commonAddress = allLocationSame && prevProducts.length > 0
  //       ? { ...prevProducts[0].location[0] }
  //       : null;
  
  //     const updatedProducts = value.map((product) => {
  //       const dataRetailPrice = product.product_retail_price || product.retail_price;
  //       const dataWholesalePrice = product.product_price || product.price || 0;
  
  //       // Check if the product already exists in the selected products
  //       const existingProduct = prevProducts.find((p) =>
  //         (p.id === product.id || p.id === product.product_id) &&
  //         p.indexId !== undefined &&
  //         p.indexId === product.indexId
  //       );
  
  //       console.log("###############ExistingProduct", existingProduct);
  
  //       if (existingProduct) {
  //         // Update existing product's quantity and location
  //         const quantity = existingProduct.quantity;
  //         const locationQuantity = existingProduct.locationQuantity;
  //         const marketingAdjustment = Number(existingProduct?.adjustment);
  
  //         // Preserve existing address if it exists, otherwise assign dynamically
  //         const location = existingProduct.location?.[0] || commonAddress || {
  //           id: 0,
  //           address: communityAddress.address || '',
  //           city: communityAddress.city || '',
  //           state: communityAddress.state || '',
  //           zip: communityAddress.zip || '',
  //         };
  
  //         const rowTotal = calculateTotal(
  //           markupType === 1 ? dataWholesalePrice : markupType === 2 ? dataRetailPrice : 0,
  //           product.dataQuantity,
  //           product.dataDiscount,
  //           quantity,
  //           locationQuantity,
  //           marketingAdjustment
  //         );
  
  //         return {
  //           ...existingProduct,
  //           quantity,
  //           rowTotal,
  //           location: [location], // Ensure location is always an array
  //         };
  //       } else {
  //         // Add new product with default quantity and location
  //         const location = commonAddress || {
  //           id: 0,
  //           address: communityAddress.address || '',
  //           city: communityAddress.city || '',
  //           state: communityAddress.state || '',
  //           zip: communityAddress.zip || '',
  //         };
  
  //         const newIndexCounter = indexCounter + 1;
  //         setIndexCounter(newIndexCounter);
  
  //         return {
  //           ...product,
  //           indexId: newIndexCounter,
  //           quantity: 1,
  //           locationQuantity: 1,
  //           discount: 0,
  //           adjustment: 0,
  //           markAdjType: 1,
  //           rowTotal: calculateTotal(
  //             markupType === 1 ? dataWholesalePrice : markupType === 2 ? dataRetailPrice : 0,
  //             product.dataQuantity,
  //             product.dataDiscount,
  //             1,
  //             1,
  //             0
  //           ),
  //           location: [location],
  //         };
  //       }
  //     });
  //     // Merge products from selectedMapserviceProducts with fromMapServices = true into the value
  //     const allSelectedProducts = [
  //       ...updatedProducts,
  //       ...selectedMapserviceProducts?.filter(product => product?.fromMapServices == true)
  //     ];
  //     const productServices = allSelectedProducts?.reduce((services, product) => {
  //       console.log("updatedProducts--product---------", product);
  //       if (product.services && product.services.length > 0) {
  //         return services.concat(
  //           product.services.map((service) => ({
  //             ...service,
  //             fromMapServices: product?.fromMapServices,
  //             productIndex: product.indexId,
  //             locationQuantity: 1,
  //           }))
  //         );
  //       }
  //       return services;
  //     }, []);
  
  //     setSelectedServices((prevServices) => {
  //       const filteredProductServices = productServices.filter((service) => {
  //         console.log("productServices-----service--", service);
  //         return !prevServices.some(
  //           (existingService) =>
  //             existingService?.labour_cost_service_id === service?.id &&
  //             existingService?.recipe_id === service?.recipe_id &&
  //             existingService?.product_id === service?.product_id &&
  //             existingService?.productIndex === service?.productIndex
  //         );
  //       });
  
  //       let updatedServices = prevServices.map((service) => ({
  //         ...service,
  //         quantity: service.quantity || 1,
  //         locationQuantity: service.locationQuantity || 1,
  //       }));
  
  //       updatedServices = updatedServices.filter((existingService) =>
  //         productServices.some(
  //           (service) =>
  //             (existingService?.labour_cost_service_id === service?.id ||
  //               existingService?.id === service?.id) &&
  //             existingService?.recipe_id === service?.recipe_id &&
  //             existingService?.product_id === service?.product_id &&
  //             existingService?.productIndex === service?.productIndex
  //         )
  //       );
  
  //       const filteredProductServicesUnique = filteredProductServices.filter((service) => {
  //         console.log("filteredProductServicesUnique--service---", service);
  //         return !updatedServices.some(
  //           (existingService) =>
  //             (existingService?.labour_cost_service_id === service?.id ||
  //               existingService?.id === service?.id) &&
  //             existingService?.recipe_id === service?.recipe_id &&
  //             existingService?.product_id === service?.product_id &&
  //             existingService?.productIndex === service?.productIndex
  //         );
  //       });
  
  //       return updatedServices.concat(filteredProductServicesUnique);
  //     });
  
  //     const filteredServices =
  //       productServices.length === 0
  //         ? labourCostServices
  //         : labourCostServices.filter(
  //             (service) =>
  //               !productServices.find(
  //                 (selectedService) => selectedService.id === service.id
  //               )
  //           );
  //     setFilteredServices(filteredServices);
  
  //     let initialServicesCost = 0;
  //     if (updatedProducts.length > 0) {
  //       initialServicesCost = updatedProducts.reduce((total, data) => {
  //         return (
  //           total +
  //           data.quantity *
  //             parseFloat(data.expected_total_service_cost?.toFixed(2))
  //         );
  //       }, 0);
  //     }
  
  //     setInitialServiceCostInProductFormula(initialServicesCost);
  //     return allSelectedProducts;
  //   });
  // };

  const handleProduct = (value) => {
  console.log('handleProduct---value--', value)
  console.log('handleProduct---selectedProducts--', selectedProducts)
  
    // Extract community address from Formik's values
    const { address: projAddress = '', city: projCity = '', state: projState = '', zip: projZip = '' } = values?.community || {};
    const communityAddress = { address: projAddress, city: projCity, state: projState, zip: projZip };
  
    setSelectedProducts((prevProducts) => {
  
      // Determine common address if allLocationSame is enabled
      // const commonAddress = allLocationSame && prevProducts.length > 0
      //   ? { ...prevProducts[0].location[0] }
      //   : null;
      const commonAddress = null;
      
      const updatedProducts = value.map((product) => {
        const dataRetailPrice = product.product_retail_price || product.retail_price;
        const dataWholesalePrice = product.product_price || product.price || 0;
  
        // Check if the product already exists in the selected products
        const existingProduct = prevProducts.find((p) =>
          (p.id === product.id || p.id === product.product_id) &&
          p.indexId !== undefined &&
          p.indexId === product.indexId
        );
  
        console.log("###############ExistingProduct", existingProduct);
  
        if (existingProduct) {
          // Update existing product's quantity and location
          const quantity = existingProduct.quantity;
          const locationQuantity = existingProduct.locationQuantity;
          const marketingAdjustment = Number(existingProduct?.adjustment);
          let location = [...existingProduct.location];
          // Preserve existing address if it exists, otherwise assign dynamically

          if (allLocationSame && commonAddress) {
            // Overwrite all location with the "common" location (from the first product)
            location = [...commonAddress];
          } else {
              // Ensure at least one address object
              for (let i = location.length; i < 1; i++) {
                location.push({
                  id: i,
                  address: '',
                  city: '',
                  state: '',
                  zip: '',
              });
              }
          }
  
          const rowTotal = calculateTotal(
            markupType === 1 ? dataWholesalePrice : markupType === 2 ? dataRetailPrice : 0,
            product.dataQuantity,
            product.dataDiscount,
            quantity,
            locationQuantity,
            marketingAdjustment
          );
  
          return {
            ...existingProduct,
            quantity,
            rowTotal,
            location: location, // Ensure location is always an array
          };
        } else {
          // Add new product with default quantity and location
          const location = commonAddress || {
            id: 0,
            address: communityAddress.address || '',
            city: communityAddress.city || '',
            state: communityAddress.state || '',
            zip: communityAddress.zip || '',
          };
  
          const newIndexCounter = indexCounter + 1;
          setIndexCounter(newIndexCounter);
  
          return {
            ...product,
            indexId: newIndexCounter,
            quantity: 1,
            locationQuantity: 1,
            discount: 0,
            allLocationSame: true,
            adjustment: 0,
            markAdjType: 1,
            rowTotal: calculateTotal(
              markupType === 1 ? dataWholesalePrice : markupType === 2 ? dataRetailPrice : 0,
              product.dataQuantity,
              product.dataDiscount,
              1,
              1,
              0
            ),
            location: [location],
          };
        }
      });
      // Merge products from selectedMapserviceProducts with fromMapServices = true into the value
      const allSelectedProducts = [
        ...updatedProducts,
        ...selectedProducts?.filter((item)=>item.isAdditionalProduct == true),
        ...selectedMapserviceProducts?.filter(product => product?.fromMapServices == true)
      ];
      const productServices = allSelectedProducts?.reduce((services, product) => {
        console.log("updatedProducts--product---------", product);
        if (product.services && product.services.length > 0) {
          return services.concat(
            product.services.map((service) => ({
              ...service,
              fromMapServices: product?.fromMapServices,
              productIndex: product.indexId,
              locationQuantity: 1,
            }))
          );
        }
        return services;
      }, []);
  
      setSelectedServices((prevServices) => {
        const filteredProductServices = productServices.filter((service) => {
          console.log("productServices-----service--", service);
          return !prevServices.some(
            (existingService) =>
              existingService?.labour_cost_service_id === service?.id &&
              existingService?.recipe_id === service?.recipe_id &&
              existingService?.product_id === service?.product_id &&
              existingService?.productIndex === service?.productIndex
          );
        });
  
        let updatedServices = prevServices.map((service) => ({
          ...service,
          quantity: service.quantity || 1,
          locationQuantity: service.locationQuantity || 1,
        }));
  
        updatedServices = updatedServices.filter((existingService) =>
          productServices.some(
            (service) =>
              (existingService?.labour_cost_service_id === service?.id ||
                existingService?.id === service?.id) &&
              existingService?.recipe_id === service?.recipe_id &&
              existingService?.product_id === service?.product_id &&
              existingService?.productIndex === service?.productIndex
          )
        );
  
        const filteredProductServicesUnique = filteredProductServices.filter((service) => {
          console.log("filteredProductServicesUnique--service---", service);
          return !updatedServices.some(
            (existingService) =>
              (existingService?.labour_cost_service_id === service?.id ||
                existingService?.id === service?.id) &&
              existingService?.recipe_id === service?.recipe_id &&
              existingService?.product_id === service?.product_id &&
              existingService?.productIndex === service?.productIndex
          );
        });
  
        return updatedServices.concat(filteredProductServicesUnique);
      });
  
      const filteredServices =
        productServices.length === 0
          ? labourCostServices
          : labourCostServices.filter(
              (service) =>
                !productServices.find(
                  (selectedService) => selectedService.id === service.id
                )
            );
      // setFilteredServices(filteredServices);
///////////////////////for additional service filter
      const updatedAdditionalSelectedServices = additionalSelectedServices?.filter(
        (service) => !productServices.some(
          (selectedService) => selectedService.id === service.id
        )
      );
      
      // Now update the state
      setAdditionalSelectedServices(updatedAdditionalSelectedServices);
      setFieldValue('services', updatedAdditionalSelectedServices)
////////////////////////
  
      let initialServicesCost = 0;
      if (updatedProducts.length > 0) {
        initialServicesCost = updatedProducts.reduce((total, data) => {
          return (
            total +
            data.quantity *
              parseFloat(data.expected_total_service_cost?.toFixed(2))
          );
        }, 0);
      }
  
      setInitialServiceCostInProductFormula(initialServicesCost);
      
      // Calculate installation date based on highest lead_time of selected products
      const productsWithLeadTime = allSelectedProducts.filter(product => product.lead_time && product.lead_time > 0);
      
      if (productsWithLeadTime.length > 0) {
        const highestLeadTime = Math.max(...productsWithLeadTime.map(product => product.lead_time));
        const installationDate = moment().add(highestLeadTime, 'days');
        
        // Set only the single installation date field
        setFieldValue('end', installationDate.unix());
      } else {
        // If no products with lead_time, set installation date to current date
        setFieldValue('end', moment().unix());
      }
      
      return allSelectedProducts;
    });
  };
  
  console.log('selectedServices-------', selectedServices);
  console.log("currentttt" , currentRFQData)
  // const handleAllLocationSameChange = () => {

  //   console.log("##################Alllll", allLocationSame);
  //   if (!allLocationSame) {
  //     const commonAddress = selectedProducts[0]?.location[0] || {
  //       address: '',
  //       city: '',
  //       state: '',
  //       zip: '',
  //     };
  //     console.log("##################Alllll", commonAddress);
  //     setSelectedProducts(prevProducts =>
  //       prevProducts.map(product => ({
  //         ...product,
  //         location: product.location.map(() => commonAddress),
  //       }))
  //     );
  //   }
  //   setAllLocationSame(!allLocationSame);
  // };

  // const handleAllServiceLocationSameChange = () => {
  //   console.log("##################Alllll", allServiceLocationSame);
    
  //   if (!allServiceLocationSame) {
  //     // Ensure there's at least one service and its location array is valid
  //     const commonAddress = additionalSelectedServices[0]?.location?.[0] || {
  //       address: '',
  //       city: '',
  //       state: '',
  //       zip: '',
  //     };
  
  //     console.log("Common Address being applied:", commonAddress);
  
  //     // Update all locations to use the commonAddress
  //     setAdditionalSelectedServices(prevProducts =>
  //       prevProducts.map(product => ({
  //         ...product,
  //         location: product.location ? product.location.map(() => ({ ...commonAddress })) : [{ ...commonAddress }],
  //       }))
  //     );
  //   }
  
  //   setAllServiceLocationSame(!allServiceLocationSame);
  // };
  
  const handleAllLocationSameChange = (productIndex) => {
    setSelectedProducts(prevProducts =>
      prevProducts.map((product, index) => {
        if (index === productIndex) {
          console.log('productIndex--1---', index)
          console.log('productIndex--2---', productIndex)

          // Toggle allLocationSame flag
          const isAllSame = !product?.allLocationSame;
          // Get the first address of the selected product
          const commonAddress = product.location[0] || {
            address: '',
            city: '',
            state: '',
            zip: '',
          };
  
          return {
            ...product,
            allLocationSame: isAllSame,
            location: product.location.map(() => commonAddress),
          };
        }
        return product;
      })
    );
  };

  const handleAllServiceLocationSameChange = () => {

    console.log("##################Alllll", allLocationSame);
    if (!allServiceLocationSame) {
      const commonAddress = additionalSelectedServices[0]?.addresses[0] || {
        address: '',
        city: '',
        state: '',
        zip: '',
      };
      setAdditionalSelectedServices(prevProducts =>
        prevProducts.map(product => ({
          ...product,
          addresses: product.addresses.map(() => commonAddress),
        }))
      );
    }
    setAllServiceLocationSame(!allServiceLocationSame);
  };
  
  const handleAllRfpServiceLocationSameChange = () => {
    
    if (!allRfpServiceLocationSame) {
      // Ensure there's at least one service and its location array is valid
      const commonAddress = cartService[0]?.location?.[0] || {
        address: '',
        city: '',
        state: '',
        zip: '',
      };
  
      console.log("Common Address being applied:", commonAddress);
  
      // Update all locations to use the commonAddress
      setCartService(prevProducts =>
        prevProducts.map(product => ({
          ...product,
          location: product.location ? product.location.map(() => ({ ...commonAddress })) : [{ ...commonAddress }],
        }))
      );
    }
  
    setAllRfpServiceLocationSame(!allRfpServiceLocationSame);
  };
  
  // const handleAllRfpProductsLocationSameChange = () => {
    
  //   if (!allRfpProductsLocationSame) {
  //     // Ensure there's at least one service and its location array is valid
  //     const commonAddress = cart[0]?.location?.[0] || {
  //       address: '',
  //       city: '',
  //       state: '',
  //       zip: '',
  //     };
  
  //     console.log("Common Address being applied:", commonAddress);
  
  //     // Update all locations to use the commonAddress
  //     setCart(prevProducts =>
  //       prevProducts.map(product => ({
  //         ...product,
  //         location: product.location ? product.location.map(() => ({ ...commonAddress })) : [{ ...commonAddress }],
  //       }))
  //     );
  //     setAllRfpProductsLocationSame(true);

  //   }else{

  //     setAllRfpProductsLocationSame(false);
  //   }
  
  // };
  
  const handleAllRfpProductsLocationSameChange = (productIndex) => {
    setCart(prevProducts =>
      prevProducts.map((product, index) => {
        if (index === productIndex) {
          const isAllSame = !product.allRfpProductsLocationSame;
  
          // Ensure there's at least one valid address and it matches `location_quantity`
          const locationQuantity = product.location_quantity || 1;
          const commonAddress = product?.location?.[0] || {
            address: '',
            city: '',
            state: '',
            zip: '',
          };
  
          console.log("Common Address being applied:", commonAddress);
  
          return {
            ...product,
            allRfpProductsLocationSame: isAllSame,
            location: isAllSame 
              ? Array.from({ length: locationQuantity }, () => ({ ...commonAddress }))
              : Array.from({ length: locationQuantity }, () => ({ ...commonAddress })),
              // : Array.from({ length: locationQuantity }, () => ({ address: '', city: '', state: '', zip: '' })),
          };
        }
        return product;
      })
    );
  };

  const handleDeleteProduct = (productId, indexId) => {
    setCheckLength(!checkLength)
    const fileredProduct = selectedProducts.filter(data => !((data.id || data.product_id) === productId && data.indexId === indexId))
    setFieldValue('products', fileredProduct);
    setSelectedProducts(fileredProduct)
    const quantityFieldName = `quantity_${productId}`;
    const discountFieldName = `discount_${productId}`;
    setFieldValue(quantityFieldName, 1);
    setFieldValue(discountFieldName, 1);
    console.log('fileredProduct-------', fileredProduct);
    console.log('selectedServices-------', selectedServices);
    console.log("###############InitialserviceCost", initialServiceCostInProductFormula);
    const filteredServices = selectedServices?.filter(service => {
      // Check if there is any product in fileredProduct array which contains the service
      return fileredProduct?.some(product => (
        product?.recipe_id === service?.recipe_id &&
        product?.id === service?.product_id &&
        product?.indexId === service?.productIndex
      ));
    });


    setSelectedServices(filteredServices);

    setSelectedServices(filteredServices);
    let initialServicesCost = 0
    if (fileredProduct.length > 0) {
      initialServicesCost = fileredProduct?.reduce((total, data, index) => {
        return total + ((data?.quantity) * (parseFloat(data?.expected_total_service_cost?.toFixed(2))));
      }, 0);
    }
    console.log('initialServiceCost In ProductFormula-----', initialServicesCost);
    setInitialServiceCostInProductFormula(initialServicesCost)
    
    // Recalculate installation date based on remaining products
    const productsWithLeadTime = fileredProduct.filter(product => product.lead_time && product.lead_time > 0);
    
    if (productsWithLeadTime.length > 0) {
      const highestLeadTime = Math.max(...productsWithLeadTime.map(product => product.lead_time));
      const installationDate = moment().add(highestLeadTime, 'days');
      
      // Set only the single installation date field
      setFieldValue('end', installationDate.unix());
    } else {
      // If no products with lead_time remain, reset installation date to current date
      setFieldValue('end', moment().unix());
    }

  }

  const handleDeleteInstallCost = (productId, indexId) => {
    // Remove only the install_cost from the product, keeping the product itself
    const updatedProducts = selectedProducts?.map((product) => {
      if (product.id === productId && product.indexId === indexId) {
        return {
          ...product,
          install_cost: null, // or 0, depending on your preference
          // product_install_cost :null,
          original_install_cost:null,
          expected_install_labor_cost :null,
          // product_total:product.actual_retail_price * product.locationQuantity,
          // product_sub_total:product.actual_retail_price * product.locationQuantity,
          retail_price:product.actual_retail_price * product.locationQuantity,
        };
      }
      return product;
    });
    
    setSelectedProducts(updatedProducts);
    setFieldValue('products', updatedProducts);
  };

  const assignServiceAddresses = (existingServices, newService, allServiceLocationSame, communityAddress) => {
    let assignedAddresses = [];
  
    if (allServiceLocationSame && existingServices.length > 0) {
      // Use the first service's address as the common address
      const commonAddress = existingServices[0]?.addresses[0] || {
        address: '',
        city: '',
        state: '',
        zip: '',
      };
      assignedAddresses = [{ ...commonAddress }];
    } else if (
      communityAddress.address &&
      communityAddress.city &&
      communityAddress.state &&
      communityAddress.zip
    ) {
      // Assign the community address if available
      assignedAddresses = [
        {
          id: 0,
          address: communityAddress.address,
          city: communityAddress.city,
          state: communityAddress.state,
          zip: communityAddress.zip,
        },
      ];
    } else {
      // Default to an empty address
      assignedAddresses = [
        {
          id: 0,
          address: '',
          city: '',
          state: '',
          zip: '',
        },
      ];
    }
  
    return {
      ...newService,
      addresses: assignedAddresses,
    };
  };
console.log('details++++++++++', details)

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: currentRFQData.name || '',
      description: currentRFQData.description || '',
      notes: currentRFQData.notes || '',
      // skills: currentRFQData.skills || [],
      // workflow: currentRFQData.workflow || [],
      clients:currentRFQData.client || null,
      project_type: currentRFQData.project_type || null,
      project_category: currentRFQData.project_category || null,
      map_service:currentRFQData.map_service || null,
      catalog_type: catalogTypes.find((type) => type.id === currentRFQData?.catalog_type) || null,
      split_catalog_type: splitOrderCatalogTypes.find((type) => type.id === currentRFQData?.split_catalog_type) || null, // New field for split order catalog type
      community: currentRFQData.community || null,
      start: currentRFQData.start || currentDate,
      end: currentRFQData.end || currentDate,
      installation_start_date: currentRFQData.installation_start_date || null,
      installation_end_date: currentRFQData.installation_end_date || null,
      // avatarUrl: currentRFQData.avatarUrl||'',
      products: currentRFQData.products || [],
      services: currentRFQData.services || [],
      markup_type: currentRFQData.markup_type || null,
      no_charge_type: currentRFQData.no_charge_type || null,
      invoice_discount: currentRFQData.invoice_discount || '',
      welcome_message: currentRFQData.welcome_message || false,
      draft: currentRFQData.draft || false,
      total: currentRFQData.total || '',
      labour_cost: currentRFQData.labour_cost || 0,
      budget: currentRFQData.budget || 0,
      tax: 0,
      client_approve: clientApprove == 0 ? false : true,
      // is_single_card: singleLocationCard  ? true : false,
      order_id: currentRFQData.order_id || '',
      subject: currentRFQData.subject || '',
      email_content: currentRFQData.email_content || '',
      rfp:null,
      estimate_id:currentRFQData.estimate_id,
      editReq:true,
      is_split:isSplitOrder ? { id: 1, label: 'Split' } : null,
      facility_type: typeof currentRFQData?.facility_type === 'string' && currentRFQData.facility_type
      ? currentRFQData.facility_type.split(',').map(id => 
          FacilityTypes.find(type => type.id == id.trim())
        ).filter(Boolean)
      : Array.isArray(currentRFQData?.facility_type) 
        ? currentRFQData.facility_type 
        : [] || FacilityTypes?.filter(fac => fac.default) || [] ,
    },
    validationSchema: NewUserSchema,
    
    onSubmit: async (values, { setSubmitting, resetForm, setErrors }) => {
      try {
        console.log('🎯 onSubmit called with values:', values);
        console.log('🎯 isFromEstimate value:', values.isFromEstimate);
        setIsSubmitted(true);
        const isFromEstimateValue = values?.isFromEstimate !== undefined ? values?.isFromEstimate : details?.isFromEstimate
        // Check for changes when isFromEstimate === 1
        if (isFromEstimateValue === 1) {
          const changes = detectChanges();
          if (changes.length > 0) {
            // Store the submission data for later use
            setPendingSubmission({ values, setSubmitting, resetForm, setErrors });
            setDetectedChanges(changes);
            setShowChangesDialog(true);
            return;
          }
        }
        // if (values.project_category?.name === 'Time & Material') {
        //   const hasEmptyName = selectedProducts?.some(product => {
        //     return !product.product_name?.trim(); // Safe check for empty or undefined product names
        //   });
        //   if (hasEmptyName) {
        //     enqueueSnackbar('Please fill in all required product names.', { variant: 'error' });
        //     return;
        //   }
        //   const hasInvalidName = selectedProducts?.some(product => {
        //     const trimmedName = product.product_name?.trim();
        //     if (trimmedName === '.') {
        //       enqueueSnackbar('Product name cannot be just a dot.', { variant: 'error' });
        //       return true;
        //     }
        //     if (trimmedName === '-') {
        //       enqueueSnackbar('Product name cannot be just a hyphen.', { variant: 'error' });
        //       return true;
        //     }
        //     if (!/^[a-zA-Z0-9\s-]+$/.test(trimmedName)) {
        //       enqueueSnackbar('Product name can only contain letters, numbers, and hyphens.', { variant: 'error' });
        //       return true;
        //     }
        //     if (trimmedName[0] === '.') {
        //       enqueueSnackbar('Product name cannot start with a dot.', { variant: 'error' });
        //       return true;
        //     }
        //     if (trimmedName[0] === '-') {
        //       enqueueSnackbar('Product name cannot start with a hyphen.', { variant: 'error' });
        //       return true;
        //     }
        //     if (trimmedName === '') {
        //       enqueueSnackbar('Product name cannot be empty or just spaces.', { variant: 'error' });
        //       return true;
        //     }
        //     return false;
        //   });          
        //   if (hasInvalidName) {
        //     // enqueueSnackbar('Product names must contain letters or numbers.', { variant: 'error' });
        //     return;
        //   }
        // }
        // Filter out items with id == 10 when project_category.id !== 11
        const filteredAdditionalServices =
        values.project_category?.id !== 11
          ? additionalSelectedServices.filter(item => {
              if (item?.labour_cost_service_id) {
                // Exclude if labour_cost_service_id is 10
                return item.labour_cost_service_id !== 10;
              } else {
                // Exclude if id is 10
                return item.id !== 10;
              }
            })
          : additionalSelectedServices;
          console.log('filteredAdditionalServices', filteredAdditionalServices);
          console.log('filteredAdditionalServices  2', values.project_category?.id );

        const hasEmptyProductName = selectedProducts?.some(product => (product.name || product.product_name || '').trim() === '');
        const hasEmptyServiceName = filteredAdditionalServices?.some(product => product.name.trim() === '');
        const hasEmptyMaterialName = selectedMaterials?.some(product => (product.name || product.product_name || '').trim() === '');

       if(selectedProducts?.length ==0 && additionalSelectedServices?.length == 0 && selectedMaterials?.length ==0 && userType !==3){
          enqueueSnackbar('Please add at least one product or service.', { variant: 'error' });
          return;
        }

        const areAllAdditionalServicesTasks = filteredAdditionalServices.every(item => item.makeAsTask === 0);
        const hasMixedMakeAsTask = !filteredAdditionalServices.every(item => item.makeAsTask === 0 || item.makeAsTask === 1) ||
          (filteredAdditionalServices.some(item => item.makeAsTask === 0) &&
          filteredAdditionalServices.some(item => item.makeAsTask === 1));
        const areAllAdditionalServicesInstalls = filteredAdditionalServices.every(item => item.makeInstallCard === 0);
        const hasMixedMakeInstalls = !filteredAdditionalServices.every(item => item.makeInstallCard === 0 || item.makeInstallCard === 1) ||
          (filteredAdditionalServices.some(item => item.makeInstallCard === 0) &&
          filteredAdditionalServices.some(item => item.makeInstallCard === 1));
        
        // 🛑 Block submission if all tasks are off
        const additionalAllOff = filteredAdditionalServices?.length > 0 && filteredAdditionalServices.every(item => item?.makeInstallCard === 0);

        const cartServiceAllOff = cartService?.length > 0 && cartService.every(item => item?.makeInstallCard_lcs === 0);

        const allInstallCardsOff = (additionalAllOff || !filteredAdditionalServices?.length) && (cartServiceAllOff || !cartService?.length);

        let noServiceNoTask = false;
        // 🛑 Block submission if Service Only job and all tasks are off
        if ( values?.project_category?.id == 11 && allInstallCardsOff && selectedProducts.length == 0) {
          noServiceNoTask = true;
          // setShowMakeTaskErrorDialog(true);
          // return;
        }
        // 🛑 Block submission if T&M job and no products and material is there and all tasks are off
        if (
          values?.project_category?.id == 12 &&
          selectedProducts?.length === 0 &&
          selectedMaterials?.length === 0 &&
          allInstallCardsOff
        ) {
          // noServiceNoTask = true;
          noServiceNoTask = false;
          // setShowMakeTaskErrorDialog(true);
          // return;
        }
        // 🛑 Block submission if No Charge job and no products and material is there and all tasks are off
        if (
          values?.project_category?.id == 13 &&
          selectedProducts?.length === 0 &&
          selectedMaterials?.length === 0 &&
          allInstallCardsOff
        ) {
          noServiceNoTask = true;
          // setShowMakeTaskErrorDialog(true);
          // return;
        }

        // Use this condition inside your if-block
        if (!confirmMakeTask && (areAllAdditionalServicesTasks || areAllAdditionalServicesInstalls) && !hasMixedMakeAsTask && !hasMixedMakeInstalls && filteredAdditionalServices.length > 0 && userType != 3) {
            setOpenMakeTaskDialog(true); // your state for opening dialog
            return;
        }

        if (hasEmptyProductName) {
          enqueueSnackbar('Please fill in all required product names.', { variant: 'error' });
          return;
        }
        if (hasEmptyServiceName) {
          enqueueSnackbar('Please fill in all required service names.', { variant: 'error' });
          return;
        }
        if (hasEmptyMaterialName) {
          enqueueSnackbar('Please fill in all required material names.', { variant: 'error' });
          return;
        }
        const hasInvalidProductName = selectedProducts?.filter(item=>item?.isAdditionalProduct == true)?.some(product => {
          const newName = product.product_name || product.name;
          const trimmedName = newName.trim();
          if (trimmedName === '.') {
            enqueueSnackbar('Product name cannot be just a dot.', { variant: 'error' });
            return true;
          }
          if (trimmedName === '-') {
            enqueueSnackbar('Product name cannot be just a hyphen.', { variant: 'error' });
            return true;
          }
          // if (!/^[a-zA-Z0-9\s-]+$/.test(trimmedName)) {
          //   enqueueSnackbar('Product name can only contain letters, numbers, and hyphens.', { variant: 'error' });
          //   return true;
          // }
          if (/[:]/.test(trimmedName)) {
            enqueueSnackbar('Product name cannot contain colon (:).', { variant: 'error' });
            return true;
          }
          if (trimmedName[0] === '.') {
            enqueueSnackbar('Product name cannot start with a dot.', { variant: 'error' });
            return true;
          }
          if (trimmedName[0] === '-') {
            enqueueSnackbar('Product name cannot start with a hyphen.', { variant: 'error' });
            return true;
          }
          if (trimmedName === '') {
            enqueueSnackbar('Product name cannot be empty or just spaces.', { variant: 'error' });
            return true;
          }
          return false;
        });
        
        const hasInvalidServiceName = filteredAdditionalServices?.filter(item=>item?.isAdditionalProduct == true)?.some(product => {
          const trimmedName = product.name.trim();
          if (trimmedName === '.') {
            enqueueSnackbar('Service name cannot be just a dot.', { variant: 'error' });
            return true;
          }
          if (trimmedName === '-') {
            enqueueSnackbar('Service name cannot be just a hyphen.', { variant: 'error' });
            return true;
          }
          if (/[:]/.test(trimmedName)) {
            enqueueSnackbar('Service name cannot contain colon (:).', { variant: 'error' });
            return true;
          }                
          if (trimmedName[0] === '.') {
            enqueueSnackbar('Service name cannot start with a dot.', { variant: 'error' });
            return true;
          }
          if (trimmedName[0] === '-') {
            enqueueSnackbar('Service name cannot start with a hyphen.', { variant: 'error' });
            return true;
          }
          if (trimmedName === '') {
            enqueueSnackbar('Service name cannot be empty or just spaces.', { variant: 'error' });
            return true;
          }
          return false;
        });
        
        const hasInvalidMaterialName = selectedMaterials?.filter(item=>item?.isAdditionalProduct == true)?.some(product => {
          const newName = product.product_name || product.name;
          const trimmedName = newName.trim();
          if (trimmedName === '.') {
            enqueueSnackbar('Material name cannot be just a dot.', { variant: 'error' });
            return true;
          }
          if (trimmedName === '-') {
            enqueueSnackbar('Material name cannot be just a hyphen.', { variant: 'error' });
            return true;
          }
          if (/[:]/.test(trimmedName)) {
            enqueueSnackbar('Material name cannot contain colon (:).', { variant: 'error' });
            return true;
          }                
          if (trimmedName[0] === '.') {
            enqueueSnackbar('Material name cannot start with a dot.', { variant: 'error' });
            return true;
          }
          if (trimmedName[0] === '-') {
            enqueueSnackbar('Material name cannot start with a hyphen.', { variant: 'error' });
            return true;
          }
          if (trimmedName === '') {
            enqueueSnackbar('Material name cannot be empty or just spaces.', { variant: 'error' });
            return true;
          }
          return false;
        });
        
        if (hasInvalidProductName || hasInvalidServiceName || hasInvalidMaterialName) {
          // enqueueSnackbar('Product names must contain letters or numbers.', { variant: 'error' });
          return;
        }

        // 🛑 Block if only proposal service or proposal exists and project_category is invalid
        if (
          selectedProducts?.length <= 0 &&
          selectedMaterials?.length <= 0 &&
          additionalSelectedServices?.length <= 0 &&
          (cartService?.length > 0 || cart?.length > 0)
        ) {
          if(values.project_category?.id == 11) {
            enqueueSnackbar("Please choose at least one additional service.",{ variant: 'error' });
          }else if(values.project_category?.id == 12 || values.project_category?.id == 13) {
            enqueueSnackbar("Please choose at least one additional service or catalog or material.",{ variant: 'error' });
          }else{
            enqueueSnackbar("Please choose at least one catalog.", { variant: 'error' });
          }
          return;
        }

        if(selectedProducts?.length <= 0 && selectedMaterials?.length <= 0 && additionalSelectedServices?.length > 0 && values.project_category?.id != 11 && values.project_category?.id != 12 && values.project_category?.id != 13 ) {
          enqueueSnackbar("Please select 'Service Only', 'Time & Material', or 'No Charge' as the job type or choose at least one catalog.", { variant: 'error' });
          return;
        }

        if(selectedProducts?.length <= 0 && additionalSelectedServices?.length <= 0 && selectedMaterials?.length > 0 && values.project_category?.id != 12 && values.project_category?.id != 13 ) {
          if(values.project_category?.id == 11) {
            enqueueSnackbar("You have selected 'Service Only'. Please choose at least one additional service or choose 'Time & Material' as the job type.",{ variant: 'error' });
          }else{
            enqueueSnackbar("Please select 'Time & Material' as the job type or choose at least one catalog.", { variant: 'error' });
          }
          return;
        }

        if(selectedProducts?.length <= 0 && additionalSelectedServices?.length > 0 && selectedMaterials?.length > 0 && values.project_category?.id != 11 && values.project_category?.id != 12 && values.project_category?.id != 13 ) {
          enqueueSnackbar("Please select 'Service Only' or 'Time & Material' as the job type or choose at least one catalog.", { variant: 'error' });
          return;
        }
        const request_id = id
        const clientsArray = values.clients ? [values.clients] : [];
        values.clientsData = clientsArray
        values.products = selectedProducts
        values.userName = user.first_name;
        // const allServices = [...selectedServices, ...additionalSelectedServices];
        const allServices = [
          ...selectedServices.map(s => ({ ...s, quantityDifference: 0 })),
          ...additionalSelectedServices
        ];
        const servicesIdArray = allServices?.map(service => service.id);

        values.avatarUrl = avatarUrl

        // values.project_category = values.project_type?.name == 'TS' ? (values.project_category || null) : null
        values.map_service = (values.project_type?.name == 'TS' && (values.project_category && values.project_category?.id == 14)) ? values.map_service : null

        values.services = servicesIdArray?.join(',')
        values.totalMarkup = totalMarkup
        values.selectedServices = allServices
        values.additionalSelectedServices = additionalSelectedServices
        values['labour_cost'] = totalLabourCost;
        const prodAddress= selectedProducts.reduce((acc, product) => {
          return [
            ...acc,
            ...product.location.map((address) => ({
              ...address,
              productId: product.id,
              productIndex: product.indexId,
              isService:0
            })),
          ];
        }, []);
        const serviceAddress= additionalSelectedServices?.reduce((acc, product) => {
          return [
            ...acc,
            ...product.addresses.map((address) => ({
              ...address,
              productId: product.labour_cost_service_id || product.id,
              productIndex: product.indexId,
              newIndexId: product.newIndexId,
              isService:1
            })),
          ];
        }, []);

        const combinedAddress = [...serviceAddress, ...prodAddress];
        const data = {
          values, userId, noServiceNoTask, userType, request_id,
          avalara_transaction_id:details?.avalara_transaction_id,
          avalara_code:details?.avalara_code,
          allLocationSame : (values.project_category?.name == 'Service only' || values.project_category?.name == 'Time & Material') ? false : allLocationSame ,
          allServiceLocationSame : allServiceLocationSame ,
          allRfpServiceLocationSame : allRfpServiceLocationSame ,
          allRfpProductsLocationSame : (values.project_category?.name == 'Service only' || values.project_category?.name == 'Time & Material') ? false : allRfpProductsLocationSame ,
          rfpProducts: cart,
          taxCategory : selectedTaxCategory?.id || null,
          rfpServices: cartService,
          materials:selectedMaterials,
          proj_status: details?.proj_status,
          // address: (values.project_category?.name == 'Service only' || values.project_category?.name == 'Time & Material')  ? serviceAddress : prodAddress
          address: combinedAddress,
           produtFormulaMaterial:produtFormulaMaterial
          // address: selectedProducts.reduce((acc, product) => {
          //   return [
          //     ...acc,
          //     ...product.location.map((address) => ({
          //       ...address,
          //       productId: product.id,
          //       productIndex: product.indexId,
          //     })),
          //   ];
          // }, []),
        }
        let isvalidationNotOk = false
        let isServicevalidationNotOk = false
        // if((values.project_category?.name == 'Service only') || (values?.project_category?.name == 'Time & Material')){
        if(additionalSelectedServices?.length > 0){
          isServicevalidationNotOk = additionalSelectedServices?.find(product => {
            if (product.addresses.length && product.addresses.some(obj =>
              [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
            )) {
              return true
            } else {
              return false
            }
          })
        }
        if((values.project_category?.name != 'Service only') && (values?.project_category?.name != 'Time & Material')){
          isvalidationNotOk = selectedProducts.find(product => {
            if (product.location.length && product.location.some(obj =>
              [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
            )) {
              return true
            } else {
              return false
            }
          })
        }
        values.total = totalsum
        values.taxAmount = taxAmount
        values.sub_total = rfqSubTotal
        values.budget = budget

        const isvalidationNotOkRfp = cart?.find(product => {
          if (product.location.length > 0 && product.location.some(obj =>
            [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
          )) {
            console.log("Validation failed for product:", product);
            return true;
          } else {
            console.log("Validation passed for product:", product);
            return false;
          }
        });

        let isvalidationNotOkRfpServices= false
        // if(values.project_category?.name == 'Service only' || (values?.project_category?.name == 'Time & Material')){
        if(cartService?.length > 0){
          isvalidationNotOkRfpServices = cartService?.find(product => {
            if (product.location.length > 0 && product.location.some(obj =>
              [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
            )) {
              console.log("Validation failed for product:", product);
              return true;
            } else {
              console.log("Validation passed for product:", product);
              return false;
            }
          });
        }

        if(userType != 3 &&
          (values?.project_category?.name == "Time & Material") && 
          // (cart.length <= 0 && cartService?.length <= 0 && additionalSelectedServices?.length <= 0 && selectedProducts?.length <= 0)
          // (cartService?.length <= 0 && additionalSelectedServices?.length <= 0)
          // values.total <= 0
          (cartService?.length <= 0 && additionalSelectedServices?.length <= 0 && selectedMaterials?.length <=0 && selectedProducts?.length <= 0)
        ){
          enqueueSnackbar('Please choose atleast one Service/ Proposal service', { variant: 'error' });
        }else if((values?.project_category?.name != "Time & Material") && (values.total <= 0) && values.project_categories == 15){
          enqueueSnackbar('Please select at least one product, service, Proposal, or material.', { variant: 'error' });
        }else if (
          isvalidationNotOk ||
          isServicevalidationNotOk || 
          isvalidationNotOkRfp || 
          isvalidationNotOkRfpServices 
        ) {
          enqueueSnackbar('Please fill all the address fields', { variant: 'error' });
        } else {
          setFormValues(values);
          setFormDatas(data);
          if(details?.status == 4){
            setOpenDialog(true);
          }else{
            // Show client approval warning popup for any edits
            handleConfirmSubmit(values,data);
          }
        }
      } catch (error) {
        console.error(error);
      }
    }
  });


  const handleConfirmSubmit = async (values=null,data=null) =>{
    setOpenDialog(false);
    setIsSubmitting(true);
    try{
      const formValuesData = values || formValues;
      const formDatasData = data || formDatas;
      console.log('Form Values:', formValuesData);
      console.log('Form Data:', formDatasData);

      // 🚀 PROGRESS TRACKING: Show progress modal and make API call
      const requestData = {
        ...formDatasData,
        quotation: formValuesData?.quotation || 0,
        socketId: null // Will be set by the progress modal
      };

      setProgressHeading("Updating Sales Order");
      setProgressRequestData(requestData);
      setShowProgressModal(true);
      
      // Wait for socket connection to establish and stabilize
      await new Promise(resolve => setTimeout(resolve, 2000));
      
      // Additional wait if socket is not ready yet
      if (!socketReady) {
          console.log('[PROGRESS-MODAL] ⏳ Waiting for socket connection...');
          await new Promise(resolve => setTimeout(resolve, 1000));
      }
      // if(formValuesData.project_category.name =="Time & Material"){ 
      //   const productResponse = await axios.post(`${REST_API_END_POINT}product/add-product-on-request`,{values:formValuesData})

      //   if(productResponse) {
      //     await axios.post(`${REST_API}webservice/edit-request`, formDatasData)
      //     .then((res) => {
      //       setOpenEdit(false)
      //       setIsOpen(false)
      //       setSelectedTaxCategory(null);
      //       setCurrentRFQdata({}) // added on 3-01-2024
      //       setSelectedProducts([])
      //       setSelectedMapserviceProducts([]);
      //       setSelectedServices([]);
      //       setAdditionalSelectedServices([])
      //       setFilteredServices([])
      //       fetchRequestDetailsNew()
      //       fetchRequestDetails()
      //       if (edit) {
      //         navigate(`/dashboard/official-request`)
      //       }
      //       enqueueSnackbar('Update success', { variant: 'success' });
      //       formik.resetForm();
      //       // resetForm();
      //     })
      //     .catch((errors) => {
      //       console.log(errors, 'error')
      //     })
      //   }

      // }else{

        await axios.post(`${REST_API}webservice/edit-request`, formDatasData)
        .then((res) => {
          setOpenEdit(false)
          setIsOpen(false)
          setSelectedTaxCategory(null);
          setCurrentRFQdata({}) // added on 3-01-2024
          setSelectedProducts([])
          setSelectedMapserviceProducts([]);
          setSelectedServices([]);
          setAdditionalSelectedServices([])
          setFilteredServices([])
          fetchRequestDetailsNew()
          fetchRequestDetails()   
          let movedToProduction = res.data.movedToProduction
          console.log('movedToProduction3', movedToProduction)
          const isTimeMaterial = formValuesData?.project_category?.name === "Time & Material"
          if(res.data.checkProjectExist && formValuesData?.client_approve === false){
            // enqueueSnackbar('Invoice approved. Converting to production now...', { variant: 'success' });
            // Don't close modal, just change heading and continue with conversion
            setProgressHeading("Converting to Production");
            handleConvertToJob(true, movedToProduction,isTimeMaterial); // Comment this line to work the previous state of the approved / in production dynamic
          }else if (formValuesData?.project_category?.name === "Time & Material" && formValuesData?.client_approve === false) {
            // Don't close modal, just change heading and continue with conversion
            setProgressHeading("Converting to Production");
            editHandleConvertToJob(movedToProduction,isTimeMaterial)
            // if(popupOn){
            //   onDataChange()
            //   closeView()
            // }
        }else{
          // Close progress modal explicitly to ensure it closes in production
          setShowProgressModal(false);
          if(popupOn){
            localStorage.removeItem('salesOrderProjectId');
            localStorage.removeItem('salesOrderProjectName');
            localStorage.removeItem('isEditSalesOrder');
            localStorage.removeItem('salesOrderOpenPopup',);
            closeView()
            setRenderCards(!renderCards)
            onDataChange()
          }else{
            if (edit) {
              navigate(`/dashboard/official-request`)
            }
          }
        }
          enqueueSnackbar('Update success', { variant: 'success' });
          formik.resetForm();
          // resetForm();
        })
        .catch((errors) => {
          console.log(errors, 'error')
          // Close progress modal on error as well
          setShowProgressModal(false);
        })
      // }
    } catch (error) {
      console.error('Error submitting form:', error);
      enqueueSnackbar('An error occurred during submission.', { variant: 'error' });
      // Close progress modal on error
      setShowProgressModal(false);
    } finally {
      setIsSubmitting(false);
      setFormValues({});
      setFormDatas({});
    }
  }

  const editHandleConvertToJob = async (movedToProduction,isTimeMaterial) => {
    console.log('isTimeMaterial', isTimeMaterial)
    try {
      // setOpenConvertToRFQ(false);
      // setConvertToRFQ(true);
      let requestId = id
      let requestPartnerId = details?.rt_partner_id
      let acceptStatus = 1
      
      // 🚀 PROGRESS TRACKING: Show progress modal and make API call
      const requestData = {
        requestId,
        requestPartnerId,
        acceptStatus,
        userId,
        projectCategoryId: values?.project_category?.id || isTimeMaterial ? 12 : null,
        socketId: null // Will be set by the progress modal
      };

      // If modal is already open (from previous operation), just update the data and continue
      if (showProgressModal) {
        setProgressRequestData(requestData);
        // Don't close and reopen modal, just continue with new data
      } else {
        setProgressHeading("Converting to Production");
        setProgressRequestData(requestData);
        setShowProgressModal(true);
      }

      // Wait for socket connection to establish and stabilize
      await new Promise(resolve => setTimeout(resolve, 2000));

      // Additional wait if socket is not ready yet
      if (!socketReady) {
          console.log('[PROGRESS-MODAL] ⏳ Waiting for socket connection...');
          await new Promise(resolve => setTimeout(resolve, 1000));
      }

      const data = { requestId, requestPartnerId, acceptStatus, userId ,projectCategoryId:values?.project_category?.id || isTimeMaterial ? 12 : null}
      const res = await axios.post(`${REST_API}webservice/request/accept-or-reject-invoice`, data);

      if (res.data.status == 1) {
        // setConfirmInvoice(false)
        // setRejectInvoice(false)
        setShowProgressModal(false);
        enqueueSnackbar('Job created successfully', { variant: 'success' });
        console.log('movedToProduction11', movedToProduction)
        console.log('time and materialssssssssss 2')
        console.log('details?.isSplitOrder',details?.isSplitOrder)
        if( (res.data.allCreatedTask?.length <= 0 && !isTimeMaterial && details?.is_split_order !==1) || (isTimeMaterial && details?.allInstallationCompleted !==1 && details?.project_status == 3)){
          handleConvertJobToInstallation(requestId) // uncomment this if any section breaks
        }
      } else {
        // setConfirmInvoice(false)
        // setRejectInvoice(false)
        setShowProgressModal(false);
        enqueueSnackbar('Failed to convert Sales Order to Job', { variant: 'error' });
      }
      if(popupOn){
        localStorage.removeItem('salesOrderProjectId');
        localStorage.removeItem('salesOrderProjectName');
        localStorage.removeItem('isEditSalesOrder');
        localStorage.removeItem('salesOrderOpenPopup',);
        closeView()
        setRenderCards(!renderCards)
        onDataChange()
      }else{
        if (edit) {
          navigate(`/dashboard/official-request`)
        }
      }
    } catch (error) {
      console.log(error, 'error in Converting Sales Order to job')
      // setConfirmInvoice(false)
      // setRejectInvoice(false)
      setShowProgressModal(false);
      enqueueSnackbar('Server Error', { variant: 'error' })
    }
    // finally{
    //   setConvertToRFQ(false);
    // }
  }

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleUpdateSalesOrderHoldStatus = async (reason) => {
    try {
      const res = await axios.post(
        `${REST_API_END_POINT}sales_order/update-sales-order-hold-status`,
        {
          request_id: details?.id,
          userId: user.user_id,
          reason: reason || '',
        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );
      if (res.data.status === 1) {
        enqueueSnackbar(res.data.message, { variant: 'success' });
        fetchRequestDetailsNew();
        fetchRequestDetails();
      } else {
        enqueueSnackbar(res.data.message, { variant: 'error' });
      }
    } catch (error) {
      console.error('Error updating hold status:', error);
    }
  };

  // useEffect(()=>{
  //   // let currentUnix = moment(currentDate).unix()
  //   //  let requestSubmitDeadline = details?.submission_deadline

  //    if((user?.user_id == details?.partner_user_id)&& (details?.accept_status == 0)){
  //     setReqAcceptClient(true)
  //    }

  // },[details])

  const submissionDeadlineUnix = details?.submission_deadline;
  const submissionDeadlineMoment = moment.unix(submissionDeadlineUnix);

  const current = moment();

  const daysLeft = submissionDeadlineMoment.diff(current, 'days');

  const handleDeleteTask = (id)=>{
    try {
      let newStatus = 2
      axios.post(`${REST_API_END_POINT}project/delete-project`,{ id: Number(id), status: newStatus },{
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if(response.data.status === 4 || response.data.status === 2 || response.data.status === 1){
          enqueueSnackbar('Job deleted successfully', { variant: 'success' });
          onDataChange()
        }else if(response.data.status === 5 || response.data.status === 3 || response.data.status === 0){
          enqueueSnackbar('Failed to delete Job', { variant: 'error' });
        }
      }).catch((error) => {
        console.error(error);
      })
    }
    catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  const handleAcceptorRejectInvoice = async (value,underReview) => {
    try {
      setConfirmInvoice(false)
      setRejectInvoice(false)
      setRequestAccept(true);
      if(underReview){
        setConfirmInvoice(false);
        setRejectInvoice(false);
        let requestId = id
        let requestPartnerId = details?.rt_partner_id;
       
        const data = { requestId, requestPartnerId, userId, additionalAmount : ((invoice.jobcostTotal || 0) + (invoice.jobcostServiceTotal || 0)), grandTotal : invoice.grandTotal || invoice.total };
        const res = await axios.post(`${REST_API}webservice/sales-order/accept-review-order`,data);
        if (res.data.status == 1) {
          enqueueSnackbar('Moved to Invoicing', { variant: 'success' });
          setConfirmInvoice(false);
          setRejectInvoice(false);
          setOpenInvoice(false);
        }else{
          enqueueSnackbar('Failed to Approve final invoice', { variant: 'error' });
          setConfirmInvoice(false);
          setRejectInvoice(false);
          setOpenInvoice(false);
        }
        onDataChange()
        fetchRequestDetailsNew();
        fetchRequestDetails();
      }else if (value == 3) {
        setConfirmInvoice(false);
        setRejectInvoice(false);
        let requestId = id
        let requestPartnerId = details?.rt_partner_id;
       
        const data = { requestId, requestPartnerId, userId, additionalAmount : ((invoice.jobcostTotal || 0) + (invoice.jobcostServiceTotal || 0)), grandTotal : invoice.grandTotal || invoice.total };
        const res = await axios.post(`${REST_API}webservice/request/accept-final-invoice`,data);
        if (res.data.status == 1) {
          enqueueSnackbar('Final invoice approved', { variant: 'success' });
          setConfirmInvoice(false);
          setRejectInvoice(false);
          setOpenInvoice(false);
        }else{
          enqueueSnackbar('Failed to Approve final invoice', { variant: 'error' });
          setConfirmInvoice(false);
          setRejectInvoice(false);
          setOpenInvoice(false);
        }
        onDataChange()
        fetchRequestDetailsNew();
        fetchRequestDetails();
      } else if (value === 2 && reason === '') {
        enqueueSnackbar('Please fill rejected reason ', { variant: 'warning' })
        return
      } else {
        let requestId = id
        let requestPartnerId = details?.rt_partner_id
        let acceptStatus = value
       
        let billing_type =details?.billing_type

        const data = { requestId, requestPartnerId, acceptStatus, userId, reason,billing_type }
        // const res = await axios.post(`${REST_API}webservice/request/accept-or-reject-invoice`, data);
        const res = await axios.post(`${REST_API}webservice/request/accept-or-reject-request-new`, data);

        if (res.data.status == 1) {
          const isTimeMaterial = details?.project_category ==12
          if(res.data.checkProjectExist){
            enqueueSnackbar('Invoice approved. Converting to production now...', { variant: 'success' });
            console.log('isTimeMaterial for client approve 1', isTimeMaterial)
            handleConvertToJob(true,false,isTimeMaterial);
            setOpenInvoice(false);
          }else if(details.project_category ==13 || invoice?.grandTotal <= 0 ){
            enqueueSnackbar('Invoice approved. Converting to production now...', { variant: 'success' });
            console.log('isTimeMaterial for client approve 2', isTimeMaterial)
            handleConvertToJob(true,false,isTimeMaterial);
            setOpenInvoice(false);
          }else{
            setOpenInvoice(false)
            setConfirmInvoice(false)
            setRejectInvoice(false)
            enqueueSnackbar('Invoice approved', { variant: 'success' });
            fetchRequestDetailsNew()
            fetchRequestDetails()
          }
        } else if (res.data.status == 2) {
          setOpenInvoice(false)
          setConfirmInvoice(false)
          setRejectInvoice(false)
          fetchRequestDetailsNew()
          fetchRequestDetails()
          if(res.data.checkProjectExist){
            enqueueSnackbar('Invoice Rejected. Deleting the related Job...', { variant: 'error' })
            handleDeleteTask(res.data.checkProjectExist);
          }else{
            enqueueSnackbar('Invoice Rejected', { variant: 'error' })
          }
          setReason('')
          navigate(PATH_DASHBOARD.official.root)
        } else {
          setOpenInvoice(false)
          setConfirmInvoice(false)
          setRejectInvoice(false)
          enqueueSnackbar(res.data.message, { variant: 'error' });
        }
      }
    } catch (error) {
      console.log(error, 'error in accepting invoice')
      setConfirmInvoice(false)
      setRejectInvoice(false)
      enqueueSnackbar('Server Error', { variant: 'error' })
    }finally{
      setRequestAccept(false);
      setRenderCards(!renderCards)
    }
  }

  const handleConvertToJob = async (existingJob = false, movedToProduction = false,isTimeMaterial) => {
    try {
      setOpenConvertToRFQ(false);
      setConvertToRFQ(true);
      let requestId = id
      let requestPartnerId = details?.rt_partner_id
      let acceptStatus = 1
     
      // 🚀 PROGRESS TRACKING: Show progress modal and make API call
      const requestData = {
        requestId,
        requestPartnerId,
        acceptStatus,
        userId,
        reason,
        movedToProduction,
        projectCategoryId: values?.project_category?.id || isTimeMaterial ? 12 : null,
        socketId: null // Will be set by the progress modal
      };

      // If modal is already open (from previous operation), just update the data and continue
      if (showProgressModal) {
        setProgressRequestData(requestData);
        // Don't close and reopen modal, just continue with new data
      } else {
        setProgressHeading("Converting to Production");
        setProgressRequestData(requestData);
        setShowProgressModal(true);
      }

      // Wait for socket connection to establish and stabilize
      await new Promise(resolve => setTimeout(resolve, 2000));

      // Additional wait if socket is not ready yet
      if (!socketReady) {
          console.log('[PROGRESS-MODAL] ⏳ Waiting for socket connection...');
          await new Promise(resolve => setTimeout(resolve, 1000));
      }

      const data = { requestId, requestPartnerId, acceptStatus, userId, reason, movedToProduction,projectCategoryId:values?.project_category?.id || isTimeMaterial ? 12 : null}
      const res = await axios.post(`${REST_API}webservice/request/accept-or-reject-invoice`, data);

      if (res.data.status == 1) {
        setConfirmInvoice(false)
        setRejectInvoice(false)
        setShowProgressModal(false);
        if((details?.noServiceNoTask === 1 &&invoice?.cust_product?.length === 0 
            && invoice?.jobcost_service?.every(service => service?.makeAsTask === 0) && details?.project_category !== 12) ){
          enqueueSnackbar('Converted to Invoicing successfully', { variant: 'success' });
           
        }else{

          enqueueSnackbar(existingJob ? 'Job updated successfully' :'Job created successfully', { variant: 'success' });
        }
        console.log('movedToProduction', movedToProduction)
        console.log('time and materialssssssssss 1',isTimeMaterial)
        if( (res.data.allCreatedTask?.length <= 0 && !isTimeMaterial && details?.is_split_order !==1) || (isTimeMaterial && details?.allInstallationCompleted !==1 && details?.proj_status === 3)){
          handleConvertJobToInstallation(requestId) // uncomment this if any section breaks
        }else{
          fetchRequestDetailsNew()
          fetchRequestDetails()
        }
        // if(res.data.allCreatedTask?.length <= 0 && details?.job_category_name !== 11){
        //   handleConvertJobToInstallation(requestId)
        // }else if(details?.job_category_name== "Service only" || details?.job_category_name == 11){
        //   handleConvertJobToInstallation(requestId)
        // }else{
        //   fetchRequestDetailsNew()
        //   fetchRequestDetails()
        // }
        onDataChange()
      } else {
        setConfirmInvoice(false)
        setRejectInvoice(false)
        setShowProgressModal(false);
        enqueueSnackbar('Failed to convert Sales Order to Job', { variant: 'error' });
      }
    } catch (error) {
      console.log(error, 'error in Converting Sales Order to job')
      setConfirmInvoice(false)
      setRejectInvoice(false)
      setShowProgressModal(false);
      // enqueueSnackbar('Server Error', { variant: 'error' })
    }finally{
      setConvertToRFQ(false);
    }
  }

  const handleConvertJobToInstallation = async (id)=>{
    const user = JSON.parse(window.localStorage.getItem('user'))

    let selectedIds=id
    let request = true
    const response = await axios.post(`${REST_API_END_POINT}installation/convert-job-to-installation`,{selectedIds,userId,request,userType:userType , clientId:details?.customer_id})
    if(response.data.status==1){
      // enqueueSnackbar("Moved to Installation successfully !", { variant: 'success' });
      fetchRequestDetailsNew()
      fetchRequestDetails()
    }else{
      // enqueueSnackbar("Installation Not Moved !", { variant: 'error' });
      fetchRequestDetailsNew()
      fetchRequestDetails()
    }
  }

  const handleReopeningRequest = async () => {
    try {
      let requestId = id
      
      const data = { requestId, userId }
      const res = await axios.post(`${REST_API}webservice/request/reopen`, data)
      if (res.data.status == 1) {
        enqueueSnackbar('Order reopened successfully', { variant: "success" })
        setReopen(false)
        fetchRequestDetailsNew()
        fetchRequestDetails()
      } else if (res.data.status == 0) {
        enqueueSnackbar('Order reopened failed', { variant: "error" })
        setReopen(false)
      }
    } catch (error) {
      console.log(error, 'Error in reopen')
    }
  }
  // const handleAcceptOrRejectRequest=async(value)=>{
  //   try {
  //     console.log(value)
  //     let requestId = id
  //     let requestPartnerId = details?.rt_partner_id
  //     let acceptStatus = value
  //     let userId=user.user_id

  //     const data={requestId,requestPartnerId,acceptStatus,userId}
  //     const res = await axios.post(`${REST_API_END_POINT}request/accept-or-reject-request`,data)

  //     if(res.data.status ==1){
  //       setReqAcceptClient(!reqAcceptClient)
  //       setRequestAccept(false)
  //       setRequestReject(false)
  //       enqueueSnackbar(value === 1 ? 'Request Accepted' : 'Request Rejected', { variant: value === 1 ? 'success' : 'error' });
  //       if(value==2){
  //         navigate(PATH_DASHBOARD.official.root)
  //       }
  //     }
  //     // setReqAcceptClient(false)
  //     // setRequestAccept(false)
  //     // setRequestReject(false)
  //   } catch (error) {
  //     console.log(error,'error in reject request')
  //   }

  // }

  const { errors, values, touched, handleSubmit, setFieldValue, getFieldProps } = formik;

  // Function to handle submission after changes dialog
  const handleChangesDialogSubmit = (shouldApprove) => {
    console.log('🟢 Changes dialog submit:', shouldApprove);
    setShowChangesDialog(false);
    
    if (shouldApprove) {
      console.log('✅ Set client_approve to true');
      
      if (pendingSubmission) {
        console.log('📝 Processing pending submission:', pendingSubmission);
        const { values, setSubmitting, resetForm, setErrors } = pendingSubmission;
        // Update the values to set isFromEstimate to 0
        const updatedValues = { ...values, isFromEstimate: 0, client_approve: true };
        console.log('🔄 Updated values with isFromEstimate: 0', updatedValues);
        // Continue with submission by calling the formik onSubmit directly
        console.log('🚀 Calling formik.onSubmit...');
        // Update form values first, then submit
        Object.keys(updatedValues).forEach(key => {
          setFieldValue(key, updatedValues[key]);
        });
        // Use setTimeout to ensure values are updated before submission
        setTimeout(() => {
          handleSubmit();
        }, 100);
      } else {
        console.log('❌ No pending submission found');
      }
    } else {
      console.log('❌ Set client_approve to false');
      
      if (pendingSubmission) {
        console.log('📝 Processing pending submission for No:', pendingSubmission);
        const { values, setSubmitting, resetForm, setErrors } = pendingSubmission;
        // Update the values to set isFromEstimate to 0 and client_approve to false
        const updatedValues = { ...values, isFromEstimate: 0, client_approve: false };
        console.log('🔄 Updated values with isFromEstimate: 0 and client_approve: false', updatedValues);
        // Continue with submission by calling the formik onSubmit directly
        console.log('🚀 Calling formik.onSubmit for No...');
        // Update form values first, then submit
        Object.keys(updatedValues).forEach(key => {
          setFieldValue(key, updatedValues[key]);
        });
        // Use setTimeout to ensure values are updated before submission
        setTimeout(() => {
          handleSubmit();
        }, 100);
      } else {
        console.log('❌ No pending submission found');
      }
    }
    
    setPendingSubmission(null);
  };


  const handleCloseMakeTastDialog = () => {
    setOpenMakeTaskDialog(false)
 }

 const handleContinueMakeTastDialog = () => {
    setOpenMakeTaskDialog(false)
    setConfirmMakeTask(true)
 }

  const setValuesToPreview = () => {
    setPreviewData(values)
  }

  // let  totalsum = 0
  // let DiscountTotal=0
  // let newTotalProductFormula1 = 0;
  // let newTotalWholesalePrice1 = 0;
  // let newTotalRetailPrice1 = 0;

  const calculateTotal = (price, quantity, discount, value, location = 1, adjustment = 0,markAdjType=0,percentageSplit=0) => {

    const parsedQuantity = parseFloat(quantity ? quantity : value) || 1;
    const parsedDiscount = parseFloat(discount) || 0;
    const locationQuantity = parseFloat(location) || 1
    const newPrice = parseFloat(price) || 0
    // let subtotal = price * parsedQuantity * locationQuantity;
    let SPMA = newPrice + ((newPrice * (adjustment ? Number(adjustment) : 0)) / 100)
    let subtotal = parseFloat(SPMA)?.toFixed(2) * parsedQuantity * locationQuantity;

    if(markAdjType ==2 || markAdjType ==3){
      SPMA = newPrice + (adjustment ? Number(adjustment) : 0)
      subtotal = parseFloat(SPMA)?.toFixed(2) * parsedQuantity * locationQuantity;
    }

    if (discount) {
      subtotal = subtotal - discount;
    }
    // if (adjustment) {
    //   subtotal = subtotal + ((subtotal * adjustment) / 100);
    // }
    if(details?.for_parent_facility){
      let amoutForSplit = parseFloat(Number(subtotal) * (Number(percentageSplit) / 100))
      subtotal = subtotal + amoutForSplit
    }
    return subtotal;
  };

  const calculateServiceTotal = (price, quantity, discount, value, location = 1) => {

    const parsedQuantity = parseFloat(quantity ? quantity : value) || 0;
    const parsedDiscount = parseFloat(discount) || 0;
    const locationQuantity = parseFloat(location) || 1
    const subtotal = price * parsedQuantity * locationQuantity;

    if (discount) {
      const totalDiscount = subtotal - discount;
      return totalDiscount;
    } else {
      return subtotal;
    }
  };
  let sum = 0
  let taxAmountData = 0 ;
  let grandTotalData = 0;
  let totalJobcostSum = 0
  let newTaxSum = 0;
  useEffect(() => {
    try {
      console.log('selectedProducts-----', selectedProducts);
      // if(selectedProducts?.length > 0 || selectedServices?.length > 0 || additionalSelectedServices?.length > 0){
      let selectedProductsTotalDiscount = selectedProducts?.reduce((total, data, index) => {
        let quantityFieldName = `quantity_${data.product_id ? data.product_id : data.id}`;
        let discountFieldName = `discount_${data.product_id ? data.product_id : data.id}`;
        const dataRetailPrice = (data.install_cost && parseFloat(data.install_cost) > 0) ? (data.product_retail_price || data.retail_price || 0) : (data.actual_retail_price || data.retail_price || 0)
        const dataWholesalePrice = data.product_price || data.price || 0
        
        // const dataQuantity = values[quantityFieldName]?values[quantityFieldName]:(data?.quantity||1)

        // const dataDiscount = values[discountFieldName]?values[discountFieldName]:(data?.discount||0);
        const dataQuantity = data?.quantity || 1

        const dataDiscount = data?.discount || 0;

        const productTotal = calculateTotal(markupType == 1 ? dataWholesalePrice : (markupType == 2 ? dataRetailPrice : 0), dataQuantity, dataDiscount, null, data?.locationQuantity, Number(data?.adjustment),data.markAdjType);
        const fixedProductTotal = parseFloat(productTotal).toFixed(2);
        return total + parseFloat(fixedProductTotal);
      }, 0);

      const selectedProductsTotalDiscountForJobCost = selectedProducts?.reduce((total, data, index) => {
        const quantityFieldName = `quantity_${data.product_id || data.id}`;
        const discountFieldName = `discount_${data.product_id || data.id}`;
        const quantityVal = values[quantityFieldName] ? values[quantityFieldName] : 1
        const discountVal = values[discountFieldName] ? values[discountFieldName] : 0
        console.log("###############quantityVal", quantityVal)
        console.log("###############quantityValdata", data)
        // const productTotal = calculateTotal(data.expected_material_cost, data.quantity, discountVal);
        const productTotal = calculateTotal(parseFloat(data.expected_material_cost), data.quantity, 0, null, data.locationQuantity, 0);
        console.log("###############product formula", productTotal)
        return total + productTotal;
      }, 0);
      // const allServices = [...selectedServices, ...additionalSelectedServices];
      const allServices = [...additionalSelectedServices];
      console.log("allServicesssss ",allServices)
      let selectedServicesCost = allServices?.reduce((total, service, index) => {
        // const quantityFieldName = `service_quantity_${index}`;
        // const quantityVal = values[quantityFieldName]?values[quantityFieldName]:1
        const quantityVal = service?.quantity ? Number(service?.quantity) : 0
        const serviceTotal = calculateServiceTotal(service.cost, quantityVal, 0);

        console.log("############SSSSSSSSSSSer", serviceTotal);

        // let selectedQuantity=selectedProducts.filter(product=>product.id===service.product_id)
        // console.log("############SSSSSSSSSSSer",selectedQuantity);
        // let quantity=selectedQuantity[0].quantity
        // return total + (serviceTotal*quantity);
        return total + serviceTotal;
      }, 0);
      // selectedServicesCost = selectedServicesCost - initialServiceCostInProductFormula
      console.log('allServices-----------', allServices);

      let selectedServicesTotalCost = allServices?.reduce((total, service, index) => {
        const quantityVal = service?.quantity ? Number(service?.quantity) : 0
        const costVal = service?.unit_cost ? Number(service?.unit_cost) : Number(service?.total_cost)
        const serviceTotal = calculateServiceTotal(costVal, quantityVal, 0);
        // const roundedServiceTotal = Math.round(serviceTotal * 100) / 100;
        return total + serviceTotal;
      }, 0);

      // New taxable toggle cost
      let selectedTaxServicesTotalCost = allServices?.reduce((total, service, index) => {
      if (service?.taxable === 0) return total;
      const quantityVal = service?.quantity ? Number(service?.quantity) : 0;
      const costVal = service?.unit_cost ? Number(service?.unit_cost) : Number(service?.total_cost);
      const serviceTotal = calculateServiceTotal(costVal, quantityVal, 0);
      return total + serviceTotal;
    }, 0);

      // const productServices = selectedProducts?.reduce((services, product) => {
      //   if (product.services?.length > 0) {
      //     return services.concat(
      //       product.services.map((service) => {
      //         const cost = parseFloat(service.unit_cost ?? service.total_cost ?? 0);
      //         const quantity = parseFloat(service.quantity ?? 1);
      //         const retail_price = parseFloat(service.retail_price ?? 0);
      //         const locationQty = parseFloat(product.locationQuantity ?? 1);

      //         const subtotal = cost * quantity;
      //         const markup = (subtotal * retail_price) / 100;
      //         const total = (subtotal + markup) * locationQty;

      //         return {
      //           ...service,
      //           totalCost: total.toFixed(2),
      //         };
      //       })
      //     );
      //   }
      //   return services;
      // }, []);
      // console.log('productServicesproductServices', productServices)
      // const getTotalServiceCostSum = (services) => {
      //   return parseFloat(
      //     services.reduce((sum, item) => {
      //       console.log('itemservices', item);
      //       if (item.id !== 10) return sum;
      //       const cost = parseFloat(item.totalCost ?? 0);
      //       return sum + cost;
      //     }, 0).toFixed(2)
      //   );
      // };


      // const totalInstallServiceCostSum = getTotalServiceCostSum(productServices);

    // console.log("productServices ",productServices)

    const installCost = selectedProducts?.map((product) => {
      const retailPrice = parseFloat(product.install_cost  || 0);
      const locationQuantity = parseFloat(product.locationQuantity || 1);

      const total = retailPrice * locationQuantity;

      return {
        ...product,
        totalCost: total.toFixed(2),
      };
    });
        console.log('🧾 installCost', installCost);

    const getTotalInstallCostSum = (installCost = []) => {
      return installCost.reduce((sum, item) => {
        const cost = parseFloat(item.totalCost || 0);
        return sum + cost;
      }, 0).toFixed(2);
    };

    const totalInstallCostSum = getTotalInstallCostSum(installCost);
    console.log('🧾 Total cost production costtt', totalInstallCostSum);
    setInstallCost(totalInstallCostSum)
    console.log("selected serviceee old ",selectedServicesTotalCost)
    console.log("selected serviceee new ",selectedTaxServicesTotalCost)

      let initialServicesCost =0
      //  selectedProducts?.reduce((total, data, index) => {
      //   const serviceTotal = (data?.quantity) * (parseFloat(data?.expected_total_service_cost?.toFixed(2))) * (data?.locationQuantity || 1) || 0;
      //   // const roundedServiceTotal = Math.round(serviceTotal * 100) / 100;
      //   return total + serviceTotal;
      // }, 0);
console.log('selectedProductsselectedProducts',selectedProducts)
            const productMaterial = selectedProducts?.reduce((materials, product) => {
        if (product.materials && product.materials.length > 0) {
          return materials.concat(
            product.materials
              .map((material) => {
                console.log('materialsssssss',material)
                const price = parseFloat(material.max_unit_cost || 0);
                const quantity = parseFloat(material.quantity || 1);
                const retail_price = parseFloat(material.retail_price || 0);

                const subtotal = price * quantity;
                const markup = (subtotal * retail_price) / 100;
                const total = (subtotal + markup) * (product.locationQuantity || 1)

                console.log('✅ total, subtotal, markup:', total, subtotal, markup);
                console.log('✅ price, quantity, retail_price:', price, quantity, retail_price);

                return {
                  ...material,
                  totalCost: total.toFixed(2),
                };
              })
          );
        }
        return materials;
      }, []);

      setProductFormulaMaterial(productMaterial)

      const getTotalCostSum = (productMaterial) => {
        return productMaterial.reduce((sum, item) => {
                  console.log('itemmmmmm',item)
          // Only include if taxable == 0 (string or number)
          if (Number(item.taxable) !== 0) return sum;

          const cost = parseFloat(item.totalCost || 0);
          return sum + cost;
        }, 0).toFixed(2);
      };

      const totalCostSum = getTotalCostSum(productMaterial);
      // setTotalMinusMaterialTax(totalCostSum)
      console.log('🧾 Total cost sum of all materials:', totalCostSum);

      console.log("###################1111selectedServicesTotalCost-1", selectedServicesTotalCost);
      console.log("###################1111initialServicesCost-1", initialServicesCost);

      const roundToThreeDecimals = (num) => Math.round(num * 1000) / 1000;
      const roundToTwoDecimals = (num) => Math.round(num * 100) / 100;

      // selectedServicesTotalCost = roundToThreeDecimals(selectedServicesTotalCost);
      // initialServicesCost = roundToThreeDecimals(initialServicesCost);
      selectedServicesTotalCost = roundToTwoDecimals(selectedServicesTotalCost);
      selectedTaxServicesTotalCost = roundToTwoDecimals(selectedTaxServicesTotalCost);
      initialServicesCost = roundToTwoDecimals(initialServicesCost);

      console.log("###################1111selectedServicesTotalCost-2", selectedServicesTotalCost);
      console.log("###################1111initialServicesCost-2", initialServicesCost);
      const selectedServicesSubTotal = roundToTwoDecimals(selectedServicesTotalCost - initialServicesCost)
      const selectedNewTaxServicesSubTotal = roundToTwoDecimals(selectedTaxServicesTotalCost - initialServicesCost)
      setTotalLabourCost(selectedServicesSubTotal)
      setTotalProductLabourCost(selectedServicesSubTotal)
      // setTotalProductInstallCost(totalInstallServiceCostSum)
      console.log("###################1111selectedServicesSubTotal", selectedServicesSubTotal);

      const newSum = (selectedProductsTotalDiscount + selectedServicesTotalCost) - (values['invoice_discount'] ? values['invoice_discount'] : 0)
      // setRFQSubTotal(newSum)
      console.log("###################1selectedProductsTotalDiscount", selectedProductsTotalDiscount);
      const selectedRfpProduct = cart?.reduce((total, data, index) => {
        let markup = markupType ? (markupType === 1 ? data.WholesaleMarkup || data.product_markup : data.RetailMarkup || data.product_markup) : 0;

        let productTotal = parseFloat((data.product_price + data.product_price * markup / 100)?.toFixed(2)) * data.quantity * data.location_quantity;
        productTotal = parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float

        console.log("#####################ProductTotal", productTotal);
        return total + productTotal;
      }, 0);

      const selectedRfpProductJobCost = cart?.reduce((total, data, index) => {
        let productTotal = data.product_price * data.quantity * data.location_quantity;
        productTotal = parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float

        console.log("#####################ProductTotal", productTotal);
        return total + productTotal;
      }, 0);

      const selectedRfpServices = cartService?.reduce((total, data, index) => {
        let markup = data.originalMarkup;
        data.sellingPrice = data.sellingPrice || data.unit_cost;

        let productTotal = (data.sellingPrice + (data.sellingPrice * markup / 100)) * data.qty;
        productTotal = parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float

        console.log("#####################ProductTotal", productTotal);
        return total + productTotal;
      }, 0);
      const selectedNonTaxRfpServices = cartService?.reduce((total, data, index) => {
        if (data?.taxable === 0) return total;
        let markup = data.originalMarkup;
        data.sellingPrice = data.sellingPrice || data.unit_cost;

        let productTotal = (data.sellingPrice + (data.sellingPrice * markup / 100)) * data.qty;
        productTotal = parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float

        console.log("#####################ProductTotal", productTotal);
        return total + productTotal;
      }, 0);

      const selectedRfpServicesJobCost = cartService?.reduce((total, data, index) => {
        let markup = data.originalMarkup;
        data.sellingPrice = data.sellingPrice || data.unit_cost;

        let productTotal = data.sellingPrice * data.qty;
        productTotal = parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float

        console.log("#####################ProductTotal", productTotal);
        return total + productTotal;
      }, 0);
      const selectedMaterialCostJobCost = selectedMaterials?.reduce((total, data, index) => {
        let productTotal = (data.product_price||data.price) * (data.quantity||0) ;
        if(data?.inhouse == 0){
          productTotal = 0
        }
        productTotal = parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float
        console.log("#####################ProductTotalewwww1",data);
        console.log("#####################ProductTotalewwww1", productTotal);
        return total + productTotal;
      }, 0);
      const selectedMaterialCost = selectedMaterials?.reduce((total, data, index) => {
        data.price=data.price ? data.price : data.product_price
        // data.markup = data.markup ? data.markup : data.product_markup
        data.markup = data.product_markup ? data.product_markup : data.markup
        let markUpCost = data.price + ((parseFloat(data.price) * parseFloat(data.markup || 0)) / 100)
        markUpCost = parseFloat(parseFloat(markUpCost).toFixed(2)) || 0;
        let productTotal = (markUpCost || data.product_retail_price) * (data.quantity||0) ;
        if(data?.inhouse == 0){
          productTotal = 0
        }
        // productTotal = values?.project_category?.name == 'Time & Material' ? 0 : parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float
        productTotal = parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float
        console.log("#####################ProductTotalewwww2-data",data);
        console.log("#####################ProductTotalewwww2--markUpCost",markUpCost);
        console.log("#####################ProductTotalewwww2--productTotal", productTotal);
        return total + productTotal;
      }, 0);

      const selectedNonTaxMaterialCost = selectedMaterials?.reduce((total, data, index) => {
        if (data?.taxable === 0) return total;
        data.price=data.price ? data.price : data.product_price
        // data.markup = data.markup ? data.markup : data.product_markup
         data.markup = data.product_markup ? data.product_markup : data.markup
        let markUpCost = data.price + ((parseFloat(data.price) * parseFloat(data.markup || 0)) / 100)
        markUpCost = parseFloat(parseFloat(markUpCost).toFixed(2)) || 0;
        let productTotal = (markUpCost || data.product_retail_price) * (data.quantity||0) ;
        if(data?.inhouse == 0){
          productTotal = 0
        }
        productTotal = values?.project_category?.name == 'Time & Material' ? 0 : parseFloat(productTotal.toFixed(2));  // Ensure two decimal places and parse back to float
        console.log("#####################ProductTotalewwww2-data",data);
        console.log("#####################ProductTotalewwww2--markUpCost",markUpCost);
        console.log("#####################ProductTotalewwww2--productTotal", productTotal);
        return total + productTotal;
      }, 0);

      console.log('selectedMaterialCostttttttt old',selectedMaterialCost)
      // console.log('totalInstallServiceCostSum old',totalInstallServiceCostSum)
      console.log('selectedMaterialCostttttttt new',selectedNonTaxMaterialCost)
      console.log("#####################Labour cost", selectedServicesSubTotal + selectedRfpServices);
      setTotalLabourCost(selectedServicesSubTotal + selectedRfpServices)
      console.log("#####################selectedRfpServices", selectedRfpServices);
      console.log("#####################selectedRfpProduct", selectedRfpProduct);
      sum = (selectedProductsTotalDiscount + selectedServicesSubTotal +selectedMaterialCost+ selectedRfpServices + selectedRfpProduct ) - (values['invoice_discount'] ? values['invoice_discount'] : 0)
      newTaxSum = (selectedProductsTotalDiscount + selectedNewTaxServicesSubTotal +selectedNonTaxMaterialCost+ selectedNonTaxRfpServices + selectedRfpProduct) - (values['invoice_discount'] ? values['invoice_discount'] : 0)- totalCostSum;
      taxAmountData = selectedTaxCategory ? (selectedTaxCategory.type === 1 ? (sum * (selectedTaxCategory.value || 0) / 100) : (selectedTaxCategory.value || 0) ) : 0;
      const newTaxAmountData = selectedTaxCategory ? (selectedTaxCategory.type === 1 ? (newTaxSum * (selectedTaxCategory.value || 0) / 100) : (selectedTaxCategory.value || 0) ) : 0;
      const taxAmountToFixed = parseFloat(parseFloat(taxAmountData).toFixed(2));
      console.log('taxAmounttttt old >',taxAmountData)
      console.log('taxAmounttttt new >',newTaxAmountData)
      let negativeCheck = (noCharge && sum > 0) ? -1 : 1
      // let negativeCheck = noCharge  ? -1 : 1
     console.log('negativeChecknegativeChecknegativeCheck',negativeCheck)
      // grandTotalData = ((parseFloat(sum) + parseFloat(taxAmountData)) * negativeCheck ).toFixed(2);
      if(!details?.avalara_code){
         grandTotalData = ((parseFloat(sum) + parseFloat(taxAmount)) * negativeCheck ).toFixed(2); //new tax grand total
        //  grandTotalData = ((parseFloat(sum) + parseFloat(taxAmountToFixed)) * negativeCheck ).toFixed(2); //new tax grand total

       }else{
         grandTotalData = ((parseFloat(sum) + parseFloat(Number(taxAmount))) * negativeCheck ).toFixed(2); //new tax grand total with avalara
       }
      console.log("#####################selectedRfpServices", selectedRfpServices);
      console.log("#####################selectedProductsTotalDiscount", selectedProductsTotalDiscount);
      setTotalSum(sum);
      console.log('grandTotalData---------', grandTotalData)
      console.log('sum---------', sum)
      console.log('totalsum--------', totalsum)
      // setTaxAmount(taxAmountData);
      // console.log('newTaxAmountData',taxAmountToFixed)
      // if(!details?.avalara_code){
        // setTaxAmount(taxAmountToFixed);  no additional tax needed
      // }
      setGrandTotal(grandTotalData);

      let selectedProductsTotalProductFormula = selectedProducts?.reduce((total, data) => {
        let quantityFieldName = `quantity_${data.product_id ? data.product_id : data.id}`;
        let discountFieldName = `discount_${data.product_id ? data.product_id : data.id}`;
        const dataRetailPrice = data.product_retail_price || data.retail_price;
        const dataWholesalePrice = data.product_price || data.price;
        const dataQuantity = values[quantityFieldName] ? values[quantityFieldName] : (data?.quantity || 1);

        let newTotalProductFormula = parseFloat(data.expected_cost?.toFixed(2)) * data.quantity * data.locationQuantity;
        newTotalProductFormula = newTotalProductFormula ? Number(newTotalProductFormula) : 0;


        return total + newTotalProductFormula;
      }, 0);

      selectedProductsTotalProductFormula = selectedProductsTotalProductFormula ? (Number(selectedProductsTotalProductFormula)) : 0

      setTotalProductFormula(selectedProductsTotalProductFormula)

      let selectedProductsTotalWholesalePrice = selectedProducts?.reduce((total, data, index) => {
        let quantityFieldName = `quantity_${data.product_id ? data.product_id : data.id}`;
        let discountFieldName = `discount_${data.product_id ? data.product_id : data.id}`;
        const dataRetailPrice = data.product_retail_price || data.retail_price
        const dataWholesalePrice = data.product_price || data.price
        const dataQuantity = values[quantityFieldName] ? values[quantityFieldName] : (data?.quantity || 1)

        let newTotalWholesalePrice = dataWholesalePrice * data.quantity * data.locationQuantity
        if(data?.adjustment){
          newTotalWholesalePrice = newTotalWholesalePrice ? newTotalWholesalePrice + ((newTotalWholesalePrice * Number(data?.adjustment)) / 100) : 0
        }
        newTotalWholesalePrice = newTotalWholesalePrice ? Number(newTotalWholesalePrice) : 0
        // return total + newTotalWholesalePrice;
        const fixedProductTotal = parseFloat(newTotalWholesalePrice).toFixed(2);
        return total + parseFloat(fixedProductTotal);
      }, 0);
      selectedProductsTotalWholesalePrice = selectedProductsTotalWholesalePrice ? Number(selectedProductsTotalWholesalePrice) : 0

      let selectedServicesTotalWholesalePrice = selectedServices?.reduce((total, data, index) => {
        let newTotalWholesalePrice = (data?.unit_cost * data?.quantityDifference)?.toFixed(2)
        newTotalWholesalePrice = newTotalWholesalePrice ? Number(newTotalWholesalePrice) : 0
        return total + newTotalWholesalePrice;
      }, 0);
      selectedServicesTotalWholesalePrice = selectedServicesTotalWholesalePrice ? Number(selectedServicesTotalWholesalePrice) : 0

      let selectedAddlServicesTotalWholesalePrice = additionalSelectedServices?.reduce((total, data, index) => {
        let newTotalWholesalePrice = data?.total
        newTotalWholesalePrice = newTotalWholesalePrice ? Number(newTotalWholesalePrice) : 0
        return total + newTotalWholesalePrice;
      }, 0);
      selectedAddlServicesTotalWholesalePrice = selectedAddlServicesTotalWholesalePrice ? Number(selectedAddlServicesTotalWholesalePrice) : 0

      let selectedCartTotalWholesalePrice = cart?.reduce((total, data, index) => {
        let markup = markupType ? (markupType === 1 ? data.WholesaleMarkup || data.product_markup : data.RetailMarkup || data.product_markup) : 0;
        let newTotalWholesalePrice = (data.location_quantity * data.quantity * ((data.product_price + (data.product_price * markup / 100)) || 0)).toFixed(2)
        newTotalWholesalePrice = newTotalWholesalePrice ? Number(newTotalWholesalePrice) : 0
        return total + newTotalWholesalePrice;
      }, 0);
      selectedCartTotalWholesalePrice = selectedCartTotalWholesalePrice ? Number(selectedCartTotalWholesalePrice) : 0

      let selectedCartServicesTotalWholesalePrice = cartService?.reduce((total, data, index) => {
        let newTotalWholesalePrice = (data.qty * (data.sellingPrice + (data.sellingPrice * data.originalMarkup / 100)))?.toFixed(2)
        newTotalWholesalePrice = newTotalWholesalePrice ? Number(newTotalWholesalePrice) : 0
        return total + newTotalWholesalePrice;
      }, 0);
      selectedCartServicesTotalWholesalePrice = selectedCartServicesTotalWholesalePrice ? Number(selectedCartServicesTotalWholesalePrice) : 0
      
      let selectedMaterialsTotalWholesalePrice = selectedMaterials?.reduce((total, data, index) => {
        let newTotalWholesalePrice = ((data.markUpCost || 0) * (data.quantity||1))?.toFixed(2)
        newTotalWholesalePrice = newTotalWholesalePrice ? Number(newTotalWholesalePrice) : 0
        return total + newTotalWholesalePrice;
      }, 0);
      selectedMaterialsTotalWholesalePrice = selectedMaterialsTotalWholesalePrice ? Number(selectedMaterialsTotalWholesalePrice) : 0

      let newTotalWholesalePrice = selectedProductsTotalWholesalePrice + selectedServicesTotalWholesalePrice + selectedAddlServicesTotalWholesalePrice + selectedCartTotalWholesalePrice + selectedCartServicesTotalWholesalePrice + selectedMaterialsTotalWholesalePrice
      setTotalWholesalePrice(newTotalWholesalePrice)

      let selectedProductsTotalRetailPrice = selectedProducts?.reduce((total, data, index) => {
        let quantityFieldName = `quantity_${data.product_id ? data.product_id : data.id}`;
        let discountFieldName = `discount_${data.product_id ? data.product_id : data.id}`;
        const dataRetailPrice = data.product_retail_price || data.retail_price
        const dataWholesalePrice = data.product_price || data.price
        const dataQuantity = values[quantityFieldName] ? values[quantityFieldName] : (data?.quantity || 1)

        let newTotalRetailPrice = dataRetailPrice * data.quantity * data.locationQuantity
        if(data?.adjustment){
          newTotalRetailPrice = newTotalRetailPrice ? newTotalRetailPrice + ((newTotalRetailPrice * Number(data?.adjustment)) / 100) : 0
        }
        newTotalRetailPrice = newTotalRetailPrice ? Number(newTotalRetailPrice) : 0
        // return total + newTotalRetailPrice;
        const fixedProductTotal = parseFloat(newTotalRetailPrice).toFixed(2);
        return total + parseFloat(fixedProductTotal);
      }, 0);
      selectedProductsTotalRetailPrice = selectedProductsTotalRetailPrice ? Number(selectedProductsTotalRetailPrice) : 0

      let newTotalRetailPrice = selectedProductsTotalRetailPrice + selectedServicesTotalWholesalePrice + selectedAddlServicesTotalWholesalePrice + selectedCartTotalWholesalePrice + selectedCartServicesTotalWholesalePrice + selectedMaterialsTotalWholesalePrice
      setTotalRetailPrice(newTotalRetailPrice)

      //discount count
      let selectedProductDiscount = selectedProducts?.reduce((acc, data, index) => {
        // const discountFieldName = `discount_${data.product_id?data.product_id:data.id}`;
        // const discountVal = values[discountFieldName]?values[discountFieldName]:(data?.discount||0);
        const discountVal = data.discount ? data.discount : 0
        let productDiscount = +discountVal || 0;
        return acc + productDiscount;
      }, 0);
      const newDiscountTotal = selectedProductDiscount + (parseFloat(values['invoice_discount']) || 0);
      setDiscountTotal(selectedProductDiscount + (parseFloat(values['invoice_discount']) || 0));

      console.log("#############selectedProductsTotalProductFormula", selectedProductsTotalProductFormula);
      console.log("#############selectedProductsTotalWholesalePrice", selectedProductsTotalWholesalePrice);
      console.log("#############selectedProductsTotalRetailPrice", selectedProductsTotalRetailPrice);
      console.log("#############newDiscountTotal", newDiscountTotal);
      console.log("#############selectedRfpProduct", selectedRfpProduct);
      console.log("#############selectedMaterialCost", selectedMaterialCost);
      console.log("#############selectedMaterialCostJobCost", selectedMaterialCostJobCost);
      console.log("#############selectedMaterialCostJobCost", selectedMaterialCostJobCost);
      console.log("#############selectedProductsTotalDiscountForJobCost", selectedProductsTotalDiscountForJobCost);
      console.log("#############selectedServicesCost", selectedServicesCost);
      console.log("#############selectedRfpProductJobCost", selectedRfpProductJobCost);
      console.log("#############selectedRfpServicesJobCost", selectedRfpServicesJobCost);


      totalJobcostSum = (selectedProductsTotalDiscountForJobCost + selectedServicesCost + selectedRfpProductJobCost + selectedRfpServicesJobCost+selectedMaterialCostJobCost);
      console.log('total job cost------- budget', totalJobcostSum);
      values['total'] = sum
      values['taxAmount'] = taxAmountData
      values['budget'] = totalJobcostSum
      setBudget(totalJobcostSum)
      let subTotal = markupType == 1 ? ((selectedProductsTotalWholesalePrice + selectedRfpProduct + selectedMaterialCost))
        : (markupType == 2 ? ((selectedProductsTotalRetailPrice + selectedRfpProduct + selectedMaterialCost)) : 0);
      console.log("################subTotal", subTotal);
      setRFQSubTotal(subTotal)
      // let selectedProductsTotalMarkupAmount = markupType == 1 ? ((selectedProductsTotalWholesalePrice - newDiscountTotal) - selectedProductsTotalProductFormula)
      //   : (markupType == 2 ? ((selectedProductsTotalRetailPrice - newDiscountTotal) - selectedProductsTotalProductFormula) : 0);
      // setTotalMarkupAmount(selectedProductsTotalMarkupAmount)
      let selectedProductsTotalMarkupAmount = sum - totalJobcostSum
      setTotalMarkupAmount(selectedProductsTotalMarkupAmount)

      // let selectedProductsTotalMarkup = (selectedProductsTotalMarkupAmount / totalJobcostSum) * 100
      let selectedProductsTotalMarkup = totalJobcostSum !== 0 
        ? (selectedProductsTotalMarkupAmount / totalJobcostSum) * 100 
        : 0;
      setTotalMarkupPercentage(selectedProductsTotalMarkup)

      console.log('selectedProductsTotalMarkupAmount-------', selectedProductsTotalMarkupAmount);
      console.log('totalJobcostSum-------', totalJobcostSum);
      console.log('selectedProductsTotalMarkup-------', selectedProductsTotalMarkup);
      console.log('initialServiceCost In ProductFormula-----', initialServicesCost);
      setInitialServiceCostInProductFormula(initialServicesCost)

    } catch (error) {
      console.log('Error--------------', error);
    }
  }, [currentRFQData, selectedTaxCategory, selectedProducts,selectedMaterials, selectedServices, additionalSelectedServices, values.markup_type, values.invoice_discount, refreshData, cartService, cart,loading])

  console.log('additionalSelectedServices--', additionalSelectedServices);
  console.log("####################selectedMaterials", selectedMaterials);
  ////image functionality
  const handleRemoveAll = () => {
    setAvatarUrl([]);
  };

  // const handleRemove = (file) => {
  //   console.log('filefilefilefile',file)
  //   const filteredItems = avatarUrl.filter((_file) => _file !== file);
  //   setAvatarUrl([filteredItems]);
  // };

  ///////
  // const handleDrop = useCallback(
  //   (acceptedFiles) => {
  //     if (acceptedFiles && acceptedFiles.length > 0) {
  //       const file = acceptedFiles[0];
  //       const Filename = new Date().getTime() + file.name;

  //       const StorageRef = imageref(storage, Filename);
  //       const uploadTask = uploadBytesResumable(StorageRef, file);

  //       uploadTask.on(
  //         'state_changed',
  //         (snapshot) => {
  //           const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
  //         },
  //         (error) => {
  //           console.error(error.message);
  //         },
  //         () => {
  //           getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
  //             setFieldValue('avatarUrl', downloadURL)

  //           });
  //         }
  //       );
  //     }
  //   },
  //   [setFieldValue]
  // );

  const handleRemove = (file) => {
    console.log('Removing file:', file);
  
    const filteredItems = avatarUrl.filter((_file) => {
      // If files have `url`, compare by `url`
      if (file.url && _file.url) {
        return _file.url !== file.url;
      }
      
      // If files have `name`, compare by `name`
      if (file.name && _file.name) {
        return _file.name !== file.name;
      }
  
      // If files have `id`, compare by `id`
      if (file.id && _file.id) {
        return _file.id !== file.id;
      }
  
      return true;
    });
  
    setAvatarUrl(filteredItems); // No need to wrap in an array
  };
  

    // const handleDrop = useCallback(
    //   (acceptedFiles) => {
    //     let permission =!explodedPermissions?.some((permission) => ['Upload Files Sales Order'].includes(permission))
    //     if(permission &&  user?.added_by_client ==1){
    //       return   enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
    //     }
    //     if (acceptedFiles && acceptedFiles.length > 0) {
    //       setIsUploading(true);
    //       const uploadPromises = acceptedFiles?.map((file) => {
    //         return new Promise((resolve, reject) => {
    //           const Filename = new Date().getTime() + file.name;
    //           const StorageRef = imageref(storage, Filename);
    //           const uploadTask = uploadBytesResumable(StorageRef, file);
  
    //           uploadTask.on(
    //             'state_changed',
    //             (snapshot) => {
    //               const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
    //               setProgress(progress);
    //             },
    //             (error) => {
    //               console.error(error.message);
    //               setIsUploading(false);
    //               reject(error);
    //             },
    //             () => {
    //               getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
    //                 resolve({
    //                   url: downloadURL,
    //                   file_type: file.type,
    //                   extension: file.name.split('.').pop(),
    //                   size: file.size
    //                 });
    //               });
    //             }
    //           );
    //         });
    //       });
  
    //       Promise.all(uploadPromises)
    //         .then((downloadURLs) => {
    //           setAvatarUrl((prevAvatarUrls) => {
    //             const updatedFiles = downloadURLs.map((file) => ({
    //               url: file.url,
    //               file_type: file.file_type,
    //               extension: file.extension,
    //               size: file.size
    //             }));
    //             return [...prevAvatarUrls, ...updatedFiles]
    //           });
    //           setIsUploading(false);
    //         })
    //         .catch((error) => {
    //           console.error(error.message);
    //           setIsUploading(false);
    //         });
    //     }
    //   },
    //   [setFieldValue]
    // );

  const handleDrop = useCallback(
    async (acceptedFiles) => {
      const noPermission = !explodedPermissions?.some((permission) =>
        ['Upload Files Sales Order'].includes(permission)
      );

      if (noPermission && user?.added_by_client === 1) {
        return enqueueSnackbar('Access Denied: You do not have sufficient permissions', {
          variant: 'error'
        });
      }

      if (acceptedFiles && acceptedFiles.length > 0) {
        setIsUploading(true);

        const uploadPromises = acceptedFiles.map(async (file) => {
          const fileName = `${Date.now()}_${file.name.replace(/\s+/g, '_')}`;
          const filePath = `sales-orders/${fileName}`;

          // Upload file to Supabase Storage
          const { error: uploadError } = await supabase.storage
            .from('signwise-attachments')
            .upload(filePath, file);

          if (uploadError) {
            console.error(uploadError.message);
            throw uploadError;
          }

          // Get public URL
          const { data: publicUrlData, error: urlError } = supabase.storage
            .from('signwise-attachments')
            .getPublicUrl(filePath);

          if (urlError || !publicUrlData?.publicUrl) {
            throw new Error('Failed to get public URL');
          }

          return {
            url: publicUrlData.publicUrl,
            file_type: file.type,
            extension: file.name.split('.').pop(),
            size: file.size
          };
        });

        Promise.all(uploadPromises)
          .then((uploadedFiles) => {
            setAvatarUrl((prev) => [...prev, ...uploadedFiles]);
            setIsUploading(false);
          })
          .catch((error) => {
            console.error('Upload failed:', error.message);
            enqueueSnackbar('Upload failed: ' + error.message, { variant: 'error' });
            setIsUploading(false);
          });
      }
    },
    [explodedPermissions, user, setAvatarUrl, setIsUploading]
  ); // supabase integration

  let subTotal =invoice?.project_category ==12 ? invoice?.jobcostTotal + 0 : 0 // invoice?.jobcostTotal + 0
  const ACCOUNT_TABS = [
    {
      value: `${user.isVendor ? '' : 'Sales Order '}Details`,
      component: details ? (
        <ViewRequest
          teamMembers={teamMembers}
          clientDetails={invoice}
          products={invoice?.cust_product}
          productsWithLocation={invoice?.cust_product_location}
          fetchRequestDetails={fetchRequestDetails}
          fetchRequestDetailsNew={fetchRequestDetailsNew}
          user={user}
          designs={designs}
          setDesigns={setDesigns}
          details={details}
          isRequest={true}
          requestId={id}
          signAgreements={signAgreements}
          customTemplate={customTemplate}
          questionnaireTemplate={questionnaireTemplate}
          allDataEmpty={allDataEmpty}
          portfolio={portfolio}
          invoice={invoice}
          setInvoice={setInvoice}
          setRenderCards={setRenderCards}
          renderCards={renderCards}
          rfpServicesEdit={rfpServicesEdit}
          requestServices={requestServices}
          labourInstallService={labourInstallService}
          explodedPermissions={explodedPermissions}
          designersList={designersList}
        />
      ) : "",
    },
    ...((user.user_type === 3 || user.user_type === 1 || explodedPermissions?.some((permission) => ['View Sales Order Client Message Board','Access Sales Order Client Message Board'].includes(permission))) ? [
    {
      value: 'client message board',
      component: (
        <PublicMessageBoard
          products={invoice?.cust_product}
          requestDetails={details}
          requestId={id}
          acceptedClients={acceptedClients}
          setRenderCards={setRenderCards}
          renderCards={renderCards}
          fetchRequestDetails={fetchRequestDetails}
          details={details}
          accessPublicMessageBoard={accessPublicMessageBoard}
        />
      ),
    }
  ] : []),
     ...((isMember && user.user_type !== 3
  ) ? [
    {
      value: 'Job Notes',
      component: (
        <Card sx={{ height: '72vh', display: 'flex' }}>
          <JobNoteWindow
          products={invoice?.cust_product}
            allUser={jobNoteMembers}
            requestIdd={id}
            designOrderId={details?.design_order_id || null}
          requestDetails={details}
            fromDesign={false}
            isDesignOrder={false}
            renderCards={renderCards}
          setRenderCards={setRenderCards}
            fetchRequestDetails={fetchRequestDetails}
            details={details}
            noteType="job"
            accessPublicMessageBoard={accessPublicMessageBoard}
          />
        </Card>
      ),
    },
    {
      value: 'Design Notes',
      component: (
        <Card sx={{ height: '72vh', display: 'flex' }}>
          <JobNoteWindow
            products={invoice?.cust_product}
            allUser={jobNoteMembers}
            requestIdd={id}
            designOrderId={details?.design_order_id || null}
            requestDetails={details}
            fromDesign={true}
            isDesignOrder={false}
          renderCards={renderCards}
            setRenderCards={setRenderCards}
          fetchRequestDetails={fetchRequestDetails}
          details={details}
            noteType="design"
          accessPublicMessageBoard={accessPublicMessageBoard}
        />
        </Card>
      ),
    }
  ] : []),
    ...(user.isVendor ? [] : [
      {
        // value: 'change order',
        value: 'Job Log',
        component: <RequestTabUpdates updates={updates?.length > 0 ? updates : []} />,
      },
      {
        value: 'payments',
        component: <PaymentRequest popupOn={popupOn} idOfProject={idOfProject} totalValue={!empty(details?.allInstallationCompleted) ? invoice?.grandTotal : invoice?.total } setLoading={setLoading} setRefresh={setRefresh} refresh={refresh} />,
      },
      {
        value: 'Locations and Notes',
        component: <Locations products={invoice?.cust_product} details={details} additionalSelectedServices={requestServices} designs={designs} rfpServices={rfpServicesEdit} />,
      },
      ...(details?.noServiceNoTask !== 1 ? [
      {
        value: 'Installation Reports',
        component: <SalesOrderInstallationReportView products={invoice?.cust_product} details={details} additionalSelectedServices={requestServices} designs={designs} rfpServices={rfpServicesEdit} />,
      },
      ] : []),
    ]),
    ...(details?.noServiceNoTask !== 1 ? [
      !details?.map_service ? 
      {
        value: 'Route - Map Services',
        component: <RouteMapInstall salesOrderDetails={details} refresh={refresh} setRefresh={setRefresh}/>,
      } : {
        value: 'Route - Map Services',
        component: <RouteMap details={details} id={id} route_id={details?.map_service} />,
      }
      ] : []),
    // ...(userType === 3 ? (user.isVendor ? [
    //   {
    //     value: 'My Proposal',
    //     component: <Proposals setReloadData={() => setRefresh(!refresh)} acceptedClients={acceptedClients} proposalData={proposalData} />,
    //   },
    // ] : []) : [
    //   {
    //     value: 'Proposals',
    //     component: <Proposals setReloadData={() => setRefresh(!refresh)} acceptedClients={acceptedClients} proposalData={proposalData} />,
    //   },
    // ]),
  ];

  const handleDeleteService = (servId, indexId, newIndexId, deletedIndex) => {
    setCheckLength(!checkLength)
    console.log('indexId--------',newIndexId,indexId,servId)
    // const newFilteredServices = additionalSelectedServices?.filter(data => !(data.id == servId && data.indexId == indexId));
    const newFilteredServices = additionalSelectedServices?.filter((data, index) => {
        console.log('indexId--------data-servId', servId, data.id)
        console.log('indexId--------data-indexId', indexId, data.indexId)
        console.log('indexId--------data-isAdditionalProduct', data.isAdditionalProduct)
        console.log('indexId--------data-newIndexId', newIndexId, data.newIndexId)
        console.log('handleDeleteService---deletedIndex', deletedIndex)
        console.log('handleDeleteService---index', index)
        if (data?.isAdditionalProduct) {
          // return data?.newIndexId !== newIndexId;
          return index != deletedIndex;
        }
        // return !(data.id == servId && data.indexId == indexId)
        return index != deletedIndex;
    });
    const newLocationStates = { ...serviceOnlyLocationStates };
    delete newLocationStates[indexId];
    setServiceOnlyLocationStates(newLocationStates);
    // const allFilteredServices = filteredServices?.find(data => data.id !== servId);
    setFieldValue('services', newFilteredServices);
    setAdditionalSelectedServices(newFilteredServices);
  };
  // useEffect(() => {
  //   if (selectedProducts.length <= 0) {
  //     setAllLocationSame(false)
  //   }
  // }, [selectedProducts])

  useEffect(() => {
    if (selectedProducts.length <= 0) {
      setAllLocationSame(false)
    }
    if (additionalSelectedServices.length <= 0) {
      setAllServiceLocationSame(false)
    }
    if (cart.length <= 0) {
      setAllRfpProductsLocationSame(false)
    }
    if (cartService.length <= 0) {
      setAllRfpServiceLocationSame(false)
    }

  }, [checkLength])

  const handleCancel = async (isEdit) => {
    
    setOpenEdit(false)
    setIsOpen(false)
    setCurrentRFQdata({})
    // resetForm();
    setSelectedProducts([])
    setSelectedMapserviceProducts([]);
    setSelectedServices([]);
    setAdditionalSelectedServices([])
    setFilteredServices([])
    fetchRequestDetailsNew()
    fetchRequestDetails()
    setAllLocationSame(false)
    // closeView()
    // onDataChange()
    // setRenderCards(!renderCards);
    if(popupOn && !isEdit){
      closeView()
      // setRenderCards(!renderCards)
      onDataChange()
      }
      if(editState){
        editState=false
        setOpenEdit(false)
        setIsOpen(false)
      }

      if(!popupOn && !isEdit){
        if(isFromProjects){
          window.history.back()
        }else{
          navigate(`/dashboard/official-request`)
        }
      }
    
    // if (edit) {
      localStorage.removeItem('salesOrderProjectId');
      localStorage.removeItem('salesOrderProjectName');
      localStorage.removeItem('isEditSalesOrder');
      localStorage.removeItem('salesOrderOpenPopup',);
      // closeView()
      // navigate(`/dashboard/official-request`)
    // }
  }

  const selectedProductsAdditionalCost = selectedProducts?.filter(item=>item?.isAdditionalProduct == true)
    ?.reduce((total, item) => total + (item.product_total || 0), 0)
    ?.toFixed(2)

  const selectedMaterialSubTotal = selectedMaterials //?.filter(item=>item?.isAdditionalProduct == true)
    ?.reduce((total, item) => total + ((item.markUpCost || 0) * (item.quantity || 0)), 0)
    ?.toFixed(2)

  console.log("cartService--cartService--", cartService);
  console.log("cartService--rfpServiceLocationStates--", rfpServiceLocationStates);
  console.log("cartService--cart--", cart);
  console.log("cartService--rfpLocationStates--", rfpLocationStates);

  let totalMarkup = 0;
  let totalServiceMarkup = 0;
  let originaltotalMarkup = 0
  let originaltotalServiceMarkup = 0
  let totalAmount = 0;
  let customerProductTotal = 0;
useEffect(() => {
  if (values.additionalMaterials?.length > 0) {
    setSelectedMaterials(values.additionalMaterials);
    setPendingAutocompleteMaterials(values.additionalMaterials);
  }
}, []);

  // const filteredProductOptions = useMemo(() => {
  //   return (allProducts || []).filter((option) => {
  //   // OLD CODE - Prevents multiple selections of same product
  //   // const notAlreadySelected = !selectedProducts?.some((selected) => selected.id === option.id);
  //   // if (!notAlreadySelected) return false;
    
  //   // NEW CODE - Allow multiple selections of the same product for different designs
  //   // Commented out the filter to enable multiple selections

  //     const categoryId = values?.project_category?.id;
  //     const catalogType = values?.catalog_type;

  //     if (categoryId === 15) {
  //       if (catalogType?.inhouse == 4) {
  //         return option.inhouse === 4;
  //       } else if (catalogType?.inhouse == 5) {
  //         return option.inhouse === 5;
  //       } else if (catalogType?.isTrafficCatalog) {
  //         return option.isTrafficCatalog === 1
  //       }
  //     }else if(categoryId === 11) {
  //        return (option.inhouse === 5 || option.isTrafficCatalog)
  //     }

  //     return option;
  //     // return option.inhouse !== 0;
  //   });
  // }, [allProducts, selectedProducts, values?.project_category?.id,,values?.catalog_type?.inhouse]);


  const filteredProductOptions = useMemo(() => {
    const filtered = (allProducts || []).filter((option) => {
      // Check if product is already selected for the same facility
      // const notAlreadySelected = !selectedProducts?.some(
      //   (selected) =>
      //     selected.id === option.id &&
      //     selected.facility_id === option.facility_id
      // );
      // if (!notAlreadySelected) return false;

      // Facility-based filtering will be applied only for split orders

      const categoryId = values?.project_category?.id;
      const catalogType = values?.catalog_type;
      const splitCatalogType = values?.split_catalog_type;

      // For split orders, apply facility match and then use split catalog type for filtering
      if (isSplitOrder) {
        const selectedFacilities = values?.facility_type || [];
        if (selectedFacilities.length === 0) {
          return false;
        }
        const selectedIds = new Set(selectedFacilities.map(f => Number(f.id)));
        const facilityMatch = selectedIds.has(Number(option.facility_id));
        if (!facilityMatch) return false;
        // If "All" is selected, show all products regardless of inhouse value
        if (splitCatalogType?.id === 'all') {
          return true;
        }
        // Otherwise, filter based on the selected split catalog type
        if (splitCatalogType?.inhouse === 4) {
          return option.inhouse === 4;
        } else if (splitCatalogType?.inhouse === 5) {
          return option.inhouse === 5;
        } else if (splitCatalogType?.inhouse === 1) {
          return option.inhouse === 1;
        } else if (splitCatalogType?.inhouse === 6) {
          return option.inhouse === 6;
        } else if (splitCatalogType?.isTrafficCatalog) {
          return option.isTrafficCatalog === 1;
        }
        return true; // Default to show all for split orders
        }else{
          const selectedFacilities = FacilityTypes.filter((f) => Number(f.id) === Number(currentFacilityId));
          if (selectedFacilities.length === 0) return false;
          const selectedIds = new Set(selectedFacilities.map((f) => Number(f.id)));
          const facilityMatch = selectedIds.has(Number(option.facility_id));
          if (!facilityMatch) return false;
        }

      if (categoryId === 15) {
        if (catalogType?.inhouse == 4) {
          return option.inhouse === 4;
        } else if (catalogType?.inhouse == 5) {
          return option.inhouse === 5;
        } else if (catalogType?.isTrafficCatalog) {
          return option.isTrafficCatalog === 1
        }
      }else if(categoryId === 11) {
         return (option.inhouse === 5 || option.isTrafficCatalog)
      }

      return option.inhouse !== 6;
    });

    // Sort in strict alphanumeric order based on description and name only (ignore suffix)
    return filtered.sort((a, b) => {
      const getSortKey = (option) => {
        const name = (option.name || '').trim();
        const description = (option.description || '').trim();
        // Sort by description first, then by name for strict alphanumeric order
        const sortString = `${description} ${name}`.trim();
        return sortString;
      };

      const keyA = getSortKey(a);
      const keyB = getSortKey(b);
      
      // Strict alphanumeric sort: case-insensitive with natural numeric ordering
      return keyA.localeCompare(keyB, undefined, { 
        numeric: true, 
        sensitivity: 'base' 
      });
    });
  }, [allProducts, selectedProducts, values?.project_category?.id, values?.catalog_type?.inhouse, values?.facility_type, isSplitOrder, values?.split_catalog_type, currentFacilityId]);

  const filterSelectedProductsByFacility = (selectedFacilities) => {
    if (!selectedFacilities || selectedFacilities.length === 0) {
      return [];
    }

    const hasArizona = selectedFacilities.some(facility => facility.id === 1);
    const hasRiverside = selectedFacilities.some(facility => facility.id === 2);

    return selectedProducts.filter(product => {
      // If only Arizona is selected, keep products with undefined/null facility_id
      if (hasArizona && !hasRiverside) {
        return product.facility_id === undefined || product.facility_id === null;
      }
      // If only Riverside is selected, keep only products with facility_id = 2
      else if (hasRiverside && !hasArizona) {
        return product.facility_id === 2;
      }
      // If both are selected, keep all products
      return true;
    });
  };

  const filteredServiceOptions = useMemo(() => {
    return (filteredServices || []).filter((option) => {
      // const notAlreadySelected = !selectedProducts?.some((selected) => selected.id === option.id);
      // if (!notAlreadySelected) return false;

      const categoryId = values?.project_category?.id;
      const installLabour = option?.id;

      if (categoryId === 12) {
        if(installLabour){
          return option.id === 10;
        }
      }
      return option.status == 1;
    });
  }, [labourCostServices,filteredServices, selectedServices, values?.project_category?.id,invoice]);

    // Function to auto-select install labour (id=10) when project_category changes to 12
    const autoSelectInstallLabour = (newProjectCategory) => {
      if (newProjectCategory?.id !== 12) return;
  
      // Auto-enable allServiceLocationSame when project_category changes to 12
      if (!allServiceLocationSame) {
        setAllServiceLocationSame(true);
      }
  
      const service10 = (labourCostServices || []).find(s => s.id === 10);
      if (!service10) return;
  
      const alreadySelected = (additionalSelectedServices || []).some(s => s.id === 10);
      if (alreadySelected) return;
  
      // Pull community address just like in onChange
      const {
        address: projAddress = '',
        city: projCity = '',
        state: projState = '',
        zip: projZip = '',
      } = values?.community || {};
  
      const communityAddress = {
        address: projAddress,
        city: projCity,
        state: projState,
        zip: projZip,
      };
      const hasCommunityAddress = projAddress && projCity && projState && projZip;
  
      // prev services for address propagation / allServiceLocationSame
      const prevServices = additionalSelectedServices || [];
      let assignedService;
  
      if (hasCommunityAddress) {
        // same utility used in onChange
        assignedService = assignServiceAddresses(
          prevServices,
          service10,
          allServiceLocationSame,
          communityAddress
        );
      } else {
        assignedService = {
          ...service10,
          addresses: [
            { id: 0, address: '', city: '', state: '', zip: '' },
          ],
        };
  
        // respect allServiceLocationSame like onChange
        if (allServiceLocationSame && prevServices.length > 0) {
          const commonAddress = { ...(prevServices[0]?.addresses?.[0] || {}) };
          assignedService.addresses[0] = commonAddress;
        }
      }
  
      const newIndexCounter = serviceIndexCounter + 1;
      setServiceIndexCounter(newIndexCounter);
  
      const serviceWithIndex = { ...assignedService, indexId: newIndexCounter, isAutoAdded: true };
  
      const nextServices = [...prevServices, serviceWithIndex];
      setFieldValue('services', nextServices);
      setAdditionalSelectedServices(nextServices);
    };

    // const handleJobTypeChange = (newValue) => {
    //   if(newValue?.name== 'No Charge' || newValue?.id==13){
    //     setNoCharge(true)
    //     // setFieldValue('client_approve',true)
    //   }else{
    //     setNoCharge(false)
    //     setFieldValue('no_charge_type', null)
    //   }
    //   if(newValue?.id !== 9){
    //     setFieldValue('is_split', null)
    //     setIsSplitOrder(false)
    //   }
    //   // if(newValue?.name == 'Service only' || newValue?.name == 'Time & Material'){
    //   if(newValue?.name == 'Time & Material'){
    //     setSelectedProducts([])
    //     setSelectedMapserviceProducts([]);
    //     setSelectedServices([])
    //     setAdditionalSelectedServices([])
    //     setSelectedMaterials([])
    //     setFilteredServices(labourCostServices)
    //     setCart([])
    //     setCartService([])
    //     setTabIndex(0)
    //     if(newValue?.name == 'Time & Material'){
    //       // addNewProductRow()
    //       // setMarkupType(1)
    //       // setFieldValue('client_approve',true)
    //     }else{
    //       setSelectedMaterials([])
    //     }
    //   }
    //   if(values.project_category?.name == 'Time & Material' || values.project_category?.id == 14){
    //     setSelectedProducts([])
    //     setSelectedMapserviceProducts([]);
    //     setSelectedServices([])
    //     setAdditionalSelectedServices([])
    //     setSelectedMaterials([])
    //     setCart([])
    //     setCartService([])
    //     setTabIndex(0)
    //     // setFieldValue('client_approve',true)
    //   }
    //   // if ( values.project_category?.name == 'Service only' ) {
    //   //   setSelectedMaterials([])
    //   // }
    //   autoSelectInstallLabour(newValue)
    //   setFieldValue('project_category', newValue)
    //   if (values?.project_type?.name !== 'TS' || newValue?.id != 14) {
    //     setFieldValue('map_service', null)
    //     // if(newValue?.name == 'Service only' || newValue?.name == 'Time & Material'){
    //     if(newValue?.name == 'Time & Material'){
    //       setSelectedProducts([]);
    //       setSelectedMapserviceProducts([]);
    //       setSelectedServices([])
    //     }
    //     setSelectedMapserviceProducts([]);
    //     // setSelectedServices([]);  this cause the calculation issue on Total Additional Service Cost (negative value)
    //     // const filteredProducts = selectedProducts?.filter(product => product?.fromMapServices !== true);
    //     // setSelectedProducts(filteredProducts);
    //   }
    // };

    const handleJobTypeChange = (newValue) => {
      // -------------------------------
      // 1) NO CHARGE LOGIC
      // -------------------------------
      if (newValue?.name == 'No Charge' || newValue?.id == 13) {
        setNoCharge(true);
      } else {
        setNoCharge(false);
        setFieldValue('no_charge_type', null);
      }

      // -------------------------------
      // 2) SPLIT ORDER RESET
      // -------------------------------
      if (newValue?.id !== 9) {
        setFieldValue('is_split', null);
        setIsSplitOrder(false);
      }

      // -------------------------------
      // 3) SWITCHING TO TIME & MATERIAL
      //    (Preserve services, only clear products/materials)
      // -------------------------------
      const switchingToTM = newValue?.name === 'Time & Material';

      if (switchingToTM) {
        setSelectedProducts([]);
        setSelectedMapserviceProducts([]);
        setSelectedMaterials([]);
        setFilteredServices(labourCostServices);
        setCart([]);
        setCartService([]);
        setTabIndex(0);
      }

      // -------------------------------
      // 4) SWITCHING AWAY FROM TIME & MATERIAL
      //    (Remove only auto-added install labour)
      // -------------------------------
      const switchingAwayFromTM =
        values.project_category?.name === 'Time & Material' &&
        newValue?.name !== 'Time & Material';

      if (switchingAwayFromTM) {
        const filteredServices = (additionalSelectedServices || []).filter(
          s => !(s.id === 10 && s.isAutoAdded)  // Remove only auto-added install labour
        );

        setAdditionalSelectedServices(filteredServices);
        setFieldValue('services', filteredServices);
      }

      // -------------------------------
      // 5) AUTO-ADD INSTALL LABOUR (category 12)
      // -------------------------------
      autoSelectInstallLabour(newValue);

      // -------------------------------
      // SERVICE ONLY (ID = 11) - Clean selected products
      // -------------------------------
      if (newValue?.id === 11) {
        const allowed = selectedProducts.filter(
          (p) => p.inhouse === 5 || p.isTrafficCatalog === 1
        );

        setSelectedProducts(allowed);
        setSelectedMapserviceProducts([]);  
        setSelectedMaterials([]);

        // ALSO update Formik values if needed
        setFieldValue('products', allowed);
      }

      // -------------------------------
      // 6) SET FINAL CATEGORY VALUE
      // -------------------------------
      setFieldValue('project_category', newValue);

      // -------------------------------
      // 7) CLEAR MAP SERVICES ONLY IF NOT CATEGORY 14
      // -------------------------------
      if (values?.project_type?.name !== 'TS' || newValue?.id != 14) {
        setFieldValue('map_service', null);

        if (newValue?.name == 'Time & Material') {
          setSelectedProducts([]);
          setSelectedMapserviceProducts([]);
        }

        setSelectedMapserviceProducts([]);
      }
    };

  return (
    <Page title="Sign Wise Solutions" >

      {(loading || convertToRFQ) ? 
        <Stack sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', alignContent: 'center',mt:8 }} >
          <LoadingScreen />
        </Stack>
      :
        <Container sx={{mt:3}}>
          <Button
            variant="outlined"
            type="submit"
            // onClick={()=>navigate(PATH_DASHBOARD.official.root)}
            // onClick={() => { window.history.back() }}
            onClick={() => {
              openEdit ? handleCancel(true) : handleCancel() //setOpenEdit(false) //handleCancel() // navigate(PATH_DASHBOARD.official.root)}
            }}
            sx={{ alignItems: 'flex-end', mb: 4 }}
            startIcon={ // Use the startIcon prop to add an icon to the left
              <Stack>
                <KeyboardBackspaceOutlined />
              </Stack>

            }
          >
            Back
          </Button>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <HeaderBreadcrumbs
              heading={details?.name}
            />
            {!openEdit && (
              <Stack marginBottom={5} flexDirection={'column'}>
                <Stack direction={'row'} alignItems={'center'} spacing={1}>
                  {(user.isVendor === 1 && proposalData && !proposalData?.length > 0) && (<Button
                    size="small"
                    variant="contained"
                    disabled={explodedPermissions?.some(permission => ['Submit Proposal'].includes(permission)) ? false : true}
                    onClick={() => setAddProposal(true)}
                    sx={{ height: 34 }}
                    startIcon={<Icon icon={plusFill} />}
                  >
                    Submit Proposal
                  </Button>)}
                </Stack>
                {(userType != 3 || (userType ==3 && details?.status == 2) ) ?
                  <Stack>
                    {(details && invoice) ? (
                      <Stack flexDirection={'row'} gap={2}>
                        {details?.proj_status !== 3 && userType !== 3 ?
                          <Stack
                            direction={'row'} alignItems={'center'} spacing={1}
                          >
                            <Button
                              onClick={() => {
                                setOpenHoldPopup(true)
                              }}
                              sx={{
                                borderRadius: 20,
                                backgroundColor: theme.palette.warning.main,
                                color: 'black',
                                boxShadow: 'none',
                                '&:hover': {
                                  backgroundColor: theme.palette.warning.dark,
                                  boxShadow: 'none',
                                },
                              }}
                              variant="contained"
                            >
                              {details?.hold === 0
                                ? 'Move to Hold'
                                : 'Release from Hold'}
                            </Button>
                          </Stack> : ''
                        }
                        {((((details?.status !== 6 && !details?.installationStatus && empty(details?.allInstallationCompleted)&& !details?.for_parent_facility) || (details?.noServiceNoTask != 1)) && details?.status !=10 && details?.allInstallationCompleted !== 1 && details?.hold !==1 && !details?.for_parent_facility ) || details?.isReview ==2)? (
                        /* {((details?.status !== 6 && !details?.installationStatus && empty(details?.allInstallationCompleted)) || (details?.noServiceNoTask != 1 && details?.proj_status != 3)) && details?.status !=10 && ( */
                          <Tooltip title="Edit">
                            <IconButton sx={{ backgroundColor: theme.palette.divider }} onClick={() => {
                              explodedPermissions?.some(permission => ['Edit Request'].includes(permission))
                                ? handleEditClick()
                                : !empty(details?.allInstallationCompleted)
                                  ? enqueueSnackbar("Cannot edit. Job has been completed", { variant: 'error' })
                                : details?.installationStatus
                                  ? enqueueSnackbar("Access Denied: Moved to Installation Phase", { variant: 'error' })
                                  : enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' });
                            }}>
                              <Icon icon={editFill} width={24} height={24} color="#ffffff" />
                            </IconButton>
                          </Tooltip>
                        ) : ''}

                       {((details?.allInstallationCompleted !== 1) || details?.isReview ==2) ? (
                            /* (details?.allInstallationCompleted !== 1 && details?.noServiceNoTask == 1) ? ( */
                            <Tooltip title="Delete">
                              <IconButton sx={{ backgroundColor: theme.palette.divider }} onClick={() => {
                                explodedPermissions?.some(permission => ['Delete request'].includes(permission))
                                  ? handleDeleteMenu()
                                  : enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' });
                              }}>
                                <Icon icon={trash2Outline} width={24} height={24} color="#ffffff" />
                              </IconButton>
                            </Tooltip>
                          ) : ''
                        }

                        {/* {!details || (details?.installationStatus || (details?.proj_status == 3 && !details?.total_installation_count)) || (details?.noServiceNoTask !== 1 && details?.proj_status == 3) ||  details?.status ==10 ? '' :
                          <Tooltip title="Delete">
                            <IconButton sx={{ backgroundColor: theme.palette.divider }} onClick={() => {
                              explodedPermissions?.some(permission => ['Delete request'].includes(permission))
                              ? handleDeleteMenu()
                              : enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' });
                            }}>
                              <Icon icon={trash2Outline} width={24} height={24} color="#ffffff" />
                            </IconButton>
                          </Tooltip>
                        } */}

                        {details?.status === 6 ? (
                          <Tooltip title="Reopen">
                            <IconButton sx={{ backgroundColor: theme.palette.divider }} onClick={handleReopen}>
                              <Icon icon={lockOpenFill} width={24} height={24} color="#ffffff" />
                            </IconButton>
                          </Tooltip>
                        ) : ''}
                        {console.log("invouiceeeeeeeeee",invoice)}
                        {explodedPermissions?.some(permission => ['Create Request','Edit Request','Delete request'].includes(permission)) ?
                          (details?.status === 3 &&details?.hold !== 1 && (details.project_category ==13 ||details?.min_payment_status ==1) && (
                            <AnimatedButton 
                            title={(details?.noServiceNoTask === 1 &&invoice?.cust_product?.length === 0 
                              && invoice?.jobcost_service?.every(service => service?.makeAsTask === 0)
                               ) ? 'Convert to Invoicing' : 'Convert to Production'} onClick={()=>{ setOpenConvertToRFQ(true); console.log('details-setOpenConvertToRFQ--',details); }} />
                          )) : '' }
                          
                          {explodedPermissions?.some(permission => ['Create Request','Edit Request','Delete request'].includes(permission)) ?
                          (details?.installation_acceptance === 1 && details?.allInstallationCompleted ? (
                            <AnimatedButton title={'Duplicate Sales Order'} onClick={()=>{ 
                              setOpenDuplicate(true)
                              // handleDuplicateSalesOrder() 
                              }} 
                            />
                          ) :"") : ''
                          }
                        {/* {details?.status === 3 && (
                          <Tooltip title="Convert to Production">
                            <IconButton sx={{ backgroundColor: theme.palette.divider }} onClick={()=>{ setOpenConvertToRFQ(true); console.log('details-setOpenConvertToRFQ--',details); }}>
                              <Icon icon={plusFill} width={24} height={24} color="#ffffff" />
                            </IconButton>
                          </Tooltip>
                        )} */}
                      </Stack>
                    ) : (
                      <Stack flexDirection="row" alignItems="center" gap={1}>
                        <CircularProgress size={20} color="primary" variant="indeterminate" />
                        <Typography variant="body2" color="textSecondary">Loading data...</Typography>
                      </Stack>
                    )}
                  </Stack>
                : ""}
              </Stack>
            )}
          </Stack>
          {openEdit && (loadingEdit || !values?.name ? (
            <LoadingScreen />
          ) : (
            <FormikProvider value={formik}>
              <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
                <Grid container spacing={3}>

                  <Grid item xs={12} md={12}>
                    <Card sx={{ p: 3 }}>
                      <Stack spacing={3}>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                          <Stack flexDirection={'column'}>
                            {/* <LabelStyle>Name</LabelStyle> */}
                            <TextField
                              //   fullWidth
                              sx={{ width: 400 }}
                              label="Order Name"
                              {...getFieldProps('name')}
                              error={Boolean(touched.name && errors.name)}
                              helperText={touched.name && errors.name}
                            />
                          </Stack>
                        </Stack>
                        {/* <LabelStyle>Description</LabelStyle> */}
                        <TextField
                          fullWidth
                          multiline
                          minRows={3}
                          maxRows={7}
                          label="keep the summary brief and make it communicates"
                          {...getFieldProps('description')}
                          error={Boolean(touched.description && errors.description)}
                          helperText={touched.description && errors.description}
                        />
                        {/* <LabelStyle>Upload Approved Design</LabelStyle> */}
                        {/* <UploadAvatar
                        accept="image/*"
                        file={values.avatarUrl}
                        maxSize={3145728}
                        onDrop={handleDrop}
                        error={Boolean(touched.avatarUrl && errors.avatarUrl)}
                      /> */}
                        {/* <UploadMultiFile
                         showPreview
                        maxSize={3145728}
                        accept="image/*"
                         files={avatarUrl}
                        onDrop={handleDrop}
                        onRemove={handleRemove}
                        onRemoveAll={handleRemoveAll}
                    // error={Boolean(touched.avatarUrl && errors.avatarUrl)}
                    /> */}

                    {userType !== 3 &&
                                      explodedPermissions?.some((permission) =>
                                        ['Create Request'].includes(permission),
                                      ) && (
                                        <>
                                          {/* {values?.project_category?.name  != 'Service only' &&
                                            values?.project_category?.name  !=
                                              'Time & Material' && (
                                              <> */}
                                                <LabelStyle>Upload Designs / Documents</LabelStyle>
                                                <UploadMultiFile
                                                  showPreview
                                                  // maxSize={3145728}
                                                  maxSize={15 * 1024 * 1024}
                                                  accept="image/*,application/pdf"
                                                  files={avatarUrl}
                                                  onDrop={handleDrop}
                                                  onRemove={handleRemove}
                                                  onRemoveAll={handleRemoveAll}
                                                  isUploading={isUploading}
                                                  // error={Boolean(touched.avatarUrl && errors.avatarUrl)}
                                                />
                                              {/* </>
                                            )} */}
                                            </>)
                    }




                        {/* <LabelStyle>Skills or services required</LabelStyle> */}
                        {/* //for client */}
                         {
                        userType !==3 ?
                        
                        <>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                          {/* <Autocomplete
                          multiple
                          fullWidth
                          id="combo-box-demo"
                          options={skills}
                          value={values.skills}
                          onChange={(event, newValue) => setFieldValue('skills', newValue)}
                          renderInput={(params) => (
                            <TextField {...params} label="Skills or services required" />
                          )}
                          getOptionLabel={(option) => option.name}
                        /> */}
                          <Autocomplete
                            sx={{ width: '50%' }}
                            id="combo-box-demo"
                            disabled={details?.checkProjectExist ? true : false}
                            options={allClientsEdit}
                            value={values.clients}
                            onChange={(event, newValue) => {
                              if (newValue) {
                                setFieldValue('clients', newValue);
                                setFieldValue('community', null);
                                fetchAllCommunityByClient(newValue);
                              } else {
                                setFieldValue('clients', null);
                                setFieldValue('community', null);
                                setCommunities([]);
                              }
                            }}

                            renderInput={(params) => (
                              <TextField required
                                {...params} label="Clients"
                                error={Boolean(touched.clients && errors.clients)}
                                helperText={touched.clients && errors.clients} />
                            )}
                            getOptionLabel={(option) => option.name}
                          />
                          {isCommunityLoading ?
                              <Stack flexDirection={'row'} alignItems='center' justifyContent='center'>
                                <CircularProgress color="primary" variant="indeterminate" />
                                <Typography variant='body2'>Loading projects...</Typography>
                              </Stack> :
                          communities.length > 0 ? (<Autocomplete
                            sx={{ width: '50%' }}
                            id="community"
                            options={communities}
                            value={values.community}
                            onChange={(event, newValue) => {
                              if(newValue){
                              setFieldValue('community', newValue)
                              if (newValue.address || newValue.city || newValue.state || newValue.zip) {
                                const { address, city, state, zip } = newValue;
                        
                                // 3) Update selected products’ addresses
                                // setSelectedProducts((prevProducts) =>
                                //   prevProducts.map((product) => {
                                //     if (product?.fromMapServices == true) {
                                //       return product;
                                //     }else{
                                //       const updatedAddresses = product?.location.map((loc) => ({
                                //         ...loc,
                                //         address: address || loc.address,
                                //         city: city || loc.city,
                                //         state: state || loc.state,
                                //         zip: zip || loc.zip,
                                //       }));
                                //       return { ...product, location: updatedAddresses ,is_single_card: true,allLocationSame: true};
                                //     }
                                //   })
                                // );
                                setSelectedProducts((prevProducts) =>
                                  prevProducts.map((product) => {
                                   if (product?.fromMapServices == true) {
                                     return product;
                                   }else{
                                     // For split orders, ensure proper address population
                                     if (isSplitOrder) {
                                       // For split orders, create proper locations based on quantity
                                       const locationQuantity = product.locationQuantity || product.quantity || 1;
                                       const updatedAddresses = Array.from({ length: locationQuantity }, () => ({
                                         id: 0,
                                         address: address,
                                         city: city,
                                         state: state,
                                         zip: zip,
                                       }));
                                       return { ...product, location: updatedAddresses ,is_single_card: true,allLocationSame: true };
                                     } else {
                                       // For normal orders, use existing logic
                                       const updatedAddresses = product.location?.map((loc) => ({
                                         ...loc,
                                         address: address || loc.address,
                                         city: city || loc.city,
                                         state: state || loc.state,
                                         zip: zip || loc.zip,
                                       }))
                                       return { ...product, location: updatedAddresses ,is_single_card: true,allLocationSame: true };
                                     }
                                   }
                                  })
                                );


                                console.log("cartServicecartServicecartService",selectedProducts)
                                // 4) Update selected services’ addresses (if applicable)
                                setAdditionalSelectedServices((prevServices) =>
                                  prevServices.map((service) => {
                                    const updatedAddresses = service.addresses.map((loc) => ({
                                      ...loc,
                                      address: address || loc.address,
                                      city: city || loc.city,
                                      state: state || loc.state,
                                      zip: zip || loc.zip,
                                    }));
                                    return { ...service, addresses: updatedAddresses };
                                  })
                                );


                                // 5) Update RFP Products’ addresses
                                

                                setCart((prevCart) =>
                                  prevCart.map((product) => {
                                    const updatedAddresses = (product.location).map((loc) => ({
                                      ...loc,
                                      address: address || loc.address,
                                      city: city || loc.city,
                                      state: state || loc.state,
                                      zip: zip || loc.zip,
                                    }));
                                    return { ...product, location: updatedAddresses };
                                  })
                                );

                                  // 6) Update RFP Services’ addresses (only for 'Service only' category)
                                  //  if (values.project_category?.name === 'Service only') {
                                    // console.log("cartServicecartServicecartService",cartService)
                                    setCartService((prevServices) =>
                                      prevServices?.map((service) => {
                                        const updatedAddresses = (service?.location|| []).map((loc) => ({
                                          ...loc,
                                          address: address || loc.address,
                                          city: city || loc.city,
                                          state: state || loc.state,
                                          zip: zip || loc.zip,
                                        }));
                                        return { ...service, location: updatedAddresses };
                                      })
                                    );
                                  // }
                                }
                              if(newValue.tax_category){
                              let taxCat = taxCategories?.find(cat => newValue.tax_category === cat.id)
                              setSelectedTaxCategory(taxCat)
                              }
                            }else {
                              setFieldValue('community', null);
                              setSelectedTaxCategory(null);
                            }
                            }}
                            renderInput={(params) => (
                              <TextField required
                                {...params} label="Project"
                                error={Boolean(touched.community && errors.community)}
                                helperText={touched.community && errors.community} />
                            )}
                            getOptionLabel={(option) => option.name}
                          />) : (
                            <Stack sx={{ width: '50%' }} justifyContent={'center'}>
                              {values?.clients ?
                                <Typography sx={{ color: "red" }}>The selected client does not have any projects yet. Please create a new project for them!</Typography>
                                : <Typography sx={{ color: "red" }}>No client selected. Please choose a client from the list.</Typography>}
                            </Stack>
                          )
                        }
                        </Stack>

                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                          <Autocomplete
                            fullWidth
                            id="combo-box-demo-type"
                            options={projectTypes}
                            value={values.project_type}
                            onChange={(event, newValue) => {
                              setFieldValue('project_type', newValue)
                              setFieldValue('project_category', null)
                              setFieldValue('map_service', null)
                              if (newValue?.name !== 'TS') {
                                setFieldValue('map_service', null)
                                const filteredProducts = selectedProducts?.filter(product => product?.fromMapServices !== true);
                                setSelectedProducts(filteredProducts);
                              }
                            }}
                            renderInput={(params) => (
                              <TextField required
                                {...params} label="Job Class"
                                error={Boolean(touched.project_type && errors.project_type)}
                                helperText={touched.project_type && errors.project_type} />
                            )}
                            getOptionLabel={(option) => option.name}

                          />

                          {/* <Autocomplete
                            fullWidth
                            disabled
                            id="combo-box-demo-type"
                            options={markupTypes}
                            value={values.markup_type}
                            onChange={(event, newValue) => {
                              setFieldValue('markup_type', newValue)
                              setMarkupType(newValue?.id)
                            }}
                            renderInput={(params) => (
                              <TextField required
                                {...params} label="Markup Type"
                                error={Boolean(touched.markup_type && errors.markup_type)}
                                helperText={touched.markup_type && errors.markup_type} />
                            )}
                            getOptionLabel={(option) => option.name}
                          /> */}
                        </Stack>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                          <Autocomplete
                            // fullWidth
                            sx={{ width: '50%' }}
                            id="combo-box-demo-category"
                            // options={projectCategories}
                            options={(values.project_type?.name == 'TS') ? projectCategories : projectCategories?.filter(ite=>ite.id != 14)}
                            value={values.project_category}
                            onChange={(event, newValue) => {
                              const isSwitchingFromTM =
                                values.project_category?.name === "Time & Material" &&
                                newValue?.name !== "Time & Material";

                              if (isSwitchingFromTM && selectedProducts?.length > 0) {
                                setPendingJobType(newValue);
                                setOpenChangeJobTypeDialog(true);
                                return; // STOP → wait for dialog confirmation
                              }
                              handleJobTypeChange(newValue);
                            }}
                            renderInput={(params) => (
                              <TextField required
                                {...params} label="Job Type"
                                error={Boolean(touched.project_category && errors.project_category)}
                                helperText={touched.project_category && errors.project_category} />
                            )}
                            getOptionLabel={(option) => option.name}
                          />
                            
                          {values.project_category?.id == 14 ? 
                            <Autocomplete
                              // fullWidth
                              sx={{ width: '50%' }}
                              id="combo-box-demo-type"
                              options={mapServices}
                              value={values.map_service}
                              onChange={(event, newValue) => {
                                console.log('map_service==newValue', newValue)
                                setFieldValue('map_service', newValue)
                                if (newValue?.products) {
                                  let newIndexCounter = indexCounter;
                                  const updatedProductsWithLocations = newValue?.products?.map((product,index) => {
                                    const filteredData = allProducts?.find((i) => i.id === product.product_id);
                                    const associatedLocations = newValue?.locations
                                      .filter((location) => location?.route_product_id === product?.id)
                                      .map((location) => ({
                                        address: location.address,
                                        city: location.city,
                                        state: location.state,
                                        zip: location.zip,
                                        route_location_id: location.id,
                                      }));
                                      newIndexCounter += 1;
                                    return {
                                      ...product,
                                      ...filteredData,
                                      indexId: newIndexCounter, // `map_${index}`,
                                      fromMapServices:true,
                                      locationQuantity: product?.qty,
                                      location: associatedLocations,
                                      discount: 0,
                                      adjustment: 0,
                                      quantity: 1,
                                      markAdjType:1
                                    };
                                  });
                                  console.log('updatedProductsWithLocations-----------',updatedProductsWithLocations)
                                  const mergedSelectedProducts = [
                                    ...selectedProducts.filter((product) => product?.fromMapServices !== true), // Keep existing products without fromMapServices
                                    ...updatedProductsWithLocations, // Add the new products from map services
                                  ];
                                  setSelectedMapserviceProducts(updatedProductsWithLocations);
                                  setSelectedProducts(mergedSelectedProducts);
                                  setIndexCounter(newIndexCounter);
                                  const productServices = mergedSelectedProducts?.reduce((services, product) => {
                                    if (product.services && product.services.length > 0) {
                                      return services.concat(
                                        product.services.map((service) => ({
                                          ...service,
                                          fromMapServices:product?.fromMapServices || false,
                                          productIndex: product?.indexId,
                                          quantity: service.quantity * product.quantity * product.locationQuantity,
                                          previousQty: service.quantity,
                                          qtyData: product.quantity,
                                          locationQuantity: product.locationQuantity,
                                        }))
                                      );
                                    }
                                    return services;
                                  }, []);
                                  setSelectedServices(productServices);
                                }
                              }}
                              renderInput={(params) => (
                                <TextField required
                                  {...params} label="Routes"
                                  error={Boolean(touched.map_service && errors.map_service)}
                                  helperText={touched.map_service && errors.map_service} />
                              )}
                              // getOptionLabel={(option) => option.name}
                              getOptionLabel={(option) => `${option.name} (${option.locations_count})`}
                            /> 
                          : '' }

                          {values.project_category?.id  == 15 ? (
                              <Autocomplete
                                // fullWidth
                                sx={{ width: '50%' }}
                                id="combo-box-demo-type"
                                options={catalogTypes}
                                value={values.catalog_type}
                                onChange={(event, newValue) => {
                                  setFieldValue('catalog_type', newValue)
                                  setFieldValue('products', [])
                                  setSelectedProducts([])
                                  setSelectedServices([])
                                  console.log('newValue=======', newValue)
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    required
                                    {...params}
                                    label="Catalog"
                                    error={Boolean(
                                      touched.catalog_type && errors.catalog_type,
                                    )}
                                    helperText={
                                      touched.catalog_type && errors.catalog_type
                                    }
                                  />
                                )}
                                getOptionLabel={(option) => option.label}
                              />
                            ) : (
                              ''
                            )}

                          {values?.project_category?.id===13 &&
                            <Autocomplete
                              // fullWidth
                              sx={{ width: '50%' }}
                              id="combo-box-demo-type"
                              options={noChargeType}
                              value={values.no_charge_type}
                              onChange={(event, newValue) => {
                                setFieldValue('no_charge_type', newValue)
                                // setMarkupType(newValue?.id)
                              }}
                              renderInput={(params) => (
                                <TextField required
                                  {...params} label="No charge Type"
                                  error={Boolean(touched.no_charge_type && errors.no_charge_type)}
                                  helperText={touched.no_charge_type && errors.no_charge_type} />
                              )}
                              getOptionLabel={(option) => option.name}
                            />}
                        </Stack>
                        {/* <Stack>
                      <Autocomplete
                          multiple
                          fullWidth
                          id="combo-box-demo"
                          options={workflow}
                          value={values.workflow}
                          onChange={(event, newValue) => setFieldValue('workflow', newValue)}
                          renderInput={(params) => (
                            <TextField {...params} label="Workflow" />
                          )}
                          getOptionLabel={(option) => option.name}

                          />
                      </Stack> */}
                      </>
                      :""}

                  {
                    values?.project_category?.id === 9 ? (
                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={{ xs: 3, sm: 2 }}
                      >
                        <Autocomplete
                          sx={{ width: '50%' }}
                          id="split-type-autocomplete"
                          options={[{ id: 1, label: 'Split' }]}
                          disabled={isSplitOrder}
                          value={values.is_split || null}
                              onChange={(event, newValue) => {
                                setFieldValue('is_split', newValue);
                                // Update isSplitOrder based on the form field value
                                setIsSplitOrder(!!newValue);
                                
                                // If split order is enabled, set default facility
                                if (newValue) {
                                  const defaultFacility = FacilityTypes?.filter(fac => fac.default);
                                  setFieldValue('facility_type', defaultFacility || []);
                                } else {
                                  // If split order is disabled, clear facility_type
                                  setFieldValue('facility_type', []);
                                }
                          }}
                          getOptionLabel={(option) => option?.label ?? ''}
                          isOptionEqualToValue={(option, value) => option?.id === value?.id}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Choose Split Type"
                              placeholder="Select split type"
                              error={Boolean(touched.is_split && errors.is_split)}
                              helperText={touched.is_split && errors.is_split}
                            />
                          )}
                        />

                        {
                          isSplitOrder ?(
                          
                            <Autocomplete
                            multiple
                            disableCloseOnSelect
                            filterSelectedOptions
                            sx={{ width: '50%' }}
                            id="combo-box-demo-type"
                            options={FacilityTypes || []}
                            value={values.facility_type || []}   
                            onChange={(event, newValue) => {
                              setFieldValue('facility_type', newValue);
                              let filteredVaue = newValue.find(v => !v.default )
                              const selectedData = (Array.isArray(filteredVaue) ? filteredVaue : [filteredVaue]) .map(v => {
                                const id = typeof v === 'object' ? v?.id : v;
                                return splitManagementSettings?.find(s => String(s?.id) === String(id));
                              })
                              .filter(Boolean);

                              setSelectedSplitOrderSettings(selectedData)
                            }}
                            getOptionLabel={(option) => option?.label ?? ''}
                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                            renderTags={(selected, getTagProps) =>
                              selected.map((option, index) => (
                                <Chip
                                  key={option?.id ?? option?.label ?? index}
                                  label={option?.label}
                                  size="small"
                                  color={option?.color}//"primary"
                                  variant="outlined"
                                  {...getTagProps({ index })} // handles delete icon
                                />
                              ))
                            }
                            renderInput={(params) => (
                              <TextField
                                required
                                {...params}
                                label="Choose Facility"
                                placeholder="Select facilities"
                                error={Boolean(touched.facility_type && errors.facility_type)}
                                helperText={touched.facility_type && errors.facility_type}
                              />
                            )}
                          />
                          )
                          :""
                        }

                        </Stack>
                    )
                      : ''
                    }

                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                          <Box
                            component={MobileDatePicker}
                            label="Start Date"
                            minDate={moment()}
                            defaultValue={moment.unix(values.start).format('MM/DD/YYYY')}
                            value={moment.unix(values.start)}
                            onChange={(date) => setFieldValue('start', moment(date).unix())}
                            renderInput={(params) => (
                              <TextField size="small" {...params} fullWidth />
                            )}
                          />

                          <Box
                            component={MobileDatePicker}
                            label="Installation Date"
                            minDate={moment()}
                            defaultValue={moment.unix(values.end).format('MM/DD/YYYY')}
                            value={values.end ? moment.unix(values.end) : null}
                            onChange={(date) => {
                              setFieldValue('end', moment(date).unix());
                              // Clear installation start/end dates when single date is selected
                              setFieldValue('installation_start_date', null);
                              setFieldValue('installation_end_date', null);
                            }}
                            renderInput={(params) => (
                              <TextField size="small" {...params} fullWidth
                                error={Boolean(touched.end && errors.end)}
                                helperText={touched.end && errors.end}
                              />
                            )}
                          />
                        </Stack>
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 2, mb: 1, fontStyle: 'italic' }}>
                          Choose either single installation date above OR installation date range below
                        </Typography>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                          <Box
                            component={MobileDatePicker}
                            minDate={moment()}
                            label="Installation Start Date"
                            value={values.installation_start_date ? moment.unix(values.installation_start_date) : null}
                            onChange={(date) => {
                              setFieldValue('installation_start_date', moment(date).unix());
                              // Clear single installation date when range is selected
                              setFieldValue('end', null);
                            }}
                            renderInput={(params) => (
                              <TextField 
                                size="small" 
                                {...params} 
                                fullWidth
                                error={Boolean(touched.installation_start_date && errors.installation_start_date)}
                                helperText={touched.installation_start_date && errors.installation_start_date}
                              />
                            )}
                          />
                          <Box
                            component={MobileDatePicker}
                            minDate={values.installation_start_date ? moment.unix(values.installation_start_date) : moment()}
                            label="Installation End Date"
                            value={values.installation_end_date ? moment.unix(values.installation_end_date) : null}
                            onChange={(date) => {
                              setFieldValue('installation_end_date', moment(date).unix());
                              // Clear single installation date when range is selected
                              setFieldValue('end', null);
                            }}
                            renderInput={(params) => (
                              <TextField 
                                size="small" 
                                {...params} 
                                fullWidth
                                error={Boolean(touched.installation_end_date && errors.installation_end_date)}
                                helperText={touched.installation_end_date && errors.installation_end_date}
                              />
                            )}
                          />
                        </Stack>

              {/* //for client */}
                       {
                        userType !==3 ?
                        
                        <>
                        {values.project_category?.name == 'Service only old' || values.project_category?.name == 'Time & Material'  ? '' : <>
                        <Divider />
                        <LabelStyleHead>Products</LabelStyleHead>
                        {false ? 
                        // {values.project_category?.name == 'Time & Material' ? 
                        <>
                        <Scrollbar>
                          <TableContainer sx={{ minWidth: 500 }}>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  {VALUE_TIME?.map((val) => (
                                    val.id === 14 ? (
                                      <Tooltip key={val.id} title="Selling Price With Marketing Adjustment">
                                        <TableCell>{val.value}</TableCell>
                                      </Tooltip>) :
                                    <TableCell key={val.id}>{val.value}</TableCell>
                                  ))}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {selectedProducts?.sort((a, b) => a.indexId - b.indexId)?.map((data, index) => {
                                  console.log("edit product log ---",data)
                                  const quantityFieldName = `quantity_${data.product_id || data.id}`;
                                  const discountFieldName = `discount_${data.product_id || data.id}`;
                                  const adjustmentFieldName = `adjustment_${data.product_id || data.id}`;

                                  let unitName = UNITS?.filter((item) => item?.id == data?.unit)
                                  unitName = unitName[0]?.name
                                  let shortUnitName = ''
                                  if (unitName == 'Square feet') {
                                    shortUnitName = 'Sq ft'
                                  } else if (unitName == 'Lineal feet') {
                                    shortUnitName = 'Lin ft'
                                  } else if (unitName == 'Square Inches') {
                                    shortUnitName = 'Sq Inches'
                                  } else if (unitName == 'Unit') {
                                    shortUnitName = 'Unit'
                                  }
                                  data['expected_cost'] = data.expected_cost || 0
                                  data['expected_material_cost'] = data.expected_material_cost || 0
                                  data['expected_service_cost'] = data.expected_service_cost || 0
                                  data['expected_total_service_cost'] = data.expected_total_service_cost || 0
                                  const dataPrice = data.price ? data.price : 0
                                  const dataretailPrice = data.retail_price ? data.retail_price : 0
                                  const dataWholesalePrice = data.price ? data.price : 0
                                  // const dataQuantity = values[quantityFieldName]
                                  const dataQuantity = data.quantity || 1
                                  console.log('data.discount--', data.discount);
                                  const dataDiscount = data.discount ? data.discount : 0

                                  const rowTotal = calculateTotal(markupType == 1 ? dataWholesalePrice : (markupType == 2 ? dataretailPrice : 0), dataQuantity, dataDiscount, data.quantity, data.locationQuantity, Number(data?.adjustment),data.markAdjType);
                                  // const markup = ((dataretailPrice - dataPrice) / dataPrice) * 100;
                                  const invoiceAmount = parseFloat(data?.expected_material_cost) + parseFloat(data?.expected_total_service_cost?.toFixed(2))
                                  console.log("rowTotal---------", rowTotal)
                                  
                                  data['markup'] = 0
                                  totalMarkup += 0
                                  data['markup_type'] = markupType
                                  data['totalMarkup'] = totalMarkup?.toFixed(2)
                                  
                                  // values['totalMarkup'] = totalMarkup?.toFixed(2)
                                  productFormulaCost += parseFloat(data.expected_cost?.toFixed(2)) * data.quantity * data.locationQuantity

                                  const pfc = parseFloat(data.expected_cost?.toFixed(2)) * data.quantity * data.locationQuantity // total product formula cost
                                  const rtp = dataretailPrice * data.quantity * data.locationQuantity // total retail price
                                  const wsp = dataWholesalePrice * data.quantity * data.locationQuantity // total wholesale price

                                  const maxDiscount_wholesale = wsp - pfc
                                  const maxDiscount_retail = rtp - pfc

                                  // const maxDiscount_wholesale = (wsp - pfc) - DiscountTotal
                                  // const maxDiscount_retail = (rtp - pfc) - DiscountTotal

                                  console.log('dataWholesalePrice--', dataWholesalePrice);
                                  console.log('dataretailPrice--', dataretailPrice);
                                  console.log('maxDiscount_wholesale--', maxDiscount_wholesale);
                                  console.log('maxDiscount_retail--', maxDiscount_retail);
                                  console.log('DiscountTotal--', DiscountTotal);
                                  console.log('pfc--', pfc);
                                  console.log('rtp--', rtp);
                                  console.log('wsp--', wsp);
                                  data['product_total']=Number(rowTotal)
                                  data['retail_price']=Number(dataretailPrice)
                                  data['price']=Number(dataPrice)
                                  data['product_id']=null

                                  let SPMA = 0
                                  if(markupType){
                                    if(markupType == 1){
                                      if(data.markAdjType==2 || data.markAdjType==3) {
                                        SPMA = (Number(dataPrice) || 0) + (data.adjustment ? Number(data.adjustment) : 0)
                                      }else{
                                        SPMA = (dataPrice ? Number(dataPrice) : 0) + (((dataPrice ? Number(dataPrice) : 0) * (data.adjustment ? Number(data.adjustment) : 0)) / 100)
                                      }
                                    }else{
                                      if(data.markAdjType==2 || data.markAdjType==3) {
                                        SPMA = (Number(dataretailPrice) || 0) + (dataretailPrice ? Number(data.adjustment) : 0)
                                      }else{
                                        SPMA = (dataretailPrice ? Number(dataretailPrice) : 0) + (((dataretailPrice ? Number(dataretailPrice) : 0) * (dataretailPrice ? Number(data.adjustment) : 0)) / 100)
                                      }
                                    }
                                  }
                                  console.log('SPMA-----data.price-----',dataPrice)
                                  console.log('SPMA-----data.adjustment-----',data.adjustment)
                                  console.log('SPMA-----data.retail_price-----',dataretailPrice)
                                  console.log('SPMA-----SPMA-----SPMA',SPMA)

                                  SPMA = Number(SPMA)
                                  data['SPMA'] = SPMA?.toFixed(2)

                                  return (
                                    <>
                                      <TableRow key={index}>
                                        <TableCell>#{data.indexId}</TableCell>
                                        <TableCell>
                                          {/* albin */}
                                        {/* <TextField required
                                            fullWidth
                                            type='text'
                                            label={'Product Name'}
                                            sx={{ width: 85 }}
                                            value={data.product_name || data.name}
                                            onChange={(event) => {
                                              let newValue = event.target.value;
                                              if (newValue !== "") {
                                                setSelectedProducts(pv => ([...pv.map(p => {
                                                  if (p.indexId === data.indexId) {
                                                    return {
                                                      ...p,
                                                      name: newValue,
                                                    }
                                                  } else {
                                                    return p;
                                                  }
                                                })]));
                                                data['name'] = newValue || '';
                                              }
                                            }}
                                            // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                            // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                          /> */}

                                          {/* ram */}

                                          <TextField
                                            required
                                            fullWidth
                                            type="text"
                                            label="Product Name"
                                            sx={{ width: 85 }}
                                            value={data.product_name || ''} // Controlled component with default to empty string
                                            onChange={(event) => {
                                              const newValue = event.target.value;

                                              // Update the selected product's name based on its indexId
                                              setSelectedProducts((prevProducts) =>
                                                prevProducts.map((product) => {
                                                  if (product.indexId === data.indexId) {
                                                    return {
                                                      ...product,
                                                      product_name: newValue, // Update the product_name with newValue
                                                    };
                                                  }
                                                  return product;
                                                })
                                              );
                                              data['product_name'] = newValue || '';
                                              if (isSubmitted) setIsSubmitted(false);
                                            }}
                                            error={isSubmitted && (!data.product_name?.trim())}
                                            helperText={isSubmitted && (!data.product_name?.trim()) ? 'Product Name is required' : ''}
                                          />
                                        </TableCell>
                                        <TableCell>
                                          <IconButton onClick={() => handleOpenNote(data.indexId, data.product_notes)}>
                                            <NoteAdd
                                              sx={{
                                                color: (!data?.product_notes || data?.product_notes === '') ? '' : theme.palette.primary.main,
                                              }}
                                            />
                                          </IconButton>
                                        </TableCell>
                                        <TableCell>
                                          <TextField required
                                            fullWidth
                                            type='number'
                                            label={'Retail Price Each'}
                                            sx={{ width: 85 }}
                                            // disabled={(values.project_category?.name == 'Time & Material') ? true : false}
                                            value={data.actual_retail_price || data.retail_price || data.price}
                                            defaultValue={0}
                                            onChange={(event) => {
                                              let newValue = event.target.value;
                                              console.log('Selling Price newValue',newValue)
                                              if (newValue !== "") {
                                                setSelectedProducts(pv => ([...pv.map(p => {
                                                  console.log('Selling Price---data',data.indexId)
                                                  console.log('Selling Price---p',p.indexId)
                                                  if (p.indexId === data.indexId) {
                                                    return {
                                                      ...p,
                                                      retail_price: Number(newValue),
                                                      price: Number(newValue),
                                                      product_retail_price : Number(newValue),
                                                      product_price : Number(newValue),
                                                    }
                                                  } else {
                                                    return p;
                                                  }
                                                })]));
                                                data['retail_price'] = Number(newValue) || 0;
                                                data['product_retail_price'] = Number(newValue) || 0;
                                                data['price'] = Number(newValue) || 0;
                                                data['product_price'] = Number(newValue) || 0;
                                              }
                                            }}
                                            // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                            // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                          />
                                        </TableCell>
                                        {/* <TableCell>{hasMarkupPermission ? (data.SPMA || null) : null}</TableCell> */}
                                        <TableCell>
                                          <TextField
                                            type="number"
                                            sx={{ width: 85 }}
                                            onKeyPress={(event) => {
                                              if (event.key === '0' && event.target.value === '') {
                                                event.preventDefault();
                                              }
                                              if (event.key === '.') {
                                                event.preventDefault();
                                              }
                                            }}
                                            fullWidth
                                            label={shortUnitName}
                                            disabled={shortUnitName == 'Unit' ? true : false}
                                            // {...getFieldProps(quantityFieldName)}
                                            defaultValue={data.quantity ? data.quantity : 1}
                                            value={data.quantity ? data.quantity : 1}

                                            onChange={(event) => {

                                              let newValue = event.target.value;
                                              if (newValue.startsWith('-')) {
                                                newValue = newValue.slice(1);
                                              }
                                              newValue = newValue.replace(/[^0-9]/g, '');
                                              if (newValue === '' || Number(newValue) <= 0) {
                                                newValue = 1;
                                              }
                                              else {
                                                newValue = Number(newValue);
                                              }

                                              setSelectedProducts(pv => ([...pv.map(p => {
                                                // if (p.id === data.id) {
                                                if (p.indexId === data.indexId) {

                                                  // let arrayAddr

                                                  // const commonAddresses = (allLocationSame && pv.length > 0) ? [...pv[0].location][0]: null;

                                                  // if(allLocationSame && commonAddresses){
                                                  //   arrayAddr = Array((newValue)).fill().map((_, i) => ({
                                                  //     ...commonAddresses,
                                                  //     id: i
                                                  //   }));

                                                  // }
                                                  // else{
                                                  //   arrayAddr = [...p.location]
                                                  //   console.log("Hifiiiiiiiiiiiiii Aff",arrayAddr);
                                                  //   if(p.location.length<=newValue){
                                                  //     arrayAddr.push(...[...Array((newValue)-p.location.length)].map((a,i)=>{
                                                  //       return {
                                                  //         id: p.location.length + i,
                                                  //         address: '',
                                                  //         city: '',
                                                  //         state: '',
                                                  //         zip: '',
                                                  //       }
                                                  //     }))
                                                  //   }else{
                                                  //     arrayAddr = arrayAddr.slice(0,-(p.location.length-(newValue)));
                                                  //   }
                                                  // }

                                                  return {
                                                    ...p,
                                                    quantity: newValue,
                                                    // location: arrayAddr
                                                  }
                                                } else {
                                                  return p;
                                                }
                                              })]));
                                              console.log("###############SElected services", selectedServices);
                                              setSelectedServices(pv => ([...pv.map(service => {
                                                // if (service.product_id === data.id && service.prQty) {
                                                console.log('data---new----', data);
                                                console.log('service---new----', service);
                                                if (service.productIndex === data.indexId && service.prQty) {
                                                  return {
                                                    ...service,
                                                    quantity: (service.prQty * (newValue) * (service?.locationQuantity || 1)).toFixed(2),
                                                    qtyData: Number(newValue),
                                                  };
                                                } else {
                                                  return {
                                                    ...service,

                                                  }
                                                }
                                              })]));
                                              //new chnage on 2-2-24
                                              //   if (newValue === '.') {
                                              //     event.preventDefault();
                                              //     return;
                                              //   }
                                              // if (newValue === '' || newValue <= 0) {
                                              //   event.preventDefault();
                                              //   return;
                                              // }
                                              //   if (newValue.startsWith('-')) {
                                              //     newValue = newValue.slice(1);
                                              //   }
                                              data['quantity'] = newValue || 1;

                                              setFieldValue(quantityFieldName, newValue);
                                            }}

                                            error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                            helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                          />
                                        </TableCell>
                                        <TableCell>
                                          <TextField
                                            type="number"
                                            onKeyPress={(event) => {
                                              if (event.key === '0' && event.target.value === '') {
                                                event.preventDefault();
                                              }
                                              if (event.key === '.') {
                                                event.preventDefault();
                                              }
                                            }}
                                            fullWidth
                                            label={"Qty"}
                                            // {...getFieldProps(quantityFieldName)}
                                            defaultValue={data.locationQuantity ? data.locationQuantity : 1}
                                            value={data.locationQuantity ? data.locationQuantity : 1}
                                            onChange={(event) => {

                                              let newValue = event.target.value;
                                              if (newValue.startsWith('-')) {
                                                newValue = newValue.slice(1);
                                              }
                                              newValue = newValue.replace(/[^0-9]/g, '');
                                              if (newValue === '' || Number(newValue) <= 0) {
                                                newValue = 1;
                                              }
                                              else {
                                                newValue = Number(newValue);
                                              }

                                              setSelectedProducts(pv => ([...pv.map(p => {
                                                // if (p.id === data.id) {
                                                if (p.indexId === data.indexId) {

                                                  let arrayAddr

                                                  const commonAddresses = (data?.allLocationSame && pv.length > 0) ? p.location[0] : null;
                                                  console.log("Hifiiiiiiiiiiiiii Aff", commonAddresses);
                                                  if (data?.allLocationSame && commonAddresses) {
                                                    arrayAddr = Array(Number(newValue)).fill().map((_, i) => ({ //1
                                                      ...commonAddresses,
                                                      id: i,
                                                      req_loc_id: p.location[i]?.req_loc_id ?? null,
                                                    }));

                                                  }
                                                  else {
                                                    arrayAddr = [...p.location]
                                                    console.log("Hifiiiiiiiiiiiiii Aff", arrayAddr);
                                                    if (p.location.length <= Number(newValue)) { //1
                                                      arrayAddr.push(...[...Array(Number(newValue) - p.location.length)].map((a, i) => { //1
                                                        return {
                                                          id: p.location.length + i,
                                                          address: '',
                                                          city: '',
                                                          state: '',
                                                          zip: '',
                                                        }
                                                      }))
                                                    }
                                                    else if (p.location.length > Number(newValue)) { //1
                                                      arrayAddr = arrayAddr.slice(0, Number(newValue)); //1
                                                    }
                                                    else {
                                                      arrayAddr = arrayAddr.slice(0, -(p.location.length - (newValue)));
                                                    }
                                                  }

                                                  return {
                                                    ...p,
                                                    // quantity:newValue,
                                                    locationQuantity: newValue,
                                                    location: arrayAddr
                                                  }
                                                } else {
                                                  return p;
                                                }
                                              })]));
                                              setSelectedServices(pv => ([...pv.map(service => {
                                                console.log("############@@@@@@@@@@service", service);
                                                console.log("############@@@@@@@@@@data", data);
                                                if (service.productIndex === data.indexId && service.prQty) {
                                                  console.log("############service.newValue", newValue);
                                                  return {
                                                    ...service,
                                                    quantity: (newValue * (service.qtyData || 1) * service.prQty).toFixed(2),
                                                    locationQuantity: newValue,
                                                  };
                                                } else {
                                                  return {
                                                    ...service,

                                                  }
                                                }
                                              })]));
                                            }}

                                            error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                            helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                          />
                                        </TableCell>
                                        <TableCell>
                                          <IconButton
                                            onClick={() => {
                                              setLocationStates({ ...locationStates, [data.indexId]: true });
                                            }}
                                          >
                                            <LocationOn sx={{
                                              color: data.location.some(obj =>
                                                [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
                                              ) ? '' : theme.palette.primary.main
                                            }} />
                                          </IconButton>
                                        </TableCell>
                                        {/* <TableCell>{data.product_id||data.id}</TableCell> */}

                                        {/* <TableCell>
                                      <Autocomplete
  sx={{ width: 70 }}
  id="combo-box-demo"
  disableClearable
  options={marketingAdjustmentType || []}
  value={marketingAdjustmentType?.find((type) => type.id === data.markAdjType)} // Use value to set the correct selected option
  onChange={(event, newValue) => {
    console.log(newValue)
    setSelectedProducts((prevProducts) => {
      return prevProducts.map((product) => {
        if (product.indexId === data.indexId) {
          return {
            ...product,
            markAdjType: newValue?.id, // Set adjustment type or default to the first option
            adjustment: 0,
          };
        }
        return product;
      });
    });
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      required
      error={Boolean(touched.marketingAdjType && errors.marketingAdjType)}
      helperText={touched.marketingAdjType && errors.marketingAdjType}
      label="Select type"
    />
  )}
  getOptionLabel={(option) => (option.name ? option.name : '')}
/>

                                          </TableCell> */}
                                        {/* <TableCell> */}
                                          {/* <TextField
                                            type="number"
                                            label="Discount"
                                            value={Number(data.discount)}
                                            // {...getFieldProps(discountFieldName)}
                                            defaultValue={data.discount ? data.discount : 0}
                                            onChange={(event) => {
                                              let newValue = event.target.value;
                                              if (newValue.startsWith('-')) {
                                                newValue = newValue.slice(1);
                                              }
                                              if (markupType == 1) {
                                                if (Number(newValue) > maxDiscount_wholesale) {
                                                  newValue = maxDiscount_wholesale.toFixed(2);
                                                }
                                              } else if (markupType == 2) {
                                                if (Number(newValue) > maxDiscount_retail) {
                                                  newValue = maxDiscount_retail.toFixed(2);
                                                }
                                              } else {
                                                newValue = 0;
                                              }
                                              if (newValue === '-0.00') {
                                                newValue = 0;
                                              }
                                              setRefreshData(!refreshData)
                                              data['discount'] = newValue
                                              setFieldValue(discountFieldName, newValue);
                                            }}
                                            error={Boolean(touched[discountFieldName] && errors[discountFieldName])}
                                            helperText={touched[discountFieldName] && errors[discountFieldName]}
                                            inputProps={{ max: markupType == 1 ? maxDiscount_wholesale : markupType == 2 ? maxDiscount_retail : 0, min: 0 }}
                                          /> */}

                                          {/* <TextField
                                            type="number"
                                            label={
                                              data.markAdjType === 2 ? "$" : data.markAdjType === 3 ? "¢" : "%"
                                            }
                                            // value={Number(data?.adjustment)}
                                            value={Number(data.adjustment).toFixed(2)}
                                            defaultValue={data?.adjustment ? Number(data?.adjustment) : 0}
                                            onChange={(event) => {
                                              let newValue = event.target.value;
                                              if (newValue.startsWith('-')) {
                                                newValue = newValue.slice(1);
                                              }
                                              
                                              if (newValue === '-0.00') {
                                                newValue = 0;
                                              }
                                              setRefreshData(!refreshData)
                                              data['adjustment'] = newValue
                                              setFieldValue(adjustmentFieldName, newValue);
                                            }}
                                            error={Boolean(touched[adjustmentFieldName] && errors[adjustmentFieldName])}
                                            helperText={touched[adjustmentFieldName] && errors[adjustmentFieldName]}
                                          />
                                        </TableCell> */}
                                        <TableCell>
                                          {rowTotal.toFixed(2)}
                                        </TableCell>
                                        <TableCell >
                                          <IconButton onClick={() => handleDeleteProduct(data.id || data.product_id, data.indexId)}>
                                            <Delete />
                                          </IconButton>
                                        </TableCell>
                                      </TableRow>
                                      <Modal
                                        open={locationStates[data.indexId]}
                                        handleClose={() => {
                                          setLocationStates({ ...locationStates, [data.indexId]: false });
                                        }}
                                      >
                                        {/* {index === 0 &&  */}
                                        <FormControlLabel
                                          control={
                                            <Switch
                                              checked={data?.allLocationSame}
                                              onChange={()=>handleAllLocationSameChange(index)}
                                            />
                                          }
                                          label="All Locations Same"
                                        />
                                        {/* } */}
                                        <Grid
                                          container
                                          spacing={3}
                                          sx={{ justifyContent: 'center', width: '100%' }}
                                        >
                                          {data.location.map((addr, i) => (
                                            <Grid item xs={12}>
                                              <Typography variant="h5" sx={{ mb: 2 }}>
                                                Location
                                              </Typography>

                                              <Stack
                                                direction={{ xs: 'column', sm: 'row' }}
                                                spacing={{ xs: 3, sm: 2 }}
                                                sx={{ mb: 2 }}
                                              >
                                                <TextField
                                                  fullWidth
                                                  label="Address"
                                                  size="small"
                                                  value={data.location[i].address || ''}
                                                  disabled={(i !== 0 && data?.allLocationSame) ? true : false}
                                                  // onChange={(event) => {
                                                  //   let arrayAddr = [...data.location]
                                                  //   arrayAddr[i].address = event.target.value;
                                                  //   setSelectedProducts(pv => ([...pv.map(p => {
                                                  //     // if (p.id === data.id) {
                                                  //     if (p.indexId === data.indexId) {
                                                  //       return {
                                                  //         ...p,
                                                  //         location: arrayAddr
                                                  //       }
                                                  //     } else {
                                                  //       return p;
                                                  //     }
                                                  //   })]))
                                                  // }}
                                                  onChange={(event) => {
                                                    setSelectedProducts((prevProducts) =>
                                                      prevProducts.map((p) => {
                                                        if (p.indexId === data.indexId) {
                                                          let updatedLocations = [...p.location];
                                                          if (p.allLocationSame) {
                                                            updatedLocations = updatedLocations.map(() => ({
                                                              ...updatedLocations[0], 
                                                              address: event.target.value, 
                                                            }));
                                                          } else {
                                                            updatedLocations[i] = {
                                                              ...updatedLocations[i], 
                                                              address: event.target.value,
                                                            };
                                                          }
                                                          return {
                                                            ...p,
                                                            location: updatedLocations,
                                                          };
                                                        }
                                                        return p;
                                                      })
                                                    );
                                                  }}
                                                />
                                              </Stack>

                                              <Stack
                                                direction={{ xs: 'column', sm: 'row' }}
                                                spacing={{ xs: 3, sm: 2 }}
                                                sx={{ mb: 2 }}
                                              >
                                                <TextField
                                                  fullWidth
                                                  label="City"
                                                  size="small"
                                                  value={data.location[i].city || ''}
                                                  disabled={(i !== 0 && data?.allLocationSame) ? true : false}
                                                  // onChange={(event) => {
                                                  //   let arrayAddr = [...data.location]
                                                  //   arrayAddr[i].city = event.target.value;
                                                  //   setSelectedProducts(pv => ([...pv.map(p => {
                                                  //     // if (p.id === data.id) {
                                                  //     if (p.indexId === data.indexId) {
                                                  //       return {
                                                  //         ...p,
                                                  //         location: arrayAddr
                                                  //       }
                                                  //     } else {
                                                  //       return p;
                                                  //     }
                                                  //   })]))
                                                  // }}
                                                  onChange={(event) => {
                                                    setSelectedProducts((prevProducts) =>
                                                      prevProducts.map((p) => {
                                                        if (p.indexId === data.indexId) {
                                                          let updatedLocations = [...p.location];
                                                          if (p.allLocationSame) {
                                                            updatedLocations = updatedLocations.map(() => ({
                                                              ...updatedLocations[0], 
                                                              city: event.target.value, 
                                                            }));
                                                          } else {
                                                            updatedLocations[i] = {
                                                              ...updatedLocations[i], 
                                                              city: event.target.value,
                                                            };
                                                          }
                                                          return {
                                                            ...p,
                                                            location: updatedLocations,
                                                          };
                                                        }
                                                        return p;
                                                      })
                                                    );
                                                  }}
                                                />
                                                <TextField
                                                  fullWidth
                                                  label="State"
                                                  size="small"
                                                  value={data.location[i].state || ''}
                                                  disabled={(i !== 0 && data?.allLocationSame) ? true : false}
                                                  // onChange={(event) => {
                                                  //   let arrayAddr = [...data.location]
                                                  //   arrayAddr[i].state = event.target.value;
                                                  //   setSelectedProducts(pv => ([...pv.map(p => {
                                                  //     // if (p.id === data.id) {
                                                  //     if (p.indexId === data.indexId) {
                                                  //       return {
                                                  //         ...p,
                                                  //         location: arrayAddr
                                                  //       }
                                                  //     } else {
                                                  //       return p;
                                                  //     }
                                                  //   })]))
                                                  // }}
                                                  onChange={(event) => {
                                                    setSelectedProducts((prevProducts) =>
                                                      prevProducts.map((p) => {
                                                        if (p.indexId === data.indexId) {
                                                          let updatedLocations = [...p.location];
                                                          if (p.allLocationSame) {
                                                            updatedLocations = updatedLocations.map(() => ({
                                                              ...updatedLocations[0], 
                                                              state: event.target.value, 
                                                            }));
                                                          } else {
                                                            updatedLocations[i] = {
                                                              ...updatedLocations[i], 
                                                              state: event.target.value,
                                                            };
                                                          }
                                                          return {
                                                            ...p,
                                                            location: updatedLocations,
                                                          };
                                                        }
                                                        return p;
                                                      })
                                                    );
                                                  }}
                                                />
                                                <TextField
                                                  fullWidth
                                                  label="Zip / Postal Code"
                                                  size="small"
                                                  value={data.location[i].zip || ''}
                                                  disabled={(i !== 0 && data?.allLocationSame) ? true : false}
                                                  // onChange={(event) => {
                                                  //   let arrayAddr = [...data.location]
                                                  //   arrayAddr[i].zip = event.target.value;
                                                  //   setSelectedProducts(pv => ([...pv.map(p => {
                                                  //     // if (p.id === data.id) {
                                                  //     if (p.indexId === data.indexId) {
                                                  //       return {
                                                  //         ...p,
                                                  //         location: arrayAddr
                                                  //       }
                                                  //     } else {
                                                  //       return p;
                                                  //     }
                                                  //   })]))
                                                  // }}
                                                  onChange={(event) => {
                                                    setSelectedProducts((prevProducts) =>
                                                      prevProducts.map((p) => {
                                                        if (p.indexId === data.indexId) {
                                                          let updatedLocations = [...p.location];
                                                          if (p.allLocationSame) {
                                                            updatedLocations = updatedLocations.map(() => ({
                                                              ...updatedLocations[0], 
                                                              zip: event.target.value, 
                                                            }));
                                                          } else {
                                                            updatedLocations[i] = {
                                                              ...updatedLocations[i], 
                                                              zip: event.target.value,
                                                            };
                                                          }
                                                          return {
                                                            ...p,
                                                            location: updatedLocations,
                                                          };
                                                        }
                                                        return p;
                                                      })
                                                    );
                                                  }}
                                                />
                                              </Stack>
                                            </Grid>
                                          ))}
                                        </Grid>

                                        <Grid container justifyContent="center" alignItems="center">
                                          <Grid item xs={12} md={4}>
                                          {/* {(i !== 0 && data?.allLocationSame) ? '' : */}
                                            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                              <LoadingButton variant="contained" onClick={() => {
                                                setIsSaving(true)
                                                setTimeout(() => {
                                                  setIsSaving(false)
                                                  setLocationStates(false)
                                                }, 100)
                                              }} loading={isSaving}>
                                                {' Save '}
                                              </LoadingButton>
                                            </Box>
                                            {/* } */}
                                          </Grid>
                                        </Grid>
                                      </Modal>
                                      <Modal
                                        open={openProductNote[data.indexId] || false}
                                        handleClose={() => handleCloseNote(data.indexId)}
                                      >
                                        <Grid
                                          container
                                          spacing={3}
                                          sx={{ justifyContent: 'center', width: '100%' }}
                                        >
                                            <Grid item xs={12}>
                                              <Typography variant="h5" sx={{ mb: 2 }}>
                                                Note
                                              </Typography>

                                              <Stack
                                                direction={{ xs: 'column', sm: 'row' }}
                                                spacing={{ xs: 3, sm: 2 }}
                                                sx={{ mb: 2 }}
                                              >
                                                <TextField
                                                  fullWidth
                                                  multiline
                                                  rows={4}
                                                  size="medium"
                                                  value={serviceCurrentNote}
                                                  onChange={handleNoteChange}
                                                  inputProps={{ maxLength: MAX_CHARACTERS }}
                                                  helperText={`${serviceCurrentNote.length}/${MAX_CHARACTERS} characters`}
                                                />
                                              </Stack>
                                            </Grid>
                                        </Grid>

                                        <Grid container justifyContent="center" alignItems="center">
                                          <Grid item xs={12} md={4}>
                                            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                              <LoadingButton
                                                variant="contained"
                                                onClick={() => handleSaveNote(data.indexId)}
                                                loading={serviceIsSavingNote}>
                                                Save
                                              </LoadingButton>
                                            </Box>
                                          </Grid>
                                        </Grid>
                                      </Modal>
                                    </>
                                  );
                                })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Scrollbar>
                        <Stack sx={{ justifyContent:'center' }}>
                        {/* <Box sx={{ justifyContent:'center' }}>
                          <Button variant="outlined" startIcon={ <Stack> <Add /> </Stack> }
                          onClick={()=>{
                            addNewProductRow()
                            // setMarkupType(1)
                          }}>Add Product Row</Button>
                        </Box> */}
                        </Stack>
                        </>
                        : <>
                        <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={'center'} spacing={{ xs: 3, sm: 2 }}>
                          <Autocomplete
                            key={`product-autocomplete-${isSplitOrder}-${values?.facility_type?.length || 0}-${filteredProductOptions?.length || 0}`}
                            sx={{ width: '50%' }}
                            multiple
                            id="combo-box-demo"
                            // options={allProducts?.filter(item=>item.inhouse == 1) || []}
                            options={filteredProductOptions}
                          //   options={
                          //   (allProducts || []).filter((option) => {
                          //     const isInhouse = option.inhouse === 1;
                          //     const isNotSelected = !selectedProducts?.some((selected) => selected.id === option.id);
                          //     return isInhouse && isNotSelected;
                          //   })
                          // }
                          // isOptionEqualToValue={(option, value) => option.id === value.id}
                          isOptionEqualToValue={() => false}

                            // value={selectedProducts}
                            value={selectedProducts?.filter(
                              (item) => (item?.fromMapServices != true && !item.isAdditionalProduct)
                            )}
                            onChange={(event, newValue) => {
                              const updated = newValue.map((item) => ({
                                ...item,
                                is_single_card: true
                              }));
                              handleProduct(updated);
                              setFieldValue('products', updated);
                            }}
                            renderInput={(params) => (
                              <TextField {...params} label="Select a product" />
                            )}
                            // getOptionLabel={(option) => option.product_name ? option.product_name : option.name}
                            getOptionLabel={(option) => {
                              const name = option.product_name || option.name || '';
                              const description = option.description || option.name || '';
                              const categoryId = values?.project_category?.id;
                              const suffix = option.inhouse === 4
                                ? '(In Stock Catalog)'
                                : option.isTrafficCatalog
                                  ? '(TC)':
                                    option.inhouse === 5
                                    ? '(Client Owned Catalog)'
                                  : option.inhouse === 0
                                    ? '(Sub Contract)'
                                    : option.inhouse === 6 
                                    ? '(Split Catalog)'
                                  : '(Production Catalog)';
                            return `${description} ${suffix} \u200B${name}`;
                            // return `${description} \u200B${name}`;
                          }}
                              renderOption={(props, option) => {
                                const description = option.description || option.name || '';
                                const categoryId = values?.project_category?.id;
                                const suffix = option.inhouse === 4
                                  ? '(In Stock Catalog)'
                                  : option.isTrafficCatalog
                                    ? '(TC)':
                                    option.inhouse === 5
                                    ? '(Client Owned Catalog)'
                                    : option.inhouse === 0
                                    ? '(Sub Contract)'
                                    : option.inhouse === 6 
                                    ? '(Split Catalog)'
                                    : '(Production Catalog)';
                                return (
                                  <li {...props}>
                                    <Tooltip title={`${description} ${suffix}`}>
                                      <span style={{
                                        display: 'inline-block',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        maxWidth: '300px',
                                        color: isSplitOrder ? theme.palette[
                                          FacilityTypes.find(f => f.id === option?.facility_id)?.color || 'primary'
                                        ]?.main
                                      : 'inherit'  
                                      }}>
                                        {`${description} ${suffix}`}
                                      </span>
                                    </Tooltip>
                                    <span style={{ display: 'none' }}>{option.name}</span>
                                  </li>
                                );
                              }}
                              onInputChange={(event, newInputValue, reason) => {
                                // Track the latest input value for production builds
                                // This ensures filterOptions gets the latest inputValue even in optimized builds
                                productInputValueRef.current = newInputValue || '';
                              }}
                              filterOptions={(options, { inputValue }) => {
                                // Always use ref value as primary source for production builds
                                // The inputValue parameter can be stale in production builds
                                const currentInput = productInputValueRef.current || (inputValue !== undefined && inputValue !== null ? inputValue : '');
                                const searchText = (currentInput || '').toString().trim().toLowerCase();
                                
                                // If no search text, return all options
                                if (!searchText) return options;
                                
                                // Filter options based on search text
                                return options.filter((option) => {
                                  const nameMatch = option.name?.toLowerCase().includes(searchText);
                                  const descMatch = option.description?.toLowerCase().includes(searchText);
                                  return nameMatch || descMatch;
                                });
                              }}
                            renderTags={(value, getTagProps) =>
                              value.map((option, index) => {
                                const categoryId = values?.project_category?.id;
                                const suffix = option.inhouse === 4
                                  ? '(In Stock Catalog)'
                                  : option.isTrafficCatalog
                                    ? '(TC)':
                                        option.inhouse === 5
                                        ? '(Client Owned Catalog)'
                                    : option.inhouse === 0
                                        ? '(Sub Contract)'
                                    : option.inhouse === 6 
                                    ? '(Split Catalog)'
                                    : '(Production Catalog)';
                                return (
                                  <Tooltip key={index} title={`${option.description || option.name || ''} ${suffix}`}>
                                    <Chip  sx={{color:isSplitOrder ?theme.palette[
                                        FacilityTypes.find(f => f.id === option?.facility_id)?.color || 'primary'
                                      ]?.main
                                    : 'inherit'}}
                                      {...getTagProps({ index })}
                                      label={`${option.description || option.name || ''} ${suffix}`}
                                    />
                                  </Tooltip>
                                );
                              })
                            }
                            // renderOption={(props, option) => (
                            //   <li {...props}>
                            //     {option.name}
                            //   </li>
                            // )}
                          />
                          {/* Split Order Catalog Type Autocomplete - Only visible for split orders */}
                          {isSplitOrder ? (
                            <Autocomplete
                              sx={{ width: '50%' }}
                              id="split-catalog-type"
                              options={splitOrderCatalogTypes}
                              value={values.split_catalog_type}
                              onChange={(event, newValue) => {
                                setFieldValue('split_catalog_type', newValue)
                                console.log('Split catalog type changed:', newValue)
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Catalog Type"
                                  placeholder="Select catalog type"
                                />
                              )}
                              getOptionLabel={(option) => option.label}
                            />
                          ):''}
                           {/* <Box sx={{ display: 'flex', flexDirection: 'column',width:'50%', alignItems: 'center', mt: 2 }}>
                          <LabelStyle sx={{fontSize:'16px'}}>Qty Location Settings</LabelStyle>
                            <Box display="flex" alignItems="center" gap={1} mt={1}>
                              <Typography variant="subtitle2">Multiple</Typography>
                              <Switch
                                color="primary"
                                {...getFieldProps('is_single_card')}
                                checked={values.is_single_card}
                                onChange={(event) => {
                                  const checked = event.target.checked;
                                  setSingleLocationCard(checked);
                                  setFieldValue('is_single_card', checked);

                                  if (checked) {
                                    setSelectedProducts((prev) =>
                                      prev.map((p) => ({
                                        ...p,
                                        // locationQuantity: 1,
                                        location: p.location?.length
                                          ? [p.location[0]]
                                          : [
                                              {
                                                id: 0,
                                                address: '',
                                                city: '',
                                                state: '',
                                                zip: '',
                                              },
                                            ],
                                      }))
                                    );

                                    // setSelectedServices((prev) =>
                                    //   prev.map((service) => ({
                                    //     ...service,
                                    //     locationQuantity: 1,
                                    //     quantity: (
                                    //       service.previousQty * 1 * (service.qtyData || 1)
                                    //     )?.toFixed(2),
                                    //   }))
                                    // );
                                  }else {
                                    setSelectedProducts((prev) =>
                                      prev.map((p) => {
                                        const count = Number(p.locationQuantity || 1);
                                        let arrayAddr = [];
                                
                                        const allSame = p.allLocationSame;
                                        const firstAddress = p.location?.[0];
                                
                                        if (allSame && firstAddress) {
                                          arrayAddr = Array(count).fill().map((_, i) => ({
                                            ...firstAddress,
                                            id: i,
                                            req_loc_id: p.location[i]?.req_loc_id ?? null,
                                          }));
                                        } else {
                                          arrayAddr = [...p.location];
                                          if (arrayAddr.length < count) {
                                            arrayAddr.push(
                                              ...Array(count - arrayAddr.length)
                                                .fill()
                                                .map((_, i) => ({
                                                  id: arrayAddr.length + i,
                                                  address: '',
                                                  city: '',
                                                  state: '',
                                                  zip: '',
                                                }))
                                            );
                                          } else if (arrayAddr.length > count) {
                                            arrayAddr = arrayAddr.slice(0, count);
                                          }
                                        }
                                
                                        return {
                                          ...p,
                                          location: arrayAddr,
                                        };
                                      })
                                    );
                                  }
                                }}
                              />
                              <Typography variant="subtitle2">Single</Typography>
                            </Box>
                          </Box> */}
                        </Stack>
                        <LabelStyle>Selected Products</LabelStyle>
                        <Scrollbar>
                          <TableContainer sx={{ minWidth: 500 }}>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  {VALUE?.map((val) => (
                                    val.id === 10 ? (
                                      <Tooltip key={val.id} title="Product Formula Cost Per Unit * Quantity">
                                        <TableCell>{val.value}</TableCell>
                                      </Tooltip>
                                    ): (val.id === 14 ? (
                                      <Tooltip key={val.id} title="Selling Price With Marketing Adjustment">
                                        <TableCell>{val.value}</TableCell>
                                      </Tooltip> )
                                     : val.id === 16 ? (
                                      // Conditionally show Incoming Percentage column
                                      isSplitOrder ? (
                                        <TableCell key={val.id}>{val.value}</TableCell>
                                      ) : null
                                    ) : (
                                      <TableCell key={val.id}>{val.value}</TableCell>
                                    ))
                                  ))}
                                  {/* {VALUE?.map((val) => (
                                  <TableCell>{val.value}</TableCell>
                                ))} */}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                    {
                                      console.log('selected productssss', selectedProducts)
                                    }
                                {selectedProducts?.sort((a, b) => a.indexId - b.indexId)?.map((data, index) => {
                                  console.log('data-----', data)
                                  const quantityFieldName = `quantity_${data.product_id || data.id}`;
                                  const discountFieldName = `discount_${data.product_id || data.id}`;
                                  const adjustmentFieldName = `adjustment_${data.product_id || data.id}`;

                                  let unitName = UNITS?.filter((item) => item?.id == data?.unit)
                                  unitName = unitName[0]?.name
                                  let shortUnitName = ''
                                  if (unitName == 'Square feet') {
                                    shortUnitName = 'Sq ft'
                                  } else if (unitName == 'Lineal feet') {
                                    shortUnitName = 'Lin ft'
                                  } else if (unitName == 'Square Inches') {
                                    shortUnitName = 'Sq Inches'
                                  } else if (unitName == 'Unit') {
                                    shortUnitName = 'Unit'
                                  }

                                  if((data.inhouse !== 1 || (data.inhouse ==1 && data.isTrafficCatalog == 1)) && !isSplitOrder){
                                    let price = data.max_price ? data.max_price : data.actual_retail_price
                                    const installCost = parseFloat(data?.install_cost) || 0
                                    data['actual_retail_price'] = price
                                    const calculatedRetailPrice = installCost > 0 ? price + installCost : price
                                    data['retail_price'] = calculatedRetailPrice
                                  }

                                  if(isSplitOrder && data?.facility_id !== currentFacilityId && !details?.for_parent_facility){
                                    const splitSetting = selectedSplitOrderSettings?.find(setting => setting?.id == data?.facility_id);
                                    let outgoingPercentage = data?.split_percentage || splitSetting?.split_percentage || 0;
                                    let incomingPercentage = data?.incoming_split_percentage || incomingSplitMarkup || 0;
                                    if (!data.originalExpectedCost) {
                                     data.originalExpectedCost = Number(data?.expected_cost)
                                   }
                                   
                                   let amountWithOutgoingPercentage = data.originalExpectedCost * (outgoingPercentage / 100)
                                   data.expected_cost = parseFloat(data.originalExpectedCost + amountWithOutgoingPercentage)
                                   console.log('data.expected_costtttttt', data.expected_cost)
                                   console.log('data.originalExpectedCosttttttt', data.originalExpectedCost)
                                   let amountWithIncomingPercentage = data.expected_cost * (incomingPercentage / 100)
                                   console.log('amountWithIncomingPercentageeee', amountWithIncomingPercentage)
                                   data['actual_retail_price'] =data.expected_cost + amountWithIncomingPercentage
                                   data['retail_price'] =data?.actual_retail_price + (data?.install_cost || 0)
                                   console.log('data?.actual_retail_priceee', data?.actual_retail_price)
                                   console.log('data?.retail_priceee', data?.retail_price)
                                   // data['retail_price'] =data?.originalExpectedCost + data?.install_cost
                                   data['incoming_split_percentage'] =incomingPercentage || 0
                                   data['split_percentage'] =outgoingPercentage || 0
                                   data['outgoing_split_percentage'] =outgoingPercentage || 0
                                   }else if(isSplitOrder && data?.facility_id == currentFacilityId && details?.for_parent_facility){
                                    // Don't set install_cost to null, preserve the original value
                                    // data['install_cost'] =null
                                    data['retail_price'] =data?.expected_cost
                                    data['actual_retail_price'] =data?.expected_cost
                                    data['expected_cost'] =data?.expected_cost
                                   }
                                  
                                  if(!data.original_install_cost){
                                    // data.original_install_cost = data.product_install_cost
                                    data.original_install_cost = data.install_cost || data.product_install_cost || null
                                    console.log('data.original_install_cost ', data.original_install_cost )
                                  }
                                  // Apply no charge logic similar to OfficialRequestAdd.js
                                  if(noCharge && data.inhouse !==0){
                                    data.install_cost =data.expected_install_labor_cost
                                    // For no charge products, calculate retail_price based on expected_cost + install_cost
                                    const expectedCost = parseFloat(data?.expected_cost) || 0
                                    const installCost = parseFloat(data?.install_cost) || 0
                                    
                                    // If install_cost is available, add it to expected_cost
                                    const calculatedRetailPrice = installCost > 0 ? expectedCost + installCost : expectedCost
                                    
                                    data['retail_price'] = calculatedRetailPrice
                                    data['actual_retail_price'] = expectedCost
                                    data['expected_cost'] = expectedCost
                                  }else{
                                    data.install_cost = data.original_install_cost || null
                                  }

                                  // if(values.project_category?.name == 'Time & Material'){
                                  //   data.price = 0
                                  //   data.product_price = 0
                                  //   data.retail_price = 0
                                  //   data.product_retail_price = 0
                                  //   data.expected_cost = 0
                                  //   data.expected_material_cost = 0
                                  //   data.expected_total_service_cost = 0
                                  // }
                                  const dataPrice = data.actual_retail_price || data.product_price || data.price
                                  const dataretailPrice = data.product_retail_price || data.retail_price
                                  const dataActualRetail = data.actual_retail_price || data.retail_price
                                  const dataWholesalePrice = data.product_price || data.price
                                  console.log('dataretailPrice---------', dataretailPrice)
                                  console.log('dataPrice---------', dataPrice)
                                  console.log('dataActualRetail---------', dataActualRetail)
                                  console.log('dataWholesalePrice---------', dataWholesalePrice)
                                  console.log('markupType---------', markupType)
                                  // const dataQuantity = values[quantityFieldName]
                                  const dataQuantity = data.quantity || 1
                                  console.log('data.discount--', data.discount);
                                  const dataDiscount = data.discount ? data.discount : 0
                                  const productCost = data.actual_retail_price ? data.actual_retail_price * data.locationQuantity : data.retail_price * data.locationQuantity
                                  let persentageSplit = data?.split_percentage || splitPercentage
                                  let incomingPercentage = data?.incoming_split_percentage || incomingSplitMarkup
                                  const rowTotal = calculateTotal(markupType == 1 ? dataWholesalePrice : (markupType == 2 ? (data.install_cost && parseFloat(data.install_cost) > 0 ? dataretailPrice : dataActualRetail) : 0), dataQuantity, dataDiscount, data.quantity, data.locationQuantity, Number(data?.adjustment),data.markAdjType,persentageSplit);
                                  console.log('rowTotal------', rowTotal)
                                  // const markup = ((dataretailPrice - dataPrice) / dataPrice) * 100;
                                  const invoiceAmount = parseFloat(data?.expected_material_cost) + parseFloat(data?.expected_total_service_cost?.toFixed(2))
                                  // let markup = markupType ? (invoiceAmount / rowTotal) : null

                                  let markup = markupType == 1 ? (((dataWholesalePrice - parseFloat(data.expected_cost?.toFixed(2))) / parseFloat(data.expected_cost?.toFixed(2))) * 100)
                                    : (markupType == 2 ? (((dataretailPrice - parseFloat(data.expected_cost?.toFixed(2))) / parseFloat(data.expected_cost?.toFixed(2))) * 100) : 0);
                                  markup = markup ? Number(markup) : 0
                                  data['markup'] = markup
                                  let markupData = data.product_markup?.toFixed(2) || data.markup?.toFixed(2)
                                  markupData = Number(markupData) * data.quantity
                                  data['markup'] = markupData
                                  totalMarkup += Number(data.product_markup) || Number(data.markup) || 0
                                  data['markup_type'] = markupType
                                  data['totalMarkup'] = totalMarkup?.toFixed(2)
                                  let originalMarkup = markupType == 1 ? data.wholesaleMarkup : markupType == 2 ? data.retailMarkup : 0
                                  originaltotalMarkup += originalMarkup
                                  // values['totalMarkup'] = totalMarkup?.toFixed(2)
                                  productFormulaCost += parseFloat(data.expected_cost?.toFixed(2)) * data.quantity * data.locationQuantity

                                  const pfc = parseFloat(data.expected_cost?.toFixed(2)) * data.quantity * data.locationQuantity // total product formula cost
                                  const rtp = dataretailPrice * data.quantity * data.locationQuantity // total retail price
                                  const wsp = dataWholesalePrice * data.quantity * data.locationQuantity // total wholesale price

                                  const maxDiscount_wholesale = wsp - pfc
                                  const maxDiscount_retail = rtp - pfc

                                  // const maxDiscount_wholesale = (wsp - pfc) - DiscountTotal
                                  // const maxDiscount_retail = (rtp - pfc) - DiscountTotal

                                  console.log('maxDiscount_wholesale--', maxDiscount_wholesale);
                                  console.log('maxDiscount_retail--', maxDiscount_retail);
                                  console.log('DiscountTotal--', DiscountTotal);
                                  console.log('pfc--', pfc);
                                  console.log('rtp--', rtp);
                                  console.log('wsp--', wsp);
                                  data['product_total']=rowTotal

                                  let SPMA = 0
                                  if(markupType){
                                    if(markupType == 1){
                                      if(data.markAdjType==2 || data.markAdjType==3) {
                                        SPMA = (Number(dataPrice) || 0) + (data.adjustment ? Number(data.adjustment) : 0)
                                      }else{

                                        SPMA = (Number(dataPrice) || 0) + (((Number(dataPrice) || 0) * (data.adjustment ? Number(data.adjustment) : 0)) / 100)
                                      }
                                    }else{
                                      if(data.markAdjType==2 || data.markAdjType==3) {
                                        SPMA = (Number(dataretailPrice) || 0) + (dataretailPrice ? Number(data.adjustment) : 0)
                                      }else{

                                        SPMA = (Number(dataretailPrice) || 0) + (((Number(dataretailPrice) || 0) * (dataretailPrice ? Number(data.adjustment) : 0)) / 100)
                                      }
                                    }
                                  }
                                  console.log('SPMA-----markupType-----',markupType,data.markAdjType)
                                  console.log('SPMA-----data.price-----',dataPrice)
                                  console.log('SPMA-----data.adjustment-----',data.adjustment)
                                  console.log('SPMA-----data.retail_price-----',dataretailPrice)
                                  console.log('SPMA-----SPMA-----',SPMA)
                                  SPMA = Number(SPMA)
                                  data['SPMA'] = SPMA?.toFixed(2)

                                  console.log(
                                    'location-colour---',data.location,
                                    data.location.some(obj =>
                                      [obj.address, obj.city, obj.state, obj.zip]?.some(value => value === '' || value === null)
                                    )
                                  );

                                  return (
                                    <>
                                      <TableRow key={`main-${data.indexId}`}>
                                        <TableCell>#{data.indexId}</TableCell>
                                        <TableCell>{data?.isAdditionalProduct ?
                                          <TextField
                                            required
                                            fullWidth
                                            type="text"
                                            label={'Product Name'}
                                            sx={{ width: 85 }}
                                            value={data.product_name || data.name}
                                            onChange={(event) => {
                                              let newValue =
                                                event.target.value

                                              // Update the selectedProducts state
                                              setSelectedProducts(
                                                (prevProducts) =>
                                                  prevProducts.map(
                                                    (product) => {
                                                      if (
                                                        product.indexId ===
                                                        data.indexId
                                                      ) {
                                                        return {
                                                          ...product,
                                                          name: newValue,
                                                          product_name: newValue,
                                                        }
                                                      } else {
                                                        return product
                                                      }
                                                    },
                                                  ),
                                              )
                                              data['name'] = newValue || ''
                                              data['product_name'] = newValue || ''
                                              if (isSubmitted)
                                                setIsSubmitted(false)
                                            }}
                                            error={
                                              isSubmitted && !data.name?.trim() && !data.product_name?.trim()
                                            }
                                            helperText={
                                              isSubmitted && !data.name?.trim() && !data.product_name?.trim()
                                                ? 'Product Name is required'
                                                : ''
                                            }                                            
                                          />
                                        :
                                         <Typography sx={{color:isSplitOrder ? theme.palette[
                                          FacilityTypes.find(f => f.id === data?.facility_id)?.color || 'primary'
                                        ]?.main
                                      : 'inherit' }}>{data.product_name || data.name}</Typography>}
                                        </TableCell>
                                        <TableCell>
                                          <IconButton onClick={() => handleOpenNote(data.indexId, data.product_notes)}>
                                            <NoteAdd
                                              sx={{
                                                color: (!data?.product_notes || data?.product_notes === '') ? '' : theme.palette.primary.main,
                                              }}
                                            />
                                          </IconButton>
                                        </TableCell>
                                        <Tooltip 
                                               title={
                                                (isSplitOrder && 
                                                 data.facility_id != currentFacilityId) 
                                                  ? ''
                                                  // (
                                                  //     <>
                                                  //       {`${data?.originalExpectedCost} + ${data?.originalExpectedCost} * (${data?.outgoing_split_percentage} / 100) = ${parseFloat(data?.expected_cost * data.locationQuantity)?.toFixed(2)}`}
                                                  //       <br />
                                                  //       {"Expected Cost + (Expected Cost * Outgoing Percentage / 100)"}
                                                  //     </>
                                                  //     <>
                                                  //     {`(${data?.outgoing_split_percentage} % Outgoing Percentage Included with Expected Cost ${data?.expected_cost}`}
                                                  //     </>
                                                  //   ) 
                                                  : ""
                                              }
                                              >
                                        <TableCell>{data?.isAdditionalProduct ? 'N/A' : (data.inhouse === 0 ? '0.00' : (parseFloat(data.expected_cost || 0) * data.quantity * data.locationQuantity).toFixed(2))}</TableCell>
                                        </Tooltip>
                                        {/* Incoming Percentage column - only show when isSplitOrder is true */}
                                        {isSplitOrder ? (
                                          <TableCell align='center'>
                                            {data?.isAdditionalProduct ? 'N/A' : (
                                              data?.facility_id != currentFacilityId ? 
                                                `${incomingPercentage || 0}%` : 
                                                '-'
                                            )}
                                          </TableCell>
                                        ) : null}
                                        {/* <TableCell>{invoiceAmount}</TableCell> */}
                                        <Tooltip title={isSplitOrder && data?.facility_id != currentFacilityId ? `Product formula cost + (Product formula cost * incoming split markup (${incomingPercentage}) / 100)` : ""}>
                                        <TableCell>{(hasMarkupPermission && markupType == 2) ? 
                                          (data?.isAdditionalProduct ?
                                            <TextField
                                              required
                                              fullWidth
                                              type="number"
                                              label={'Retail Price Each'}
                                              // disabled={values.project_category?.name == 'Time & Material' ? true : false}
                                              sx={{ width: 85 }}
                                              value={dataActualRetail}
                                              // onWheel={(e) => e.target.blur()}
                                              onKeyPress={(event) => {
                                                // if (event.key === '0' && event.target.value === '') {
                                                //   event.preventDefault();
                                                // }
                                                if (event.key === '-') {
                                                  event.preventDefault();
                                                }
                                                if (event.key === 'e') {
                                                  event.preventDefault();
                                                }
                                              }}
                                              inputProps={{ min: 0 }}
                                              defaultValue={0}
                                              onChange={(event) => {
                                                let newValue =
                                                  event.target.value
                                                if (newValue !== '') {
                                                  setSelectedProducts(
                                                    (pv) => [
                                                      ...pv.map((p) => {
                                                        if ( p.indexId === data.indexId ) {
                                                          return {
                                                            ...p,
                                                            retail_price:newValue,
                                                            product_retail_price:newValue,
                                                          }
                                                        } else {
                                                          return p
                                                        }
                                                      }),
                                                    ],
                                                  )
                                                  data['product_retail_price'] = newValue || 0
                                                  data['retail_price'] = newValue || 0
                                                  // dataretailPrice = newValue || 0
                                                }
                                              }}
                                              // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                              // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                            /> :
                                          (  dataActualRetail  *
                                            (data?.locationQuantity || 1))?.toFixed(2))
                                          : null}</TableCell>
                                          </Tooltip>
                                        <TableCell>{(hasMarkupPermission && markupType == 1) ? 
                                        (data?.isAdditionalProduct ?
                                          <TextField
                                            required
                                            fullWidth
                                            type="number"
                                            label={'Retail Price Each'}
                                            // disabled={values.project_category?.name == 'Time & Material' ? true : false}
                                            sx={{ width: 85 }}
                                            value={dataPrice}
                                            // onWheel={(e) => e.target.blur()}
                                            onKeyPress={(event) => {
                                              // if (event.key === '0' && event.target.value === '') {
                                              //   event.preventDefault();
                                              // }
                                              if (event.key === '-') {
                                                event.preventDefault();
                                              }
                                              if (event.key === 'e') {
                                                event.preventDefault();
                                              }
                                            }}
                                            inputProps={{ min: 0 }}
                                            defaultValue={0}
                                            onChange={(event) => {
                                              let newValue = event.target.value
                                              if (newValue !== '') {
                                                setSelectedProducts(
                                                  (pv) => [
                                                    ...pv.map((p) => {
                                                      if ( p.indexId === data.indexId ) {
                                                        return {
                                                          ...p,
                                                          product_price:newValue,
                                                          price:newValue,
                                                        }
                                                      } else {
                                                        return p
                                                      }
                                                    }),
                                                  ],
                                                )
                                                data['product_price'] = newValue || 0
                                                data['price'] = newValue || 0
                                                // dataPrice = newValue || 0
                                              }
                                            }}
                                            // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                            // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                          /> :
                                          dataPrice?.toFixed(2))
                                        : null}</TableCell>
                                        {/* <TableCell>{hasMarkupPermission ? (data.SPMA || null) : null}</TableCell> */}
                                        {/* <TableCell>{hasMarkupPermission ? Number(markupData).toFixed(2) : null}</TableCell> */}

                                        {/* <TableCell> */}
                                          {/* previos */}
                                          {/* {(hasMarkupPermission && markupType == 1) ? data.wholesaleMarkup?.toFixed(2)
                                            : (hasMarkupPermission && markupType == 2) ? data.pf_retail_markup?.toFixed(2)
                                              : null} */}
                                              {/* old */}
                                          {/* {(hasMarkupPermission && markupType == 1) ? data.wholesaleMarkup?.toFixed(2)
                                            : (hasMarkupPermission && markupType == 2) ? data.retailMarkup?.toFixed(2)
                                              : null} */}
                                        {/* </TableCell> */}
                                        {/* <TableCell>{shortUnitName}</TableCell> */}
                                        <TableCell>
                                          <TextField
                                            type="number"
                                            sx={{ width: 85 }}
                                            onKeyPress={(event) => {
                                              if (event.key === '0' && event.target.value === '') {
                                                event.preventDefault();
                                              }
                                              if (event.key === '.') {
                                                event.preventDefault();
                                              }
                                            }}
                                            fullWidth
                                            label={shortUnitName}
                                            disabled={(data?.fromMapServices == true) ? true : shortUnitName == 'Unit' ? true : false}
                                            // {...getFieldProps(quantityFieldName)}
                                            defaultValue={data.quantity ? data.quantity : 1}
                                            value={data.quantity ? data.quantity : 1}

                                            onChange={(event) => {

                                              let newValue = event.target.value;
                                              if (newValue.startsWith('-')) {
                                                newValue = newValue.slice(1);
                                              }
                                              newValue = newValue.replace(/[^0-9]/g, '');
                                              if (newValue === '' || Number(newValue) <= 0) {
                                                newValue = 1;
                                              }
                                              else {
                                                newValue = Number(newValue);
                                              }

                                              setSelectedProducts(pv => ([...pv.map(p => {
                                                // if (p.id === data.id) {
                                                if (p.indexId === data.indexId) {

                                                  // let arrayAddr

                                                  // const commonAddresses = (data?.allLocationSame && pv.length > 0) ? [...pv[0].location][0]: null;

                                                  // if(data?.allLocationSame && commonAddresses){
                                                  //   arrayAddr = Array((newValue)).fill().map((_, i) => ({
                                                  //     ...commonAddresses,
                                                  //     id: i
                                                  //   }));

                                                  // }
                                                  // else{
                                                  //   arrayAddr = [...p.location]
                                                  //   console.log("Hifiiiiiiiiiiiiii Aff",arrayAddr);
                                                  //   if(p.location.length<=newValue){
                                                  //     arrayAddr.push(...[...Array((newValue)-p.location.length)].map((a,i)=>{
                                                  //       return {
                                                  //         id: p.location.length + i,
                                                  //         address: '',
                                                  //         city: '',
                                                  //         state: '',
                                                  //         zip: '',
                                                  //       }
                                                  //     }))
                                                  //   }else{
                                                  //     arrayAddr = arrayAddr.slice(0,-(p.location.length-(newValue)));
                                                  //   }
                                                  // }

                                                  return {
                                                    ...p,
                                                    quantity: newValue,
                                                    // location: arrayAddr
                                                  }
                                                } else {
                                                  return p;
                                                }
                                              })]));
                                              console.log("###############SElected services", selectedServices);
                                              setSelectedServices(pv => ([...pv.map(service => {
                                                // if (service.product_id === data.id && service.prQty) {
                                                console.log('data---new----', data);
                                                console.log('service---new----', service);
                                                if (service.productIndex === data.indexId && service.prQty) {
                                                  return {
                                                    ...service,
                                                    quantity: (service.prQty * (newValue) * (service?.locationQuantity || 1)).toFixed(2),
                                                    qtyData: Number(newValue),
                                                  };
                                                } else {
                                                  return {
                                                    ...service,

                                                  }
                                                }
                                              })]));
                                              //new chnage on 2-2-24
                                              //   if (newValue === '.') {
                                              //     event.preventDefault();
                                              //     return;
                                              //   }
                                              // if (newValue === '' || newValue <= 0) {
                                              //   event.preventDefault();
                                              //   return;
                                              // }
                                              //   if (newValue.startsWith('-')) {
                                              //     newValue = newValue.slice(1);
                                              //   }
                                              data['quantity'] = newValue || 1;

                                              setFieldValue(quantityFieldName, newValue);
                                            }}

                                            error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                            helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                          />
                                        </TableCell>
                                        <TableCell>
                                          <TextField
                                            type="number"
                                            onKeyPress={(event) => {
                                              if (event.key === '0' && event.target.value === '') {
                                                event.preventDefault();
                                              }
                                              if (event.key === '.') {
                                                event.preventDefault();
                                              }
                                            }}
                                            fullWidth
                                            disabled={(data?.fromMapServices == true) ? true : false}
                                            label={"Qty"}
                                            // {...getFieldProps(quantityFieldName)}
                                            defaultValue={data.locationQuantity ? data.locationQuantity : 1}
                                            value={data.locationQuantity ? data.locationQuantity : 1}
                                            onChange={(event) => {

                                              let newValue = event.target.value;
                                              if (newValue.startsWith('-')) {
                                                newValue = newValue.slice(1);
                                              }
                                              newValue = newValue.replace(/[^0-9]/g, '');
                                              if (newValue === '' || Number(newValue) <= 0) {
                                                newValue = 1;
                                              }
                                              else {
                                                newValue = Number(newValue);
                                              }
                                              const newAddr = data?.is_single_card ? 1 : newValue

                                              setSelectedProducts(pv => ([...pv.map(p => {
                                                // if (p.id === data.id) {
                                                if (p.indexId === data.indexId) {

                                                  let arrayAddr

                                                  const commonAddresses = (data?.allLocationSame && pv.length > 0) ? p.location[0] : null;
                                                  console.log("Hifiiiiiiiiiiiiii Aff", commonAddresses);
                                                  if (data?.allLocationSame && commonAddresses) {
                                                    arrayAddr = Array(Number(newAddr)).fill().map((_, i) => ({
                                                      ...commonAddresses,
                                                      id: i,
                                                      req_loc_id: p.location[i]?.req_loc_id ?? null,
                                                    }));

                                                  }
                                                  else {
                                                    arrayAddr = [...p.location]
                                                    console.log("Hifiiiiiiiiiiiiii Aff", arrayAddr);
                                                    if (p.location.length <= Number(newAddr)) {
                                                      arrayAddr.push(...[...Array(Number(newAddr) - p.location.length)].map((a, i) => {
                                                        return {
                                                          id: p.location.length + i,
                                                          address: '',
                                                          city: '',
                                                          state: '',
                                                          zip: '',
                                                        }
                                                      }))
                                                    }
                                                    else if (p.location.length > Number(newAddr)) {
                                                      arrayAddr = arrayAddr.slice(0, Number(newAddr));
                                                    }
                                                    else {
                                                      arrayAddr = arrayAddr.slice(0, -(p.location.length - Number(newAddr)));
                                                    }
                                                  }

                                                  return {
                                                    ...p,
                                                    // quantity:newValue,
                                                    locationQuantity: newValue,
                                                    location: arrayAddr
                                                  }
                                                } else {
                                                  return p;
                                                }
                                              })]));
                                              setSelectedServices(pv => ([...pv.map(service => {
                                                console.log("############@@@@@@@@@@service", service);
                                                console.log("############@@@@@@@@@@data", data);
                                                if (service.productIndex === data.indexId && service.prQty) {
                                                  console.log("############service.newValue", newValue);
                                                  return {
                                                    ...service,
                                                    quantity: (newValue * (service.qtyData || 1) * service.prQty).toFixed(2),
                                                    locationQuantity: newValue,
                                                  };
                                                } else {
                                                  return {
                                                    ...service,

                                                  }
                                                }
                                              })]));
                                            }}

                                            error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                            helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                          />
                                        </TableCell>
                                        <TableCell>
                                          <IconButton
                                            onClick={() => {
                                              setLocationStates({ ...locationStates, [data.indexId]: true });
                                            }}
                                          >
                                            <LocationOn sx={{
                                              color: data.location.some(obj =>
                                                [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
                                              ) ? '' : theme.palette.primary.main
                                            }} />
                                          </IconButton>
                                        </TableCell>
                                        {/* <TableCell>{data.product_id||data.id}</TableCell> */}

                                        {/* <TableCell>
                                          <Autocomplete
                                            sx={{ width: 70 }}
                                            id="combo-box-demo"
                                            disableClearable
                                            // disabled={values.project_category?.name == 'Time & Material' ? true : false}
                                            options={marketingAdjustmentType || []}
                                            value={marketingAdjustmentType?.find((type) => type.id === data.markAdjType)} // Use value to set the correct selected option
                                            onChange={(event, newValue) => {
                                              console.log(newValue)
                                              setSelectedProducts((prevProducts) => {
                                                return prevProducts.map((product) => {
                                                  if (product.indexId === data.indexId) {
                                                    return {
                                                      ...product,
                                                      markAdjType: newValue?.id, // Set adjustment type or default to the first option
                                                      // adjustment: 0,
                                                    };
                                                  }
                                                  return product;
                                                });
                                              });
                                            }}
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                required
                                                error={Boolean(touched.marketingAdjType && errors.marketingAdjType)}
                                                helperText={touched.marketingAdjType && errors.marketingAdjType}
                                                label="Select type"
                                              />
                                            )}
                                            getOptionLabel={(option) => (option.name ? option.name : '')}
                                          />
                                        </TableCell> */}

                                        {/* <TableCell> */}
                                          {/* <TextField
                                            type="number"
                                            label="Discount"
                                            value={Number(data.discount)}
                                            // {...getFieldProps(discountFieldName)}
                                            defaultValue={data.discount ? data.discount : 0}
                                            onChange={(event) => {
                                              let newValue = event.target.value;
                                              if (newValue.startsWith('-')) {
                                                newValue = newValue.slice(1);
                                              }
                                              if (markupType == 1) {
                                                if (Number(newValue) > maxDiscount_wholesale) {
                                                  newValue = maxDiscount_wholesale.toFixed(2);
                                                }
                                              } else if (markupType == 2) {
                                                if (Number(newValue) > maxDiscount_retail) {
                                                  newValue = maxDiscount_retail.toFixed(2);
                                                }
                                              } else {
                                                newValue = 0;
                                              }
                                              if (newValue === '-0.00') {
                                                newValue = 0;
                                              }
                                              setRefreshData(!refreshData)
                                              data['discount'] = newValue
                                              setFieldValue(discountFieldName, newValue);
                                            }}
                                            error={Boolean(touched[discountFieldName] && errors[discountFieldName])}
                                            helperText={touched[discountFieldName] && errors[discountFieldName]}
                                            inputProps={{ max: markupType == 1 ? maxDiscount_wholesale : markupType == 2 ? maxDiscount_retail : 0, min: 0 }}
                                          /> */}

                                          {/* <TextField
                                            type="number"
                                            label={
                                              data.markAdjType === 2 ? "$" : data.markAdjType === 3 ? "¢" : "%"
                                            }
                                            // disabled={values.project_category?.name == 'Time & Material' ? true : false}
                                            value={Number(data.adjustment) || null }
                                            // defaultValue={data?.adjustment ? Number(data?.adjustment) : 0}
                                            onChange={(event) => {
                                              let newValue = event.target.value;
                                              // if (newValue.startsWith('-')) {
                                              //   newValue = newValue.slice(1);
                                              // }
                                              
                                              // if (newValue === '-0.00') {
                                              //   newValue = 0;
                                              // }

                                                    // Allow only two decimal places
                                                    if (newValue.includes('.')) {
                                                      const parts = newValue.split('.');
                                                      if (parts[1].length > 2) {
                                                        newValue = `${parts[0]}.${parts[1].slice(0, 2)}`;
                                                      }
                                                    }
                                              setRefreshData(!refreshData)
                                              data['adjustment'] = newValue
                                              setFieldValue(adjustmentFieldName, newValue);
                                            }}
                                            onKeyDown={(event) => {
                                              if (event.key === '-' || event.key === '+') {
                                                event.preventDefault();
                                              }
                                            }}
                                            error={Boolean(touched[adjustmentFieldName] && errors[adjustmentFieldName])}
                                            helperText={touched[adjustmentFieldName] && errors[adjustmentFieldName]}
                                          />

                                        </TableCell> */}
                                        <TableCell>
                                          {productCost.toFixed(2)}
                                        </TableCell>
                                        <TableCell>
                                          {
                                            data?.install_cost ? '' :
                                              rowTotal.toFixed(2)
                                          } 
                                        </TableCell>
                                        <TableCell>
                                        {(data?.fromMapServices == true) ? '' : 
                                          <IconButton onClick={() => handleDeleteProduct(data.id || data.product_id, data.indexId)}>
                                            <Delete />
                                          </IconButton>
                                        }
                                        </TableCell>
                                      </TableRow>
                                      {
                                        data?.install_cost ?
                                          <TableRow key={`summary-${data.indexId}`}>
                                            <TableCell>#{data?.indexId}</TableCell>
                                            <TableCell><Typography sx={{color:isSplitOrder ? theme.palette[
                                        FacilityTypes.find(f => f.id === data?.facility_id)?.color || 'primary'
                                      ]?.main
                                    : 'inherit' }}>Install Price</Typography></TableCell>
                                            <TableCell align='center'>-</TableCell>
                                            <TableCell align='center'>-</TableCell>
                                            {/* Incoming Percentage column for Install Price - only show when isSplitOrder is true */}
                                            {isSplitOrder ? (
                                              <TableCell align='center'>-</TableCell>
                                            ) : null}
                                            {/* <TableCell align='center'>
                                              {(
                                              parseFloat(data?.install_cost || 0) *
                                              (data?.locationQuantity || 1)
                                            ).toFixed(2)}
                                            </TableCell> */}
                                            <TableCell >
                                              {
                                              parseFloat(data?.install_cost || 0).toFixed(2)}
                                            </TableCell>
                                            <TableCell align='center'></TableCell>
                                            {Array.from({ length: 3 }).map((_, idx) => (
                                              <TableCell align='center' key={idx}>-</TableCell>
                                            ))} 
                                            <TableCell align='center'>
                                              {(
                                              parseFloat(data?.install_cost || 0) *
                                              (data?.locationQuantity || 1)
                                            ).toFixed(2)}
                                            </TableCell>
                                            <TableCell>
                                              {
                                                data?.install_count ? '' :
                                                  rowTotal.toFixed(2)
                                              }
                                            </TableCell>
                                            <TableCell>
                                              <IconButton onClick={() => handleDeleteInstallCost(data.id || data.product_id, data.indexId)}>
                                                <Delete />
                                              </IconButton>
                                            </TableCell>
                                          </TableRow> :
                                          ''
                                      }
                                      <TableRow>
                                        <TableCell colSpan={15} sx={{ padding: 0 }}>
                                          <Divider />
                                        </TableCell>
                                      </TableRow> 
                                      <Modal
                                        open={locationStates[data.indexId]}
                                        handleClose={() => {
                                          setLocationStates({ ...locationStates, [data.indexId]: false });
                                        }}
                                      >
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent={'space-between'} alignItems={'center'}>
                                        {((data?.fromMapServices != true) 
                                        // && index === 0
                                      ) && <FormControlLabel
                                          control={
                                            <Switch
                                              checked={data?.allLocationSame}
                                              onChange={()=>handleAllLocationSameChange(index)}
                                            />
                                          }
                                          label="All Locations Same"
                                        />}
                                        {
                                          values.project_category?.id !==14 ?
                                        <Box sx={{ display: 'flex', flexDirection: 'column',width:'50%', alignItems: 'center', mt: 2 }}>
                                        <LabelStyle>Qty Location Settings</LabelStyle>
                                          <Box display="flex" alignItems="center" gap={1} mt={1}>
                                            <Typography variant="subtitle2">Multiple</Typography>
                                            <Switch
                                              color="primary"
                                              checked={Boolean(data?.is_single_card)}
                                              onChange={(event) => {
                                                const checked = event.target.checked;
                                                setSelectedProducts((prev) =>
                                                  prev.map((p) => {
                                                    if (p.indexId !== data.indexId) return p;
                                                
                                                    const count = Number(p.locationQuantity || 1);
                                                
                                                    if (checked) {
                                                      return {
                                                        ...p,
                                                        is_single_card: true,
                                                        location: p.location?.length
                                                          ? [p.location[0]]
                                                          : [
                                                              {
                                                                id: 0,
                                                                address: '',
                                                                city: '',
                                                                state: '',
                                                                zip: '',
                                                              },
                                                            ],
                                                      };
                                                    } else {
                                                      const allSame = p.allLocationSame;
                                                      const firstAddress = p.location?.[0];
                                                      let arrayAddr = [];
                                                
                                                      if (allSame && firstAddress) {
                                                        arrayAddr = Array(count)
                                                          .fill()
                                                          .map((_, i) => ({
                                                            ...firstAddress,
                                                            id: i,
                                                            req_loc_id: p.location[i]?.req_loc_id ?? null,
                                                          }));
                                                      } else {
                                                        arrayAddr = [...p.location];
                                                        if (arrayAddr.length < count) {
                                                          arrayAddr.push(
                                                            ...Array(count - arrayAddr.length)
                                                              .fill()
                                                              .map((_, i) => ({
                                                                id: arrayAddr.length + i,
                                                                address: '',
                                                                city: '',
                                                                state: '',
                                                                zip: '',
                                                              }))
                                                          );
                                                        } else if (arrayAddr.length > count) {
                                                          arrayAddr = arrayAddr.slice(0, count);
                                                        }
                                                      }
                                                
                                                      return {
                                                        ...p,
                                                        is_single_card: false,
                                                        location: arrayAddr,
                                                      };
                                                    }
                                                  })
                                                );
                                              }}
                                            />
                                            <Typography variant="subtitle2">Single</Typography>
                                          </Box>
                                        </Box> : ''
                                        }
                                        </Stack>
                                        <Grid
                                          container
                                          spacing={3}
                                          sx={{ justifyContent: 'center', width: '100%' }}
                                        >
                                          {data.location.map((addr, i) => (
                                            <Grid item xs={12}>
                                              <Typography variant="h5" sx={{ mb: 2 }}>
                                                Location {data?.fromMapServices == true ? i+1 : i+1}
                                              </Typography>

                                              <Stack
                                                direction={{ xs: 'column', sm: 'row' }}
                                                spacing={{ xs: 3, sm: 2 }}
                                                sx={{ mb: 2 }}
                                              >
                                                <TextField
                                                  fullWidth
                                                  label="Address1"
                                                  size="small"
                                                  value={data.location[i].address || ''}
                                                  disabled={(data?.fromMapServices == true && data.location[i].address) ? true : (i !== 0 && data?.allLocationSame) ? true : false}
                                                  // onChange={(event) => {
                                                  //   let arrayAddr = [...data.location]
                                                  //   arrayAddr[i].address = event.target.value;
                                                  //   setSelectedProducts(pv => ([...pv.map(p => {
                                                  //     // if (p.id === data.id) {
                                                  //     if (p.indexId === data.indexId) {
                                                  //       return {
                                                  //         ...p,
                                                  //         location: arrayAddr
                                                  //       }
                                                  //     } else {
                                                  //       return p;
                                                  //     }
                                                  //   })]))
                                                  // }}
                                                  onChange={(event) => {
                                                    setSelectedProducts((prevProducts) =>
                                                      prevProducts.map((p) => {
                                                        if (p.indexId === data.indexId) {
                                                          let updatedLocations = [...p.location];
                                                          if (p.allLocationSame) {
                                                            updatedLocations = updatedLocations.map(() => ({
                                                              ...updatedLocations[0], 
                                                              address: event.target.value, 
                                                            }));
                                                          } else {
                                                            updatedLocations[i] = {
                                                              ...updatedLocations[i], 
                                                              address: event.target.value,
                                                            };
                                                          }
                                                          return {
                                                            ...p,
                                                            location: updatedLocations,
                                                          };
                                                        }
                                                        return p;
                                                      })
                                                    );
                                                  }}
                                                />
                                              </Stack>

                                              <Stack
                                                direction={{ xs: 'column', sm: 'row' }}
                                                spacing={{ xs: 3, sm: 2 }}
                                                sx={{ mb: 2 }}
                                              >
                                                <TextField
                                                  fullWidth
                                                  label="City"
                                                  size="small"
                                                  value={data.location[i].city || ''}
                                                  disabled={(data?.fromMapServices == true && data.location[i].city) ? true : (i !== 0 && data?.allLocationSame) ? true : false}
                                                  // onChange={(event) => {
                                                  //   let arrayAddr = [...data.location]
                                                  //   arrayAddr[i].city = event.target.value;
                                                  //   setSelectedProducts(pv => ([...pv.map(p => {
                                                  //     // if (p.id === data.id) {
                                                  //     if (p.indexId === data.indexId) {
                                                  //       return {
                                                  //         ...p,
                                                  //         location: arrayAddr
                                                  //       }
                                                  //     } else {
                                                  //       return p;
                                                  //     }
                                                  //   })]))
                                                  // }}
                                                  onChange={(event) => {
                                                    setSelectedProducts((prevProducts) =>
                                                      prevProducts.map((p) => {
                                                        if (p.indexId === data.indexId) {
                                                          let updatedLocations = [...p.location];
                                                          if (p.allLocationSame) {
                                                            updatedLocations = updatedLocations.map(() => ({
                                                              ...updatedLocations[0], 
                                                              city: event.target.value, 
                                                            }));
                                                          } else {
                                                            updatedLocations[i] = {
                                                              ...updatedLocations[i], 
                                                              city: event.target.value,
                                                            };
                                                          }
                                                          return {
                                                            ...p,
                                                            location: updatedLocations,
                                                          };
                                                        }
                                                        return p;
                                                      })
                                                    );
                                                  }}
                                                />
                                                <TextField
                                                  fullWidth
                                                  label="State"
                                                  size="small"
                                                  value={data.location[i].state || ''}
                                                  disabled={(data?.fromMapServices == true && data.location[i].state) ? true : (i !== 0 && data?.allLocationSame) ? true : false}
                                                  // onChange={(event) => {
                                                  //   let arrayAddr = [...data.location]
                                                  //   arrayAddr[i].state = event.target.value;
                                                  //   setSelectedProducts(pv => ([...pv.map(p => {
                                                  //     // if (p.id === data.id) {
                                                  //     if (p.indexId === data.indexId) {
                                                  //       return {
                                                  //         ...p,
                                                  //         location: arrayAddr
                                                  //       }
                                                  //     } else {
                                                  //       return p;
                                                  //     }
                                                  //   })]))
                                                  // }}
                                                  onChange={(event) => {
                                                    setSelectedProducts((prevProducts) =>
                                                      prevProducts.map((p) => {
                                                        if (p.indexId === data.indexId) {
                                                          let updatedLocations = [...p.location];
                                                          if (p.allLocationSame) {
                                                            updatedLocations = updatedLocations.map(() => ({
                                                              ...updatedLocations[0], 
                                                              state: event.target.value, 
                                                            }));
                                                          } else {
                                                            updatedLocations[i] = {
                                                              ...updatedLocations[i], 
                                                              state: event.target.value,
                                                            };
                                                          }
                                                          return {
                                                            ...p,
                                                            location: updatedLocations,
                                                          };
                                                        }
                                                        return p;
                                                      })
                                                    );
                                                  }}
                                                />
                                                <TextField
                                                  fullWidth
                                                  label="Zip / Postal Code"
                                                  size="small"
                                                  value={data.location[i].zip || ''}
                                                  disabled={(data?.fromMapServices == true && data.location[i].zip) ? true : (i !== 0 && data?.allLocationSame) ? true : false}
                                                  // onChange={(event) => {
                                                  //   let arrayAddr = [...data.location]
                                                  //   arrayAddr[i].zip = event.target.value;
                                                  //   setSelectedProducts(pv => ([...pv.map(p => {
                                                  //     // if (p.id === data.id) {
                                                  //     if (p.indexId === data.indexId) {
                                                  //       return {
                                                  //         ...p,
                                                  //         location: arrayAddr
                                                  //       }
                                                  //     } else {
                                                  //       return p;
                                                  //     }
                                                  //   })]))
                                                  // }}
                                                  onChange={(event) => {
                                                    setSelectedProducts((prevProducts) =>
                                                      prevProducts.map((p) => {
                                                        if (p.indexId === data.indexId) {
                                                          let updatedLocations = [...p.location];
                                                          if (p.allLocationSame) {
                                                            updatedLocations = updatedLocations.map(() => ({
                                                              ...updatedLocations[0], 
                                                              zip: event.target.value, 
                                                            }));
                                                          } else {
                                                            updatedLocations[i] = {
                                                              ...updatedLocations[i], 
                                                              zip: event.target.value,
                                                            };
                                                          }
                                                          return {
                                                            ...p,
                                                            location: updatedLocations,
                                                          };
                                                        }
                                                        return p;
                                                      })
                                                    );
                                                  }}
                                                />
                                              </Stack>
                                            </Grid>
                                          ))}
                                        </Grid>

                                        <Grid container justifyContent="center" alignItems="center">
                                          <Grid item xs={12} md={4}>
                                          {/* {(data?.fromMapServices == true) ? '' : (i !== 0 && data?.allLocationSame) ? '' : */}
                                            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                              <LoadingButton variant="contained" onClick={() => {
                                                setIsSaving(true)
                                                setTimeout(() => {
                                                  setIsSaving(false)
                                                  setLocationStates(false)
                                                }, 100)
                                              }} loading={isSaving}>
                                                {' Save '}
                                              </LoadingButton>
                                            </Box>
                                            {/* } */}
                                          </Grid>
                                        </Grid>
                                      </Modal>
                                      <Modal
                                        open={openProductNote[data.indexId] || false}
                                        handleClose={() => handleCloseNote(data.indexId)}
                                      >
                                        <Grid
                                          container
                                          spacing={3}
                                          sx={{ justifyContent: 'center', width: '100%' }}
                                        >
                                            <Grid item xs={12}>
                                              <Typography variant="h5" sx={{ mb: 2 }}>
                                                Note
                                              </Typography>

                                              <Stack
                                                direction={{ xs: 'column', sm: 'row' }}
                                                spacing={{ xs: 3, sm: 2 }}
                                                sx={{ mb: 2 }}
                                              >
                                                <TextField
                                                  fullWidth
                                                  multiline
                                                  rows={4}
                                                  size="medium"
                                                  value={serviceCurrentNote}
                                                  onChange={handleNoteChange}
                                                  inputProps={{ maxLength: MAX_CHARACTERS }}
                                                  helperText={`${serviceCurrentNote.length}/${MAX_CHARACTERS} characters`}
                                                  InputProps={{
                                                    sx: {
                                                      color: 'error.main',
                                                    }
                                                  }}
                                                />
                                              </Stack>
                                            </Grid>
                                        </Grid>

                                        <Grid container justifyContent="center" alignItems="center">
                                          <Grid item xs={12} md={4}>
                                            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                              <LoadingButton
                                                variant="contained"
                                                onClick={() => handleSaveNote(data.indexId)}
                                                loading={serviceIsSavingNote}>
                                                Save
                                              </LoadingButton>
                                            </Box>
                                          </Grid>
                                        </Grid>
                                      </Modal>
                                    </>
                                  );
                                })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Scrollbar>
                        {/* <Stack sx={{ justifyContent: 'space-between', alignItems: 'center', display:'flex', flexDirection:'row' }}>
                          <Button
                            variant="outlined"
                            startIcon={
                              <Stack>
                                {' '}
                                <Add />{' '}
                              </Stack>
                            }
                            onClick={() => {
                              addNewProductRow()
                              // setMarkupType(1)
                            }}
                          >
                            Add Product Row
                          </Button>
                          <Typography variant="h6">
                            Total Additional Product Cost:{' '}
                            {selectedProductsAdditionalCost}
                          </Typography>
                        </Stack> */}
                        </>}   
                        </>}

                        <Divider />
                        <Stack direction='row'>
                          <LabelStyleHead>Services</LabelStyleHead>
                          {showServices ? <Remove sx={{ color: theme.palette.primary.main }} onClick={(e) => { setShowServices(false) }} /> : <Add sx={{ color: theme.palette.primary.main }} onClick={(e) => { setShowServices(true) }} />}
                        </Stack>
                        {showServices && <>
                          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                            <Autocomplete
                              sx={{ width: 400 }}
                              multiple
                              id="combo-box-demo"
                              options={
                                filteredServices?.filter(item =>
                                  item.status === 1 
                                  // &&
                                  // !additionalSelectedServices.some(selectedService =>
                                  //   selectedService?.id === item?.id || selectedService?.labour_cost_service_id === item?.id
                                  // )
                                ) || []
                              }
                              // options={filteredServiceOptions}
                              value={additionalSelectedServices?.filter(item=>!item.isAdditionalProduct)}
                              // value={values.services}
                              // onChange={(event, newValue) => {
                              //   setFieldValue('services', newValue);
                              //   // setAdditionalSelectedServices(newValue);
                              //   setAdditionalSelectedServices(prevProducts => {
                              //     const updatedProducts = newValue?.map((product, index) => {
                              //       const existingProduct = prevProducts.find(p => (p?.id === product?.id && p?.indexId === product?.indexId));
                              //       console.log('existingProduct-----------------',existingProduct)
                              //       console.log('prevProducts-----------------',prevProducts)
                              //       console.log('product-----------------',product)
                              //       if (existingProduct) {
                              //         let addresses = [...existingProduct?.addresses];
                              //         for (let i = addresses?.length; i < 1; i++) {
                              //           addresses.push({
                              //             id: i,
                              //             address: '',
                              //             city: '',
                              //             state: '',
                              //             zip: '',
                              //           });
                              //         }
                              //         return {
                              //           ...existingProduct,
                              //           addresses
                              //         };
                              //       } else {
                              //         const newAddresses = [{
                              //           id: 0,
                              //           address: '',
                              //           city: '',
                              //           state: '',
                              //           zip: '',
                              //         }];
                            
                              //         // if (prevProducts.length > 0) {
                              //         //   const commonAddress = { ...prevProducts[0].addresses[0] } || {
                              //         //     address: '',
                              //         //     city: '',
                              //         //     state: '',
                              //         //     zip: '',
                              //         //   };
                              //         //   newAddresses[0] = commonAddress;
                              //         // }
                              //         const newIndexCounter = serviceIndexCounter + 1
                              //         setServiceIndexCounter(newIndexCounter);
                              //         return {
                              //           ...product,
                              //           indexId: newIndexCounter,
                              //           addresses: newAddresses
                              //         };
                              //       }
                              //     });
                              //     return updatedProducts;
                              //   });
                              // }}


                              onChange={(event, newValue) => {
                                // Extract community address from Formik's values
                                const { address: projAddress = '', city: projCity = '', state: projState = '', zip: projZip = '' } = values?.community || {};
                              
                                const communityAddress = { 
                                  address: projAddress, 
                                  city: projCity, 
                                  state: projState, 
                                  zip: projZip 
                                };
                              
                                // Update Formik's field value
                                setFieldValue('services', newValue);
                              
                                // Update additional selected services
                                setAdditionalSelectedServices((prevProducts) => {
                                  const additionals = prevProducts?.filter(item => item.isAdditionalProduct === true || item.isAdditionalProduct === 1)
                                  const updatedProducts = newValue?.map((product) => {
                                    // Check if the product already exists in the selected services
                                    const existingProduct = prevProducts.find(
                                      (p) => p?.id === product?.id && p?.indexId === product?.indexId
                                    );
                              
                                    if (existingProduct) {
                                      // -----------------------
                                      // Update existing product's addresses
                                      // -----------------------
                                      let addresses = [...existingProduct?.addresses];
                                      for (let i = addresses.length; i < 1; i++) {
                                        addresses.push({
                                          id: i,
                                          address: '',
                                          city: '',
                                          state: '',
                                          zip: '',
                                        });
                                      }
                                      return {
                                        ...existingProduct,
                                        addresses,
                                      };
                                    } else {
                                      // -----------------------
                                      // Add a new product
                                      // -----------------------
                                      const assignedService = assignServiceAddresses(
                                        prevProducts,
                                        product,
                                        allServiceLocationSame,
                                        communityAddress
                                      );
                              
                                      // Increment the service index counter for a unique indexId
                                      const newIndexCounter = serviceIndexCounter + 1;
                                      setServiceIndexCounter(newIndexCounter);
                              
                                      return {
                                        ...assignedService,
                                        indexId: newIndexCounter,
                                        quantity: 1,
                                      };
                                    }
                                  });
                                  const finalServices = [...updatedProducts, ...additionals];
                                  console.log('finalServices--additionals', additionals)
                                  console.log('finalServices--updatedProducts', updatedProducts)
                                  console.log('finalServices--finalServices', finalServices)
                                  return finalServices;
                                });
                              }}
                              //previos one
                              // onChange={(event, newValue) => {
                              //   setFieldValue('services', newValue);
                                
                              //   setAdditionalSelectedServices(prevProducts => {
                              //     const updatedProducts = newValue?.map((product, index) => {
                              //       const existingProduct = prevProducts.find(
                              //         p => p?.id === product?.id && p?.indexId === product?.indexId
                              //       );
                              
                              //       if (existingProduct) {
                              //         // Update existing product's addresses
                              //         let addresses = [...existingProduct?.addresses];
                              //         for (let i = addresses?.length; i < 1; i++) {
                              //           addresses.push({
                              //             id: i,
                              //             address: '',
                              //             city: '',
                              //             state: '',
                              //             zip: '',
                              //           });
                              //         }
                              //         return {
                              //           ...existingProduct,
                              //           addresses,
                              //         };
                              //       } else {
                              //         // Add a new product
                              //         let newAddresses = [
                              //           {
                              //             id: 0,
                              //             address: '',
                              //             city: '',
                              //             state: '',
                              //             zip: '',
                              //           },
                              //         ];
                              
                              //         // If allServiceLocationSame is enabled, use the common address
                              //         if (allServiceLocationSame && prevProducts.length > 0) {
                              //           const commonAddress = { ...prevProducts[0].addresses[0] };
                              //           newAddresses[0] = commonAddress;
                              //         }
                              
                              //         const newIndexCounter = serviceIndexCounter + 1;
                              //         setServiceIndexCounter(newIndexCounter);
                              
                              //         return {
                              //           ...product,
                              //           indexId: newIndexCounter,
                              //           addresses: newAddresses,
                              //         };
                              //       }
                              //     });
                              
                              //     return updatedProducts;
                              //   });
                              // }}
                              
                              renderInput={(params) => (
                                <TextField {...params} required
                                  error={Boolean(touched.services && errors.services)}
                                  helperText={touched.services && errors.services}
                                  label={
                                    // ((values.project_category?.name == 'Time & Material') || (values.project_category?.name == 'Service only')) 
                                    values.project_category?.name == 'Service only'
                                    ? "Select services" : "Select additional services"
                                  } />
                              )}
                              getOptionLabel={(option) =>
                                option?.name
                                  ? `${option.name} (${option.inhouse === 1 ? 'Inhouse' : 'Sub contract'})`
                                  : ''
                              }
                            />
                          </Stack>
                          <LabelStyle>Selected services</LabelStyle>
                          <Scrollbar>
                            <TableContainer sx={{ minWidth: 500 }}>
                              <Table>
                                <TableHead>
                                  <TableRow>
                                    {/* {VALUE_SERVICES?.map((val) => (
                                      // ((values.project_category?.name == 'Time & Material') && val.id === 6) ? <TableCell></TableCell> : 
                                      (((values.project_category?.name == 'Service only') 
                                      // || 
                                      // (values.project_category?.name == 'Time & Material')
                                    
                                      && val.id === 0)
                                      // || ((values.project_category?.name !== 'Service only') && val.id === 6)
                                      ) ? null : (
                                        <TableCell>{val.value}</TableCell>
                                      ))
                                    )} */}
                                     {VALUE_SERVICES?.map((val) => (
                                        <TableCell>{val.value}</TableCell>
                                      )
                                    )}
                                  </TableRow>
                                </TableHead>

                                {/* <TableBody>
                                  {selectedServices?.map((data, index) => {
                                    const quantityFieldName = `service_quantity_${index}`;
                                    // if(values.project_category?.name == 'Time & Material'){
                                    //   data['total_cost'] = 0
                                    //   data['unit_cost'] = 0
                                    //   data['cost'] = 0
                                    //   data['quantity'] = 0
                                    // }
                                    const dataCost = data.unit_cost || data.total_cost
                                    const total = dataCost * data.quantity
                                    totalAmount += total
                                    data['totalAmount'] = totalAmount?.toFixed(2)
                                    let markup = 0
                                    if(total > 0){
                                      markup = dataCost / total
                                    }
                                    data['markup'] = markup?.toFixed(2)
                                    totalServiceMarkup += markup
                                    data['total'] = total?.toFixed(2)
                                    data['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                    let originalMarkup = data.originalMarkup || 0
                                    originaltotalServiceMarkup += originalMarkup
                                    // values['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                    console.log("############WWWWW", originalMarkup);
                                    let qtyData = data.qtyData || 1
                                    console.log("############qtyData", qtyData);
                                    const previousQty = data.prQty*qtyData * (data.locationQuantity||1);
                                    const newQty = (data.prQty * qtyData * data.locationQuantity || 1)?.toFixed(2)
                                    let quantityDifference = 0
                                    if(values.project_category?.name == 'Time & Material'){
                                      // quantityDifference = 0
                                      quantityDifference = Number(data.quantity) - newQty;
                                    }else{
                                      quantityDifference = Number(data.quantity) - newQty;
                                    }
                                    data['quantityDifference'] = quantityDifference
                                    data['jobcost_unit_cost'] = data.cost
                                    data['jobcost_quantity'] = quantityDifference
                                    data['jobcost_total_cost'] = (data.cost*Number(data.quantity))?.toFixed(2)
                                    return (
                                      <>
                                        <TableRow key={index}>
                                          <TableCell>#{data?.productIndex}</TableCell>
                                          <TableCell>{data.name}</TableCell>
                                          <TableCell>{originalMarkup?.toFixed(2)}</TableCell>
                                          <TableCell>{data.cost}</TableCell>
                                          <TableCell>{dataCost}</TableCell>
                                          <TableCell>
                                            <TextField
                                              type="number"
                                              // sx={{ width: 400 }}           
                                              sx={{ minWidth: '80px' }}                                                                     
                                              label={'Hours'}
                                              // {...getFieldProps(quantityFieldName)}
                                              // disabled={(data?.fromMapServices == true) ? true : false}
                                              value={Number(data.quantity)}
                                              // disabled={(data?.fromMapServices == true) ? true : values.project_category?.name == 'Time & Material' ? true : false}
                                              disabled
                                              // value={values.project_category?.name == 'Time & Material' ? 0 : Number(data.quantity)}
                                              // defaultValue={(values.project_category?.name == 'Time & Material' && Number(data?.id) === 10) ? 0 : (data.quantity ? Number(data.quantity) : 0)}
                                              defaultValue={data.quantity ? Number(data.quantity) : 0}
                                              onChange={(event) => {
                                                let newValue = event.target.value;
                                                const newData = { ...data, quantity: newValue || 0 };
                                                if (newValue.startsWith('-')) {
                                                  newValue = newValue.slice(1);
                                                }
                                                if (newValue < previousQty) {
                                                  setShowWarning(prev => {
                                                    const newWarnings = [...prev];
                                                    newWarnings[index] = true;
                                                    return newWarnings;
                                                  });
                                                  console.log('data?.prQty---', data?.prQty);
                                                  data['quantity'] = previousQty;
                                                  setFieldValue(quantityFieldName, previousQty);
                                                } else {
                                                  setShowWarning(prev => {
                                                    const newWarnings = [...prev];
                                                    newWarnings[index] = false;
                                                    return newWarnings;
                                                  });
                                                  data['quantity'] = newValue || 1;
                                                  setFieldValue(quantityFieldName, newValue);
                                                }

                                                const updatedServices = [...selectedServices];
                                                updatedServices[index] = newData;
                                                updatedServices[index] = newData;

                                                updatedServices[index] = newData;

                                                setSelectedServices(updatedServices);
                                              }}
                                              inputProps={{ min: previousQty}}
                                              error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                              helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                            />
                                            {showWarning[index] && (
                                              <Typography color="error" variant='body2'>
                                                Cannot reduce the added hours in the product formula. If you need to reduce, change it in the product formula.
                                              </Typography>
                                            )}
                                          </TableCell>
                                          <TableCell>{(data.cost*quantityDifference?.toFixed(2))?.toFixed(2)}</TableCell>
                                          <TableCell>{(data.unit_cost * quantityDifference?.toFixed(2))?.toFixed(2)}</TableCell>
                                          <TableCell>{total?.toFixed(2)}</TableCell>
                                        </TableRow>
                                      </>
                                    );
                                  })}
                                  
                                </TableBody> */}
                                  {console.log(additionalSelectedServices,'------------------------------additionalSelectedServices')}
                                <TableBody>
                                  {additionalSelectedServices?.map((data, index) => {
                                    console.log("############additional services", data);
                                    // if(values.project_category?.name == 'Time & Material'){
                                    //   data['total_cost'] = 0
                                    //   data['unit_cost'] = 0
                                    //   data['cost'] = 0
                                    //   data['quantity'] = 0
                                    // }
                                    const quantityFieldName = `service_quantity_${index}`;
                                    const dataQuantity = data?.quantity ? data?.quantity : 0;
                                    const dataCost = data.unit_cost || data.total_cost
                                    let total, originalMarkup
                                    // Check if nocharge is enabled
                                    if (noCharge) {
                                      // Nocharge case: markup = 0, original markup = 0, total = cost * quantity
                                      total = data.cost * dataQuantity
                                      data['markup'] = 0.00
                                      data['quantity'] = dataQuantity
                                      totalServiceMarkup += 0
                                      data['total'] = total ? total?.toFixed(2) : 0.00
                                      data['total_cost'] = data?.cost
                                      data['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                      originalMarkup = 0
                                      data['originalMarkup'] = 0
                                      originaltotalServiceMarkup += 0
                                    } else {
                                      // Normal case: existing logic
                                      total = dataCost * dataQuantity
                                      // Fix division by zero issue that causes infinity
                                      const markup = (total > 0) ? (dataCost / Number(total)) : 0
                                      data['markup'] = markup ? markup?.toFixed(2) : 0.00
                                      data['quantity'] = dataQuantity
                                      totalServiceMarkup += markup
                                      data['total'] = total ? total?.toFixed(2) : 0.00
                                      data['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                      originalMarkup = data.originalMarkup || 0
                                      data['originalMarkup'] = data.originalMarkup || 0
                                      originaltotalServiceMarkup += originalMarkup
                                    }
                                    const quantityDifference = Number(data.quantity)
                                    data['quantityDifference'] = quantityDifference
                                    data['jobcost_unit_cost'] = data.cost
                                    data['jobcost_quantity'] = quantityDifference
                                    data['jobcost_total_cost'] = (data.cost*Number(data?.quantity) || 1)?.toFixed(2)
                                    // values['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                    console.log('total---', total);
                                    console.log('data---', data);
                                    return (
                                      <>
                                        <TableRow key={index}>
                                        {/* {(values.project_category?.name != 'Service only' && values.project_category?.name != 'Time & Material') ? ( */}
                                        {values.project_category?.name != 'Service only old' ? (
                                          <TableCell></TableCell>
                                        ) : null}
                                          <TableCell>{
                                            data?.isAdditionalProduct ?
                                            <TextField
                                              required
                                              fullWidth
                                              type="text"
                                              label={'Service Name'}
                                              sx={{ width: 85 }}
                                              value={data.name}
                                              onChange={(event) => {
                                                let newValue = event.target.value

                                                // Update the selectedProducts state
                                                setAdditionalSelectedServices(
                                                  (prevProducts) =>
                                                    prevProducts.map((service) => {
                                                        if ( service.newIndexId === data.newIndexId ) {
                                                          return {
                                                            ...service,
                                                            name: newValue,
                                                          }
                                                        } else {
                                                          return service
                                                        }
                                                      },
                                                    ),
                                                )
                                                data['name'] = newValue || ''
                                                if (isSubmitted)
                                                  setIsSubmitted(false)
                                              }}
                                              error={
                                                isSubmitted && data?.name?.trim() === ''
                                              }
                                              helperText={
                                                isSubmitted && data?.name?.trim() === '' ? 'Service Name is required' : ''
                                              }
                                            />
                                            : 
                                            data.name}</TableCell>
                                          <TableCell>
                                            <IconButton onClick={() => handleOpenServiceNote(data.indexId || data.newIndexId, data.service_notes)}>
                                              <NoteAdd
                                                sx={{
                                                  color: (!data?.service_notes || data?.service_notes === '') ? '' : theme.palette.primary.main,
                                                }}
                                              />
                                            </IconButton>
                                          </TableCell>
                                          <TableCell>{originalMarkup ? originalMarkup?.toFixed(2) : 0.00}</TableCell>
                                          <TableCell>{data.cost}</TableCell>
                                          <TableCell>{
                                            data?.isAdditionalProduct ?
                                            <TextField
                                              required
                                              fullWidth
                                              type="number"
                                              label={'Hourly Cost'}
                                              // disabled={values.project_category?.name == 'Time & Material' ? true : false}
                                              sx={{ width: 85 }}
                                              value={dataCost}
                                              // onWheel={(e) => e.target.blur()}
                                              onKeyPress={(event) => {
                                                // if (event.key === '0' && event.target.value === '') {
                                                //   event.preventDefault();
                                                // }
                                                if (event.key === '-') {
                                                  event.preventDefault();
                                                }
                                                if (event.key === 'e') {
                                                  event.preventDefault();
                                                }
                                              }}
                                              inputProps={{ min: 0 }}
                                              defaultValue={0}
                                              onChange={(event) => {
                                                let newValue = event.target.value
                                                if (newValue !== '') {
                                                  setAdditionalSelectedServices((pv) => [
                                                      ...pv.map((p) => {
                                                        if ( p.newIndexId === data.newIndexId ) {
                                                          return {
                                                            ...p,
                                                            total_cost: newValue,
                                                            unit_cost: newValue,
                                                          }
                                                        } else {
                                                          return p
                                                        }
                                                      }),
                                                    ],
                                                  )
                                                  data['total_cost'] =  newValue || 0
                                                  data['unit_cost'] =  newValue || 0
                                                }
                                              }}
                                              // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                              // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                            /> :
                                            dataCost}</TableCell>
                                          <TableCell>
                                            <TextField
                                              type="number"
                                              // sx={{ width: 400 }} 
                                              sx={{ minWidth: '80px' }}
                                              label={'Hours'}
                                              {...getFieldProps(quantityFieldName)}
                                              // disabled={(values.project_category?.name == 'Time & Material') ? true : false }
                                              // value={(values.project_category?.name == 'Time & Material' && Number(data?.id) === 10) ? 0 : Number(data?.quantity) || 0}
                                              value={Number(data?.quantity) || 0}
                                              // defaultValue={(values.project_category?.name == 'Time & Material' && Number(data?.id) === 10 ) ? 0 : 1}
                                              defaultValue={1}
                                              onKeyPress={(event) => { 
                                                if (event.key === '-') {
                                                  event.preventDefault();
                                                }
                                              }}
                                              onChange={(event) => {
                                                let newValue = event.target.value || 0;
                                                // if (newValue.startsWith('-')) {
                                                //   newValue = newValue.slice(1);
                                                // }
                                                // data['quantity'] = newValue || 1;
                                                const newData = { ...data, quantity: newValue || 0 };
                                                const updatedServices = [...additionalSelectedServices];
                                                updatedServices[index] = newData;
                                                setAdditionalSelectedServices(updatedServices);
                                                setFieldValue(quantityFieldName, newValue);
                                              }}

                                              onWheel={(e) => e.target.blur()}

                                              onKeyDown={(event) => {
                                                if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                                                  const newValue = event.target.value || 0;
                                                  if (newValue < 1 && event.key === 'ArrowDown') {
                                                    event.preventDefault(); 
                                                  }
                                                }
                                              }}

                                              error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                              helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                            />
                                          </TableCell>   
                                          {/* <TableCell>
                                            {data?.is_dos == 1 ? 'N/A' : (
                                            <Switch
                                              checked={data.makeAsTask === 1}
                                              onChange={(e) => {
                                                const newValue = e.target.checked ? 1 : 0;
                                                setAdditionalSelectedServices((prevServices) =>
                                                  prevServices.map((service) =>
                                                    service.indexId === data.indexId
                                                      ? { ...service, makeAsTask: newValue }
                                                      : service
                                                  )
                                                );
                                                data['makeAsTask'] = newValue;
                                              }}
                                              color="primary"
                                            />
                                            )}
                                          </TableCell>
                                          <TableCell>
                                            {data?.is_dos == 1 ? 'N/A' : (
                                            <Switch
                                              checked={data.makeInstallCard === 1}
                                              onChange={(e) => {
                                                const newValue = e.target.checked ? 1 : 0;
                                                setAdditionalSelectedServices((prevServices) =>
                                                  prevServices.map((service) =>
                                                    service.indexId === data.indexId
                                                      ? { ...service, makeInstallCard: newValue }
                                                      : service
                                                  )
                                                );
                                                data['makeInstallCard'] = newValue;
                                              }}
                                              color="primary"
                                            />)}
                                          </TableCell> */}
                                          {/* {values.project_category?.name == 'Service only'  || (values?.project_category?.name == 'Time & Material') ? ( */}
                                          <TableCell>
                                            <IconButton
                                              onClick={() => {
                                                const indexKey = data.indexId ?? data.newIndexId;
                                                setServiceOnlyLocationStates({ ...serviceOnlyLocationStates, [indexKey]: true });
                                              }}
                                            >
                                              <LocationOn sx={{
                                                color: data?.addresses?.some(obj =>
                                                  [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
                                                ) ? '' : theme.palette.primary.main
                                              }} />
                                            </IconButton>
                                          </TableCell>
                                          {/* ) : null}                                   */}
                                          <TableCell>{data?.isAdditionalProduct ? 'N/A' : (data.cost*quantityDifference)?.toFixed(2)}</TableCell>
                                          <TableCell>{total ? total?.toFixed(2) : 0.00}</TableCell>
                                          <TableCell>{total ? total?.toFixed(2) : 0.00}</TableCell>
                                          <TableCell align='right'>
                                            <IconButton onClick={() => handleDeleteService(data.id, data.indexId, data.newIndexId, index)}>
                                              <Delete />
                                            </IconButton>
                                          </TableCell>
                                        </TableRow>
                                        <Modal
                                            open={serviceOnlyLocationStates[data.indexId]}
                                            handleClose={() => {
                                              const indexKey = data.indexId ?? data.newIndexId;
                                              setServiceOnlyLocationStates({ ...serviceOnlyLocationStates, [indexKey]: false });
                                            }}
                                          >
                                               {index === 0 && <FormControlLabel
                                          control={
                                            <Switch
                                              checked={allServiceLocationSame}
                                              onChange={handleAllServiceLocationSameChange}
                                            />
                                          }
                                          label="All Locations Same"
                                        />}
                                            <Grid
                                              container
                                              spacing={3}
                                              sx={{ justifyContent: 'center', width: '100%' }}
                                            >

                                              {data?.addresses?.map((addr, i) => (
                                                <Grid item xs={12}>
                                                  {/* Side Heading */}
                                                  <Typography variant="h5" sx={{ mb: 2 }}>
                                                    Location
                                                  </Typography>

                                                  {/* Address Fields */}

                                                  <Stack
                                                    direction={{ xs: 'column', sm: 'row' }}
                                                    spacing={{ xs: 3, sm: 2 }}
                                                    sx={{ mb: 2 }}
                                                  >
                                                    <TextField
                                                      fullWidth
                                                      label="Address"
                                                      size="small"
                                                      value={data.addresses[i].address || ''}
                                                      disabled={index !== 0 && allServiceLocationSame ? true : false}
                                                      onChange={(event) => {
                                                        let arrayAddr = [...data.addresses]
                                                        arrayAddr[i].address = event.target.value;
                                                        setAdditionalSelectedServices(pv => ([...pv.map(p => {
                                                          // if (p.id === data.id) {
                                                          if (p.indexId === data.indexId) {
                                                            return {
                                                              ...p,
                                                              addresses: arrayAddr
                                                            }
                                                          } else {
                                                            return p;
                                                          }
                                                        })]))
                                                      }}
                                                    />
                                                  </Stack>

                                                  {/* City, State, Zip Fields */}
                                                  <Stack
                                                    direction={{ xs: 'column', sm: 'row' }}
                                                    spacing={{ xs: 3, sm: 2 }}
                                                    sx={{ mb: 2 }}
                                                  >
                                                    <TextField
                                                      fullWidth
                                                      label="City"
                                                      size="small"
                                                      value={data.addresses[i].city || ''}
                                                      disabled={index !== 0 && allServiceLocationSame ? true : false}
                                                      onChange={(event) => {
                                                        let arrayAddr = [...data.addresses]
                                                        arrayAddr[i].city = event.target.value;
                                                        setAdditionalSelectedServices(pv => ([...pv.map(p => {
                                                          // if (p.id === data.id) {
                                                          if (p.indexId === data.indexId) {
                                                            return {
                                                              ...p,
                                                              addresses: arrayAddr
                                                            }
                                                          } else {
                                                            return p;
                                                          }
                                                        })]))
                                                      }}
                                                    />
                                                    <TextField
                                                      fullWidth
                                                      label="State"
                                                      size="small"
                                                      value={data.addresses[i].state || ''}
                                                      disabled={index !== 0 && allServiceLocationSame ? true : false}
                                                      onChange={(event) => {
                                                        let arrayAddr = [...data.addresses]
                                                        arrayAddr[i].state = event.target.value;
                                                        setAdditionalSelectedServices(pv => ([...pv.map(p => {
                                                          // if (p.id === data.id) {
                                                          if (p.indexId === data.indexId) {
                                                            return {
                                                              ...p,
                                                              addresses: arrayAddr
                                                            }
                                                          } else {
                                                            return p;
                                                          }
                                                        })]))
                                                      }}
                                                    />
                                                    <TextField
                                                      fullWidth
                                                      label="Zip / Postal Code"
                                                      size="small"
                                                      value={data.addresses[i].zip || ''}
                                                      disabled={index !== 0 && allServiceLocationSame ? true : false}
                                                      onChange={(event) => {
                                                        let arrayAddr = [...data.addresses]
                                                        arrayAddr[i].zip = event.target.value;
                                                        setAdditionalSelectedServices(pv => ([...pv.map(p => {
                                                          if (p.indexId === data.indexId) {
                                                            // if (p.id === data.id) {
                                                            return {
                                                              ...p,
                                                              addresses: arrayAddr
                                                            }
                                                          } else {
                                                            return p;
                                                          }
                                                        })]))
                                                      }}
                                                    />
                                                  </Stack>
                                                </Grid>
                                              ))}
                                            </Grid>

                                            {index !== 0 && allServiceLocationSame ? '' :
                                            <Grid container justifyContent="center" alignItems="center">
                                              <Grid item xs={12} md={4}>
                                                <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                                  <LoadingButton variant="contained" onClick={() => {
                                                    setIsSaving(true)
                                                    setTimeout(() => {
                                                      setIsSaving(false)
                                                      setServiceOnlyLocationStates(false)
                                                    }, 100)
                                                  }} loading={isSaving}>
                                                    {' Save '}
                                                  </LoadingButton>
                                                  {/* <Button variant="outlined" type="submit" onClick={() => { setLocationStates(false) }}>
                                                  Cancel
                                                </Button> */}
                                                </Box>
                                              </Grid>
                                            </Grid>}
                                          </Modal>
                                      </>
                                    );
                                  })}
                                  {/* <TableRow>
                                    <TableCell colSpan={8}>
                                      <Typography variant="h6" align="right">
                                        Total Additional Cost: {totalProductLabourCost.toFixed(2)}
                                      </Typography>
                                    </TableCell>
                                  </TableRow> */}
                                </TableBody>

                              </Table>
                            </TableContainer>
                          </Scrollbar>
                          <Stack sx={{ justifyContent: 'flex-end', alignItems: 'flex-end', display:'flex', flexDirection:'column' }}>
                            {/* <Button
                              variant="outlined"
                              startIcon={
                                <Stack>
                                  {' '}
                                  <Add />{' '}
                                </Stack>
                              }
                              onClick={() => {
                                addNewServiceRow()
                                // setMarkupType(1)
                              }}
                            >
                              Add Service Row
                            </Button> */}
                            <Typography variant="h6">
                              Total Additional Service Cost:{' '}
                              {totalProductLabourCost?.toFixed(2)}
                            </Typography>
                            {/* <Typography variant="h6">
                              Total Product Labor Cost:{' '}
                              {Number(totalProductInstallCost || 0).toFixed(2)}
                            </Typography> */}
                          </Stack>
                          {/* {(values.project_category?.name == 'Time & Material') ? '' :
                          <> */}
                          {(values?.project_type?.name == 'TS' && values?.project_category?.id == 14) || values?.project_category?.id == 12  ? '' :
                          <>
                          <LabelStyleHead>Proposals</LabelStyleHead>

                          <Autocomplete
                            options={rfps}
                            // getOptionLabel={(option) => option.description}
                            getOptionLabel={(option) =>
                            option && option.description
                              ? `${option.description} ( ${option.vendor_name || ''})`
                              : ''
                            }
                            value={values.rfp}
                            onChange={(event, value) => {handleRfpSelect(event, value)
                              setFieldValue('rfp',value)
                            }}
                            renderInput={(params) => <TextField {...params} label="Select Proposal" />}
                            filterOptions={(options, { inputValue }) =>
                              options.filter((option) => {
                                const searchText = inputValue.toLowerCase();
                                return (
                                  option.name?.toLowerCase().includes(searchText) ||
                                  option.description?.toLowerCase().includes(searchText)
                                  // option.description?.toLowerCase().includes(searchText)
                                );
                              })
                            }
                          />

                          {/* Modal for RFP Selection */}
                          <Modal open={openModal} handleClose={closeModal}>
                            <Box sx={{ position: 'relative', p: 3, bgcolor: 'background.paper', boxShadow: 24 }}>

                              <Tabs value={tabIndex}
                                variant="fullWidth"
                                sx={{
                                  marginBottom: 4

                                }}
                                onChange={handleTabChange}>
                                <Tab label="Products" sx={{ width: '50%', minWidth: 0 }} />
                                <Tab label="Services" sx={{ width: '50%', minWidth: 0 }} />
                                {/* {((values?.project_category?.name != 'Service only') && (values?.project_category?.name != 'Time & Material')) && <Tab label="Products" sx={{ width: '50%', minWidth: 0 }}  />} */}
                                <Tab label="Materials" sx={{ width: '50%', minWidth: 0 }} />
                              </Tabs>
                              
                              {tabIndex === 0 && (
                                <TableContainer sx={{ minWidth: 500 }}>
                                  <Table>
                                  <TableHead>
                                    <TableRow>
                                    <TableCell align='center'>Name</TableCell>
                                    <TableCell align='center'>Unit Cost</TableCell>
                                    <TableCell align='center'>Unit</TableCell>
                                    <TableCell align='center'>Qty</TableCell>
                                    <TableCell align='center'>Total Cost</TableCell>
                                    <TableCell align='center'></TableCell>
                                    </TableRow>
                                  </TableHead>
                                  {rfpProducts?.filter((product)=>product.material == 0 ).map((product) => {
                                    let unitName = UNITS?.filter((item) => item?.id == product?.unit)
                                    unitName = unitName[0]?.name
                                    let shortUnitName = ''
                                    if (unitName == 'Square feet') {
                                      shortUnitName = 'Sq ft'
                                    } else if (unitName == 'Lineal feet') {
                                      shortUnitName = 'Lin ft'
                                    } else if (unitName == 'Square Inches') {
                                      shortUnitName = 'Sq Inches'
                                    } else if (unitName == 'Unit') {
                                      shortUnitName = 'Unit'
                                    }
                                    if(values?.project_category?.name == 'Time & Material'){
                                      product.product_price = 0
                                      // product.quantity = 0
                                    }
                                    return(
                                    // <Box key={product.id} sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                                      <TableRow key={product.id}>
                                        <TableCell align='center'>{product.product_name}</TableCell>
                                        <TableCell align='center'>${product.product_price}</TableCell>
                                        <TableCell align='center'>{product.quantity} {shortUnitName}</TableCell>
                                        <TableCell align='center'>{product.location_quantity}</TableCell>
                                        <TableCell align='center'>${(product.location_quantity*product.quantity * ((product.product_price).toFixed(2) || 0)).toFixed(2)}</TableCell>
                                        <TableCell align='center'><Button onClick={() => addToCart(product)}>Add</Button></TableCell>
                                      </TableRow>
                                    // </Box>
                                  )})}
                                  </Table>
                                </TableContainer>
                              )}
                                {tabIndex === 1 && (
                                  <TableContainer sx={{ minWidth: 500 }}>
                                  <Table>
                                  <TableHead>
                                    {/* <TableRow> */}
                                      <TableCell align='center'>Name</TableCell>
                                      <TableCell align='center'>Unit Cost</TableCell>
                                      <TableCell align='center'>Hours</TableCell>
                                      <TableCell align='center'>Total Cost</TableCell>
                                      <TableCell align='center'></TableCell>
                                    {/* </TableRow> */}
                                  </TableHead>
                                  {rfpServices.map((service) => {
                                    if(values?.project_category?.name == 'Time & Material'){
                                      service.sellingPrice = 0
                                      service.quantity = 0
                                      service.total_cost = 0
                                    }
                                    return(
                                    // <Box key={service.id} sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                                      <TableRow key={service.id}>
                                        <TableCell align='center'>{service.name}</TableCell>
                                        <TableCell align='center'>${service.sellingPrice}</TableCell>
                                        <TableCell align='center'>{service.quantity}</TableCell>
                                        <TableCell align='center'>${service.total_cost}</TableCell>
                                        <TableCell align='center'><Button onClick={() => addToCart(service)}>Add</Button></TableCell>
                                      </TableRow>
                                    // </Box>
                                  )})}
                                  </Table>
                                  </TableContainer>
                              )}
                              {tabIndex === 2 && (
                                <TableContainer sx={{ minWidth: 500 }}>
                                  <Table>
                                  <TableHead>
                                    <TableRow>
                                    <TableCell align='center'>Name</TableCell>
                                    <TableCell align='center'>Unit Cost</TableCell>
                                    <TableCell align='center'>Unit</TableCell>
                                    <TableCell align='center'>Qty</TableCell>
                                    <TableCell align='center'>Total Cost</TableCell>
                                    <TableCell align='center'></TableCell>
                                    </TableRow>
                                  </TableHead>
                                  {rfpProducts.filter((product)=>product.material == 1).map((product) => {
                                    let unitName = UNITS?.filter((item) => item?.id == product?.unit)
                                    unitName = unitName[0]?.name
                                    let shortUnitName = ''
                                    if (unitName == 'Square feet') {
                                      shortUnitName = 'Sq ft'
                                    } else if (unitName == 'Lineal feet') {
                                      shortUnitName = 'Lin ft'
                                    } else if (unitName == 'Square Inches') {
                                      shortUnitName = 'Sq Inches'
                                    } else if (unitName == 'Unit') {
                                      shortUnitName = 'Unit'
                                    }
                                    return(
                                    // <Box key={product.id} sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                                      <TableRow key={product.id}>
                                        <TableCell align='center'>{product.product_name}</TableCell>
                                        <TableCell align='center'>${product.product_price}</TableCell>
                                        <TableCell align='center'>{product.quantity} {shortUnitName}</TableCell>
                                        <TableCell align='center'>{product.location_quantity}</TableCell>
                                        <TableCell align='center'>${(product.location_quantity*product.quantity * ((product.product_price).toFixed(2) || 0)).toFixed(2)}</TableCell>
                                        <TableCell align='center'><Button onClick={() => addToCart(product)}>Add</Button></TableCell>
                                      </TableRow>
                                    // </Box>
                                  )})}
                                  </Table>
                                </TableContainer>
                              )}
                            </Box>
                          </Modal>
                          <Scrollbar>
                            <TableContainer sx={{ minWidth: 500 }}>
                              <Table>
                                <TableHead>
                                  <TableRow>
                                    {VALUE_RFP_Product?.map((val) => (

                                      <TableCell key={val.id}>{val.value}</TableCell>

                                    ))}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {cart?.filter((item)=>item.material == 0)?.map((data, index) => {
                                    console.log('cart---------', cart)
                                    let unitName = UNITS?.filter((item) => item?.id == data?.unit)
                                    unitName = unitName[0]?.name
                                    let shortUnitName = ''
                                    if (unitName == 'Square feet') {
                                      shortUnitName = 'Sq ft'
                                    } else if (unitName == 'Lineal feet') {
                                      shortUnitName = 'Lin ft'
                                    } else if (unitName == 'Square Inches') {
                                      shortUnitName = 'Sq Inches'
                                    } else if (unitName == 'Unit') {
                                      shortUnitName = 'Unit'
                                    }
                                    if(values.project_category?.name == 'Time & Material'){
                                      data.product_price = 0
                                      data.product_retail_price = 0
                                      data.sellingPrice = 0
                                    }
                                    // let markup = markupType ? markupType === 1 ? data.WholesaleMarkup || data.product_markup : data.RetailMarkup || data.product_markup : 0
                                    let markup = parseFloat(Number(data?.markup)) || 0
                                    data.product_markup = markup
                                    if(noCharge){
                                      data.product_markup = 0
                                      data.markup = 0
                                      markup = 0
                                    }
                                    return (
                                      <>
                                        <TableRow key={data.id}>
                                          <TableCell>{data.name || data.product_name}</TableCell>
                                          {/* <TableCell>{invoiceAmount}</TableCell> */}
                                          <TableCell>
                                            {markup?.toFixed(2) || 0.00}
                                          </TableCell>
                                          <TableCell>
                                            {data.product_price?.toFixed(2) || 0}
                                          </TableCell>
                                          <TableCell>
                                            {(data.product_price + (data.product_price * markup / 100)).toFixed(2) || 0.00}
                                          </TableCell>
                                          <TableCell>
                                            {data.quantity} {shortUnitName}
                                          </TableCell>
                                          <TableCell>
                                            {data.location_quantity}
                                          </TableCell>
                                          {/* <TableCell>
                                            {(data.product_price * data.quantity * data.location_quantity)?.toFixed(2)||0}
                                          </TableCell> */}
                                          <TableCell>
                                            {(data.location_quantity * data.quantity * ((data.product_price + (data.product_price * markup / 100)) || 0)).toFixed(2)}
                                          </TableCell>  
                                          {/* <TableCell>N/A</TableCell>
                                          <TableCell>N/A</TableCell>*/}
                                          <TableCell>
                                            <IconButton
                                              onClick={() => {
                                                setRfpLocationStates({ ...rfpLocationStates, [data.product_id]: true });
                                              }}
                                            >
                                              <LocationOn sx={{
                                                color: data && data.location && data.location.some(obj =>
                                                  [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
                                                ) ? '' : theme.palette.primary.main
                                              }} />
                                            </IconButton>
                                          </TableCell>
                                          <TableCell >
                                            <IconButton onClick={() => handleDeleteRFPProduct(data.product_id)}>
                                              <Delete />
                                            </IconButton>
                                          </TableCell>
                                        </TableRow>
                                        <Modal
                                          open={rfpLocationStates[data.product_id]}
                                          handleClose={() => {
                                            setRfpLocationStates({ ...rfpLocationStates, [data.product_id]: false });
                                          }}
                                        >
                                          {/* {index === 0 &&  */}
                                          <FormControlLabel
                                            control={
                                              <Switch
                                                checked={data?.allRfpProductsLocationSame}
                                                onChange={()=>handleAllRfpProductsLocationSameChange(index) }
                                              />
                                            }
                                            label="All Locations Same"
                                          />
                                          {/* } */}

                                          <Grid
                                            container
                                            spacing={3}
                                            sx={{ justifyContent: 'center', width: '100%' }}
                                          >

                                            {data?.location?.map((addr, i) => (
                                              <Grid item xs={12}>
                                                {/* Side Heading */}
                                                <Typography variant="h5" sx={{ mb: 2 }}>
                                                  Location {i+1}
                                                </Typography>

                                                {/* Address Fields */}

                                                <Stack
                                                  direction={{ xs: 'column', sm: 'row' }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    label="Address"
                                                    size="small"
                                                    value={data.location[i].address || ''}

                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.location]
                                                    //   arrayAddr[i].address = event.target.value;
                                                    //   setCart(pv => ([...pv.map(p => {


                                                    //     if (p.product_id === data.product_id) {
                                                    //       return {
                                                    //         ...p,
                                                    //         addresses: arrayAddr
                                                    //       }
                                                    //     }
                                                    //     else {
                                                    //       return {
                                                    //         ...p
                                                    //       }
                                                    //     }

                                                    //   })]))
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.location];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                address: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                address: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              location: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                    }}
                                                  />
                                                </Stack>

                                                {/* City, State, Zip Fields */}
                                                <Stack
                                                  direction={{ xs: 'column', sm: 'row' }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    label="City"
                                                    size="small"
                                                    value={data.location[i].city || ''}

                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.location]
                                                    //   arrayAddr[i].city = event.target.value;
                                                    //   setCart(pv => ([...pv.map(p => {


                                                    //     if (p.product_id === data.product_id) {
                                                    //       return {
                                                    //         ...p,
                                                    //         addresses: arrayAddr
                                                    //       }
                                                    //     }
                                                    //     else {
                                                    //       return {
                                                    //         ...p
                                                    //       }
                                                    //     }

                                                    //   })]))
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.location];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                city: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                city: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              location: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                    }}
                                                  />
                                                  <TextField
                                                    fullWidth
                                                    label="State"
                                                    size="small"
                                                    value={data.location[i].state || ''}

                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.location]
                                                    //   arrayAddr[i].state = event.target.value;
                                                    //   setCart(pv => ([...pv.map(p => {

                                                    //     if (p.product_id === data.product_id) {
                                                    //       return {
                                                    //         ...p,
                                                    //         addresses: arrayAddr
                                                    //       }
                                                    //     }
                                                    //     else {
                                                    //       return {
                                                    //         ...p
                                                    //       }
                                                    //     }

                                                    //   })]))
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.location];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                state: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                state: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              location: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                    }}
                                                  />
                                                  <TextField
                                                    fullWidth
                                                    label="Zip / Postal Code"
                                                    size="small"
                                                    value={data.location[i].zip || ''}

                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.location]
                                                    //   arrayAddr[i].zip = event.target.value;
                                                    //   setCart(pv => ([...pv.map(p => {


                                                    //     if (p.product_id === data.product_id) {
                                                    //       return {
                                                    //         ...p,
                                                    //         addresses: arrayAddr
                                                    //       }
                                                    //     }
                                                    //     else {
                                                    //       return {
                                                    //         ...p
                                                    //       }
                                                    //     }

                                                    //   })]))
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.location];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                zip: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                zip: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              location: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                    }}
                                                  />
                                                </Stack>
                                              </Grid>
                                            ))}
                                          </Grid>


                                          <Grid container justifyContent="center" alignItems="center">
                                            <Grid item xs={12} md={4}>
                                              <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                                <LoadingButton variant="contained" onClick={() => {
                                                  setIsSaving(true)
                                                  setTimeout(() => {
                                                    setIsSaving(false)
                                                    setRfpLocationStates(false)
                                                  }, 100)
                                                }} loading={isSaving}>
                                                  {' Save '}
                                                </LoadingButton>

                                              </Box>
                                            </Grid>
                                          </Grid>
                                        </Modal>
                                      </>
                                    );
                                  })}
                                </TableBody>
                                {
                                  cartService?.length > 0 ?
                                    <Typography variant='subtitle2' sx={{ fontWeight: 500 }}>Services</Typography>
                                    : ''
                                }
                                <TableBody>
                                  {cartService?.map((data, index) => {
                                    if(values.project_category?.name == 'Time & Material'){
                                      data.sellingPrice = 0
                                      data.unit_cost = 0
                                      data.qty = 0
                                    }
                                    if(noCharge){
                                      data.product_markup = 0
                                      data.originalMarkup = 0
                                      data.markup = 0
                                    }
                                    data.sellingPrice = data.sellingPrice || data.unit_cost
                                    data.originalMarkup = data.originalMarkup || data.product_markup

                                    return (
                                      <>
                                        <TableRow key={data.id}>
                                          <TableCell>
                                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                                              {data.name || data.product_name}
                                            </Typography>
                                            {data?.service_notes ? 
                                              <Stack direction={'column'}>
                                                <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography> 
                                                <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' ,color: 'error.main'}}>{data.service_notes}</Typography> 
                                              </Stack>
                                              : ''}
                                          </TableCell>
                                          {/* <TableCell>
                                            <IconButton onClick={() => handleOpenServiceNote(data.indexId, data.service_notes)}>
                                              <NoteAdd
                                                sx={{
                                                  color: (!data?.service_notes || data?.service_notes === '') ? '' : theme.palette.primary.main,
                                                }}
                                              />
                                            </IconButton>
                                          </TableCell> */}
                                          {/* <TableCell>{invoiceAmount}</TableCell> */}
                                          <TableCell>
                                            {data.originalMarkup?.toFixed(2)}
                                          </TableCell>
                                          <TableCell>
                                            {data.sellingPrice?.toFixed(2)}
                                          </TableCell>
                                          <TableCell>
                                            {((data.sellingPrice + (data.sellingPrice * data.originalMarkup / 100)))?.toFixed(2)}
                                          </TableCell>
                                          <TableCell>
                                            {data.qty} Hours
                                          </TableCell>
                                          <TableCell>-</TableCell>                                     
                                          {/* <TableCell>
                                            {(data.qty*data.sellingPrice).toFixed(2)||0}
                                          </TableCell> */}
                                          <TableCell>
                                            {(data.qty * (data.sellingPrice + (data.sellingPrice * data.originalMarkup / 100)))?.toFixed(2)}
                                          </TableCell>
                                          {/* <TableCell>
                                            <Switch
                                              checked={data.makeAsTask === 1}
                                              onChange={(e) => {
                                                const newValue = e.target.checked ? 1 : 0;
                                                setCartService((prevServices) =>
                                                  prevServices.map((service) =>
                                                    service.id === data.id
                                                      ? { ...service, makeAsTask: newValue }
                                                      : service
                                                  )
                                                );
                                                data['makeAsTask'] = newValue;
                                              }}
                                              color="primary"
                                            />
                                          </TableCell>
                                          <TableCell>
                                            <Switch
                                              checked={data.makeInstallCard === 1}
                                              onChange={(e) => {
                                                const newValue = e.target.checked ? 1 : 0;
                                                setCartService((prevServices) =>
                                                  prevServices.map((service) =>
                                                    service.id === data.id
                                                      ? { ...service, makeInstallCard: newValue }
                                                      : service
                                                  )
                                                );
                                                data['makeInstallCard'] = newValue;
                                              }}
                                              color="primary"
                                            />
                                          </TableCell> */}
                                          {/* <TableCell></TableCell> */}
                                          {/* {((values?.project_category?.name == 'Service only') ||
                                            (values?.project_category?.name == 'Time & Material')) ? ( */}

                                          <TableCell>
                                            <IconButton
                                              onClick={() => {
                                                setRfpServiceLocationStates({ ...rfpServiceLocationStates, [data.id]: true });
                                              }}
                                            >
                                              <LocationOn sx={{
                                                color: data && data.location && data.location.some(obj =>
                                                  [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
                                                ) ? '' : theme.palette.primary.main
                                              }} />
                                            </IconButton>
                                          </TableCell>
                                          {/* ):
                                          <TableCell></TableCell>
                                          } */}
                                          <TableCell >
                                            <IconButton onClick={() => handleDeleteRFPService(data.labour_cost_service_id)}>
                                              <Delete />
                                            </IconButton>
                                          </TableCell>
                                        </TableRow>
                                        <Modal
                                          open={rfpServiceLocationStates[data.id]}
                                          handleClose={() => {
                                            setRfpServiceLocationStates({ ...rfpServiceLocationStates, [data.id]: false });
                                          }}
                                        >
                                            {index === 0 && <FormControlLabel
                                          control={
                                            <Switch
                                              checked={allRfpServiceLocationSame}
                                              onChange={handleAllRfpServiceLocationSameChange}
                                            />
                                          }
                                          label="All Locations Same"
                                        />}

                                          <Grid
                                            container
                                            spacing={3}
                                            sx={{ justifyContent: 'center', width: '100%' }}
                                          >

                                            {data?.location?.map((addr, i) => (
                                              <Grid item xs={12}>
                                                {/* Side Heading */}
                                                <Typography variant="h5" sx={{ mb: 2 }}>
                                                  Location
                                                </Typography>

                                                {/* Address Fields */}

                                                <Stack
                                                  direction={{ xs: 'column', sm: 'row' }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    label="Address"
                                                    size="small"
                                                    value={data.location[i].address || ''}
                                                    disabled={index !== 0 && allRfpServiceLocationSame ? true : false}
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.location]
                                                    //   arrayAddr[i].address = event.target.value;
                                                    //   setCartService(pv => ([...pv.map(p => {


                                                    //     if (p.id === data.id) {
                                                    //       return {
                                                    //         ...p,
                                                    //         location: arrayAddr
                                                    //       }
                                                    //     }
                                                    //     else {
                                                    //       return {
                                                    //         ...p
                                                    //       }
                                                    //     }

                                                    //   })]))
                                                    // }}
                                                    onChange={(event) => {
                                                      const updatedValue = event.target.value;
                                                    
                                                      setCartService((prevServices) =>
                                                        prevServices.map((service) => {
                                                          let updatedLocations = [...service.location];
                                                    
                                                          if (allRfpServiceLocationSame) {
                                                            // Apply the new value to all services in cartService
                                                            return {
                                                              ...service,
                                                              location: updatedLocations.map(loc => ({
                                                                ...loc,
                                                                address: updatedValue, // Update address field, same logic applies for others
                                                              })),
                                                            };
                                                          } else {
                                                            // Update only the specific service
                                                            if (service.id === data.id) {
                                                              updatedLocations[i].address = updatedValue;
                                                            }
                                                            return {
                                                              ...service,
                                                              location: updatedLocations,
                                                            };
                                                          }
                                                        })
                                                      );
                                                    }}                                                    
                                                  />
                                                </Stack>

                                                {/* City, State, Zip Fields */}
                                                <Stack
                                                  direction={{ xs: 'column', sm: 'row' }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    label="City"
                                                    size="small"
                                                    value={data.location[i].city || ''}
                                                    disabled={index !== 0 && allRfpServiceLocationSame ? true : false}
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.location]
                                                    //   arrayAddr[i].city = event.target.value;
                                                    //   setCartService(pv => ([...pv.map(p => {


                                                    //     if (p.id === data.id) {
                                                    //       return {
                                                    //         ...p,
                                                    //         location: arrayAddr
                                                    //       }
                                                    //     }
                                                    //     else {
                                                    //       return {
                                                    //         ...p
                                                    //       }
                                                    //     }

                                                    //   })]))
                                                    // }}
                                                    onChange={(event) => {
                                                      const updatedValue = event.target.value;
                                                    
                                                      setCartService((prevServices) =>
                                                        prevServices.map((service) => {
                                                          let updatedLocations = [...service.location];
                                                    
                                                          if (allRfpServiceLocationSame) {
                                                            // Apply the new value to all services in cartService
                                                            return {
                                                              ...service,
                                                              location: updatedLocations.map(loc => ({
                                                                ...loc,
                                                                city: updatedValue, // Update city field, same logic applies for others
                                                              })),
                                                            };
                                                          } else {
                                                            // Update only the specific service
                                                            if (service.id === data.id) {
                                                              updatedLocations[i].city = updatedValue;
                                                            }
                                                            return {
                                                              ...service,
                                                              location: updatedLocations,
                                                            };
                                                          }
                                                        })
                                                      );
                                                    }}                                                    
                                                  />
                                                  <TextField
                                                    fullWidth
                                                    label="State"
                                                    size="small"
                                                    value={data.location[i].state || ''}
                                                    disabled={index !== 0 && allRfpServiceLocationSame ? true : false}
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.location]
                                                    //   arrayAddr[i].state = event.target.value;
                                                    //   setCartService(pv => ([...pv.map(p => {

                                                    //     if (p.id === data.id) {
                                                    //       return {
                                                    //         ...p,
                                                    //         location: arrayAddr
                                                    //       }
                                                    //     }
                                                    //     else {
                                                    //       return {
                                                    //         ...p
                                                    //       }
                                                    //     }

                                                    //   })]))
                                                    // }}
                                                    onChange={(event) => {
                                                      const updatedValue = event.target.value;
                                                    
                                                      setCartService((prevServices) =>
                                                        prevServices.map((service) => {
                                                          let updatedLocations = [...service.location];
                                                    
                                                          if (allRfpServiceLocationSame) {
                                                            // Apply the new value to all services in cartService
                                                            return {
                                                              ...service,
                                                              location: updatedLocations.map(loc => ({
                                                                ...loc,
                                                                state: updatedValue, // Update state field, same logic applies for others
                                                              })),
                                                            };
                                                          } else {
                                                            // Update only the specific service
                                                            if (service.id === data.id) {
                                                              updatedLocations[i].state = updatedValue;
                                                            }
                                                            return {
                                                              ...service,
                                                              location: updatedLocations,
                                                            };
                                                          }
                                                        })
                                                      );
                                                    }}                                                    
                                                  />
                                                  <TextField
                                                    fullWidth
                                                    label="Zip / Postal Code"
                                                    size="small"
                                                    value={data.location[i].zip || ''}
                                                    disabled={index !== 0 && allRfpServiceLocationSame ? true : false}
                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.location]
                                                    //   arrayAddr[i].zip = event.target.value;
                                                    //   setCartService(pv => ([...pv.map(p => {


                                                    //     if (p.id === data.id) {
                                                    //       return {
                                                    //         ...p,
                                                    //         location: arrayAddr
                                                    //       }
                                                    //     }
                                                    //     else {
                                                    //       return {
                                                    //         ...p
                                                    //       }
                                                    //     }

                                                    //   })]))
                                                    // }}
                                                    onChange={(event) => {
                                                      const updatedValue = event.target.value;
                                                    
                                                      setCartService((prevServices) =>
                                                        prevServices.map((service) => {
                                                          let updatedLocations = [...service.location];
                                                    
                                                          if (allRfpServiceLocationSame) {
                                                            // Apply the new value to all services in cartService
                                                            return {
                                                              ...service,
                                                              location: updatedLocations.map(loc => ({
                                                                ...loc,
                                                                zip: updatedValue, // Update ZIP field, same logic applies for others
                                                              })),
                                                            };
                                                          } else {
                                                            // Update only the specific service
                                                            if (service.id === data.id) {
                                                              updatedLocations[i].zip = updatedValue;
                                                            }
                                                            return {
                                                              ...service,
                                                              location: updatedLocations,
                                                            };
                                                          }
                                                        })
                                                      );
                                                    }}                                                    
                                                  />
                                                </Stack>
                                              </Grid>
                                            ))}
                                          </Grid>

                                          {index !== 0 && allRfpServiceLocationSame ? '' :
                                          <Grid container justifyContent="center" alignItems="center">
                                            <Grid item xs={12} md={4}>
                                              <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                                <LoadingButton variant="contained" onClick={() => {
                                                  setIsSaving(true)
                                                  setTimeout(() => {
                                                    setIsSaving(false)
                                                    setRfpServiceLocationStates(false)
                                                  }, 100)
                                                }} loading={isSaving}>
                                                  {' Save '}
                                                </LoadingButton>

                                              </Box>
                                            </Grid>
                                          </Grid>}
                                        </Modal>
                                      </>
                                    );
                                  })}
                                </TableBody>
                                {cart?.filter((item)=>item.material == 1).length > 0 ?
                                  <Typography variant='subtitle2' sx={{fontWeight:500}}>Materials</Typography>
                                  :''}
                                <TableBody>
                                  {cart?.filter((item)=>item.material == 1)?.map((data, index) => {
                                    let unitName = UNITS?.filter((item) => item?.id == data?.unit)
                                    unitName = unitName[0]?.name
                                    let shortUnitName = ''
                                    if (unitName == 'Square feet') {
                                      shortUnitName = 'Sq ft'
                                    } else if (unitName == 'Lineal feet') {
                                      shortUnitName = 'Lin ft'
                                    } else if (unitName == 'Square Inches') {
                                      shortUnitName = 'Sq Inches'
                                    } else if (unitName == 'Unit') {
                                      shortUnitName = 'Unit'
                                    }
                                    if(values.project_category?.name == 'Time & Material'){
                                      data.product_price = 0
                                      data.product_retail_price = 0
                                      data.sellingPrice = 0
                                    }
                                    // let markup = markupType ? markupType === 1 ? data.WholesaleMarkup || data.product_markup : data.RetailMarkup || data.product_markup : 0
                                    let markup = parseFloat(Number(data?.markup)) || 0
                                    data.product_markup = markup
                                    if(noCharge){
                                      data.product_markup = 0
                                      data.markup = 0
                                      markup = 0
                                    }
                                    return (
                                      <>
                                        <TableRow key={data.id}>
                                          <TableCell>{data.name || data.product_name}</TableCell>
                                          {/* <TableCell>{invoiceAmount}</TableCell> */}
                                          <TableCell>
                                            {markup?.toFixed(2) || 0.00}
                                          </TableCell>
                                          <TableCell>
                                            {data.product_price?.toFixed(2) || 0}
                                          </TableCell>
                                          <TableCell>
                                            {(data.product_price + (data.product_price * markup / 100)).toFixed(2) || 0.00}
                                          </TableCell>
                                          <TableCell>
                                            {data.quantity} {shortUnitName}
                                          </TableCell>
                                          <TableCell>
                                            {data.location_quantity}
                                          </TableCell>
                                          {/* <TableCell>
                                            {(data.product_price * data.quantity * data.location_quantity)?.toFixed(2)||0}
                                          </TableCell> */}
                                          <TableCell>
                                            {(data.location_quantity * data.quantity * ((data.product_price + (data.product_price * markup / 100)) || 0)).toFixed(2)}
                                          </TableCell>  
                                          {/* <TableCell>N/A</TableCell>
                                          <TableCell>N/A</TableCell>*/}
                                          <TableCell>
                                            <IconButton
                                              onClick={() => {
                                                setRfpLocationStates({ ...rfpLocationStates, [data.product_id]: true });
                                              }}
                                            >
                                              <LocationOn sx={{
                                                color: data && data.location && data.location.some(obj =>
                                                  [obj.address, obj.city, obj.state, obj.zip].some(value => (value === '' || value === null))
                                                ) ? '' : theme.palette.primary.main
                                              }} />
                                            </IconButton>
                                          </TableCell>
                                          <TableCell >
                                            <IconButton onClick={() => handleDeleteRFPProduct(data.product_id)}>
                                              <Delete />
                                            </IconButton>
                                          </TableCell>
                                        </TableRow>
                                        <Modal
                                          open={rfpLocationStates[data.product_id]}
                                          handleClose={() => {
                                            setRfpLocationStates({ ...rfpLocationStates, [data.product_id]: false });
                                          }}
                                        >
                                          {/* {index === 0 &&  */}
                                          <FormControlLabel
                                            control={
                                              <Switch
                                                checked={data?.allRfpProductsLocationSame}
                                                onChange={()=>handleAllRfpProductsLocationSameChange(index) }
                                              />
                                            }
                                            label="All Locations Same"
                                          />
                                          {/* } */}

                                          <Grid
                                            container
                                            spacing={3}
                                            sx={{ justifyContent: 'center', width: '100%' }}
                                          >

                                            {data?.location?.map((addr, i) => (
                                              <Grid item xs={12}>
                                                {/* Side Heading */}
                                                <Typography variant="h5" sx={{ mb: 2 }}>
                                                  Location {i+1}
                                                </Typography>

                                                {/* Address Fields */}

                                                <Stack
                                                  direction={{ xs: 'column', sm: 'row' }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    label="Address"
                                                    size="small"
                                                    value={data.location[i].address || ''}

                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.location]
                                                    //   arrayAddr[i].address = event.target.value;
                                                    //   setCart(pv => ([...pv.map(p => {


                                                    //     if (p.product_id === data.product_id) {
                                                    //       return {
                                                    //         ...p,
                                                    //         addresses: arrayAddr
                                                    //       }
                                                    //     }
                                                    //     else {
                                                    //       return {
                                                    //         ...p
                                                    //       }
                                                    //     }

                                                    //   })]))
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.location];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                address: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                address: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              location: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                    }}
                                                  />
                                                </Stack>

                                                {/* City, State, Zip Fields */}
                                                <Stack
                                                  direction={{ xs: 'column', sm: 'row' }}
                                                  spacing={{ xs: 3, sm: 2 }}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <TextField
                                                    fullWidth
                                                    label="City"
                                                    size="small"
                                                    value={data.location[i].city || ''}

                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.location]
                                                    //   arrayAddr[i].city = event.target.value;
                                                    //   setCart(pv => ([...pv.map(p => {


                                                    //     if (p.product_id === data.product_id) {
                                                    //       return {
                                                    //         ...p,
                                                    //         addresses: arrayAddr
                                                    //       }
                                                    //     }
                                                    //     else {
                                                    //       return {
                                                    //         ...p
                                                    //       }
                                                    //     }

                                                    //   })]))
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.location];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                city: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                city: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              location: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                    }}
                                                  />
                                                  <TextField
                                                    fullWidth
                                                    label="State"
                                                    size="small"
                                                    value={data.location[i].state || ''}

                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.location]
                                                    //   arrayAddr[i].state = event.target.value;
                                                    //   setCart(pv => ([...pv.map(p => {

                                                    //     if (p.product_id === data.product_id) {
                                                    //       return {
                                                    //         ...p,
                                                    //         addresses: arrayAddr
                                                    //       }
                                                    //     }
                                                    //     else {
                                                    //       return {
                                                    //         ...p
                                                    //       }
                                                    //     }

                                                    //   })]))
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.location];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                state: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                state: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              location: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                    }}
                                                  />
                                                  <TextField
                                                    fullWidth
                                                    label="Zip / Postal Code"
                                                    size="small"
                                                    value={data.location[i].zip || ''}

                                                    // onChange={(event) => {
                                                    //   let arrayAddr = [...data.location]
                                                    //   arrayAddr[i].zip = event.target.value;
                                                    //   setCart(pv => ([...pv.map(p => {


                                                    //     if (p.product_id === data.product_id) {
                                                    //       return {
                                                    //         ...p,
                                                    //         addresses: arrayAddr
                                                    //       }
                                                    //     }
                                                    //     else {
                                                    //       return {
                                                    //         ...p
                                                    //       }
                                                    //     }

                                                    //   })]))
                                                    // }}
                                                    disabled={
                                                      i !== 0 &&
                                                      data?.allRfpProductsLocationSame
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={(event) => {
                                                      setCart((prevProducts) =>
                                                        prevProducts.map((p) => {
                                                          if (p.product_id === data.product_id) {
                                                            let updatedAddresses = [...p.location];
                                                            if (p.allRfpProductsLocationSame) {
                                                              updatedAddresses = updatedAddresses.map(() => ({
                                                                ...updatedAddresses[0],
                                                                zip: event.target.value,
                                                              }));
                                                            } else {
                                                              updatedAddresses[i] = {
                                                                ...updatedAddresses[i],
                                                                zip: event.target.value,
                                                              };
                                                            }
                                                            return {
                                                              ...p,
                                                              location: updatedAddresses,
                                                            };
                                                          }
                                                          return p;
                                                        })
                                                      );
                                                    }}
                                                  />
                                                </Stack>
                                              </Grid>
                                            ))}
                                          </Grid>


                                          <Grid container justifyContent="center" alignItems="center">
                                            <Grid item xs={12} md={4}>
                                              <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                                <LoadingButton variant="contained" onClick={() => {
                                                  setIsSaving(true)
                                                  setTimeout(() => {
                                                    setIsSaving(false)
                                                    setRfpLocationStates(false)
                                                  }, 100)
                                                }} loading={isSaving}>
                                                  {' Save '}
                                                </LoadingButton>

                                              </Box>
                                            </Grid>
                                          </Grid>
                                        </Modal>
                                      </>
                                    );
                                  })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Scrollbar>
                          </>}
                           {/* {
                            (values?.project_category?.name == 'Time & Material' && details?.allInstallationCompleted !== 1) ?
                            ''
                            :( 
                              <> */}
                           
                          <LabelStyleHead>Materials</LabelStyleHead>
                          {/* <Typography></Typography> */}
                          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                            {/* <Autocomplete
                              sx={{ width: 400 }}
                              multiple
                              id="combo-box-demo"
                              // options={materials || []}
                              // options={materials?.filter((option) => !selectedMaterials?.some(selected => selected.product_id === option.id)) || []}
                              // options={
                              //   materials?.filter((option) => {
                              //     // Exclude selected materials
                              //     const isSelected = selectedMaterials?.some((selected) => selected.product_id === option.id);
                              //     const isServiceOnly = values.project_category?.name === 'Service only';
                              //     // Filter materials: show only inhouse = 1 unless it's 'Service only'
                              //     const shouldInclude = isServiceOnly || option.inhouse === 1;
                              //     return !isSelected && shouldInclude;
                              //   }) || []
                              // }
                                options={
                              materials?.filter((option) => {
                                const isServiceOnly = values.project_category?.name === 'Service only';
                                return isServiceOnly || option.inhouse === 1;
                              }) || []
                            }
                              value={selectedMaterials?.filter(item => !item?.isAdditionalProduct)}
                              // onChange={(event, newValue) => {
                                
                              //   handleMaterial(newValue);
                              // }}
                             onChange={(event, newValue) => {
                              if (!newValue || newValue.length === 0) return;

                              const lastSelected = newValue[newValue.length - 1];

                              const isAlreadyStocked = selectedMaterials.some(
                                (item) =>
                                  item.id === lastSelected.id &&
                                  item.stock_type &&
                                  (item.stock_type === 1 || item.convertion_unit)
                              );

                              if (newValue.length < pendingAutocompleteMaterials.length || isAlreadyStocked) {
                                setFieldValue('additionalMaterials', newValue);
                                setPendingAutocompleteMaterials(newValue);
                                handleMaterial(newValue);
                                setSelectedMaterials([
                                  ...newValue,
                                  ...selectedMaterials.filter(item => item.isAdditionalProduct)
                                ]);
                                return;
                              }

                              setPendingAutocompleteMaterials(newValue);
                              setFieldValue('additionalMaterials', newValue);
                              handleMaterialStockCheck(lastSelected);
                            }}


                              renderInput={(params) => (
                                <TextField {...params} label="Materials" variant="outlined" />
                              )}
                              // getOptionLabel={(option) => option.name ? option.name : option.product_name?option.product_name:''}
                              // getOptionLabel={(option) => {
                              //   const name = option.name || option.product_name || '';
                              //   const ownershipLabel = option.inhouse === 1 ? ' (Inhouse)' : ' (Client owned)';
                              //   return name + ownershipLabel;
                              // }}
                              getOptionLabel={(option) => {
                                console.log('optionssssssssss',option)
                                const name = option.name || option.product_name || '';
                                const description = option.description ||option.product_description || '';
                                const ownership  = option.inhouse === 1 ? ' (Inhouse)' : ' (Client owned)';
                                const stockLabel = option.stock_type === 1
                                  ? 'Finished'
                                  : `Partial - ${UNITS?.find(u => u.id === option.convertion_unit)?.name || 'Unit'}`;
                                return `${description}${ownership} [${stockLabel}] \u200B${name}`;
                              }}
                              isOptionEqualToValue={(option, value) => option.id === value.id}
                              renderOption={(props, option) => {
                                const description = option.description || '';
                                const ownership = option.inhouse === 1 ? ' (Inhouse)' : ' (Client owned)';
                                const fullText = `${description}${ownership}`;
                                return (
                                  <li {...props}>
                                    <Tooltip title={fullText}>
                                      <span style={{
                                        display: 'inline-block',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        maxWidth: '300px'
                                      }}>
                                        {fullText}
                                      </span>
                                    </Tooltip>
                                    <span style={{ display: 'none' }}>{option.name}</span>
                                  </li>
                                );
                              }}
                              filterOptions={(options, { inputValue }) =>
                                options.filter((option) => {
                                  console.log("Name:", option.name, "Description:", option.description);
                                  const searchText = inputValue.toLowerCase();
                                  return (
                                    option.name?.toLowerCase().includes(searchText) ||
                                    option.description?.toLowerCase().includes(searchText)
                                    // option.description?.toLowerCase().includes(searchText)
                                  );
                                })
                              }
                              renderTags={(value, getTagProps) =>
                              value.map((option, index) => {
                                const suffix = option.inhouse === 1 ? '(Inhouse)' : '(Client owned)';
                                const tooltipText = `${option.description  || ''} ${suffix}`;
                                return(
                                  <Tooltip
                                  key={index}
                                  title={tooltipText}
                                >
                                <Chip
                                  {...getTagProps({ index })}
                                  label={`${option.description || ''} ${option.inhouse === 1 ? '(Inhouse)' : '(Client owned)'}`}
                                />
                                </Tooltip>
                              )})
                            }
                            /> */}
                            <Autocomplete
                              sx={{ width: 400 }}
                              multiple
                              id="combo-box-demo"
                              // options={
                              //   materials?.filter((option) => {
                              //     const isServiceOnly = values.project_category?.name === 'Service only';
                              //     return isServiceOnly || option.inhouse === 1;
                              //   }) || []
                              // }
                              options={
                                materials?.filter((option) =>
                                  option.inhouse === 0 || option.inhouse === 1
                                ) || []
                              }
                              value={selectedMaterials?.filter(item => !item?.isAdditionalProduct)}
// onChange={(event, newValue) => {
//   // if (!newValue || newValue.length === 0) return;

//   const lastSelected = newValue[newValue.length - 1];
//    if (newValue.length === 0) {
//     const onlyAdditional = selectedMaterials.filter(item => item.isAdditionalProduct === true);
//     setSelectedMaterials(onlyAdditional);
//     setPendingAutocompleteMaterials(onlyAdditional);
//     setFieldValue('additionalMaterials', onlyAdditional);
//     handleMaterial(onlyAdditional);
//     return;
//   }

//   // Handle removal
// if (newValue.length < pendingAutocompleteMaterials.length) {
//   const updated = newValue;

//   const additionalRows = selectedMaterials.filter(item =>
//     item.isAdditionalProduct === true &&
//     !updated.some(u =>
//       (u.product_id || u.id) === (item.product_id || item.id) &&
//       u.stock_type === item.stock_type &&
//       (item.stock_type === 1 || u.convertion_unit === item.convertion_unit)
//     )
//   );

//   const finalList = [...updated, ...additionalRows];

//   setFieldValue('additionalMaterials', finalList);
//   setPendingAutocompleteMaterials(finalList);
//   handleMaterial(finalList);
//   setSelectedMaterials(finalList);
//   return;
// }


//   // ✅ Do NOT update pendingAutocompleteMaterials or selectedMaterials yet
//   // let the stock dialog decide what to do with `lastSelected`
//    if (lastSelected) {
//     handleMaterialStockCheck(lastSelected);
//   }
// }}
onChange={(event, newValue) => {
  if (!newValue) return;

  // 1. Full clear
  if (newValue.length === 0) {
    const onlyAdditional = selectedMaterials.filter(item => item.isAdditionalProduct === true);
    setSelectedMaterials(onlyAdditional);
    setPendingAutocompleteMaterials(onlyAdditional);
    setFieldValue('additionalMaterials', onlyAdditional);
    handleMaterial(onlyAdditional);
    return;
  }

  // 2. Detect removed items
  const removedItems = selectedMaterials.filter(
    prev => !newValue.some(cur =>
      (cur.product_id || cur.id) === (prev.product_id || prev.id) &&
      cur.stock_type === prev.stock_type &&
      (cur.stock_type === 1 || cur.convertion_unit === prev.convertion_unit)
    )
  );

  if (removedItems.length > 0) {
    const remainingAdditionalRows = selectedMaterials.filter(
      item => item.isAdditionalProduct === true &&
        !newValue.some(u =>
          (u.product_id || u.id) === (item.product_id || item.id) &&
          u.stock_type === item.stock_type &&
          (item.stock_type === 1 || u.convertion_unit === item.convertion_unit)
        )
    );

    const finalList = [...newValue, ...remainingAdditionalRows];
    setFieldValue('additionalMaterials', finalList);
    setPendingAutocompleteMaterials(newValue); // Sync base state
    setSelectedMaterials(finalList);
    handleMaterial(finalList);
    return;
  }

  // 3. If added new item
  const lastSelected = newValue[newValue.length - 1];
  if (lastSelected) {
    handleMaterialStockCheck(lastSelected); // 🧠 Your main addition logic
  }
}}



                              getOptionLabel={(option) => {
                                const name = option.name || option.product_name || '';
                                const description = option.description || option.product_description || option.product_name || '';
                                const ownership = option.inhouse === 1 ? ' (Inhouse)' : ' (Client owned)';
                                return `${description}${ownership} \u200B${name}`;
                              }}
                              isOptionEqualToValue={(option, value) =>
                                option.product_id === value.product_id &&
                                option.stock_type === value.stock_type &&
                                option.convertion_unit === value.convertion_unit
                              }

                              renderOption={(props, option) => {
                                const description = option.description || option.product_description || option.product_name || '';
                                const ownership = option.inhouse === 1 ? ' (Inhouse)' : ' (Client owned)';
                                // const stockLabel = option.stock_type === 1
                                //   ? 'Finished'
                                //   : `Partial - ${UNITS?.find(u => u.id === option.convertion_unit)?.name || 'Unit'}`;
                                // const fullText = `${description} ${ownership} [${stockLabel}]`;
                                const fullText = `${description || option.name || option.product_name} ${ownership}`;
                                return (
                                  <li {...props}>
                                    <Tooltip title={fullText}>
                                      <span style={{
                                        display: 'inline-block',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        maxWidth: '300px'
                                      }}>
                                        {fullText}
                                      </span>
                                    </Tooltip>
                                    <span style={{ display: 'none' }}>{option.name}</span>
                                  </li>
                                );
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Materials"
                                  error={Boolean(touched.additionalMaterials && errors.additionalMaterials)}
                                  helperText={touched.additionalMaterials && errors.additionalMaterials}
                                />
                              )}
                              filterOptions={(options, { inputValue }) =>
                                options.filter((option) => {
                                  const searchText = inputValue.toLowerCase();
                                  return (
                                    option.name?.toLowerCase().includes(searchText) ||
                                    option.description?.toLowerCase().includes(searchText)
                                  );
                                })
                              }
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => {
                                  const suffix = option.inhouse === 1 ? '(Inhouse)' : '(Client owned)';
                                  const stockLabel = option.stock_type === 1
                                    ? 'Finished'
                                    : `Partial - ${UNITS?.find(u => u.id === option.convertion_unit)?.name || 'Unit'}`;
                                  const tooltipText = `${option.description || option.name || option.product_name || ''} ${suffix} [${stockLabel}]`;
                                  return (
                                    <Tooltip key={index} title={tooltipText}>
                                      <Chip
                                        {...getTagProps({ index })}
                                        label={`${option.description || option.name || option.product_name || ''} ${suffix} [${stockLabel}]`}
                                      />
                                    </Tooltip>
                                  );
                                })
                              }
                            />

                          </Stack>
                          <LabelStyle>Selected Materials</LabelStyle>
                          <Scrollbar>
                            <TableContainer sx={{ minWidth: 500 }}>
                              <Table>
                                <TableHead>
                                  <TableRow>
                                    {VALUE_MATERIAL?.map((val) => (
                                      val.id === 3 ? (
                                        <Tooltip key={val.id} title="Unit Price + ((Unit Price * Markup)/100)">
                                          <TableCell key={val.id}>{val.value}</TableCell>
                                        </Tooltip>
                                      ) : val.id === 5 ? (
                                        <Tooltip key={val.id} title="Unit Price * Quantity">
                                          <TableCell key={val.id}>{val.value}</TableCell>
                                        </Tooltip>
                                      ) : val.id === 6 ? (
                                        <Tooltip key={val.id} title="Markup Cost * Quantity">
                                          <TableCell key={val.id}>{val.value}</TableCell>
                                        </Tooltip>
                                      ) :
                                      <TableCell key={val.id}>{val.value}</TableCell>
                                     
                                    ))}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {selectedMaterials?.map((data, index) => {
                                    console.log("################Materials",data);
                                    let unitName ='';
                                    if(data?.stock_type===1){
                                    unitName = UNITS?.filter((item) => item?.id == data?.unit)
                                    }else{
                                     unitName = UNITS?.filter((item) => item?.id == data?.convertion_unit)
                                    }
                                      let shortUnitName = unitName[0]?.short_name
                                    // if (unitName == 'Square feet') {
                                    //   shortUnitName = 'Sq ft'
                                    // } else if (unitName == 'Lineal feet') {
                                    //   shortUnitName = 'Lin ft'
                                    // } else if (unitName == 'Square Inches') {
                                    //   shortUnitName = 'Sq Inches'
                                    // } else if (unitName == 'Unit') {
                                    //   shortUnitName = 'Unit'
                                    // }
                                    data.price=data.price ? data.price : data.product_price 
                                    // if(values.project_category?.name == 'Time & Material'){
                                    //   data['price'] = 0
                                    //   data['quantity'] = 0
                                    // }
                                    if (values.project_category?.name == 'Service only' && data?.inhouse == 0 ) {
                                      data['price'] = 0
                                    }
                                    data.product_id= data.product_id ? data.product_id : data.id
                                    // data.markup = data.markup ? data.markup : data.product_markup
                                    data.markup = data?.product_markup ||  data.markup 
                                    if(noCharge){
                                      data.product_markup = 0
                                      data.markup = 0
                                    }
                                    const markUpCost = data.price + ((parseFloat(data.price) * parseFloat(data.markup || 0)) / 100)
                                    data['markUpCost'] = parseFloat(parseFloat(markUpCost).toFixed(2)) || 0; 
                                                                        
                                    let stock= 'Partial'
                                    if(data.stock_type===1 ){
                                      stock ='Finished'
                                    }            
                                    return (
                                      <>
                                        <TableRow key={data?.newIndexId || index}>
                                         
                                         <TableCell>
                                          {data?.isAdditionalProduct ?
                                            <TextField
                                              required
                                              fullWidth
                                              type="text"
                                              label={'Material Name'}
                                              sx={{ width: 85 }}
                                              value={data.name||data.product_name}
                                              onChange={(event) => {
                                                let newValue = event.target.value

                                                // Update the selectedProducts state
                                                setSelectedMaterials(
                                                  (prevProducts) =>
                                                    prevProducts.map((service) => {
                                                        if ( service.newIndexId === data.newIndexId ) {
                                                          return {
                                                            ...service,
                                                            name: newValue,
                                                            product_name: newValue,
                                                          }
                                                        } else {
                                                          return service
                                                        }
                                                      },
                                                    ),
                                                )
                                                data['name'] = newValue || ''
                                                data['product_name'] = newValue || ''
                                                if (isSubmitted)
                                                  setIsSubmitted(false)
                                              }}
                                              error={
                                                isSubmitted && !data.name?.trim() && !data.product_name?.trim()
                                              }
                                              helperText={
                                                isSubmitted && !data.name?.trim() && !data.product_name?.trim()
                                                  ? 'Material Name is required'
                                                  : ''
                                              }                                              
                                            />
                                          : (data.name||data.product_name)}
                                          {data?.isAdditionalProduct ? '' : data.inhouse==1 ? ' (Inhouse)' : ' (Client owned)'}
                                          </TableCell>
                                          <TableCell>
                                            {stock}
                                          </TableCell>

                                         <TableCell>{
                                          data?.isAdditionalProduct ?
                                            <TextField
                                              required
                                              fullWidth
                                              type="number"
                                              label={'Unit Price'}
                                              // disabled={values.project_category?.name == 'Time & Material' ? true : false}
                                              sx={{ width: 85 }}
                                              value={data.price}
                                              // onWheel={(e) => e.target.blur()}
                                              onKeyPress={(event) => {
                                                // if (event.key === '0' && event.target.value === '') {
                                                //   event.preventDefault();
                                                // }
                                                if (event.key === '-') {
                                                  event.preventDefault();
                                                }
                                                if (event.key === 'e') {
                                                  event.preventDefault();
                                                }
                                              }}
                                              inputProps={{ min: 0 }}
                                              defaultValue={0}
                                              onChange={(event) => {
                                                let newValue = event.target.value
                                                if (newValue !== '') {
                                                  setAdditionalSelectedServices((pv) => [
                                                      ...pv.map((p) => {
                                                        if ( p.newIndexId === data.newIndexId ) {
                                                          return {
                                                            ...p,
                                                            price: Number(newValue),
                                                          }
                                                        } else {
                                                          return p
                                                        }
                                                      }),
                                                    ],
                                                  )
                                                  data['price'] =  Number(newValue || 0)
                                                }
                                              }}
                                              // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                              // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                            />
                                          : 
                                          data.price}</TableCell>
                                      <TableCell>
                                        <TextField
                                          required
                                          fullWidth
                                          type='number'
                                          label='Markup'
                                          disabled={noCharge}
                                          value={Number(data.markup) || 0}
                                          defaultValue={0}
                                          onKeyPress={(event) => {
                                            if (['-', 'e'].includes(event.key)) {
                                              event.preventDefault();
                                            }
                                          }}
                                          onChange={(event) => {
                                            let newValue = event.target.value;
                                            if (newValue === '' || /^0[0-9]+$/.test(newValue)) newValue = '0';

                                            setSelectedMaterials((pv) =>
                                              pv.map((p) => {
                                                const isMatch = data.isAdditionalProduct
                                                  ? p.newIndexId === data.newIndexId
                                                  : (p.product_id || p.id) === (data.product_id || data.id) &&
                                                    p.stock_type === data.stock_type &&
                                                    (p.stock_type === 1 || p.convertion_unit === data.convertion_unit);

                                                return isMatch ? { ...p, markup: Number(newValue) } : p;
                                              })
                                            );

                                            data['markup'] = Number(newValue);
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell>{data.markUpCost || 0}</TableCell>
                                      <TableCell>
                                        <TextField
                                          required
                                          fullWidth
                                          type='number'
                                          label={shortUnitName || 'Quantity'}
                                          // disabled={values.project_category?.name === 'Time & Material'}
                                          // value={values.project_category?.name === 'Time & Material' ? 0 : Number(data.quantity) || 0}
                                          value={Number(data.quantity) || 0}
                                          // defaultValue={values.project_category?.name === 'Time & Material' ? 0 : 1}
                                          defaultValue={1}
                                          onKeyPress={(event) => {
                                            if (['-', 'e'].includes(event.key)) {
                                              event.preventDefault();
                                            }
                                          }}
                                          onChange={(event) => {
                                            let newValue = event.target.value;
                                            if (newValue === '') return;
                                            if(details?.job_category_name == 'Time & Material' && details?.allInstallationCompleted == 1){
                                              let stock = data.stock_type === 1 ? 'Finished' : 'Partial';
                                            if (stock === 'Finished' && Number(newValue) > data.finishedProductQty) {
                                              enqueueSnackbar('Quantity exceeds finished material stock', { variant: 'error' })
                                              return;
                                            } else if (stock === 'Partial' && Number(newValue) > data.partial_stock) {
                                              enqueueSnackbar('Quantity exceeds partial material stock', { variant: 'error' })
                                              return; 
                                            }
                                            }
                                            setSelectedMaterials((prev) =>
                                              prev.map((p) => {
                                                const isMatch = data.isAdditionalProduct
                                                  ? p.newIndexId === data.newIndexId
                                                  : (p.product_id || p.id) === (data.product_id || data.id) &&
                                                    p.stock_type === data.stock_type &&
                                                    (p.stock_type === 1 || p.convertion_unit === data.convertion_unit);

                                                return isMatch ? { ...p, quantity: Number(newValue) } : p;
                                              })
                                            );

                                            data['quantity'] = Number(newValue);
                                          }}
                                          onWheel={(e) => e.target.blur()}
                                          onKeyDown={(event) => {
                                            if (['ArrowUp', 'ArrowDown'].includes(event.key)) {
                                              const newValue = event.target.value || 0;
                                              if (newValue < 1 && event.key === 'ArrowDown') {
                                                event.preventDefault();
                                              }
                                            }
                                          }}
                                        />
                                      </TableCell>

                                         <TableCell>{(data.price*(data.quantity||0))?.toFixed(2)}</TableCell>
                                         <TableCell>{((data.markUpCost || 0) * (data.quantity||0))?.toFixed(2)}</TableCell>
                                          <TableCell >
                                            {/* <IconButton onClick={() => handleDeleteMaterial(data.id, data.newIndexId,)}> */}
                                            <IconButton
                                                onClick={() => handleDeleteMaterial(data.product_id || data.id, data.stock_type, data.stock_type === 2 ? data.convertion_unit : 0)}
                                              >
                                              <Delete />
                                            </IconButton>
                                          </TableCell>
                                        </TableRow>
                                        
                                      </>
                                    );
                                  })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Scrollbar>
                          <Stack sx={{ justifyContent: 'flex-end', alignItems: 'center', display:'flex', flexDirection:'row' }}>
                            {/* <Button
                              variant="outlined"
                              startIcon={
                                <Stack>
                                  {' '}
                                  <Add />{' '}
                                </Stack>
                              }
                              onClick={() => {
                                addNewMaterialRow()
                                // setMarkupType(1)
                              }}
                            >
                              Add Material Row
                            </Button> */}
                            <Typography variant="h6">
                              Total Additional Material Cost:{' '}
                              {selectedMaterialSubTotal}
                            </Typography>
                          </Stack>
                          {/* </>
                           )
                          } */}
                          <Divider />
                          <TextField
                            fullWidth
                            multiline
                            minRows={3}
                            maxRows={7}
                            label="Notes"
                            {...getFieldProps('notes')}
                            error={Boolean(touched.notes && errors.notes)}
                            helperText={touched.notes && errors.notes}
                            InputProps={{
                                sx: {
                                  color: 'error.main',
                                }
                              }}
                          />
                        </>}
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} justifyContent={'space-between'}>
                          <TextField
                            sx={{ width: 400 }}
                            type='number'
                            onKeyPress={(event) => {
                              if (event.key === '-') {
                                event.preventDefault();
                              }
                            }}
                            onChange={(event) => {
                              let newValue = event.target.value
                              let data = 0
                              if (markupType === 1) {
                                data = totalWholesalePrice - budget
                                
                              } else if (markupType === 2) {
                                data = totalRetailPrice - budget
                              }
                              if (Number(newValue) > data) {
                                newValue = data?.toFixed(2);
                              }
                              if (newValue === '-0.00') {
                                newValue = 0;
                              }
                                console.log("discounttttttttttttttttttt",totalWholesalePrice - budget);

                              console.log('newValue-2-------', newValue);
                              setFieldValue('invoice_discount', newValue)
                            }}
                            label={hasDiscountPermission ? "Discount (Access Denied)" : "Discount"}
                            disabled = {hasDiscountPermission}
                            value={values.invoice_discount}
                            // {...getFieldProps('invoice_discount')}
                            error={Boolean(touched.invoice_discount && errors.invoice_discount)}
                            helperText={touched.invoice_discount && errors.invoice_discount}
                            inputProps={{ max: (markupType === 1) ? totalWholesalePrice - budget : ((markupType === 2) ? totalRetailPrice - budget : 0) , min: 0 }}
                          />
                          {/* <Autocomplete
                            sx={{ width: 400 }}
                            id="combo-box-demo"
                            disabled={true}
                            options={taxCategories || []}
                            value={selectedTaxCategory || null}
                            onChange={(event, newValue) => {
                              setSelectedTaxCategory(newValue);
                            }}
                            renderInput={(params) => (
                              <TextField {...params} label="Tax category" />
                            )}
                            getOptionLabel={(option) => option.name ? option.name : ''}
                          /> */}
                        </Stack>
                        <Typography sx={{ color: theme.palette.error.main }}>**All values in the software are rounded to two decimal places in accordance with standard US calculation practices.</Typography>
                        <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={'center'} spacing={{ xs: 3, sm: 2 }}>
                          <Stack>
                            
                            {/* <TextField
                            sx={{ width: 400 }}
                            type='number'
                            onChange={(event, newValue) => setFieldValue('invoice_discount', newValue)}
                            label="Extra Discount"
                            {...getFieldProps('invoice_discount')}
                            error={Boolean(touched.invoice_discount && errors.invoice_discount)}
                            helperText={touched.invoice_discount && errors.invoice_discount}
                          /> */}

                            {/* <Typography sx={{ color: 'text.secondary' }}>Sub Total: {rfqSubTotal ? rfqSubTotal?.toFixed(2) : 0}</Typography>
                          <Typography sx={{ color: 'text.secondary' }}>Service cost in Product Formula: {initialServiceCostInProductFormula ? initialServiceCostInProductFormula?.toFixed(2) : 0}</Typography>
                          <Typography sx={{ color: 'text.secondary' }}>Total ({rfqSubTotal?.toFixed(2)} - {initialServiceCostInProductFormula?.toFixed(2)}): {totalsum ? totalsum?.toFixed(2) : 0}</Typography> */}
                          <Typography >
                              Sub Total: {totalsum ? totalsum.toFixed(2) : '0.00'}
                            </Typography>
                            {/* <Typography >
                              Tax: {parseFloat(taxAmount).toFixed(2) || 0.00}  
                            </Typography> */}
                            <Box display="flex" alignItems="center" gap={1}>
                              <Typography>
                                Tax: {parseFloat(taxAmount).toFixed(2) || '0.00'}
                              </Typography>
                              {
                                details?.avalara_code ? (
                              <>
                              <img
                                src={AVALARALOGO}
                                width="20px"
                                height="12px"
                                style={{ marginTop: '2px' }} // Adjust for alignment if needed
                                alt="Avalara logo"
                              />
                               <Typography sx={{ marginTop: '8px',color:"#fd6400",fontSize:"12px"}}>
                                             Synced with Avalara
                                </Typography>
                                </>
):""}

                            </Box>
                            <Typography sx={{ color:noCharge? 'red' :'yellow' }}>
                              Grand Total: {(noCharge && grandTotal >0) ?(grandTotal * -1) :grandTotal || 0.00}
                            </Typography>
                            {/* <Typography sx={{ color: 'yellow' }}>Grand Total : {totalsum ? totalsum?.toFixed(2) : 0}</Typography> */}
                            {/* <Typography sx={{ color: 'yellow' }}>Total Product Formula Cost: {budget ? budget?.toFixed(2) : 0}</Typography> */}
                            <Typography >Total Discount: {DiscountTotal ? DiscountTotal?.toFixed(2) : 0.00}</Typography>

                            {/* <Tooltip title="Sub Total - Total Product Formula Cost">
                              <Typography sx={{ cursor: 'pointer' }}>Total Markup Amount: {totalMarkupAmount ? parseFloat(Number(totalMarkupAmount))?.toFixed(2) : 0}</Typography>
                            </Tooltip>

                            <Tooltip title="(Total Markup Amount / Total Product Formula Cost) * 100">
                              <Typography sx={{ cursor: 'pointer' }}>Total Markup Percentage: {totalMarkupPercentage ? parseFloat(Number(totalMarkupPercentage))?.toFixed(2) : 0}</Typography>
                            </Tooltip> */}

                            {/* <Typography sx={{ color: 'text.secondary' }}>Total Product Markup: {(originaltotalMarkup/selectedProducts.length)?.toFixed(2)}</Typography> */}
                            {/* { showServices ?<Typography sx={{ color: 'text.secondary' }}>Total Service Markup: {(originaltotalServiceMarkup/(selectedServices.length+additionalSelectedServices.length))?.toFixed(2)}</Typography>:""} */}
                          </Stack>
                          <Stack direction={'column'} display={'flex'} justifyContent={'center'}>
                          <FormControlLabel
                            onChange={() => {
                              // Toggle the value of welcome_message using setCurrentRFQdata
                              setCurrentRFQdata((prevData) => ({
                                ...prevData,
                                welcome_message: !prevData.welcome_message,
                              }));
                            }}
                            control={<Switch  {...getFieldProps('welcome_message')} color="primary"
                              checked={values.welcome_message == 1}
                            />}
                            labelPlacement="end"
                            label="Use Custom Welcome Message"
                            sx={{ mt: 6 , mb:2 }}
                          />
                          {
                            noCharge ? ""
                          :
                          <FormControlLabel
                          control={
                            <Switch
                            {...getFieldProps('client_approve')}
                              color="primary"
                              checked={values.client_approve}
                              onChange={(event) => setFieldValue('client_approve', event.target.checked)}
                            />
                          }
                          labelPlacement="end"
                          label="Enable for Client Approval"
                          sx={{ mt: 0 }}
                        />
                        
                      }
                        </Stack>
                        </Stack>
                        {values.welcome_message == true && (
                          <>
                            <Stack>
                              <LabelStyle>Subject</LabelStyle>
                              <TextField
                                //   fullWidth
                                type='text'
                                sx={{ width: 400 }}
                                defaultValue={values.subject}
                                {...getFieldProps('subject')}
                                error={Boolean(touched.subject && errors.subject)}
                                helperText={touched.subject && errors.subject}
                              />
                            </Stack>
                            <LabelStyle>Email Content</LabelStyle>
                            <TextField
                              fullWidth
                              multiline
                              minRows={3}
                              maxRows={7}
                              label="Email Content"
                              defaultValue={values.email_content}
                              {...getFieldProps('email_content')}
                              error={Boolean(touched.email_content && errors.email_content)}
                              helperText={touched.email_content && errors.email_content}
                            />
                          </>
                        )}
                        <LabelStyle>Order state</LabelStyle>
                        <Typography>While in draft mode, clients you add to order tasks won't be notified</Typography>
                        <FormControlLabel
                          onChange={() => {

                            setCurrentRFQdata((prevData) => ({
                              ...prevData,
                              draft: !prevData.draft,
                            }));
                          }}
                          control={<Switch {...getFieldProps('draft')} color="primary" checked={values.draft} />}
                          labelPlacement="end"
                          label="Draft"
                          sx={{ mt: 5 }}
                        />
                        <Dialog open={openMakeTaskDialog} onClose={handleCloseMakeTastDialog}>
                          <DialogTitle>Do you want to continue?</DialogTitle>
                          <DialogContent>
                            {(() => {
                              // Filter out items with id == 10 when project_category.id !== 11
                            const filteredAdditionalServices = values.project_category?.id !== 11 ? additionalSelectedServices.filter(item => {
                                            if (item?.labour_cost_service_id) {
                                              // Exclude if labour_cost_service_id is 10
                                              return item?.labour_cost_service_id !== 10;
                                            } else {
                                              // Exclude if id is 10
                                              return item?.id !== 10;
                                            }
                                          })
                                          : additionalSelectedServices;
                              
                              const additionalServicesWithoutTask = filteredAdditionalServices?.filter(item => item?.makeAsTask === 0) || [];
                              const additionalServicesWithoutInstallCard = filteredAdditionalServices?.filter(item => item?.makeInstallCard === 0) || [];

                              const proposalServicesWithoutTask = cartService?.filter(item => item?.makeAsTask === 0) || [];
                              const proposalServicesWithoutInstallCard = cartService?.filter(item => item?.makeInstallCard === 0) || [];

                              return (
                                <Alert severity="warning">
                                  {additionalServicesWithoutTask.length > 0 || proposalServicesWithoutTask.length > 0 ? (
                                    <div>
                                      {additionalServicesWithoutTask.length > 0 && (
                                        <>The additional services <em>{additionalServicesWithoutTask.map(item => item.name).join(', ')}</em></>
                                      )}
                                      {additionalServicesWithoutTask.length > 0 && proposalServicesWithoutTask.length > 0 && <> and </>}
                                      {proposalServicesWithoutTask.length > 0 && (
                                        <>The proposal services <em>{proposalServicesWithoutTask.map(item => item.name).join(', ')}</em></>
                                      )}
                                      {' '}have the <strong>Make As Task</strong> toggle turned off. {`${values?.project_category?.id == 12 ? "This will appear in production without tasks" :"These will not appear in production as they are not creating tasks."}`}
                                      <br /><br />
                                    </div>
                                  ) : null}

                                  {additionalServicesWithoutInstallCard.length > 0 || proposalServicesWithoutInstallCard.length > 0 ? (
                                    <div>
                                      {additionalServicesWithoutInstallCard.length > 0 && (
                                        <>The additional services <em>{additionalServicesWithoutInstallCard.map(item => item.name).join(', ')}</em></>
                                      )}
                                      {additionalServicesWithoutInstallCard.length > 0 && proposalServicesWithoutInstallCard.length > 0 && <> and </>}
                                      {proposalServicesWithoutInstallCard.length > 0 && (
                                        <>The proposal services <em>{proposalServicesWithoutInstallCard.map(item => item.name).join(', ')}</em></>
                                      )}
                                      {' '}have the <strong>Make Install Card</strong> toggle turned off. These will not appear in installation as they are not creating install cards.
                                      <br /><br />
                                    </div>
                                  ) : null}

                                  Do you want to continue?
                                </Alert>
                              );
                            })()}
                          </DialogContent>
                          <DialogActions>
                            <Button variant='outlined' onClick={handleCloseMakeTastDialog} color="inherit">
                              No
                            </Button>
                            <Button
                              onClick={() => {
                                handleContinueMakeTastDialog();
                                setTimeout(() => {
                                  handleSubmit();
                                }, 100); // small delay ensures dialog closes before submission
                              }}
                              variant="contained"
                            >
                              Yes
                            </Button>
                          </DialogActions>
                        </Dialog>
                        <Dialog open={showMakeTaskErrorDialog} onClose={() => setShowMakeTaskErrorDialog(false)}>
                          <DialogTitle>Action Required: Enable Service Install Card</DialogTitle>
                          <DialogContent>
                            <Alert severity="error">
                              {values?.project_category?.id == 11 ? (
                                <>
                                  You cannot submit a <strong>Service Only</strong> job if all selected services have the <em>Make Install Card</em> toggle turned off.
                                  At least one service must generate an install card to proceed.
                                </>
                              ) : (
                                <>
                                  You cannot submit a <strong>Time & Material</strong> job without any products or materials,
                                  and with all services having the <em>Make Install Card</em> toggle turned off. Please add a
                                  product, material, or enable the <em>Make Install Card</em> toggle for at least one service.
                                </>
                              )}
                            </Alert>
                          </DialogContent>
                          <DialogActions>
                            <Button onClick={() => setShowMakeTaskErrorDialog(false)} color="primary" variant="contained">
                              OK, I Understand
                            </Button>
                          </DialogActions>
                        </Dialog>

                        <Dialog
                          open={openChangeJobTypeDialog}
                          onClose={() => setOpenChangeJobTypeDialog(false)}
                        >
                          <DialogTitle>Confirm Job Type Change</DialogTitle>

                          <DialogContent>
                            <Typography>
                              Switching from <strong>Time & Material</strong> will clear all selected Products, Materials,
                              Map Services and related calculations. Your existing Services will be preserved.
                              Do you want to continue?
                            </Typography>
                          </DialogContent>

                          <DialogActions>
                            <Button
                              onClick={() => {
                                setOpenChangeJobTypeDialog(false);
                                setPendingJobType(null);
                              }}
                              color="inherit"
                            >
                              Cancel
                            </Button>

                            <Button
                              onClick={() => {
                                setOpenChangeJobTypeDialog(false);
                                handleJobTypeChange(pendingJobType); // Apply change
                                setPendingJobType(null);
                              }}
                              color="error"
                              variant="contained"
                            >
                              Yes, Change
                            </Button>
                          </DialogActions>
                        </Dialog>


                                          {/* Service Note Modal */}
                  {cartService?.map((data, index) => (
                    <Modal
                      key={`service-note-${data.indexId || data.id}`}
                      open={serviceNoteState?.[data.indexId || data.id] || false}
                      handleClose={() => handleCloseServiceNote(data.indexId || data.id)}
                    >
                      <Grid
                        container
                        spacing={3}
                        sx={{ justifyContent: 'center', width: '100%' }}
                      >
                        <Grid item xs={12}>
                          <Typography variant="h5" sx={{ mb: 2, }}>
                            Note
                          </Typography>

                          <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={{ xs: 3, sm: 2 }}
                            sx={{ mb: 2 }}
                          >
                            <TextField
                              fullWidth
                              multiline
                              rows={4}
                              size="medium"
                              value={serviceCurrentNote}
                              onChange={handleServiceNoteChange}
                              inputProps={{ maxLength: MAX_CHARACTERS }}
                              helperText={`${serviceCurrentNote.length}/${MAX_CHARACTERS} characters`}
                              InputProps={{
                                sx: {
                                  color: 'error.main',
                                }
                              }}
                            />
                          </Stack>
                        </Grid>
                      </Grid>

                      <Grid container justifyContent="center" alignItems="center">
                        <Grid item xs={12} md={4}>
                          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                            <LoadingButton
                              variant="contained"
                              onClick={() => handleSaveServiceNote(data.indexId || data.id)}
                              loading={serviceIsSavingNote}>
                              Save
                            </LoadingButton>
                          </Box>
                        </Grid>
                      </Grid>
                    </Modal>
                  ))}

                  {/* Service Note Modal for additionalSelectedServices */}
                  {additionalSelectedServices?.map((data, index) => (
                    <Modal
                      key={`additional-service-note-${data.indexId || data.newIndexId || index}`}
                      open={serviceNoteState?.[data.indexId || data.newIndexId || index] || false}
                      handleClose={() => handleCloseServiceNote(data.indexId || data.newIndexId || index)}
                    >
                      <Grid
                        container
                        spacing={3}
                        sx={{ justifyContent: 'center', width: '100%' }}
                      >
                        <Grid item xs={12}>
                          <Typography variant="h5" sx={{ mb: 2, }}>
                            Note
                          </Typography>

                          <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={{ xs: 3, sm: 2 }}
                            sx={{ mb: 2 }}
                          >
                            <TextField
                              fullWidth
                              multiline
                              rows={4}
                              size="medium"
                              value={serviceCurrentNote}
                              onChange={handleServiceNoteChange}
                              inputProps={{ maxLength: MAX_CHARACTERS }}
                              helperText={`${serviceCurrentNote.length}/${MAX_CHARACTERS} characters`}
                              InputProps={{
                                sx: {
                                  color: 'error.main',
                                }
                              }}
                            />
                          </Stack>
                        </Grid>
                      </Grid>

                      <Grid container justifyContent="center" alignItems="center">
                        <Grid item xs={12} md={4}>
                          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                            <LoadingButton
                              variant="contained"
                              onClick={() => handleSaveServiceNote(data.indexId || data.newIndexId || index)}
                              loading={serviceIsSavingNote}>
                              Save
                            </LoadingButton>
                          </Box>
                        </Grid>
                      </Grid>
                    </Modal>
                  ))}

                  {/* Service Note Modal for selectedServices */}
                  {selectedServices?.map((data, index) => (
                    <Modal
                      key={`selected-service-note-${data.indexId || data.id || index}`}
                      open={serviceNoteState?.[data.indexId || data.id || index] || false}
                      handleClose={() => handleCloseServiceNote(data.indexId || data.id || index)}
                    >
                      <Grid
                        container
                        spacing={3}
                        sx={{ justifyContent: 'center', width: '100%' }}
                      >
                        <Grid item xs={12}>
                          <Typography variant="h5" sx={{ mb: 2, }}>
                            Note
                          </Typography>

                          <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={{ xs: 3, sm: 2 }}
                            sx={{ mb: 2 }}
                          >
                            <TextField
                              fullWidth
                              multiline
                              rows={4}
                              size="medium"
                              value={serviceCurrentNote}
                              onChange={handleServiceNoteChange}
                              inputProps={{ maxLength: MAX_CHARACTERS }}
                              helperText={`${serviceCurrentNote.length}/${MAX_CHARACTERS} characters`}
                              InputProps={{
                                sx: {
                                  color: 'error.main',
                                }
                              }}
                            />
                          </Stack>
                        </Grid>
                      </Grid>

                      <Grid container justifyContent="center" alignItems="center">
                        <Grid item xs={12} md={4}>
                          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                            <LoadingButton
                              variant="contained"
                              onClick={() => handleSaveServiceNote(data.indexId || data.id || index)}
                              loading={serviceIsSavingNote}>
                              Save
                            </LoadingButton>
                          </Box>
                        </Grid>
                      </Grid>
                    </Modal>
                  ))}

                        </>
                        :""}
                        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                          <LoadingButton type="submit" variant="contained" loading={isSubmitting}  >
                            Save Order
                          </LoadingButton>
                          <Button variant="outlined" onClick={() => {
                            setOpenPreview(!openPreview),
                              setValuesToPreview()
                          }}>
                            Preview
                          </Button>
                          <Button variant="outlined" onClick={() => openEdit ? handleCancel(true) : handleCancel()}>
                            Cancel
                          </Button>
                        </Box>
                      </Stack>
                    </Card>
                  </Grid>
                </Grid>
              </Form>
            </FormikProvider>
          ))}
          {!openEdit && (
            <>
            {(details && invoice && !loadingEdit) ? (
              <Stack direction={'row'} display={'flex'} alignItems={'center'} spacing={{ xs: 3, sm: 2 }}>
                {/* <Typography  fontSize={'1.09rem'} variant="overline" sx={{ color: 'text.secondary', }}>RFQ</Typography> */}
                {details?.id && (invoice?.total !== 0 || details?.job_category_name == 'Time & Material') && !user.isVendor && (
                  (empty(details?.installation_acceptance) && !empty(details?.allInstallationCompleted)) ?
                    <AnimatedButton title={ details?.isReview ==2 ? "Review" :'Invoice'} onClick={() => {
                      let permission =!explodedPermissions?.some((permission) => ['View Billing /Download/ Invoices Sales Order'].includes(permission))
                      if(permission &&  user?.added_by_client ==1){
                        return   enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                      }
                      setOpenInvoice(!openInvoice)}} />
                  :
                  <Link
                    color={theme.palette.success.dark}
                    onClick={() => {
                      let permission =!explodedPermissions?.some((permission) => ['View Billing /Download/ Invoices Sales Order'].includes(permission))
                      if(permission &&  user?.added_by_client ==1){
                        return   enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' })
                      }
                      setOpenInvoice(!openInvoice)}
                    }
                    // component={RouterLink}
                    to={''}
                  >
                    {details?.status === 2 ? (
                      <Badge badgeContent={'1'} color={'warning'}>
                        <Typography fontSize={'1.09rem'} variant="overline">
                          <span style={{ textDecoration: 'underline' }}>Invoice</span>
                        </Typography>
                      </Badge>) : (
                      <Typography fontSize={'1.09rem'} variant="overline">Invoice</Typography>
                    )}
                  </Link>
                )}
                <Typography fontWeight={'0.09rem'} variant="overline" >
                  <Label
                    sx={{ p: '12px' }}
                    variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                    color={getStatusColorAndLabel(details?.status,details?.installationStatus,details?.allInstallationCompleted,details?.installation_acceptance,details?.min_payment_status,details?.job_category_name,details?.billing_type,details?.installationCompleteStatus, details?.noServiceNoTask, details?.proj_status,details?.partial_install ).color} >
                    {getStatusColorAndLabel(details?.status,details?.installationStatus,details?.allInstallationCompleted,details?.installation_acceptance,details?.min_payment_status,details?.job_category_name,details?.billing_type,details?.installationCompleteStatus, details?.noServiceNoTask, details?.proj_status,details?.partial_install ).label}
                  </Label>
                </Typography>
                {((userType == 3 ||userType !== 1 ||  (userType == 1 && details?.status !==2)) && (((details?.allInstallationCompleted == 1) && empty(details?.installation_acceptance)) || !(details?.status == 4 || details?.status == 3)) && ((isClient || userType == 3) ? details?.client_approve == 1 : true)) && details?.project_type && details?.status !==6 &&
                  /* {((userType == 3 ||userType !== 1 ||  (userType == 1 && details?.status !==2)) && (details?.status == 4 && empty(details?.installation_acceptance) && details?.allInstallationCompleted == 1) && ((isClient || userType == 3) ? details?.client_approve == 1 : true)) && If approve and reject is not needed in the "Open" status of sales order in client side uncomment this and comment the above */
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    {(requestAccept) ? 
                      <Stack alignItems='center' justifyContent='center'>
                        <CircularProgress color="primary" variant="indeterminate" />
                      </Stack> 
                      : 
                      <>
                        {confirmInvoice ? 
                          <Stack alignItems='center' justifyContent='center'>
                            <CircularProgress color="primary" variant="indeterminate" />
                          </Stack>
                        :
                          <Button type="submit" variant="contained"
                            onClick={() =>{
                              let permission =!explodedPermissions?.some((permission) => ['Approve Proofs(Final Client invoice approval)'].includes(permission))
                           
                            if(details?.status==4 && user.added_by_client ==1 && permission ){
                             return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });
                             
                            }else{

                              setConfirmInvoice(true)}
                            }
                            }
                          // onClick={()=>handleAcceptorRejectInvoice(1)}
                          >
                            Approve
                          </Button>}
                          {invoiceReject ? 
                          <Stack alignItems='center' justifyContent='center'>
                            <CircularProgress color="primary" variant="indeterminate" />
                          </Stack>
                        :
                          <>
                            {(!empty(details?.installationStatus) || details?.isReview ==2 ) ? '' :
                            <Button size="small" variant="outlined"
                              onClick={() => setRejectInvoice(true)}
                              //  onClick={()=>handleAcceptorRejectInvoice(2)}
                              sx={{ color: theme.palette.error.main }} >
                              Reject
                            </Button>}
                          </>
                        }
                      </>
                    }
                  </Box>}
              </Stack>
            ) : ('')}

              <Grid container spacing={3}>

                <Grid sx={{ mt: 3 }} item xs={12} md={12}>
                  <Stack spacing={3}>
                    <Stack spacing={5}>
                      <Tabs
                        value={currentTab}
                        scrollButtons="auto"
                        variant="scrollable"
                        allowScrollButtonsMobile
                        onChange={handleChangeTab}
                      >
                        {ACCOUNT_TABS.map((tab) => (
                          <Tab
                            disableRipple
                            key={tab.value}
                            label={capitalCase(tab.value)}
                            value={tab.value}
                            sx={{
                              fontWeight:500
                            }}
                          />
                        ))}
                      </Tabs>

                      {ACCOUNT_TABS.map((tab) => {
                        const isMatched = tab.value === currentTab
                        return isMatched && <Box key={tab.value}>{tab.component}</Box>
                      })}
                    </Stack>
                  </Stack>
                </Grid>

              </Grid>
            </>)}

          {/* adding client modal  */}
          <AddClients
            request_id={id}
            setIsOpen={setIsOpen}
            setAllClients={setAllClients}
            allClients={allClients?.filter(a => !a.isVendor)}
            addClient={addClient}
            setAddClient={setAddClient} />
          <AddClients
            isVendor
            request_id={id}
            setIsOpen={setIsOpen}
            setAllClients={setAllClients}
            allClients={allClients?.filter(a => a.isVendor)}
            addClient={addVendor}
            setAddClient={setAddVendor} />
          <AddProposal
            request_id={id}
            setIsOpen={setIsOpen}
            setReloadData={() => setRefresh(!refresh)}
            addProposal={addProposal}
            setAddProposal={setAddProposal} />
          {/* invoice modal */}
          <Modal modalTitle={'Sales Order Details'} open={openInvoice === true} handleClose={() => setOpenInvoice(false)}>
            <Stack direction={{ xs: 'column', sm: 'row', md: 'column' }}
              spacing={{ xs: 3, sm: 2 }}>
              <Stack direction="row" justifyContent={'flex-end'} alignItems="center" spacing={1}>
                <ReactToPrint
                  trigger={() => (<Button> <Print />Print A3</Button>)}
                  content={() => componentRef.current}
                  copyStyles={false}
                  pageStyle={`
                    @media print {
                      body {
                        font-size: 12pt;
                      }
                      table {
                        width: 100%;
                        border-collapse: collapse;
                        margin-bottom: 10px;
                      }

                      th, td {
                        border: 1px solid #ddd;
                        padding: 4px;
                        text-align: left;
                      }
                      #right {
                        text-align: right;
                        margin-top: -200px; 
                      }
                      #total {
                        text-align: right;
                        display:flex;
                        justify-content: flex-end;
                      }
                      #subtotal {
                        text-align: left;
                        
                      }
                      #discount {
                        text-align: left;
                        word-wrap: break-word;
                        margin-right: 100px;
                    }
                    
                      #totalmain {
                        text-align: left;
                        
                      }
                      #subtotal1 {
                        text-align: left;
                        
                      }
                      #discount1 {
                        text-align: left;
                        word-wrap: break-word;
                        margin-right: 30px;
                    }
                    
                      #totalmain1 {
                        text-align: left;
                        
                      }
                      #total1 {
                        text-align: right;
                        display:flex;
                        justify-content: flex-end;
                        margin-top: -320px; 
                        
                      }
                      #logoImage {
                        height: 100px;
                        width:100px;
                      }
                      #order{
                        margin-bottom:-20px
                      }
                      #title{
                        margin-bottom:-20px
                      }
                      #orderID {
                        margin-bottom:-20px
                      }
                      #to {
                        margin-bottom:-20px
                      }
                      
                    }
                  `}
                />
                {(details?.status === 4 || details?.status === 3) && SEND_EMAIL && <Button onClick={handleSendEmail}>Send Email</Button>}
                <div style={{ display: "none" }}>
                  <PrintFunction
                    invoiceDate={invoiceDate}
                    openInvoice={openInvoice}
                    details={details}
                    invoice={invoice}
                    subTotal={subTotal}
                    ref={componentRef}
                    cartService={cartService}
                    additionalSelectedServices={additionalSelectedServices}
                    invoiceSelectedServices={invoiceSelectedServices}
                    data={data}
                    userType={userType}
                    labourInstallService={labourInstallService}
                  />
                </div>

              </Stack>
            </Stack>
            <Grid container spacing={3} >

              <Grid item xs={12} sm={6} sx={{ mb: 5 }}>
                <Grid item xs={12} sm={6} sx={{ mb: 5 }}>
                  <Box component="img" alt="logo" src={COMPANY_LOGO} sx={{ height: 98 }} />
                </Grid>
                <Typography variant="body2">{COMPANY_NAME}</Typography>
                <Typography variant="body2">www.{COMPANY_NAME}.com</Typography>
                <Typography variant="body2">
                  {data?.address}, {data?.city}, {data?.state}, {data?.zipcode}
                </Typography>
                <Typography variant="body2">Telephone: +15208362947</Typography>
              </Grid>
              <Grid item xs={12} sm={6} sx={{ mb: 5 }}>

                <Typography variant="body2">
                  Order date: {invoiceDate}
                </Typography>
                {/* <Stack sx={{display:'flex',flexDirection:'row'}}> */}
                {/* <Typography variant="body2">Order status:</Typography> */}
                <Label
                  variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                  color={getStatusColorAndLabel(details?.status,details?.installationStatus,details?.allInstallationCompleted,details?.installation_acceptance,details?.min_payment_status,details?.job_category_name,details?.billing_type,details?.installationCompleteStatus, details?.noServiceNoTask, details?.proj_status,details?.partial_install).color} >
                  {getStatusColorAndLabel(details?.status,details?.installationStatus,details?.allInstallationCompleted,details?.installation_acceptance,details?.min_payment_status,details?.job_category_name,details?.billing_type,details?.installationCompleteStatus, details?.noServiceNoTask, details?.proj_status,details?.partial_install).label}
                </Label>
                {/* </Stack> */}
                <Typography variant="body2">Job Name: {details?.name}</Typography>
                <Typography variant="body2">Project Name: {details?.community_name || ''}</Typography>
                {/* <Typography variant="body2">Order ID: #{details?.doc_number}</Typography> */}
                
                                {
                                 (details?.installation_acceptance && details?.est_doc_number) && (details?.doc_number !== details?.est_doc_number)?
                                 <>
                                   <Typography variant="body2">
                                 Job Number : {details?.est_doc_number ? `#${details?.est_doc_number}` : ''}
                               </Typography>
                                    <Typography variant="body2">
                                  Invoice Number : {details?.doc_number ? `#${details?.doc_number}` : ''}
                               </Typography>
                               </>
                                 :
                                <Typography variant="body2">
                                Order ID: #{details?.doc_number}
                               </Typography>
                               }
                <Box sx={{ gap : 0.5, mt:2, alignItems:'flex-start'}}>
                  <Typography variant="body2" sx={{ fontWeight: 'bold' }}>To,</Typography>
                  {/* <Box sx={{ ml: 2 }}> */}
                    <Typography variant="body2">Customer: {
                      details?.is_split_order && details?.for_parent_facility == 1 
                        ? FacilityTypes?.find(facility => facility.id === details?.origin_facility_id)?.label || invoice?.customer_name || ''
                        : invoice?.customer_name || ''
                    }</Typography>
                    {/* <Typography variant="body2">Project Name: {details?.community_name || ''}</Typography> */}
                    <Typography variant="body2">Address: {invoice?.customer_address || ''}</Typography>
                    <Typography variant="body2">Phone: {invoice?.customer_phone || ''}</Typography>
                  {/* </Box> */}
                </Box>
                {(details?.job_category_name == 'Time & Material') ? 
                  <Label variant='filled' color="info">Time & Material</Label>
                : ''}
              </Grid>
            </Grid>
            <Grid container spacing={2}>

              <Scrollbar>
                {/* {((details?.job_category_name == 'Time & Material') && (details?.allInstallationCompleted == 1)) ?  */}
                {(details?.job_category_name == 'Time & Material') ? 
                  <>
                  {(invoice?.cust_product?.filter(item=>item.material != 1)?.length > 0) ? <>
                  <Typography variant='h6'>{'Products'}</Typography>
                  <TableContainer sx={{ minWidth: 420, mt: 3 }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>PRODUCT & NOTE</TableCell>
                          {invoice?.cust_product?.filter(item=>item.material != 1)?.some(item => item.product_notes) && <TableCell>SKU</TableCell>}
                          <TableCell align="center">UNIT</TableCell>
                          <TableCell>UNIT PRICE</TableCell>
                          <TableCell>QTY</TableCell>
                          <TableCell>TOTAL</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {invoice?.cust_product?.filter(item=>item.material != 1)?.map((val) => {
                          const { vid, product_name, product_notes,vpt_number, product_price, product_retail_price, adjustment, 
                            quantity, locationQuantity,actual_retail_price,install_cost, product_total, discount, unit, unit_qty, material,rfp,markAdjType,
                            services = [],
                          } = val
                          console.log('product_total', product_total)

                          // Get labor install
                          const labourService = services?.find(service => service.labour_cost_service_id === 10);
                          const minusAmountLabourInstall = (labourService?.service_original_cost * labourService?.prQty) || 0;
                          const labourQty = (labourService?.prQty || 0) * locationQuantity;
                          const labourRate = labourService?.service_original_cost || 0;
                          const labourTotal = labourQty * labourRate;
                          const labourInitial = (labourService?.prQty || 0) * labourRate;
                          
                          // Unit name logic
                          let unitData = UNITS?.filter((item) => item?.id == unit)
                          let shortUnitName = unitData[0]?.short_name || 'Unit'
                          let unitName = unitData[0]?.name

                          //  subTotal += product_total    
                          let SPMA = 0
                          if(markAdjType==2 || markAdjType==3){
                            SPMA = (actual_retail_price || product_retail_price || 0) +  (adjustment ? Number(adjustment) : 0)
            
                          }else{

                            SPMA = (actual_retail_price || product_retail_price || 0) + (((product_retail_price || 0) * (adjustment ? Number(adjustment) : 0)) / 100)
                          }
                          SPMA = parseFloat(SPMA)?.toFixed(2)           

                          let rowTotal = 0;

                          if (markAdjType == 1) {
                              rowTotal = product_total || 0.00;
                          } else {
                              // rowTotal = (SPMA * (locationQuantity * quantity) - minusAmountLabourInstall);
                              rowTotal = SPMA * (locationQuantity * quantity);
                          }

                          // Ensure rowTotal is a number before calling toFixed
                          if (typeof rowTotal === 'number') {
                              customerProductTotal = rowTotal.toFixed(2);
                          } else {
                              customerProductTotal = "0.00"; // Handle the case where rowTotal isn't a valid number
                          }
                          console.log('customerProductTotal', customerProductTotal , invoice?.jobcostTotal)
                          return (
                          <React.Fragment key={vid}>
                            {/* Product Row */}
                            <TableRow
                            //  sx={{
                            //   borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                            // }}
                            >
                              <TableCell width={'25%'} sx={{ flexWrap: 'wrap', overflow: 'hidden' }}>
                                {product_notes ? 
                                  <Typography variant='subtitle2' sx={{ fontWeight: 'bold',wordBreak: 'break-word', overflowWrap: 'break-word'}}>{product_notes}</Typography> 
                                  
                                  : 
                                  <Typography variant='subtitle2' sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word' }}>{product_name}</Typography>
                                  }
                                {(material === 1 && rfp==0 && details?.job_category_name != 'Time & Material') && (
                                  // <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                                  //   (Addl. Material{val?.stock_type === 1 
                                  //     ? ' - Finished' 
                                  //     : val?.stock_type === 2 
                                  //       ? ` - Partial (${UNITS?.find(u => u.id === val?.convertion_unit)?.short_name || 'Unit'})` 
                                  //       : ''})
                                  // </Typography>
                                  <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>(Addl. Material)</Typography> 
                                )}
                                {(material === 1 && rfp==1 && details?.job_category_name != 'Time & Material') ? 
                                <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>(Material)</Typography> 
                              : null}
                              </TableCell>
                              <TableCell align="center">{material === 1 ? '1' : quantity}({shortUnitName})</TableCell>
                              {/* <TableCell>${(SPMA ? SPMA - (labourInitial || 0) : 0)?.toFixed(2)}</TableCell> */}
                              {/* <TableCell>${(Number(SPMA) || 0).toFixed(2)}</TableCell> */}
                              {invoice?.cust_product?.some(item => item.product_notes) ? <TableCell>{product_notes ? vpt_number : ''}</TableCell> : ''}
                              <TableCell>${(Number(actual_retail_price) || (Number(SPMA) || 0)).toFixed(2)}</TableCell>
                              <TableCell>{locationQuantity}</TableCell>
                              {/* {markAdjType==1?
                                // <TableCell>${product_total ? (product_total - labourTotal)?.toFixed(2) : 0.00}</TableCell>
                                <TableCell>${product_total ? product_total?.toFixed(2) : 0.00}</TableCell>
                              :
                                // <TableCell>${((SPMA * (locationQuantity * quantity)) - labourTotal)?.toFixed(2)}</TableCell>
                                <TableCell>${(Number(SPMA) || 0).toFixed(2)}</TableCell>
                              } */}
                              {markAdjType==1?
                              // <TableCell>${product_total ? product_total?.toFixed(2) : 0.00}</TableCell>
                              <TableCell>${
                                install_cost ?
                                ((actual_retail_price * (locationQuantity * quantity)) || 0).toFixed(2) :
                                material === 1 ?
                                ((SPMA * locationQuantity ) || 0).toFixed(2) :
                                ((SPMA * (locationQuantity * quantity)) || 0).toFixed(2)
                                }</TableCell>
                            :
                              // <TableCell>${((SPMA * (locationQuantity * quantity)) - labourTotal)?.toFixed(2)}</TableCell>
                              <TableCell>${
                                install_cost ?
                                ((actual_retail_price * (locationQuantity * quantity)) || 0).toFixed(2) :
                                material === 1 ?
                                ((SPMA * locationQuantity ) || 0).toFixed(2) :
                                ((SPMA * (locationQuantity * quantity)) || 0).toFixed(2)
                                }</TableCell>
                            }
                            </TableRow>
                            {/* Labor Install Row (if exists) */}
                            {/* {labourService && (
                              <TableRow>
                                <TableCell sx={{ pl: 4 }}>{labourService?.name}</TableCell>
                                <TableCell align="center">N/A</TableCell>
                                <TableCell>${labourRate?.toFixed(2)}</TableCell>
                                <TableCell>{labourQty?.toFixed(2)}</TableCell>
                                <TableCell>${labourTotal?.toFixed(2)}</TableCell>
                              </TableRow>
                            )} */}
                            {install_cost ? (
                              <TableRow>
                                <TableCell sx={{ pl: 4 }}>Install Price</TableCell>
                                {invoice?.cust_product?.some(item => item.product_notes) ? <TableCell>-</TableCell> : ''}
                                <TableCell align="center">-</TableCell>
                                <TableCell>${install_cost || 0}</TableCell>
                                <TableCell>-</TableCell>
                                <TableCell>
                                  ${((install_cost || 0) * (locationQuantity || 1) * (quantity || 1)).toFixed(2)}
                                </TableCell>

                              </TableRow>
                            ):''}
                            <TableRow>
                              <TableCell colSpan={5}>
                                <Box sx={{ borderBottom: (theme) => `solid 1px ${theme.palette.divider}` }} />
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                          )
                        }
                        )}

                      </TableBody>
                    </Table>
                  </TableContainer>
                </> : null}
                {/* <Typography variant='h6' sx={{ mt: 2 }}>{(labourInstallService?.length > 0 ) ? ((details?.job_category_name != 'Service only' && details?.job_category_name != 'Time & Material') ? "Services(Labor Install)" : 'Services(Labor Install)') : ""}</Typography>
                    <TableContainer sx={{ minWidth: 420, mt: 3 }}>
                      <Table>
                        {(labourInstallService?.length > 0 ) &&
                          <TableHead>
                            <TableRow>
                              <TableCell colSpan={2}>NAME</TableCell>
                              <TableCell>COST (HOURLY)</TableCell>
                              <TableCell>HOURS</TableCell>
                              <TableCell>TOTAL COST</TableCell>
                            </TableRow>
                          </TableHead>}
                        <TableBody>
                        {labourInstallService?.map((ser) => {
                            console.log('invoiceSelectedServices--@@ 1', ser);
                            return (
                              <TableRow sx={{
                                borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                              }}>
                                <TableCell colSpan={2}>
                                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                                    {ser?.name}-({ser.productName})
                                  </Typography>
                                  {ser?.service_notes ? 
                                    <Stack direction={'column'}>
                                      <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography> 
                                      <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' ,color: 'error.main'}}>{ser.service_notes}</Typography> 
                                    </Stack>
                                    : ''}
                                </TableCell>
                                <TableCell>${ser ? ser?.unit_cost?.toFixed(2) : 0}</TableCell>
                                <TableCell>{ser ? ser?.quantity?.toFixed(2) : 0}</TableCell>
                                <TableCell>${ser ? ser?.total_cost?.toFixed(2) : 0}</TableCell>
                              </TableRow>
                            )
                          })}
                          </TableBody>
                          </Table>
                      </TableContainer> */}
                    {(!empty(invoice?.jobcost_product)) ? 
                    <>
                    <Typography variant='h6' sx={{ mt: 2 }}>Materials</Typography> 
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell colSpan={2}>NAME</TableCell>
                            <TableCell>UNIT COST</TableCell>
                            <TableCell>QUANTITY</TableCell>
                            <TableCell>TOTAL COST</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {invoice?.jobcost_product?.map((val,index) => {
                            const { id, product_name, unit_price, quantity, total, unit,partial_unit, unit_qty } = val
                            let unitToUse = partial_unit ? partial_unit : unit
                            let unitName = UNITS?.filter((item) => item?.id == unitToUse)
                            let shortUnitName = unitName[0]?.short_name || 'Unit'
                            unitName = unitName[0]?.name
                            // let shortUnitName = ''
                            // if (unitName == 'Square feet') {
                            //   shortUnitName = 'Sq ft'
                            // } else if (unitName == 'Lineal feet') {
                            //   shortUnitName = 'Lin ft'
                            // } else if (unitName == 'Square Inches') {
                            //   shortUnitName = 'Sq Inches'
                            // } else if (unitName == 'Unit') {
                            //   shortUnitName = 'Unit'
                            // }
                            return (
                              <TableRow sx={{
                                borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                              }}>
                                <TableCell colSpan={2}>{product_name}</TableCell>
                                <TableCell> ${unit_price}</TableCell>
                                <TableCell>{quantity}({shortUnitName})</TableCell>
                                <TableCell> ${total}</TableCell>
                              </TableRow>
                            )
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    </>
                    : ''}
                    {/* {invoice?.jobcost_service?.filter((item)=>item.product_id == null)?.length > 0 ? <Typography variant='h6' sx={{ mt: 2 }}>Additional Services</Typography> : ''} */}
                    <TableContainer>
                        <Table>
                        {invoice?.jobcost_service?.filter((item)=>item.product_id == null)?.length > 0 ? 
                        <>
                          <TableHead>
                            <TableRow>
                              <TableCell colSpan={2}>ADDITIONAL SERVICES</TableCell>
                              <TableCell>HOURLY COST</TableCell>
                              <TableCell>HOURS</TableCell>
                              <TableCell>TOTAL COST</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {invoice?.jobcost_service?.filter((item)=>item.product_id == null)?.map((ser,index) => {
                              return (
                                <TableRow sx={{
                                  borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                                }}>
                                  <TableCell colSpan={2}>
                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                                      {ser?.name}
                                    </Typography>
                                    {ser?.service_notes ? 
                                      <Stack direction={'column'}>
                                        <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography> 
                                        <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' ,color: 'error.main'}}>{ser.service_notes}</Typography> 
                                      </Stack>
                                      : ''}
                                  </TableCell>
                                  <TableCell>${ser ? parseFloat(ser?.service_original_cost)?.toFixed(2) : 0}</TableCell>
                                  {/* <TableCell>{ser ? parseFloat(ser?.jobcost_quantity)?.toFixed(2) : 0}</TableCell> */}
                                  <TableCell>{ser ? parseFloat(ser?.quantity)?.toFixed(2) : 0}</TableCell>
                                  <TableCell>${ser ? ser?.total_service_cost : 0}</TableCell>
                                </TableRow>
                              )
                            })}
                          </TableBody>
                        </> : ''}
                    {(invoice?.jobcostTotal && invoice?.jobcostTotal > 0) ? (
                      <RowResultStyle>
                        <TableCell colSpan={3} />
                        <TableCell align="right">
                          <Typography variant="overline">Material Total</Typography>
                        </TableCell>
                        <TableCell align="left" width={10}>
                          <Typography variant="overline">${invoice ? invoice?.jobcostTotal?.toFixed(2) : 0.00}</Typography>
                        </TableCell>
                      </RowResultStyle>
                    ) : ''}
                    {/* {(invoice?.project_category == 12 && details?.allInstallationCompleted == 1) ? '' : */}
                    {(invoice?.project_category == 12) ? '' :
                    <RowResultStyle>
                        <TableCell colSpan={3} />
                        <TableCell align="right">
                          <Typography variant="overline">Product Total</Typography>
                        </TableCell>
                        <TableCell align="left" width={10}>
                          <Typography variant="overline">
                            ${invoice?.cust_product?.reduce((sum, val) => {
                              const {
                                product_retail_price = 0, adjustment = 0, markAdjType,
                                product_total = 0, locationQuantity = 1, quantity = 1,
                                services = []
                              } = val;

                              const labourService = services?.find(s => s.labour_cost_service_id === 10);
                              const labourTotal = (labourService?.service_original_cost || 0) * (labourService?.prQty || 0) * locationQuantity;

                              let SPMA = (markAdjType === 2 || markAdjType === 3)
                                ? product_retail_price + Number(adjustment)
                                : product_retail_price + ((product_retail_price * Number(adjustment)) / 100);

                              const effectiveTotal = markAdjType === 1
                                // ? product_total - labourTotal
                                // : (SPMA * (locationQuantity * quantity)) - labourTotal;
                                ? product_total
                                  : (SPMA * (locationQuantity * quantity));

                              return sum + effectiveTotal;
                            }, 0)?.toFixed(2)}
                        </Typography>
                      </TableCell>
                    </RowResultStyle>
                    }

                    {(labourInstallService?.length > 0 || 
                      additionalSelectedServices?.some(
                        x => x.labour_cost_service_id === 10 && (x.total_cost || 0) > 0
                      ) ||
                        invoice?.cust_product?.some(
                          val => parseFloat(val.install_cost || 0) > 0
                        )
                    ) && (
                      <RowResultStyle>
                        <TableCell colSpan={3} />
                        <TableCell align="right">
                          <Typography variant="overline">Install Total</Typography>
                        </TableCell>
                        <TableCell align="left" width={10}>
                          {/* <Typography variant="overline">
                              ${invoice?.cust_product?.reduce((sum, val) => {
                                const labourService = val?.services?.find(s => s.labour_cost_service_id === 10);
                                return sum + (labourService?.service_original_cost || 0) * (labourService?.prQty || 0) * (val?.locationQuantity || 1);
                              }, 0)?.toFixed(2)}
                          </Typography> */}
                          <Typography variant="overline">
                            ${(
                                (invoice?.cust_product?.reduce((sum, val) => {
                                  const labourService = val?.services?.find(
                                    s => s.labour_cost_service_id === 10
                                  );
                                  return (
                                    sum +
                                    (labourService?.service_original_cost || 0) *
                                      (labourService?.prQty || 0) *
                                      (val?.locationQuantity || 1)
                                  );
                                }, 0) || 0) +
                                (additionalSelectedServices?.reduce(
                                  (s, x) =>
                                    x.labour_cost_service_id === 10 ? s + (x.total_cost || 0) : s,
                                  0
                                ) || 0)
                              ).toFixed(2)}
                          </Typography>
                        </TableCell>
                      </RowResultStyle>
                    )}

                    <RowResultStyle>
                      <TableCell colSpan={3} />
                      <TableCell align="right">
                        {/* <Typography variant="overline">{details?.job_category_name != 'Service only' ? 'Additional Labor Cost' : 'Labor Cost'}</Typography> */}
                        {/* <Typography variant="overline">{(details?.job_category_name != 'Service only' && details?.job_category_name != 'Time & Material') ? 'Additional Services' : 'Services'}</Typography> */}
                        <Typography variant="overline">{(details?.job_category_name != 'Service only') ? 'Additional Services Total' : 'Services Total'}</Typography>
                      </TableCell>
                      <TableCell align="left" width={10}>
                        {/* <Typography variant="overline">${details ? details?.labour_cost?.toFixed(2) : 0.00}</Typography> */}
                        <Typography variant="overline">
                          ${(
                            (invoiceSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                            // (additionalSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                            (additionalSelectedServices?.reduce(
                                    (s, x) =>
                                      x.labour_cost_service_id === 10  
                                        ? s
                                        : s + (x.total_cost || 0),
                                    0
                                ) || 0) +
                            (cartService?.reduce((s, x) => {
                              const sp = x.sellingPrice || x.unit_cost || 0;
                              const markup = x.originalMarkup || x.product_markup || 0;
                              const final = sp + (sp * markup / 100);
                              return s + ((x.qty || 0) * final);
                            }, 0) || 0)
                          )?.toFixed(2)}
                        </Typography>
                      </TableCell>
                    </RowResultStyle>

                    <RowResultStyle>
                      <TableCell colSpan={3} />
                      <TableCell align="right">
                        <Typography variant="overline">Subtotal</Typography>
                      </TableCell>
                      <TableCell align="left" width={10}>
                        <Typography variant="overline">
                          ${(
                            (subTotal || 0) +
                            (invoiceSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                            (additionalSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                            (cartService?.reduce((s, x) => {
                              const sp = x.sellingPrice || x.unit_cost || 0;
                              const markup = x.originalMarkup || x.product_markup || 0;
                              const final = sp + (sp * markup / 100);
                              return s + ((x.qty || 0) * final);
                            }, 0) || 0)+
                            (invoice?.cust_product?.reduce((sum, val) => {
                              const labourService = val?.services?.find(
                                s => s.labour_cost_service_id === 10
                              );
                              return (
                                sum +
                                (labourService?.service_original_cost || 0) *
                                  (labourService?.prQty || 0) *
                                  (val?.locationQuantity || 1)
                              )
                            }, 0) || 0)
                          )?.toFixed(2)}
                        </Typography>
                      </TableCell>
                    </RowResultStyle>

                    {invoice?.extra_discount > 0 && (
                    <RowResultStyle>
                      <TableCell colSpan={3} />
                      <TableCell align="right">
                        <Typography variant="overline">Discount</Typography>
                      </TableCell>
                      <TableCell align="left" width={10}>
                        <Typography variant="overline">${invoice ? invoice?.extra_discount?.toFixed(2) : 0.00}</Typography>
                      </TableCell>
                    </RowResultStyle>
                    )}
                    
                    {invoice?.tax_amount > 0 && (
                    <RowResultStyle>
                      <TableCell colSpan={3} />
                      <TableCell align="right">
                        <Typography variant="overline">Tax</Typography>
                      </TableCell>
                      <TableCell align="left" width={10}>
                        <Typography variant="overline">${invoice ? invoice?.tax_amount?.toFixed(2) : 0.00}</Typography>
                      </TableCell>
                    </RowResultStyle>
                    )}

                    <RowResultStyle>
                      <TableCell colSpan={3} />
                      <TableCell align="right">
                        <Typography variant="subtitle1"  sx={{ color: invoice?.grandTotal < 0 ? 'red' : 'inherit' }}>Total</Typography>
                      </TableCell>
                      <TableCell align="left" width={10}>
                        <Typography variant="subtitle1"  sx={{ color: invoice?.grandTotal < 0 ? 'red' : 'inherit' }}>${invoice?.grandTotal ? invoice?.grandTotal?.toFixed(2) : 0.00}</Typography>
                      </TableCell>
                    </RowResultStyle>

                          {invoice?.project_category == 13 ? '' : 
                            <>
                            {(userType !=3 && details?.job_category_name != 'Time & Material' && details?.job_category_name != 'No Charge') ?
                            (details?.billing_type ? (
                            <RowResultStyle>
                              <TableCell colSpan={3} />
                              <TableCell align="right" sx={{display:"flex"}}>
                              <Typography fontSize={"small"} variant="caption"  sx={{ color:  'inherit' }}> (only viewable for admin)</Typography>
                                <Typography variant="subtitle1"  sx={{ color:  '#12b2e3' }}>Billing Type</Typography>
                              </TableCell>
                              <TableCell align="left" width={10}>
                                <Typography variant="subtitle1"  sx={{ color:  '#12b2e3' }}>{details?.billing_type ? `${details?.billing_type} %` :"Nil"}</Typography>
                              </TableCell>
                            </RowResultStyle>
                            ) : '')
                            :""}
                         {
                         (invoice?.total && details?.billing_type)?

                            <RowResultStyle>
                              <TableCell colSpan={3} />
                              <TableCell align="right">
                                <Typography variant="subtitle1"  sx={{ color:  'yellow' }}>Minimum Payable Amount</Typography>
                              </TableCell>
                              <TableCell align="left" width={10}>
                                <Typography variant="subtitle1"  sx={{ color:  'yellow' }}>${(invoice?.total && details?.billing_type)? parseFloat((invoice?.total *details?.billing_type) / 100).toFixed(2) :0.00}</Typography>
                              </TableCell>
                            </RowResultStyle>
                            :""
                            }
                            {details?.totalPaidAmount > 0 && (
                              <RowResultStyle>
                                <TableCell colSpan={3} />
                                <TableCell align="right">
                                  <Typography variant="subtitle1"  sx={{ color: details?.totalPaidAmount < 0 ? 'red' : 'green' }}>Amount Paid</Typography>
                                </TableCell>
                                <TableCell align="left" width={10}>
                                  <Typography variant="subtitle1"  sx={{ color: details?.totalPaidAmount < 0 ? 'red' : 'green' }}>${details?.totalPaidAmount ? parseFloat(details?.totalPaidAmount)?.toFixed(2) : 0.00}</Typography>
                                </TableCell>
                              </RowResultStyle>
                            )}
                            {details?.totalPaidAmount > 0 && (
                              <RowResultStyle>
                                <TableCell colSpan={3} />
                                <TableCell align="right">
                                  <Typography variant="subtitle1"  sx={{ color: invoice?.newBalanceDue <= 0 ? 'inherit' : 'red' }}>Balance Due</Typography>
                                </TableCell>
                                <TableCell align="left" width={10}>
                                  <Typography variant="subtitle1"  sx={{ color: invoice?.newBalanceDue <= 0 ? 'inherit' : 'red' }}>${invoice?.newBalanceDue ? parseFloat(invoice?.newBalanceDue <= 0 ? 0.00 : invoice?.newBalanceDue)?.toFixed(2) : 0.00}</Typography>
                                </TableCell>
                              </RowResultStyle>
                            )}
                            </>
                          }
                      </Table>
                    </TableContainer>
                    {(details?.allInstallationCompleted == 1 && !empty(invoice?.note_data)) ? (
                      <>
                        <Typography variant="h6" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>Installation Notes</Typography>
                        <Stack spacing={2}>
                          {invoice?.note_data?.map((val, index) => {
                            const { id, authorized_by, note, timestamp } = val;
                            return (
                              <Paper
                                key={id}
                                elevation={3}
                                sx={{ padding: 2, borderRadius: 2, backgroundColor: 'rgba(145, 158, 171, 0.16)', color: '#ffffff' }}
                              >
                                <Grid container spacing={2}>
                                  <Grid item xs={12} sm={8}>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                                      {note}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={12} sm={4} sx={{ textAlign: { xs: 'left', sm: 'right' } }}>
                                    {/* <Typography variant="body2" sx={{ color: 'primary.light' }}> */}
                                    <Typography variant="body2" sx={{ color: theme.palette.primary.main }}>
                                      Added By: {authorized_by}
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: theme.palette.primary.main }}>
                                      {moment.unix(timestamp).format('MM-DD-YYYY hh:mm:ss A')}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Paper>
                            );
                          })}
                        </Stack>
                      </>
                    ) : ''}
                  </> :
                  <>
                  {(invoice?.cust_product?.length > 0) ? <>
                  <Typography variant='h6'>{details?.job_category_name != 'Time & Material' ? 'Products' : 'Products'}</Typography>
                  <TableContainer sx={{ minWidth: 420, mt: 3 }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>PRODUCT & NOTE</TableCell>
                          {invoice?.cust_product?.some(item => item.product_notes) && <TableCell>SKU</TableCell>}
                          <TableCell align="center">UNIT</TableCell>
                          <TableCell align="center">QTY</TableCell>
                          {/* {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3) ? <TableCell>WHOLESALE PRICE</TableCell> : ''}
                          {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3) ? <TableCell>SPLIT MARKUP</TableCell> : ''} */}
                          <TableCell align="center">UNIT PRICE EACH</TableCell>
                          <TableCell>TOTAL</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {invoice?.cust_product?.map((val) => {
                          const { vid,split_percentage,wholesale_price, product_name,facility_id,expected_cost, product_notes,vpt_number, product_price, product_retail_price, adjustment, 
                            quantity, locationQuantity,actual_retail_price,install_cost, product_total, discount, unit, unit_qty, material,rfp,markAdjType,
                            services = [],
                          } = val
                          // Get labor install
                          const labourService = services?.find(service => service.labour_cost_service_id === 10);
                          const minusAmountLabourInstall = (labourService?.service_original_cost * labourService?.prQty) || 0;
                          const labourQty = (labourService?.prQty || 0) * locationQuantity;
                          const labourRate = labourService?.service_original_cost || 0;
                          const labourTotal = labourQty * labourRate;
                          const labourInitial = (labourService?.prQty || 0) * labourRate;
                          
                          // Unit name logic
                          let unitData = UNITS?.filter((item) => item?.id == unit)
                          let shortUnitName = unitData[0]?.short_name || 'Unit'
                          let unitName = unitData[0]?.name   

                          let SPMA = 0
                          if(markAdjType==2 || markAdjType==3){
                            SPMA = (actual_retail_price || product_retail_price || 0) +  (adjustment ? Number(adjustment) : 0)
            
                          }else{

                            SPMA = (actual_retail_price || product_retail_price || 0) + (((product_retail_price || 0) * (adjustment ? Number(adjustment) : 0)) / 100)
                          }
                          SPMA = parseFloat(SPMA)?.toFixed(2)                 
                          return (
                          <React.Fragment key={vid}>
                            {/* Product Row */}
                            <TableRow
                            //  sx={{
                            //   borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                            // }}
                            >
                              <TableCell width={'25%'} sx={{ flexWrap: 'wrap', overflow: 'hidden' }}>
                                {product_notes ? 
                                <Typography variant='body2' sx={{ fontWeight: 'bold',wordBreak: 'break-word', overflowWrap: 'break-word' }}>{product_notes}</Typography> 
                                : 
                                <Typography variant='subtitle2' sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word' }}>{product_name}</Typography>
                                }
                                {/* {(material === 1 && details?.job_category_name != 'Time & Material') ? 
                                    <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                                      (Addl. Material{val?.stock_type === 1 
                                        ? ' - Finished' 
                                        : val?.stock_type === 2 
                                          ? ` - Partial (${UNITS?.find(u => u.id === val?.convertion_unit)?.short_name || 'Unit'})` 
                                          : ''})
                                    </Typography>
                                : ''} */}
                                {(material === 1 && rfp==0 &&  details?.job_category_name != 'Time & Material') ? 
                                <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>(Addl. Material)</Typography> 
                              : ''}
                              {(material === 1 && rfp==1 && details?.job_category_name != 'Time & Material') ? 
                                <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>(Material)</Typography> 
                              : null}

                              </TableCell>
                              {invoice?.cust_product?.some(item => item.product_notes) ? <TableCell>{product_notes ? vpt_number : ''}</TableCell> : ''}
                              {/* <TableCell align="center">{material === 1 ? '1' : quantity}({shortUnitName})</TableCell> */}
                              <TableCell align="center">{material === 1 ? `1 (${shortUnitName})` : '-'}</TableCell>
                              <TableCell align="center">{locationQuantity}</TableCell>
                              {/* <TableCell>${(SPMA ? SPMA - (labourInitial || 0) : 0)?.toFixed(2)}</TableCell> */}
                              {/* <TableCell>${(Number(SPMA) || 0).toFixed(2)}</TableCell> */}
                              {/* {(details?.is_split_order  && details?.origin_facility_id == currentFacilityId && userType != 3) ? 
                              <TableCell align="center">
                                {details?.is_split_order && facility_id != currentFacilityId ? `$${wholesale_price || 0}` : '-'}
                              </TableCell>
                              :''
                              }
                              {(details?.is_split_order  && details?.origin_facility_id == currentFacilityId && userType != 3) ? 
                              <TableCell align="center">
                                {details?.is_split_order && facility_id != currentFacilityId ? `${incomingSplitMarkup || 0}%` : '-'}
                              </TableCell>
                              :''
                              } */}
                              {/* <Tooltip title={
                                details?.is_split_order && facility_id != currentFacilityId 
                                  ? `Wholesale price + (Wholesale price  * incoming split markup (${incomingSplitMarkup || 0}) / 100)` 
                                  : ""
                              }> */}
                                <TableCell align="center">${(Number(actual_retail_price) || (Number(SPMA) || 0)).toFixed(2)}</TableCell>
                              {/* </Tooltip> */}
                              {/* <TableCell>{locationQuantity}</TableCell> */}
                              {/* {markAdjType==1?
                                // <TableCell>${product_total ? (product_total - labourTotal)?.toFixed(2) : 0.00}</TableCell>
                                <TableCell>${product_total ? product_total?.toFixed(2) : 0.00}</TableCell>
                              :
                                // <TableCell>${((SPMA * (locationQuantity * quantity)) - labourTotal)?.toFixed(2)}</TableCell>
                                <TableCell>${product_total ? product_total?.toFixed(2) : 0.00}</TableCell>
                              } */}
                              {markAdjType==1?
                                // <TableCell>${product_total ? product_total?.toFixed(2) : 0.00}</TableCell>
                                <TableCell>${
                                  install_cost ?
                                  ((actual_retail_price * (locationQuantity * quantity)) || 0).toFixed(2) :
                                  material === 1 ?
                                  ((SPMA * locationQuantity ) || 0).toFixed(2) :
                                  ((SPMA * (locationQuantity * quantity)) || 0).toFixed(2)
                                  }</TableCell>
                              :
                                // <TableCell>${((SPMA * (locationQuantity * quantity)) - labourTotal)?.toFixed(2)}</TableCell>
                                <TableCell>${
                                  install_cost ?
                                  ((actual_retail_price * (locationQuantity * quantity)) || 0).toFixed(2) :
                                  material === 1 ?
                                  ((SPMA * locationQuantity ) || 0).toFixed(2) :
                                  ((SPMA * (locationQuantity * quantity)) || 0).toFixed(2)
                                  }</TableCell>
                              }
                            </TableRow>
                            {/* Labor Install Row (if exists) */}
                            {/* {labourService && (
                              <TableRow>
                                <TableCell sx={{ pl: 4 }}>{labourService?.name}</TableCell>
                                <TableCell align="center">N/A</TableCell>
                                <TableCell>${labourRate?.toFixed(2)}</TableCell>
                                <TableCell>{labourQty?.toFixed(2)}</TableCell>
                                <TableCell>${labourTotal?.toFixed(2)}</TableCell>
                              </TableRow>
                            )} */}
                            {install_cost ? (
                              <TableRow>
                                <TableCell sx={{ pl: 4 }}>Install Price</TableCell>
                                {invoice?.cust_product?.some(item => item.product_notes) ? <TableCell>-</TableCell> : ''}
                                <TableCell align="center">-</TableCell>
                                {/* {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3) ?
                                  <TableCell align="center">
                                    {details?.is_split_order && facility_id != currentFacilityId ? '-' : '-'}
                                  </TableCell>
                                  : ''
                                }
                                {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3) ?
                                  <TableCell align="center">
                                    {details?.is_split_order && facility_id != currentFacilityId ? '-' : '-'}
                                  </TableCell>
                                  : ''
                                } */}
                                <TableCell align="center">-</TableCell>
                                <TableCell align="center">${install_cost || 0}</TableCell>
                                <TableCell>
                                  ${((install_cost || 0) * (locationQuantity || 1) * (quantity || 1)).toFixed(2)}
                                </TableCell>

                              </TableRow>
                            ):''}
                            <TableRow>
                                <TableCell colSpan={
                                  (invoice?.cust_product?.some(item => item.product_notes) ? 6 : 5) + 
                                 (details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3 ? 2 : 0)
                                }>
                                <Box sx={{ borderBottom: (theme) => `solid 1px ${theme.palette.divider}` }} />
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                          )
                        }
                        )}

                      </TableBody>
                    </Table>
                  </TableContainer>
                  </> : null}
                  {/* <Typography variant='h6' sx={{ mt: 2 }}>{(additionalSelectedServices?.length > 0 || cartService?.length > 0 || invoiceSelectedServices?.length > 0) ? ((details?.job_category_name != 'Service only' && details?.job_category_name != 'Time & Material') ? "Additional Services" : 'Services') : ""}</Typography> */}
                  {/* <Typography variant='h6' sx={{ mt: 2 }}>{(additionalSelectedServices?.length > 0 || cartService?.length > 0 || invoiceSelectedServices?.length > 0) ? ((details?.job_category_name != 'Service only' ) ? "Additional Services" : 'Services') : ""}</Typography> */}
                  <TableContainer sx={{ minWidth: 420, mt: 3 }}>
                    <Table>
                      {(additionalSelectedServices?.length > 0 || cartService?.length > 0 || invoiceSelectedServices?.length > 0) &&
                        <TableHead>
                          <TableRow>
                            <TableCell colSpan={2}>{((details?.job_category_name != 'Service only' ) ? "ADDITIONAL SERVICES" : 'SERVICES')}</TableCell>
                            <TableCell>COST (HOURLY)</TableCell>
                            <TableCell>HOURS</TableCell>
                            <TableCell>TOTAL COST</TableCell>
                          </TableRow>
                        </TableHead>}
                      <TableBody>
                        {invoice?.cust_product?.map((val) => {
                          const { vid, product_name, product_price, product_retail_price,
                            quantity, product_total, discount, unit, unit_qty,markAdjType,adjustment,locationQuantity
                          } = val
                          let unitName = UNITS?.filter((item) => item?.id == unit)
                          unitName = unitName[0]?.name
                          let shortUnitName = ''
                          if (unitName == 'Square feet') {
                            shortUnitName = 'Sq ft'
                          } else if (unitName == 'Lineal feet') {
                            shortUnitName = 'Lin ft'
                          } else if (unitName == 'Square Inches') {
                            shortUnitName = 'Sq Inches'
                          } else if (unitName == 'Unit') {
                            shortUnitName = 'Unit'
                          }

                          let SPMA = 0
                        if(markAdjType==2 || markAdjType==3) {
                          SPMA = (product_retail_price || 0) + (adjustment ? Number(adjustment) : 0)
                        }else{
                          SPMA = (product_retail_price || 0) + (((product_retail_price || 0) * (adjustment ? Number(adjustment) : 0)) / 100)

                        }
                        SPMA = parseFloat(SPMA)?.toFixed(2)  

                        let theSubTotalAmount =markAdjType==1?product_total: (SPMA * (locationQuantity * quantity))

                          subTotal += theSubTotalAmount
                          return (
                            null
                          )
                        })}

                        {openInvoice && invoiceSelectedServices?.map((ser) => {
                          console.log('invoiceSelectedServices--@@', ser);
                          return (
                            <TableRow sx={{
                              borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                            }}>
                              <TableCell colSpan={2}>
                                <Typography variant='subtitle2' sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word' }}>{ser?.name}</Typography>
                                {ser?.service_notes ? 
                                  <Stack direction={'column'}>
                                    <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography> 
                                    <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' ,color: 'error.main'}}>{ser.service_notes}</Typography> 
                                  </Stack>
                                  : ''}
                              </TableCell>
                              <TableCell>${ser ? ser?.unit_cost?.toFixed(2) : 0}</TableCell>
                              <TableCell>{ser ? ser?.quantity?.toFixed(2) : 0}</TableCell>
                              <TableCell>${ser ? ser?.total_cost?.toFixed(2) : 0}</TableCell>
                            </TableRow>
                          )
                        })}

                        {openInvoice && additionalSelectedServices
                          ?.filter(servItem=>{
                            // if (details?.job_category_name != 'Time & Material' && servItem.labour_cost_service_id == 10) {
                            //   return false;
                            // }
                            return true;
                          })?.map((ser) => {
                            console.log('additionalSelectedServices--', ser);
                            return (
                              <TableRow sx={{
                                borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                              }}>
                                <TableCell colSpan={2}>
                                  <Typography variant='subtitle2' sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word' }}>{ser?.name}</Typography>
                                  {ser?.service_notes ? 
                                    <Stack direction={'column'}>
                                      <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography> 
                                      <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' ,color: 'error.main'}}>{ser.service_notes}</Typography> 
                                    </Stack>
                                    : ''}
                                </TableCell>
                                <TableCell>${ser ? ser?.unit_cost?.toFixed(2) : 0}</TableCell>
                                <TableCell>{ser ? ser?.quantity?.toFixed(2) : 0}</TableCell>
                                <TableCell>${ser ? ser?.total_cost?.toFixed(2) : 0}</TableCell>
                              </TableRow>
                            )
                          }
                        )}

                        {openInvoice && cartService?.map((ser) => {
                          console.log('cartService--', ser);
                          ser.sellingPrice = details?.project_category == 13 ? ser.unit_cost : ser.sellingPrice || ser.unit_cost
                          ser.originalMarkup = details?.project_category == 13 ? 0 :ser.originalMarkup || ser.product_markup
                          return (
                            <TableRow sx={{
                              borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                            }}>
                              <TableCell colSpan={2}>
                                <Typography variant='subtitle2' sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word' }}>{ser?.name}</Typography>
                                {ser?.service_notes ? 
                                  <Stack direction={'column'}>
                                    <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography> 
                                    <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' ,color: 'error.main'}}>{ser.service_notes}</Typography> 
                                  </Stack>
                                  : ''}
                              </TableCell>
                              <TableCell> ${((ser.sellingPrice + (ser.sellingPrice * ser.originalMarkup / 100)))?.toFixed(2)}</TableCell>
                              <TableCell>{ser ? ser?.qty?.toFixed(2) : 0}</TableCell>
                              <TableCell> ${(ser.qty * (ser.sellingPrice + (ser.sellingPrice * ser.originalMarkup / 100)))?.toFixed(2)}</TableCell>
                            </TableRow>
                          )
                        }
                        )}
                       
                      <RowResultStyle>
                        <TableCell colSpan={3} />
                        <TableCell align="right">
                          <Typography variant="overline">Product Total</Typography>
                        </TableCell>
                        <TableCell align="left" width={10}>
                          <Typography variant="overline">
                            ${invoice?.cust_product?.reduce((sum, val) => {
                              const {
                                product_retail_price = 0,material= 0, adjustment = 0, markAdjType,
                                product_total = 0,actual_retail_price,install_cost, locationQuantity = 1, quantity = 1,
                                services = []
                              } = val;

                              const labourService = services?.find(s => s.labour_cost_service_id === 10);
                              const labourTotal = (labourService?.service_original_cost || 0) * (labourService?.prQty || 0) * locationQuantity;
                              const basePrice = actual_retail_price !== 0 && actual_retail_price != null
                              ? actual_retail_price
                              : product_retail_price;
                              // let SPMA = (markAdjType === 2 || markAdjType === 3)
                              //   ? product_retail_price + Number(adjustment)
                              //   : product_retail_price + ((product_retail_price * Number(adjustment)) / 100);

                              // const effectiveTotal = markAdjType === 1
                              //   // ? product_total - labourTotal
                              //   // : (SPMA * (locationQuantity * quantity)) - labourTotal;
                              //   ? product_total
                              //     : (SPMA * (locationQuantity * quantity));
                              let SPMA = (markAdjType === 2 || markAdjType === 3)
                                  ? basePrice + Number(adjustment)
                                  : basePrice + ((basePrice * Number(adjustment)) / 100);
                              const effectiveTotal = markAdjType === 1 && material === 0
                              // ? product_total
                              ? (SPMA * (locationQuantity * quantity)) :
                              material === 1 ? (SPMA * locationQuantity)
                              : (SPMA * (locationQuantity * quantity));

                              return sum + effectiveTotal;
                            }, 0)?.toFixed(2)}
                        </Typography>
                        </TableCell>
                      </RowResultStyle>

                      {(labourInstallService?.length > 0 || 
                        additionalSelectedServices?.some(
                          x => x.labour_cost_service_id === 10 && (x.total_cost || 0) > 0
                        ) ||
                        invoice?.cust_product?.some(
                          val => parseFloat(val.install_cost || 0) > 0
                        )
                      ) &&
                      <RowResultStyle>
                        <TableCell colSpan={3} />
                        <TableCell align="right">
                          <Typography variant="overline">Install Total</Typography>
                        </TableCell>
                        <TableCell align="left" width={10}>
                          {/* <Typography variant="overline">
                              ${invoice?.cust_product?.reduce((sum, val) => {
                                const labourService = val?.services?.find(s => s.labour_cost_service_id === 10);
                                return sum + (labourService?.service_original_cost || 0) * (labourService?.prQty || 0) * (val?.locationQuantity || 1);
                              }, 0)?.toFixed(2)}
                          </Typography> */}
                          <Typography variant="overline">
                                  ${(
                                    // (invoice?.cust_product?.reduce((sum, val) => {
                                    //   const labourService = val?.services?.find(
                                    //     s => s.labour_cost_service_id === 10
                                    //   );
                                    //   return (
                                    //     sum +
                                    //     (labourService?.service_original_cost || 0) *
                                    //     (labourService?.prQty || 0) *
                                    //     (val?.locationQuantity || 1)
                                    //   );
                                    // }, 0) || 0) +
                                    (invoice?.cust_product?.reduce((sum, val) => {
                                    const installCost = parseFloat(val?.install_cost || 0);
                                    const locationQty = parseFloat(val?.locationQuantity || 1);
                                    const quantity = parseFloat(val?.quantity || 1);

                                    if (installCost) {
                                      return sum + installCost * locationQty * quantity;
                                    }
                                    return sum;
                                  }, 0) || 0) +
                                    (additionalSelectedServices?.reduce(
                                      (s, x) =>
                                        x.labour_cost_service_id === 10 ? s + (x.total_cost || 0) : s,
                                      0
                                    ) || 0)
                                  ).toFixed(2)}
                                </Typography>
                        </TableCell>
                      </RowResultStyle>
                      }

                      <RowResultStyle>
                        <TableCell colSpan={3} />
                        <TableCell align="right">
                          {/* <Typography variant="overline">{details?.job_category_name != 'Service only' ? 'Additional Labor Cost' : 'Labor Cost'}</Typography> */}
                          {/* <Typography variant="overline">{(details?.job_category_name != 'Service only' && details?.job_category_name != 'Time & Material') ? 'Additional Services' : 'Services'}</Typography> */}
                          <Typography variant="overline">{(details?.job_category_name != 'Service only') ? 'Additional Services Total' : 'Services Total'}</Typography>
                        </TableCell>
                        <TableCell align="left" width={10}>
                          {/* <Typography variant="overline">${details ? details?.labour_cost?.toFixed(2) : 0.00}</Typography> */}
                          <Typography variant="overline">
                            ${(
                              (invoiceSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                              // (additionalSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                              (additionalSelectedServices?.reduce(
                                    (s, x) =>
                                      x.labour_cost_service_id === 10 
                                        ? s
                                        : s + (x.total_cost || 0),
                                    0
                                ) || 0) +
                              (cartService?.reduce((s, x) => {
                                const sp = x.sellingPrice || x.unit_cost || 0;
                                const markup = x.originalMarkup || x.product_markup || 0;
                                const final = sp + (sp * markup / 100);
                                return s + ((x.qty || 0) * final);
                              }, 0) || 0)
                            )?.toFixed(2)}
                          </Typography>
                        </TableCell>
                      </RowResultStyle>

                      <RowResultStyle>
                        <TableCell colSpan={3} />
                        <TableCell align="right">
                          <Typography variant="overline">Subtotal</Typography>
                        </TableCell>
                        <TableCell align="left" width={10}>
                          <Typography variant="overline">
                            ${(
                              (subTotal || 0) +
                              (invoiceSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                              (additionalSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                              (cartService?.reduce((s, x) => {
                                const sp = x.sellingPrice || x.unit_cost || 0;
                                const markup = x.originalMarkup || x.product_markup || 0;
                                const final = sp + (sp * markup / 100);
                                return s + ((x.qty || 0) * final);
                              }, 0) || 0)
                            //   (invoice?.cust_product?.reduce((sum, val) => {
                            //   const labourService = val?.services?.find(
                            //     s => s.labour_cost_service_id === 10
                            //   );
                            //   return (
                            //     sum +
                            //     (labourService?.service_original_cost || 0) *
                            //       (labourService?.prQty || 0) *
                            //       (val?.locationQuantity || 1)
                            //   )
                            // }, 0) || 0)
                            )?.toFixed(2)}
                          </Typography>
                        </TableCell>
                      </RowResultStyle>

                      {invoice?.extra_discount > 0 && (
                      <RowResultStyle>
                        <TableCell colSpan={3} />
                        <TableCell align="right">
                          <Typography variant="overline">Discount</Typography>
                        </TableCell>
                        <TableCell align="left" width={10}>
                          <Typography variant="overline">${invoice ? invoice?.extra_discount?.toFixed(2) : 0.00}</Typography>
                        </TableCell>
                      </RowResultStyle>
                      )}
                      
                      {invoice?.tax_amount > 0 && (
                      <RowResultStyle>
                        <TableCell colSpan={3} />
                        <TableCell align="right">
                          <Typography variant="overline">Tax</Typography>
                        </TableCell>
                        <TableCell align="left" width={10}>
                          <Typography variant="overline">${invoice ? invoice?.tax_amount?.toFixed(2) : 0.00}</Typography>
                        </TableCell>
                      </RowResultStyle>
                      )}

                      <RowResultStyle>
                        <TableCell colSpan={3} />
                        <TableCell align="right">
                          <Typography variant="subtitle1" sx={{ color: invoice?.total < 0 ? 'red' : 'inherit' }}>Total</Typography>
                        </TableCell>
                        <TableCell align="left" width={10}>
                          <Typography variant="subtitle1" sx={{ color: invoice?.total < 0 ? 'red' : 'inherit' }}>${invoice?.total ? invoice?.total?.toFixed(2) : 0.00}</Typography>
                        </TableCell>
                      </RowResultStyle>
                                           
                      {invoice?.project_category == 13 ? '' : 
                        <>
                          {(userType !=3 && details?.job_category_name != 'Time & Material' && details?.job_category_name != 'No Charge') ?
                          (details?.billing_type ? (
                            <RowResultStyle>
                              <TableCell colSpan={3} />
                              <TableCell align="right" sx={{display:"flex", alignItems: "center",gap: 1}}>
                                <Typography fontSize={"small"} variant="caption"  sx={{ color:  'inherit' }}> (only viewable for admin)</Typography>
                                <Typography variant="subtitle1"  sx={{ color:  '#12b2e3' }}>Billing Type</Typography>
                              </TableCell>
                              <TableCell align="left" width={10}>
                                <Typography variant="subtitle1"  sx={{ color:  '#12b2e3' }}>{details?.billing_type ? `${details?.billing_type} %` :"Nil"}</Typography>
                              </TableCell>
                            </RowResultStyle>
                          ) : '')
                          :""}
                        {(invoice?.total && details?.billing_type) ?
                          <RowResultStyle>
                            <TableCell colSpan={3} />
                            <TableCell align="right">
                              <Typography variant="subtitle1"  sx={{ color:  'yellow' }}>Minimum Payable Amount</Typography>
                            </TableCell>
                            <TableCell align="left" width={10}>
                              <Typography variant="subtitle1"  sx={{ color:  'yellow' }}>${(invoice?.total && details?.billing_type)? parseFloat((invoice?.total *details?.billing_type) / 100).toFixed(2) :0.00}</Typography>
                            </TableCell>
                          </RowResultStyle>
                          :""
                          }
                          {details?.totalPaidAmount > 0 && (
                          <RowResultStyle>
                            <TableCell colSpan={3} />
                            <TableCell align="right">
                              <Typography variant="subtitle1"  sx={{ color: details?.totalPaidAmount < 0 ? 'red' : 'green' }}>Amount Paid</Typography>
                            </TableCell>
                            <TableCell align="left" width={10}>
                              <Typography variant="subtitle1"  sx={{ color: details?.totalPaidAmount < 0 ? 'red' : 'green' }}>${details?.totalPaidAmount ? parseFloat(details?.totalPaidAmount)?.toFixed(2) : 0.00}</Typography>
                            </TableCell>
                          </RowResultStyle>
                          )}
                          {details?.totalPaidAmount > 0 && (
                          <RowResultStyle>
                            <TableCell colSpan={3} />
                            <TableCell align="right">
                              <Typography variant="subtitle1"  sx={{ color: details?.dueAmount <= 0 ? 'inherit' : 'red' }}>Balance Due</Typography>
                            </TableCell>
                            <TableCell align="left" width={10}>
                              <Typography variant="subtitle1"  sx={{ color: details?.dueAmount <= 0 ? 'inherit' : 'red' }}>${details?.dueAmount ? parseFloat(details?.dueAmount <= 0 ? 0.00 : details?.dueAmount)?.toFixed(2) : 0.00}</Typography>
                            </TableCell>
                          </RowResultStyle>
                          )}
                        </>
                      }
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {(details?.allInstallationCompleted == 1 && !empty(invoice?.note_data)) ? (
                    <>
                      <Typography variant="h6" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>Installation Notes</Typography>
                      <Stack spacing={2}>
                        {invoice?.note_data?.map((val, index) => {
                          const { id, authorized_by, note, timestamp } = val;
                          return (
                            <Paper
                              key={id}
                              elevation={3}
                              sx={{ padding: 2, borderRadius: 2, backgroundColor: 'rgba(145, 158, 171, 0.16)', color: '#ffffff' }}
                            >
                              <Grid container spacing={2}>
                                <Grid item xs={12} sm={8}>
                                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                                    {note}
                                  </Typography>
                                </Grid>
                                <Grid item xs={12} sm={4} sx={{ textAlign: { xs: 'left', sm: 'right' } }}>
                                  {/* <Typography variant="body2" sx={{ color: 'primary.light' }}> */}
                                  <Typography variant="body2" sx={{ color: theme.palette.primary.main }}>
                                    Added By: {authorized_by}
                                  </Typography>
                                  <Typography variant="body2" sx={{ color: theme.palette.primary.main }}>
                                    {moment.unix(timestamp).format('MM-DD-YYYY hh:mm:ss A')}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Paper>
                          );
                        })}
                      </Stack>
                    </>
                  ) : ''}
                  </>
                }
                {((userType == 3 ||userType !== 1 ||  (userType == 1 && details?.status !==2)) && (((details?.allInstallationCompleted == 1) && empty(details?.installation_acceptance)) || !(details?.status == 4 || details?.status == 3)) && ((isClient || userType == 3) ? details?.client_approve == 1 : true)) && details?.project_type && details?.status !==6 &&
                  <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    {(requestAccept) ? 
                      <Stack alignItems='center' justifyContent='center'>
                        <CircularProgress color="primary" variant="indeterminate" />
                      </Stack> 
                      : 
                      <>
                        {confirmInvoice ? 
                          <Stack alignItems='center' justifyContent='center'>
                            <CircularProgress color="primary" variant="indeterminate" />
                          </Stack>
                        :
                          <Button type="submit" variant="contained"
                            onClick={() =>{
                              let permission =!explodedPermissions?.some((permission) => ['Approve Proofs(Final Client invoice approval)'].includes(permission))
                           
                            if(details?.status==4 && user.added_by_client ==1 && permission ){
                             return  enqueueSnackbar('Access Denied: You do not have sufficient permissions', { variant: 'error' });
                             
                            }else{

                              setConfirmInvoice(true)}
                            }
                            }
                          // onClick={()=>handleAcceptorRejectInvoice(1)}
                          >
                            Approve
                          </Button>}
                          {invoiceReject ? 
                          <Stack alignItems='center' justifyContent='center'>
                            <CircularProgress color="primary" variant="indeterminate" />
                          </Stack>
                        :
                          <>
                            {(!empty(details?.installationStatus) || details?.isReview ==2 ) ? '' :
                            <Button size="small" variant="outlined"
                              onClick={() => setRejectInvoice(true)}
                              //  onClick={()=>handleAcceptorRejectInvoice(2)}
                              sx={{ color: theme.palette.error.main }} >
                              Reject
                            </Button>}
                          </>
                        }
                      </>
                    }
                  </Box>}
                {/* {(userType ==3&&details?.status!=4&&details?.onboard_complete==0) && 
                <Box sx={{ mt: 3,  display: 'flex', justifyContent: 'flex-end',gap:1 }}>
                  <Button type="submit" variant="contained" 
                   onClick={()=> navigate(PATH_DASHBOARD.official.process,{state:{requestId:id}})}
                  // onClick={()=>handleAcceptorRejectInvoice(1)}
                   >                 
                   Proceed to Workflow
                  </Button>
                 
                </Box>} */}
              </Scrollbar>

            </Grid>
          </Modal>
          {/* delete popup */}
          <ConfirmationPopup
            open={openDelete}
            handleClick={handleDeleteRFQ}
            handleClose={() => { setOpenDelete(!openDelete), setIsOpen(false) }}
            message={'You want to delete this order '}
            loading={loadingDelete}
          />
          <ConfirmationPopup
            open={openDialog}
            handleClick={handleConfirmSubmit}
            handleClose={handleCloseDialog}
            message={'you want to submit this order? The changes will be applied to the job upon client acceptance.'}
          />

          <ConfirmationPopup
            open={openConvertToRFQ}
            loading={isLoading} // ✅ only passed here
            handleClick={async () => {
              setIsLoading(true);
              await handleConvertToJob();
              setIsLoading(false);
            }}
            handleClose={() => { setOpenConvertToRFQ(false) }}
            message={`You want to convert this Sales Order to ${(details?.noServiceNoTask === 1 &&invoice?.cust_product?.length === 0 
                              && invoice?.jobcost_service?.every(service => service?.makeAsTask === 0)
                               ) ? "Invoicing" : "Production"}`}
          />

          <ConfirmationPopup
            open={openDuplicate}
            loading={isLoading} // ✅ only passed here
            handleClick={async () => {
              setIsLoading(true);
              await handleDuplicateSalesOrder();
              setIsLoading(false);
            }}
            handleClose={() => { setOpenDuplicate(false) }}
            message={'You want to duplicate this Sales Order ?'}
          />

          <ConfirmationPopup
            open={openDuplicate}
            loading={isLoading} // ✅ only passed here
            handleClick={async () => {
              setIsLoading(true);
              await handleDuplicateSalesOrder();
              setIsLoading(false);
            }}
            handleClose={() => { setOpenDuplicate(false) }}
            message={'You want to duplicate this Sales Order ?'}
          />

          {/* Accept request invoice */}
          <ConfirmationPopup
            open={confirmInvoice}
            loading={isLoadingInvoice}
            handleClick={async () => {
              setIsLoadingInvoice(true);
               if(details?.isReview ==2) {
                 await handleAcceptorRejectInvoice(3,true);
               }else if (details?.allInstallationCompleted === 1) {
                await handleAcceptorRejectInvoice(3);
              } else {
                await handleAcceptorRejectInvoice(1);
              }

              setIsLoadingInvoice(false);
            }}
            handleClose={() => setConfirmInvoice(false)}
            // message={'You want to Approve this invoice'} if the message not needed any change in "Open" status sales order then uncomment this and comment below one
            message={details?.status === 2 ? 'You want to Approve this ?' : 'You want to Approve this invoice'}
          />
          {/* reject request invoice */}
          {/* <ConfirmationPopup 
        open={invoiceReject}
        handleClick={()=>handleAcceptorRejectInvoice(2)}
         handleClose={()=>setRejectInvoice(false)}
         message={'You want to reject this invoice '}
        /> */}
          {/* Reopen rejected request  */}
          <ConfirmationPopup
            open={reOpen}
            handleClick={() => handleReopeningRequest()}
            handleClose={() => setReopen(false)}
            message={'You want to reopen this order '}
          />
          {/* Preview Modal */}
          {openPreview && (
            <Modal
              width={900}
              open={openPreview}
              handleClose={() => {
                setOpenPreview(false);
              }}
              modalTitle={'Preview'}
            >
              <ReactToPrint
                trigger={() => <Button variant="contained" color="primary">Print A3</Button>}

                content={() => printableContentRef.current}
                pageStyle={`@media print {
    .print-black {
      color: black !important;
      background:white !important
    }
    table {
      width: 100%;
      border-collapse: collapse;
      margin-bottom: 10px;
    }
    * {
      color: black !important;
      background-color: white !important;
    }
    .MuiTableCell-root {
      color: black !important;
    }
    .MuiInputBase-input {
      color: black !important;
    }
    .no-scrollbar::-webkit-scrollbar {
      display: none;
    }
    .no-scrollbar {
      -ms-overflow-style: none;  /* IE and Edge */
      scrollbar-width: none;  /* Firefox */
    }
      .enable-for-print {
      pointer-events: auto;
      color: black !important;
    }
      .print-black .enable-for-print input[type='number'],
.print-black .enable-for-print input[type='text'] {
  color: black !important; /* Set the text color to black for input fields */
}
  .css-wr96yv-MuiInputBase-input-MuiOutlinedInput-input {
    
  color: black !important;
  opacity: 1;
    -webkit-text-fill-color:black !important;
  }
    input[type=number]{
    color:black !important}
  }`}
              />
              <div ref={printableContentRef} className="print-black">
                <Grid container sx={{ justifyContent: 'center', }} spacing={3} >
                  <Grid item xs={12} md={12}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                      }}
                      spacing={2}
                    >
                      <Stack
                        direction={{ xs: 'column', md: 'row' }}
                        display="flex"
                        justifyContent="space-between"
                      >
                        <Typography variant="subtitle2">
                          <span style={{ color: theme.palette.primary.darker }}>Nameeeee: </span>
                          {previewData?.name}
                        </Typography>

                        <Typography variant="subtitle2">
                          <span style={{ color: theme.palette.primary.darker }}>Use custom welcome message: </span>
                          {previewData.welcome_message == null ? 'No' : previewData.welcome_message == false ? 'No' : 'Yes'}
                        </Typography>
                      </Stack>
                      <Stack>
                        <Typography variant="subtitle2" style={{ color: theme.palette.primary.darker }}>
                          Description:
                        </Typography>
                        <Typography variant="subtitle2" style={{ overflowWrap: 'break-word', wordWrap: 'break-word', wordBreak: 'break-word' }}>
                          {previewData?.description}
                        </Typography>
                      </Stack>
                      <Stack
                        direction={{ xs: 'column', md: 'row' }}
                        display="flex"
                        justifyContent="space-between"
                      >
                        {/* <Typography variant="subtitle2">
                      <span style={{ color:theme.palette.primary.darker,
                        overflowWrap: 'break-word', wordWrap: 'break-word',
                         wordBreak: 'break-word' }}>Skills or services required:</span> <br/>
                          <List>
                           {previewData?.skills?.map((val, index) => (
                           <ListItem sx={{ listStyleType: 'disc', paddingLeft: '20px' }} key={index}>
                           <ListItemText primary={val.name} />
                           </ListItem>
                                   ))}
                                </List>
                    </Typography> */}
                        {/* <Typography variant="subtitle2">
                      <span style={{ color:theme.palette.primary.darker }}>Workflows: </span> <br/>                                           
                      <List>
                           {previewData?.workflow?.map((val, index) => (
                           <ListItem sx={{ listStyleType: 'dics', paddingLeft: '20px' }} key={index}>
                           <ListItemText primary={val.name} />
                           </ListItem>
                                   ))}
                                </List>
                    </Typography> */}
                      </Stack>
                      <Stack
                        direction={{ xs: 'column', md: 'row' }}
                        display="flex"
                        justifyContent="space-between"
                      >
                        <Typography variant="subtitle2">
                          <span style={{ color: theme.palette.primary?.darker }}>Job Class: </span>
                          {previewData?.project_type?.name}
                        </Typography>
                        {/* <Typography variant="subtitle2">
                          <span style={{ color: theme.palette.primary.darker, }}>Markup Type: </span>
                          {previewData?.markup_type?.name}
                        </Typography> */}
                      </Stack>
                      <Stack
                        direction={{ xs: 'column', md: 'row' }}
                        display="flex"
                        justifyContent="space-between"
                      >
                        <Typography variant="subtitle2">
                          <span style={{ color: theme.palette.primary?.darker, }}>Job Type: </span>
                          {previewData?.project_category?.name}
                        </Typography>
                        {previewData?.project_category?.id===13 &&<Typography variant="subtitle2">
                          <span style={{ color: theme.palette.primary?.darker, }}>No Charge Type: </span>
                          {previewData?.no_charge_type?.name}
                        </Typography>}
                        {previewData?.project_category?.id===14 &&<Typography variant="subtitle2">
                          <span style={{ color: theme.palette.primary?.darker, }}>Routes: </span>
                          {previewData?.map_service?.name}
                        </Typography>}
                      </Stack>

                      <Stack
                        direction={{ xs: 'column', md: 'row' }}
                        display="flex"
                        justifyContent="space-between"
                      >
                        <Typography variant="subtitle2">
                          <span style={{ color: theme.palette.primary.darker }}>Client: </span>
                          {previewData?.clients?.name}
                        </Typography>
                        <Typography variant="subtitle2">
                          <span style={{ color: theme.palette.primary.darker }}>Project: </span>
                          {previewData?.community?.name}
                        </Typography>
                      </Stack>

                      <Stack
                        direction={{ xs: 'column', md: 'row' }}
                        display="flex"
                        justifyContent="space-between"
                      >
                        <Typography variant="subtitle2">
                          <span style={{ color: theme.palette.primary.darker }}>Start Date: </span>
                          {moment.unix(previewData.start).format("MM/DD/YYYY")}
                        </Typography>
                        <Typography variant="subtitle2">
                          <span style={{ color: theme.palette.primary.darker }}>installation Date: </span>
                          {moment.unix(previewData.end).format("MM/DD/YYYY")}
                        </Typography>
                      </Stack>
                      {/* {(previewData?.project_category?.name == 'Service only' || previewData?.project_category?.name == 'Time & Material') ? null : <> */}
                      {/* || previewData?.project_category?.name == 'Time & Material' */}
                      {(previewData?.project_category?.name == 'Service only') ? null : <>
                      <Typography>PRODUCTS</Typography>
                      <Scrollbar>
                        <TableContainer sx={{ minWidth: 500 }}>
                          <Table>
                            <TableHead>
                              <TableRow>
                                {/* {VALUEPreview?.map((val) => (
                                  <TableCell>{val.value}</TableCell>
                                ))} */}
                                {previewData?.project_category?.name == 'Time & Material' ?
                                VALUE_TIME_Preview?.map((val) => (
                                  val.id === 14 ? (
                                    <Tooltip key={val.id} title="Selling Price With Marketing Adjustment">
                                      <TableCell>{val.value}</TableCell>
                                    </Tooltip>) :
                                  <TableCell>{val.value}</TableCell>
                                )) :
                                VALUEPreview?.map((val) => (
                                  val.id === 14 ? (
                                    <Tooltip key={val.id} title="Selling Price With Marketing Adjustment">
                                      <TableCell>{val.value}</TableCell>
                                    </Tooltip>) :
                                  <TableCell>{val.value}</TableCell>
                                ))}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {selectedProducts?.sort((a, b) => a.indexId - b.indexId)?.map((data, index) => {
                                const quantityFieldName = `quantity_${data.product_id || data.id}`;
                                const discountFieldName = `discount_${data.product_id || data.id}`;
                                let unitName = UNITS?.filter((item) => item?.id == data?.unit)
                                unitName = unitName[0]?.name
                                let shortUnitName = ''
                                if (unitName == 'Square feet') {
                                  shortUnitName = 'Sq ft'
                                } else if (unitName == 'Lineal feet') {
                                  shortUnitName = 'Lin ft'
                                } else if (unitName == 'Square Inches') {
                                  shortUnitName = 'Sq Inches'
                                } else if (unitName == 'Unit') {
                                  shortUnitName = 'Unit'
                                }
                                
                                // Apply no charge logic similar to OfficialRequestAdd.js
                                if(noCharge){
                                  // For no charge products, calculate retail_price based on expected_cost + install_cost
                                  const expectedCost = parseFloat(data?.expected_cost) || 0
                                  const installCost = parseFloat(data?.install_cost) || 0
                                  
                                  // If install_cost is available, add it to expected_cost
                                  const calculatedRetailPrice = installCost > 0 ? expectedCost + installCost : expectedCost
                                  
                                  data['retail_price'] = calculatedRetailPrice
                                  data['actual_retail_price'] = expectedCost
                                  data['expected_cost'] = expectedCost
                                }
                                
                                const dataPrice = data.product_price || data.price
                                
                                const dataWholesalePrice = data.product_price || data.price
                                const dataQuantity = values[quantityFieldName]
                                const dataDiscount = data.discount ? data.discount : values[discountFieldName]
                                const dataretailPrice = data.product_retail_price || data.retail_price
                                const dataActualPrice = data.actual_retail_price || data.retail_price
                                console.log('dataPrice---------2222', dataPrice)
                                console.log('dataWholesalePrice---------2222', dataWholesalePrice)
                                console.log('dataretailPrice---------2222', dataretailPrice)
                                console.log('dataActualPrice---------2222', dataActualPrice)
                                // const markup = ((dataretailPrice - dataPrice) / dataPrice) * 100;
                                const rowTotal = calculateTotal(markupType == 1 ? dataPrice : (markupType == 2 ? (data.install_cost && parseFloat(data.install_cost) > 0 ? dataretailPrice : dataActualPrice) : 0), dataQuantity, dataDiscount, data.quantity, data.locationQuantity, Number(data?.adjustment),data.markAdjType);
                                const invoiceAmount = parseFloat(data?.expected_material_cost) + parseFloat(data?.expected_total_service_cost?.toFixed(2))
                                let markup = markupType ? (invoiceAmount / rowTotal) : null
                                markup = markup ? Number(markup) : 0
                                // data['markup'] = Math.round(markup)
                                console.log("###########Discount", data);
                                
                               
                                return (
                                  <>
                                  <TableRow key={index}>
                                    <TableCell>#{data.indexId}</TableCell>
                                    {/* <TableCell>{data.product_name || data.name}</TableCell> */}
                                    <TableCell width={'25%'} sx={{ flexWrap: 'wrap', overflow: 'hidden' }}>
                                      <Typography variant='body2' sx={{ fontWeight: 'bold', mb: 1, wordBreak: 'break-word', overflowWrap: 'break-word' }}>{data?.product_name || data?.name}</Typography>
                                      {data?.product_notes ? 
                                      <Stack direction={'column'}>
                                        <Typography variant='body2' sx={{textDecoration: 'underline',color: 'error.main'}}>Note : </Typography> 
                                        <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' ,color: 'error.main'}}>{data?.product_notes}</Typography> 
                                      </Stack>
                                      : ''}
                                    </TableCell>
                                    {/* <TableCell>{invoiceAmount}</TableCell> */}

                                    {previewData?.project_category?.name == 'Time & Material' ? 
                                    <TableCell>{dataActualPrice || dataPrice || 0}</TableCell>
                                  : <>
                                    <TableCell>{(hasMarkupPermission && markupType == 2) ? dataActualPrice : null}</TableCell>
                                    <TableCell>{(hasMarkupPermission && markupType == 1) ? dataPrice : null}</TableCell>
                                  </>}
                                  {/* <TableCell>{hasMarkupPermission ? (data.SPMA || null) : null}</TableCell> */}
                                  {/* {previewData?.project_category?.name == 'Time & Material' ? null :  */}
                                    {/* // <TableCell> */}
                                      {/* {hasMarkupPermission ? (data.markup ? data.markup?.toFixed(2) : 0) : null} */}
                                      {/* previos */}
                                      {/* {(hasMarkupPermission && markupType == 1) ? data.wholesaleMarkup?.toFixed(2)
                                        : (hasMarkupPermission && markupType == 2) ? data.retailMarkup?.toFixed(2)
                                          : null}
                                    </TableCell>} */}
                                    {/* <TableCell>{shortUnitName}</TableCell> */}
                                    <TableCell>
                                      {/* <TextField required
                                        fullWidth
                                        type='number'
                                        
                                        sx={{ width: 85 }}
                                       
                                        label={shortUnitName}
                                        value={Number(data.quantity)}
                                        defaultValue={1}
                                      /> */}
                                      {Number(data.quantity)} {shortUnitName}
                                    </TableCell>
                                    <TableCell>
                                      {/* <TextField required
                                        fullWidth
                                        type='number'
                                         
                                       
                                      
                                        sx={{ width: 85 }}
                                        label={'Qty'}
                                        value={Number(data.locationQuantity)}
                                        defaultValue={1}
                                      /> */}
                                      {Number(data.locationQuantity)}
                                    </TableCell>
                                    {/* <TableCell>{data.id}</TableCell> */}
                                    {/* <TableCell align="center">
                                      {Number(data.discount)?.toFixed(2)}
                                      {data.markAdjType === 3 ? "¢" : data.markAdjType === 2 ? "$" : "%"} {data?.adjustment ? Number(data?.adjustment)?.toFixed(2) : 0}
                                    </TableCell> */}
                                      <TableCell >
                                        {data?.install_cost && parseFloat(data?.install_cost) > 0 ?
                                        (
                                          parseFloat(data?.actual_retail_price || 0) *
                                          (data?.locationQuantity || 1)
                                        ).toFixed(2):
                                        (
                                          parseFloat(data?.actual_retail_price || 0) *
                                          (data?.locationQuantity || 1)
                                        ).toFixed(2)
                                      }
                                      
                                      </TableCell>
                                    <TableCell>
                                      {data?.install_cost && parseFloat(data?.install_cost) > 0 ? '' :
                                      rowTotal?.toFixed(2)
                                      }
                                    </TableCell>
                                  </TableRow>
                                    {
                                      data?.install_cost && parseFloat(data?.install_cost) > 0 ?
                                        <TableRow key={`summary-${data.indexId}`}>
                                          <TableCell>#{data?.indexId}</TableCell>
                                          <TableCell>Install Price</TableCell>
                                          <TableCell >
                                            {data?.install_cost}
                                          </TableCell>
                                          <TableCell align='center'></TableCell>
                                          <TableCell align='center'></TableCell>
                                          <TableCell align='center'></TableCell>
                                          <TableCell >
                                            {(
                                              parseFloat(data?.install_cost || 0) *
                                              (data?.locationQuantity || 1)
                                            ).toFixed(2)}
                                          </TableCell>
                                          <TableCell>
                                            {rowTotal?.toFixed(2)}
                                          </TableCell>
                                        </TableRow>
                                        :
                                        ''
                                    }
                                <TableRow>
                                      <TableCell colSpan={15} sx={{ padding: 0 }}>
                                        <Divider />
                                      </TableCell>
                                    </TableRow>
                                </>
                                );
                              })}

                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Scrollbar>
                      </>}
                      <LabelStyle>SERVICES</LabelStyle>
                      <Scrollbar>
                        <TableContainer sx={{ minWidth: 500 }}>
                          <Table>
                            <TableHead>
                              <TableRow>
                                {VALUE_SERVICES?.map((val) => (
                                  (((previewData?.project_category?.name == 'Service only') && val.id === 0) || (val.id === 6)) ? null : (
                                    <TableCell>{val.value}</TableCell>
                                  )
                                ))}
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {/* {selectedServices?.map((data, index) => {
                                const dataCost = data.unit_cost || data.total_cost
                                let originalMarkup = data.originalMarkup || 0
                                let markup = data.markup || 0
                                const total = dataCost * data.quantity
                                data['total'] = total?.toFixed(2)
                                console.log("###########data total", data);
                                const newQty = (data.prQty * (data.qtyData || 1) * data.locationQuantity)?.toFixed(2)
                                const quantityDifference = data.quantity - newQty;
                                data['quantityDifference'] = quantityDifference
                                return (
                                  <>
                                    <TableRow key={index}>
                                      <TableCell>#{data?.productIndex}</TableCell>
                                      <TableCell>
                                        <Typography variant="subtitle2" sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                                          {data.name}
                                        </Typography>
                                        {data?.service_notes ? 
                                          <Stack direction={'column'}>
                                            <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography> 
                                            <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' ,color: 'error.main'}}>{data.service_notes}</Typography> 
                                          </Stack>
                                          : ''}
                                      </TableCell>
                                      <TableCell>{originalMarkup?.toFixed(2)}</TableCell>
                                      <TableCell>{data.cost}</TableCell>
                                      <TableCell>{dataCost}</TableCell>
                                      <TableCell>{data.quantity}</TableCell>
                                      <TableCell>{(data.cost*quantityDifference?.toFixed(2))?.toFixed(2)}</TableCell>
                                      <TableCell>{(data.unit_cost * quantityDifference?.toFixed(2))?.toFixed(2)}</TableCell>
                                      <TableCell>{data.total}</TableCell>
                                      <TableCell></TableCell>
                                      <TableCell align='right'>
                                      </TableCell>
                                    </TableRow>
                                  </>
                                );
                              })} */}
                              {additionalSelectedServices?.map((data, index) => {
                                const dataCost = data.unit_cost || data.total_cost
                                const total = dataCost * (data?.quantity || 1)
                                data['total'] = total ? total?.toFixed(2) : 0.00
                                let originalMarkup = data.originalMarkup || 0
                                console.log("###########data total", data);
                                const quantityDifference = Number(data.quantity)
                                data['quantityDifference'] = quantityDifference
                                return (
                                  <TableRow key={data.id}>
                                    {(previewData?.project_category?.name == 'Service only' || previewData?.project_category?.name == 'Time & Material') ? <TableCell></TableCell> : <TableCell></TableCell>}
                                    <TableCell>
                                      <Typography variant="subtitle2" sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                                        {data.name}
                                      </Typography>
                                      {data?.service_notes ? 
                                        <Stack direction={'column'}>
                                          <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography> 
                                          <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' ,color: 'error.main'}}>{data.service_notes}</Typography> 
                                        </Stack>
                                        : ''}
                                    </TableCell>
                                    <TableCell></TableCell>
                                    <TableCell>{originalMarkup?.toFixed(2)}</TableCell>
                                    <TableCell>{data.cost}</TableCell>
                                    <TableCell>{data.unit_cost || data.total_cost}</TableCell>
                                    <TableCell>{previewData?.project_category?.name == 'Time & Material' ? 0 : data?.quantity || 1}</TableCell>
                                    <TableCell>{(data.cost*quantityDifference?.toFixed(2))?.toFixed(2)}</TableCell>
                                    <TableCell>{data.total}</TableCell>
                                    <TableCell>{data.total}</TableCell>
                                  </TableRow>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Scrollbar>
                      
                      <Divider />
                      { (cart?.length > 0 || cartService?.length > 0 ) ? <>
                      <Typography>Proposals</Typography>
                      <Scrollbar>
                        <TableContainer sx={{ minWidth: 500}}>
                        {/* <TableContainer sx={{ minWidth: 500, whiteSpace: 'nowrap' }}> */}
                          <Table>
                            <TableHead>
                              <TableRow>

                                {VALUE_RFP_Product?.map((val) => (

                                  <TableCell key={val.id}>{val.value}</TableCell>

                                ))}
                              </TableRow>
                            </TableHead>
                            <TableBody >
                              {cart?.map((data, index) => {
                                let unitName = UNITS?.filter((item) => item?.id == data?.unit)
                                unitName = unitName[0]?.name
                                let shortUnitName = ''
                                if (unitName == 'Square feet') {
                                  shortUnitName = 'Sq ft'
                                } else if (unitName == 'Lineal feet') {
                                  shortUnitName = 'Lin ft'
                                } else if (unitName == 'Square Inches') {
                                  shortUnitName = 'Sq Inches'
                                } else if (unitName == 'Unit') {
                                  shortUnitName = 'Unit'
                                }
                                // let markup = markupType ? markupType === 1 ? data.WholesaleMarkup : data.RetailMarkup : 0
                                let markup = parseFloat(Number(data?.markup)) || 0
                                return (
                                  <TableRow key={index}>
                                    <TableCell>{data.name || data.product_name}</TableCell>
                                    {/* <TableCell>{invoiceAmount}</TableCell> */}
                                    <TableCell>
                                      {markup?.toFixed(2) || 0.00}
                                    </TableCell>
                                    <TableCell>
                                      {data.product_price?.toFixed(2) || 0}
                                    </TableCell>
                                    <TableCell>
                                      {(data.product_price + (data.product_price * markup / 100)).toFixed(2) || 0.00}
                                    </TableCell>
                                    <TableCell>
                                      {data.quantity} {shortUnitName}
                                    </TableCell>
                                    <TableCell>
                                      {data.location_quantity}
                                    </TableCell>
                                    {/* <TableCell>
                                            {(data.product_price * data.quantity * data.location_quantity)?.toFixed(2)||0}
                                    </TableCell> */}
                                    <TableCell>
                                      {(data.location_quantity * data.quantity * ((data.product_price + (data.product_price * markup / 100)).toFixed(2) || 0)).toFixed(2)}
                                    </TableCell>
                                   
                                  </TableRow>
                                );
                              })}

                            </TableBody>
                            {cartService?.length > 0 ? <h6>Services</h6> : null}
                            <TableBody>
                              {cartService?.map((data, index) => {


                                return (
                                  <>
                                    <TableRow key={data.id}>
                                      <TableCell>
                                        <Typography variant="subtitle2" sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                                          {data.name || data.product_name}
                                        </Typography>
                                        {data?.service_notes ? 
                                          <Stack direction={'column'}>
                                            <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography> 
                                            <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' ,color: 'error.main'}}>{data.service_notes}</Typography> 
                                          </Stack>
                                          : ''}
                                      </TableCell>
                                      {/* <TableCell>
                                            <IconButton onClick={() => handleOpenServiceNote(data.indexId, data.service_notes)}>
                                              <NoteAdd
                                                sx={{
                                                  color: (!data?.service_notes || data?.service_notes === '') ? '' : theme.palette.primary.main,
                                                }}
                                              />
                                            </IconButton>
                                          </TableCell> */}
                                      {/* <TableCell>{invoiceAmount}</TableCell> */}
                                      <TableCell>
                                        {data.originalMarkup?.toFixed(2)}
                                      </TableCell>
                                      <TableCell>
                                        {data.sellingPrice?.toFixed(2)}
                                      </TableCell>
                                      <TableCell>
                                        {((data.sellingPrice + (data.sellingPrice * data.originalMarkup / 100)))?.toFixed(2)}
                                      </TableCell>
                                      <TableCell>
                                        {data.qty} Hours
                                      </TableCell>
                                      <TableCell>-</TableCell>
                                      {/* <TableCell>
                                            {(data.qty*data.sellingPrice).toFixed(2)||0}
                                      </TableCell> */}
                                      <TableCell>
                                        {(data.qty * (data.sellingPrice + (data.sellingPrice * data.originalMarkup / 100)))?.toFixed(2)}
                                      </TableCell>
                                    
                                    </TableRow>

                                  </>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Scrollbar>
                      </> : null}
                      {selectedMaterials?.length > 0 ? <>
                      <Typography>MATERIALS</Typography>
                      <Scrollbar>
                            <TableContainer sx={{ minWidth: 500 }}>
                              <Table>
                                <TableHead>
                                  <TableRow>
                                    {VALUE_MATERIAL?.map((val) => (
                                      val.id === 3 ? (
                                        <Tooltip key={val.id} title="Unit Price + ((Unit Price * Markup)/100)">
                                          <TableCell key={val.id}>{val.value}</TableCell>
                                        </Tooltip>
                                      ) : val.id === 5 ? (
                                        <Tooltip key={val.id} title="Unit Price * Quantity">
                                          <TableCell key={val.id}>{val.value}</TableCell>
                                        </Tooltip>
                                      ) : val.id === 6 ? (
                                        <Tooltip key={val.id} title="Markup Cost * Quantity">
                                          <TableCell key={val.id}>{val.value}</TableCell>
                                        </Tooltip>
                                      ) :
                                      <TableCell key={val.id}>{val.value}</TableCell>
                                     
                                    ))}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {selectedMaterials?.map((data, index) => {
                                    console.log("################Materials",data);
                                    let unitName = UNITS?.filter((item) => item?.id == data?.unit)
                                    unitName = unitName[0]?.name
                                    let shortUnitName = ''
                                    if (unitName == 'Square feet') {
                                      shortUnitName = 'Sq ft'
                                    } else if (unitName == 'Lineal feet') {
                                      shortUnitName = 'Lin ft'
                                    } else if (unitName == 'Square Inches') {
                                      shortUnitName = 'Sq Inches'
                                    } else if (unitName == 'Unit') {
                                      shortUnitName = 'Unit'
                                    }
                                    data.price=data.price ? data.price : data.product_price || 0 
                                    data.product_id= data.product_id ? data.product_id : data.id
                                    data.markup = data.markup ? data.markup : data.product_markup
                                    const markUpCost = data.price + ((parseFloat(data.price) * parseFloat(data.markup || 0)) / 100)
                                    data['markUpCost'] = parseFloat(parseFloat(markUpCost).toFixed(2)) || 0;
                                     let stock= 'Partial'
                                    if(data.stock_type===1 ){
                                      stock ='Finished'
                                    } 
                                    return (
                                      <>
                                        <TableRow key={index}>
                                         
                                         <TableCell>{data.name || data.product_name}{data.inhouse==1 ? ' (Inhouse)' : ' (Client owned)'}</TableCell>
                                         <TableCell>{stock}</TableCell>
                                         <TableCell>{data.price}</TableCell>
                                         <TableCell>{data.markup || 0}</TableCell>
                                         <TableCell>{data.markUpCost || 0}</TableCell>
                                         <TableCell>{data.quantity || 1} {shortUnitName}</TableCell>
                                         {/* <TableCell>{(data.price * (data.quantity || 1))?.toFixed(2)}</TableCell> */}
                                         <TableCell>{((data.markUpCost || 0) * (data.quantity || 1))?.toFixed(2)}</TableCell>
                                          <TableCell >
                                          </TableCell>
                                        </TableRow>
                                        
                                      </>
                                    );
                                  })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Scrollbar>
                          <Divider />
                          </> : null}
                      <Stack>
                        <Typography variant="subtitle2" style={{ color: theme.palette.primary.darker }}>
                          Notes:
                        </Typography>
                        <Typography variant="subtitle2" sx={{ overflowWrap: 'break-word', wordWrap: 'break-word', wordBreak: 'break-word', color:'error.main' }}>
                          <Scrollbar
                            sx={{
                              maxHeight: 200,
                              '& .simplebar-content': {
                                maxHeight: 200,
                                display: 'flex',
                                flexDirection: 'column',
                              },
                            }}
                          >{previewData?.notes}</Scrollbar>

                        </Typography>
                      </Stack>
                      <Stack
                        direction={{ xs: 'column', md: 'row' }}
                        display="flex"
                        justifyContent="space-between"
                      >
                        <Typography variant="subtitle2">
                          <span style={{ color:noCharge? 'red' : theme.palette.primary.darker }}>Grand Total: </span>
                          <span style={{ color:noCharge? 'red' : theme.palette.primary.darker }}> 
                            {grandTotal ? parseFloat((noCharge && grandTotal >0) ? (grandTotal * -1) : grandTotal)?.toFixed(2) : 0.00} </span>
                        </Typography>

                        {/* <Tooltip title="Sub Total - Total Product Formula Cost">
                          <Typography variant="subtitle2" sx={{ cursor: 'pointer' }}>
                            <span style={{ color: theme.palette.primary.darker }}>Total Markup Amount: </span>
                            {totalMarkupAmount ? parseFloat(Number(totalMarkupAmount))?.toFixed(2) : 0}
                          </Typography>
                        </Tooltip>

                        <Tooltip title="(Total Markup Amount / Total Product Formula Cost) * 100">
                          <Typography variant="subtitle2" sx={{ cursor: 'pointer' }}>
                            <span style={{ color: theme.palette.primary.darker }}>Total Markup Percentage: </span>
                            {totalMarkupPercentage ? parseFloat(Number(totalMarkupPercentage))?.toFixed(2) : 0}
                          </Typography>
                        </Tooltip> */}

                        {/* <Typography variant="subtitle2">
                      <span style={{ color:theme.palette.primary.darker }}>Total Service Markup: </span>
                      {totalServiceMarkup ? totalServiceMarkup?.toFixed(2) : 0}
                    </Typography> */}
                        <Typography variant="subtitle2">
                          <span style={{ color: theme.palette.primary.darker }}>Total Discount: </span>
                          {DiscountTotal ? DiscountTotal?.toFixed(2) : 0.00}
                        </Typography>
                      </Stack>
                      <Stack
                        direction={{ xs: 'column', md: 'row' }}
                        display="flex"
                        justifyContent="space-between"
                      >
                        <Typography variant="subtitle2">
                          <Label
                            variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                            color={getStatusColorAndLabel(details?.status,details?.installationStatus,details?.allInstallationCompleted,details?.installation_acceptance,details?.min_payment_status,details?.job_category_name,details?.billing_type,details?.installationCompleteStatus, details?.noServiceNoTask, details?.proj_status,details?.partial_install ).color} >
                            {getStatusColorAndLabel(details?.status,details?.installationStatus,details?.allInstallationCompleted,details?.installation_acceptance,details?.min_payment_status,details?.job_category_name,details?.billing_type,details?.installationCompleteStatus, details?.noServiceNoTask, details?.proj_status,details?.partial_install).label}
                          </Label>
                        </Typography>
                      </Stack>

                    </Stack>
                  </Grid>
                </Grid>
              </div>
            </Modal>
          )}
          {/* reject request invoice */}
          {invoiceReject == true && <Dialog
            open={invoiceReject}
            onClose={() => { setRejectInvoice(false) }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            BackdropComponent={Backdrop}
            BackdropProps={{ invisible: true }}
          >
            <DialogTitle id="alert-dialog-title">
              {"Are you sure ?"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                You want to reject this invoice
              </DialogContentText>
              <TextField
                sx={{ width: 400 }}
                label="Reason For Rejection"
                type="text"
                multiline
                minRows={3}
                maxRows={7}
                onInput={(event) => setReason(event.target.value)}
              />
            </DialogContent>
            <DialogActions>
              <Button size="small" variant="contained"
                onClick={() => handleAcceptorRejectInvoice(2)}
                sx={{ color: theme.palette.background.paper }}>OK</Button>

              <Button size="small" variant="outlined"
                onClick={() => { setRejectInvoice(false), setReason('') }}
                sx={{ color: theme.palette.error.main }}
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>}
          <Dialog open={openDialogNoStock} >
            <DialogTitle>
              No stock available for this material.
            </DialogTitle>
            {/* <DialogContent>
              No stock available for this material. Please add stock first.
            </DialogContent> */}
            <DialogActions>
              <Button onClick={closeDialogNoStock} color="error">Close</Button>
            </DialogActions>
          </Dialog>
         <Dialog open={openDialogPartial} >
          <DialogTitle>Select Stock Type</DialogTitle>
          <DialogContent>
            <RadioGroup
              value={String(stockType)}
              onChange={(e) => {
                const val = e.target.value;
                setStockType(val === '1' ? 1 : 2);
                if (val === '1') setConvertionUnit(0);
              }}
            >
              <FormControlLabel value="1" control={<Radio />} label={`Finished Product (${finishedProducts?.length === 0 ? 'No stock' : finishedProducts?.length})`} />
              <FormControlLabel value="2" control={<Radio />} label="Partial Finished Product" />
            </RadioGroup>

            {stockType === 2 && (
              partialProducts.length > 0 ? (
                <>
                  <Typography>Select Conversion Unit</Typography>
                  <RadioGroup
                    value={convertionUnit}
                    onChange={(e) => setConvertionUnit(Number(e.target.value))}
                  >
                    {UNITS
                      .filter(u => partialProducts.some(p => p.partial_unit === u.id))
                      .map(u => (
                        <FormControlLabel
                          key={u.id}
                          value={u.id}
                          control={<Radio />}
                          label={u.name}
                        />
                      ))}
                  </RadioGroup>
                </>
              ) : (
                <Typography color="error">No partial stock found</Typography>
              )
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={closeDialog} color="error">Cancel</Button>
            <Button
              onClick={handleSubmitPopUp}
              disabled={stockType === 1 ? finishedProducts?.length === 0 : stockType === 2 && partialProducts.length === 0}
              variant="contained"
            >
              Add Material
            </Button>
          </DialogActions>
        </Dialog>
          <Dialog
            open={openHoldPopup}
            onClose={() => {
              setOpenHoldPopup(false);
              setHoldReason('');
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            BackdropProps={{ invisible: true }}
          >
            <DialogTitle id="alert-dialog-title">
              {details?.hold === 1 ? 'Remove from Hold?' : 'Move to Hold?'}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {
                  details?.hold === 1
                    ? 'You want to move this Sales Order from Hold.'
                    : 'You want to move this Sales Order to Hold.'
                }
              </DialogContentText>
              {(details?.hold === 0) ? (
                <TextField
                  sx={{ width: 400 }}
                  label="Reason"
                  type="text"
                  multiline
                  minRows={3}
                  maxRows={7}
                  value={holdReason}
                  onChange={(e) => {
                    setHoldReason(e.target.value);
                    if (holdReasonError) setHoldReasonError('');
                  }}
                  error={Boolean(holdReasonError)}
                  helperText={holdReasonError}
                />
              ) : ''}
            </DialogContent>
            <DialogActions>
              <Button
                size="small"
                variant="contained"
                onClick={async () => {
                  if ((details?.hold === 0) && !holdReason.trim()) {
                    setHoldReasonError(`Reason is required to put this Sales Order on Hold`);
                    return;
                  }
                  setIsSubmittingHold(true);
                  await handleUpdateSalesOrderHoldStatus(holdReason)
                  setIsSubmittingHold(false);
                  setOpenHoldPopup(false);
                  setHoldReason('');
                  setHoldReasonError('');
                }}
                disabled={isSubmittingHold}
              >
                {isSubmittingHold ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  'OK'
                )}
              </Button>
              <Button
                size="small"
                variant="outlined"
                onClick={() => {
                  setOpenHoldPopup(false);
                  setHoldReason('');
                }}
                sx={{ color: theme.palette.error.main }}
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
        </Container>
      }
      {/* Progress Modal */}
      <RequestProgressModal
        open={showProgressModal}
        onClose={() => setShowProgressModal(false)}
        requestData={progressRequestData}
        onSocketReady={setSocketReady}
        heading={progressHeading}
      />
      
      {/* Changes Confirmation Dialog */}
      <Dialog open={showChangesDialog} onClose={() => setShowChangesDialog(false)}>
        <DialogTitle>Changes Detected</DialogTitle>
        {/* <DialogContent>
          <Typography variant="body1" sx={{ mb: 2 }}>
            The following changes have been detected in your sales order:
          </Typography>
          <Box sx={{ maxHeight: 300, overflow: 'auto' }}>
            {detectedChanges.map((change, index) => (
              <Typography key={index} variant="body2" sx={{ mb: 1, pl: 2 }}>
                • {change}
              </Typography>
            ))}
          </Box>
          <Typography variant="body1" sx={{ mt: 2 }}>
            Do you want to send these changes for client approval?
          </Typography>
        </DialogContent> */}
       <DialogContent>
  <Typography variant="body1" sx={{ mb: 2 }}>
    Changes have been made to this sales order.
  </Typography>

  {/* Show list of changed sections */}
  {getChangedSectionNames().length > 0 && (
    <>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Sections with detected changes:
      </Typography>
      <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap', mb: 2 }}>
        {getChangedSectionNames().map((section) => (
          <Chip key={section} label={section} color="warning" variant="outlined" />
        ))}
      </Stack>
    </>
  )}

  <Typography
    variant="body1"
    sx={{
      mt: 1,
      fontWeight: 500,
      color: 'warning.main',
    }}
  >
    Do you want to send these changes for client approval?
  </Typography>
</DialogContent>

<DialogActions>
  <Button onClick={() => handleChangesDialogSubmit(false)} color="error" variant="outlined">
    No
  </Button>
  <Button onClick={() => handleChangesDialogSubmit(true)} variant="contained" color="primary">
    Yes
  </Button>
</DialogActions>

      </Dialog>
    </Page >
  )
}

const PrintFunction = forwardRef(({ invoiceDate, details, additionalSelectedServices, invoice, subTotal, cartService, openInvoice, invoiceSelectedServices, data,userType,labourInstallService }, ref) => {
  const theme = useTheme();
  const { COMPANY_LOGO, COMPANY_NAME } = useCompanyProfile()
  let customerProductTotal = 0;
  return (
    <Stack ref={ref}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} sx={{ mb: 5, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <Box component="img" alt="logo" src={COMPANY_LOGO} id="logoImage" sx={{ height: 98, alignSelf: 'flex-start' }} />
        </Grid>
        <Grid item xs={12} sm={6} sx={{ mb: 5, display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
          {/* <Typography variant="h1">Invoice from:</Typography> */}
          <Typography variant="h3">{COMPANY_NAME}</Typography>
          <Typography variant="h3">www.{COMPANY_NAME}.com</Typography>
          <Typography variant="h4">
            {data?.address}<br /> {data?.city}<br /> {data?.state}, {data?.zipcode}
          </Typography>
          <Typography variant="h4">Telephone: +15208362947</Typography>
        </Grid>
      </Grid>

      <Grid container spacing={2}>

        <Grid id="total1" item xs={12} sm={6} >
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
            <Box id="order" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography id="discount1" variant="h5" style={{ textAlign: 'left' }}>Order date:</Typography>
              <Typography variant="h5">{invoiceDate}</Typography>
            </Box>
            <Box id="title" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <Typography id="discount1" variant="h5" style={{ textAlign: 'left' }}>Job Name:</Typography>
              <Typography variant="h5"
              style={{
                  maxWidth: '200px',
                  wordBreak: 'break-word',
                  whiteSpace: 'normal',
                  textAlign: 'left',
                }}
              >{details?.name}</Typography>
            </Box>
            <Box id="title" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography id="discount1" variant="h5" style={{ textAlign: 'left' }}>Project Name:</Typography>
              <Typography variant="h5"
              style={{
                  maxWidth: '200px',
                  wordBreak: 'break-word',
                  whiteSpace: 'normal',
                  textAlign: 'left',
                }}
              >{details?.community_name || ''}</Typography>
            </Box>
            {
                (details?.installation_acceptance && details?.est_doc_number) && (details?.doc_number !== details?.est_doc_number)?
                <>
                 <Box id="orderID" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography id="discount" variant="h5" style={{ textAlign: 'left' }}>Job Number :</Typography>
              <Typography variant="h5">#{details?.est_doc_number}</Typography>
            </Box>
             <Box id="orderID" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography id="discount" variant="h5" style={{ textAlign: 'left' }}>Invoice Number :</Typography>
              <Typography variant="h5">#{details?.doc_number}</Typography>
            </Box>

                </>
                :
                <Box id="orderID" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography id="discount" variant="h5" style={{ textAlign: 'left' }}>Order ID:</Typography>
              <Typography variant="h5">#{details?.doc_number}</Typography>
            </Box>
            }
            <Box id="to" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography id="totalmain1" variant="h5" 
              style={{
                  maxWidth: '200px',
                  wordBreak: 'break-word',
                  whiteSpace: 'normal',
                  textAlign: 'left',
                }}
              >To:</Typography>
              <Typography variant="h5" style={{ textAlign: 'right' }}>{
                details?.is_split_order && details?.for_parent_facility == 1 
                  ? FacilityTypes?.find(facility => facility.id === details?.origin_facility_id)?.label || invoice?.customer_name
                  : invoice?.customer_name
              }</Typography>
            </Box>
            <Box id="to" style={{ display: 'flex', alignItems: 'center',justifyContent:'space-between' }}>
              <Typography id="totalmain1" variant="h5" 
              style={{
                  maxWidth: '200px',
                  wordBreak: 'break-word',
                  whiteSpace: 'normal',
                  textAlign: 'left',
                }}
              >Address:</Typography>
              <Typography variant="h5" style={{textAlign:'right', ml:2}}>{invoice?.customer_address}</Typography>
            </Box>
            <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography id="totalmain1" variant="h4" >Phone:</Typography>
              <Typography variant="h4" style={{ textAlign: 'right' }}>{invoice?.customer_phone}</Typography>
            </Box>
            {(details?.job_category_name == 'Time & Material') ? 
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  border: 1,
                  borderColor: 'black',
                }}
              >
                <Typography id="totalmain1" variant="h4" >{details?.job_category_name}</Typography>
              </Box> 
            : ''}

          </Box>
        </Grid>
        {/* {((details?.job_category_name == 'Time & Material') && (details?.allInstallationCompleted == 1)) ?  */}
        {(details?.job_category_name == 'Time & Material') ? 
          <>
            <Scrollbar>
               {(invoice?.cust_product?.filter(item=>item.material != 1)?.length > 0) ? <>
                  <Typography variant='h6'>{'Products'}</Typography>
                  <TableContainer sx={{ minWidth: 420, mt: 3 }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>PRODUCT & NOTE</TableCell>
                          <TableCell align="center">UNIT</TableCell>
                          <TableCell>UNIT PRICE</TableCell>
                          <TableCell>QTY</TableCell>
                          <TableCell>TOTAL</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {invoice?.cust_product?.filter(item=>item.material != 1)?.map((val) => {
                          const { vid, product_name, product_notes, product_price, product_retail_price, adjustment, 
                            quantity, locationQuantity,actual_retail_price,install_cost, product_total, discount, unit, unit_qty, material,rfp,markAdjType,
                            services = [],
                          } = val

                          // Get labor install
                          const labourService = services?.find(service => service.labour_cost_service_id === 10);
                          const minusAmountLabourInstall = (labourService?.service_original_cost * labourService?.prQty) || 0;
                          const labourQty = (labourService?.prQty || 0) * locationQuantity;
                          const labourRate = labourService?.service_original_cost || 0;
                          const labourTotal = labourQty * labourRate;
                          const labourInitial = (labourService?.prQty || 0) * labourRate;
                          
                          // Unit name logic
                          let unitData = UNITS?.filter((item) => item?.id == unit)
                          let shortUnitName = unitData[0]?.short_name || 'Unit'
                          let unitName = unitData[0]?.name

                          let SPMA = 0
                          if(markAdjType==2 || markAdjType==3){
                            SPMA = (actual_retail_price || product_retail_price || 0) +  (adjustment ? Number(adjustment) : 0)
            
                          }else{

                            SPMA = (actual_retail_price || product_retail_price || 0) + (((product_retail_price || 0) * (adjustment ? Number(adjustment) : 0)) / 100)
                          }
                          SPMA = parseFloat(SPMA)?.toFixed(2)           

                          let rowTotal = 0;

                          if (markAdjType == 1) {
                              rowTotal = product_total || 0.00;
                          } else {
                              // rowTotal = (SPMA * (locationQuantity * quantity) - minusAmountLabourInstall);
                              rowTotal = SPMA * (locationQuantity * quantity);
                          }

                          // Ensure rowTotal is a number before calling toFixed
                          if (typeof rowTotal === 'number') {
                              customerProductTotal = rowTotal.toFixed(2);
                          } else {
                              customerProductTotal = "0.00"; // Handle the case where rowTotal isn't a valid number
                          }
                          console.log('customerProductTotal', customerProductTotal , invoice?.jobcostTotal)
                          return (
                          <React.Fragment key={vid}>
                            {/* Product Row */}
                            <TableRow
                            //  sx={{
                            //   borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                            // }}
                            >
                              <TableCell width={'25%'} sx={{ flexWrap: 'wrap', overflow: 'hidden' }}>
                                <Typography variant='subtitle2' sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word' }}>{product_name}</Typography>
                                {product_notes ? 
                                <Stack direction={'column'}>
                                  <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main'}}>Note : </Typography> 
                                  <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word',color: 'error.main' }}>{product_notes}</Typography> 
                                </Stack>
                                : ''}
                                {(material === 1 && rfp === 0 && details?.job_category_name != 'Time & Material') ? 
                                  <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>(Addl. Material)</Typography> 
                                : ''}
                                {(material === 1 && rfp===1 && details?.job_category_name != 'Time & Material') ? 
                                <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>(Material)</Typography> 
                              : null}
                              </TableCell>
                              <TableCell align="center">{material === 1 ? '1' : quantity}({shortUnitName})</TableCell>
                              {/* <TableCell>${(SPMA ? SPMA - (labourInitial || 0) : 0)?.toFixed(2)}</TableCell> */}
                              {/* <TableCell>${(Number(SPMA) || 0).toFixed(2)}</TableCell> */}
                               <TableCell>${(Number(actual_retail_price) || (Number(SPMA) || 0)).toFixed(2)}</TableCell>
                              <TableCell>{locationQuantity}</TableCell>
                              {/* {markAdjType==1?
                                // <TableCell>${product_total ?(product_total - labourTotal)?.toFixed(2) : 0.00}</TableCell>
                                <TableCell>${product_total ? product_total?.toFixed(2) : 0.00}</TableCell>
                                :
                                // <TableCell>${((SPMA * (locationQuantity * quantity)) - labourTotal)?.toFixed(2)}</TableCell>
                                <TableCell>${(Number(SPMA) || 0).toFixed(2)}</TableCell>
                              } */}
                              {markAdjType==1?
                                                                // <TableCell>${product_total ? product_total?.toFixed(2) : 0.00}</TableCell>
                                <TableCell>${
                                  install_cost ?
                                  ((actual_retail_price * (locationQuantity * quantity)) || 0).toFixed(2) :
                                  material === 1 ?
                                  ((SPMA * locationQuantity ) || 0).toFixed(2) :
                                  ((SPMA * (locationQuantity * quantity)) || 0).toFixed(2)
                                  }</TableCell>
                              :
                                // <TableCell>${((SPMA * (locationQuantity * quantity)) - labourTotal)?.toFixed(2)}</TableCell>
                                <TableCell>${
                                  install_cost ?
                                  ((actual_retail_price * (locationQuantity * quantity)) || 0).toFixed(2) :
                                  material === 1 ?
                                  ((SPMA * locationQuantity ) || 0).toFixed(2) :
                                  ((SPMA * (locationQuantity * quantity)) || 0).toFixed(2)
                                  }</TableCell>
                              }
                            </TableRow>
                            {/* Labor Install Row (if exists) */}
                            {/* {labourService && (
                              <TableRow>
                                <TableCell sx={{ pl: 4 }}>{labourService?.name}</TableCell>
                                <TableCell align="center">N/A</TableCell>
                                <TableCell>${labourRate?.toFixed(2)}</TableCell>
                                <TableCell>{labourQty?.toFixed(2)}</TableCell>
                                <TableCell>${labourTotal?.toFixed(2)}</TableCell>
                              </TableRow>
                            )} */}
                            {install_cost ? (
                              <TableRow>
                                <TableCell sx={{ pl: 4 }}>Install Price</TableCell>
                                <TableCell align="center">-</TableCell>
                                <TableCell>${install_cost || 0}</TableCell>
                                <TableCell>-</TableCell>
                                <TableCell>
                                  ${((install_cost || 0) * (locationQuantity || 1) * (quantity || 1)).toFixed(2)}
                                </TableCell>

                              </TableRow>
                            ):''}
                            {/* <TableRow>
                              <TableCell colSpan={5}>
                                <Box sx={{ borderBottom: (theme) => `solid 1px ${theme.palette.divider}` }} />
                              </TableCell>
                            </TableRow> */}
                          </React.Fragment>
                          )
                        }
                        )}

                      </TableBody>
                    </Table>
                  </TableContainer>
                </> : null}
                {/* <Typography variant='h6' sx={{ mt: 2 }}>{(labourInstallService?.length > 0 ) ? ((details?.job_category_name != 'Service only' && details?.job_category_name != 'Time & Material') ? "Services(Labor Install)" : 'Services(Labor Install)') : ""}</Typography>
                    <TableContainer sx={{ minWidth: 420, mt: 3 }}>
                      <Table>
                        {(labourInstallService?.length > 0 ) &&
                          <TableHead>
                            <TableRow>
                              <TableCell colSpan={2}>NAME</TableCell>
                              <TableCell>COST (HOURLY)</TableCell>
                              <TableCell>HOURS</TableCell>
                              <TableCell>TOTAL COST</TableCell>
                            </TableRow>
                          </TableHead>}
                        <TableBody>
                        {labourInstallService?.map((ser) => {
                            console.log('invoiceSelectedServices--@@ 1', ser);
                            return (
                              <TableRow sx={{
                                borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                              }}>
                                <TableCell colSpan={2}>
                                  <Typography variant="subtitle2" sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                                    {ser?.name}-({ser.productName})
                                  </Typography>
                                  {ser?.service_notes ? 
                                    <Stack direction={'column'}>
                                      <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography> 
                                      <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' ,color: 'error.main'}}>{ser.service_notes}</Typography> 
                                    </Stack>
                                    : ''}
                                </TableCell>
                                <TableCell>${ser ? ser?.unit_cost?.toFixed(2) : 0}</TableCell>
                                <TableCell>{ser ? ser?.quantity?.toFixed(2) : 0}</TableCell>
                                <TableCell>${ser ? ser?.total_cost?.toFixed(2) : 0}</TableCell>
                              </TableRow>
                            )
                          })}
                          </TableBody>
                          </Table>
                      </TableContainer> */}
              {(!empty(invoice?.jobcost_product)) ? 
              <>
              <Typography variant='h4' sx={{ mt: 2 }}>Materials</Typography> 
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell colSpan={2}>NAME</TableCell>
                      <TableCell>UNIT COST</TableCell>
                      <TableCell>QUANTITY</TableCell>
                      <TableCell>TOTAL COST</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {invoice?.jobcost_product?.map((val,index) => {
                      const { id, product_name, unit_price, quantity, total, unit, unit_qty, partial_unit } = val
                      let unitToUse = partial_unit ? partial_unit : unit
                      let unitName = UNITS?.filter((item) => item?.id == unitToUse)
                      let shortUnitName = unitName[0]?.short_name || 'Unit'
                      unitName = unitName[0]?.name
                      return (
                        <TableRow sx={{
                          borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                        }}>
                          <TableCell colSpan={2}>{product_name}</TableCell>
                          <TableCell> ${unit_price}</TableCell>
                          <TableCell>{quantity}({shortUnitName})</TableCell>
                          <TableCell> ${total}</TableCell>
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
              </>
              : ''}
              {/* {invoice?.jobcost_service?.filter((item)=>item.product_id == null)?.length > 0 ? <Typography variant='h6' sx={{ mt: 2 }}>Additional Services</Typography> : ''} */}
              <TableContainer>
                  <Table>
                  {invoice?.jobcost_service?.filter((item)=>item.product_id == null)?.length > 0 ? 
                  <>
                    <TableHead>
                      <TableRow>
                        <TableCell colSpan={2}>ADDITIONAL SERVICES</TableCell>
                        <TableCell>HOURLY COST</TableCell>
                        <TableCell>HOURS</TableCell>
                        <TableCell>TOTAL COST</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {invoice?.jobcost_service?.filter((item)=>item.product_id == null)?.map((ser,index) => {
                        return (
                          <TableRow sx={{
                            borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                          }}>
                            <TableCell colSpan={2}>
                              <Typography variant="subtitle2" sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                                {ser?.name}
                              </Typography>
                              {ser?.service_notes ? 
                                <Stack direction={'column'}>
                                  <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography> 
                                  <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' ,color: 'error.main'}}>{ser.service_notes}</Typography> 
                                </Stack>
                                : ''}
                            </TableCell>
                            <TableCell>${ser ? parseFloat(ser?.service_original_cost)?.toFixed(2) : 0}</TableCell>
                            {/* <TableCell>{ser ? parseFloat(ser?.jobcost_quantity)?.toFixed(2) : 0}</TableCell> */}
                            <TableCell>{ser ? parseFloat(ser?.quantity)?.toFixed(2) : 0}</TableCell>
                            <TableCell>${ser ? ser?.total_service_cost : 0}</TableCell>
                          </TableRow>
                        )
                      })}
                    </TableBody>
                  </> : ''}
                </Table>
              </TableContainer>
            </Scrollbar>
            <Grid id="total" item xs={12} sm={6} >
              <Box sx={{ mb: 5, display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '8px' }}>
              {(invoice?.jobcostTotal && invoice?.jobcostTotal > 0) ?
              <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography id="subtotal" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0,width: '300px', }}>Material Total</Typography>
                <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>
                  ${(invoice?.jobcostTotal).toFixed(2)}
                </Typography>
                {/* <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>{invoice?.jobcostTotal ? invoice?.jobcostTotal?.toFixed(2) : 0.00}</Typography> */}
              </Box> : ''}
              {/* {(invoice?.project_category == 12 && details?.allInstallationCompleted == 1) ? '' : */}
              {(invoice?.project_category == 12) ? '' :
              <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography id="subtotal" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0,width: '300px', }}>Product Total</Typography>
                <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>
                  ${invoice?.cust_product?.reduce((sum, val) => {
                    const {
                      product_retail_price = 0,material = 0 , adjustment = 0, markAdjType,
                      product_total = 0,actual_retail_price,install_cost, locationQuantity = 1, quantity = 1,
                      services = []
                    } = val;
      
                    const labourService = services?.find(s => s.labour_cost_service_id === 10);
                    const labourTotal = (labourService?.service_original_cost || 0) * (labourService?.prQty || 0) * locationQuantity;
                    const basePrice = actual_retail_price !== 0 && actual_retail_price != null
                    ? actual_retail_price
                    : product_retail_price;
                    // let SPMA = (markAdjType === 2 || markAdjType === 3)
                    //   ? product_retail_price + Number(adjustment)
                    //   : product_retail_price + ((product_retail_price * Number(adjustment)) / 100);
      
                    // const effectiveTotal = markAdjType === 1
                    //   // ? product_total - labourTotal
                    //   // : (SPMA * (locationQuantity * quantity)) - labourTotal;
                    //   ? product_total
                    //    : (SPMA * (locationQuantity * quantity));
                    let SPMA = (markAdjType === 2 || markAdjType === 3)
                        ? basePrice + Number(adjustment)
                        : basePrice + ((basePrice * Number(adjustment)) / 100);

                      const effectiveTotal = markAdjType === 1 && material === 0
                        // ? product_total
                        ? (SPMA * (locationQuantity * quantity)) :
                        material === 1 ? (SPMA * locationQuantity)
                        : (SPMA * (locationQuantity * quantity));
      
                    return sum + effectiveTotal;
                  }, 0)?.toFixed(2)}
                </Typography>
              </Box>
              }
              {(labourInstallService?.length > 0 || 
                additionalSelectedServices?.some(
                  x => x.labour_cost_service_id === 10 && (x.total_cost || 0) > 0
                ) ||
                  invoice?.cust_product?.some(
                    val => parseFloat(val.install_cost || 0) > 0
                  )
              ) &&
                <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Typography id="subtotal" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0,width: '300px', }}>Install Total</Typography>
                  {/* <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>
                    ${invoice?.cust_product?.reduce((sum, val) => {
                      const labourService = val?.services?.find(s => s.labour_cost_service_id === 10);
                      return sum + (labourService?.service_original_cost || 0) * (labourService?.prQty || 0) * (val?.locationQuantity || 1);
                    }, 0)?.toFixed(2)}
                  </Typography> */}
                  <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>
                      ${(
                          // (invoice?.cust_product?.reduce((sum, val) => {
                          //   const labourService = val?.services?.find(
                          //     s => s.labour_cost_service_id === 10
                          //   );
                          //   return (
                          //     sum +
                          //     (labourService?.service_original_cost || 0) *
                          //       (labourService?.prQty || 0) *
                          //       (val?.locationQuantity || 1)
                          //   );
                          // }, 0) || 0) +
                          (invoice?.cust_product?.reduce((sum, val) => {
                            const installCost = parseFloat(val?.install_cost || 0);
                            const locationQty = parseFloat(val?.locationQuantity || 1);
                            const quantity = parseFloat(val?.quantity || 1);

                            if (installCost) {
                              return sum + installCost * locationQty * quantity;
                            }
                            return sum;
                          }, 0) || 0) +
                          (additionalSelectedServices?.reduce(
                            (s, x) =>
                              x.labour_cost_service_id === 10 ? s + (x.total_cost || 0) : s,
                            0
                          ) || 0)
                        ).toFixed(2)}
                    </Typography>
                </Box>
              }
              
              <Box style={{ display: 'flex', alignItems: 'center',justifyContent:'space-between'  }}>
                <Typography id="discount" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0 }}> Additional Services Total</Typography>
                <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>
                  ${(
                    (invoiceSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                    // (additionalSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                    (additionalSelectedServices?.reduce(
                        (s, x) =>
                          x.labour_cost_service_id === 10       // ⬅ skip labour install rows
                            ? s
                            : s + (x.total_cost || 0),
                        0
                    ) || 0) +
                    (cartService?.reduce((s, x) => {
                      const sp = x.sellingPrice || x.unit_cost || 0;
                      const markup = x.originalMarkup || x.product_markup || 0;
                      const final = sp + (sp * markup / 100);
                      return s + ((x.qty || 0) * final);
                    }, 0) || 0)
                  )?.toFixed(2)}
                </Typography>
              </Box>
      
              <Box style={{ display: 'flex', alignItems: 'center',justifyContent:'space-between' }}>
                <Typography id="subtotal" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0,width: '300px', }}>Subtotal</Typography>
                <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>
                  ${(
                    (subTotal || 0) +
                    // (invoiceSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                    (additionalSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                    (cartService?.reduce((s, x) => {
                      const sp = x.sellingPrice || x.unit_cost || 0;
                      const markup = x.originalMarkup || x.product_markup || 0;
                      const final = sp + (sp * markup / 100);
                      return s + ((x.qty || 0) * final);
                    }, 0) || 0)
                    // (invoice?.cust_product?.reduce((sum, val) => {
                    //   const labourService = val?.services?.find(
                    //     s => s.labour_cost_service_id === 10
                    //   );
                    //   return (
                    //     sum +
                    //     (labourService?.service_original_cost || 0) *
                    //       (labourService?.prQty || 0) *
                    //       (val?.locationQuantity || 1)
                    //   )
                    // }, 0) || 0)
                  )?.toFixed(2)}
                </Typography>
              </Box>
              {invoice?.extra_discount > 0 && (
              <Box style={{ display: 'flex', alignItems: 'center',justifyContent:'space-between'  }}>
                <Typography id="discount" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0 }}>Discount</Typography>
                <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>${invoice ? invoice?.extra_discount?.toFixed(2) : 0.00}</Typography>
              </Box>
              )}
              {invoice?.tax_amount > 0 && (
              <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography id="discount" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0 }}>Tax</Typography>
                <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>${invoice ? invoice?.tax_amount?.toFixed(2) : 0.00}</Typography>
              </Box>
              )}
              <Box style={{ display: 'flex', alignItems: 'center',justifyContent:'space-between' }}>
                <Typography id="totalmain" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0 }}>Total</Typography>
                <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>${invoice?.grandTotal ? invoice?.grandTotal?.toFixed(2) : 0.00}</Typography>
              </Box>

              {invoice?.project_category == 13 ? '' : 
              <>
              {
              (userType !=3 && details?.job_category_name != 'Time & Material' && details?.job_category_name != 'No Charge') ?
              (details?.billing_type ? (
              <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography id="subtotal" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0,width: '300px', }}>Billing Type</Typography>
                <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>{details?.billing_type ? `${details?.billing_type} %` :"Nil"}</Typography>
              </Box>
              ) : '' )
              :""}
              {(invoice?.total && details?.billing_type)?
                <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Typography id="subtotal" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0,width: '300px', }}>Minimum Payable Amount</Typography>
                  <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>${(invoice?.total && details?.billing_type)? parseFloat((invoice?.total *details?.billing_type) / 100).toFixed(2) :0.00}</Typography>
                </Box>
              : "" }

              {details?.totalPaidAmount > 0 && (
              <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography id="subtotal" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0,width: '300px', }}>Amount Paid</Typography>
                <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>${details?.totalPaidAmount ? details?.totalPaidAmount?.toFixed(2) : 0.00}</Typography>
              </Box>
              )}
              {details?.totalPaidAmount > 0 && (
              <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography id="subtotal" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0,width: '300px', }}>Balance Due</Typography>
                <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>${invoice?.newBalanceDue ? parseFloat(invoice?.newBalanceDue <= 0 ? 0.00 : invoice?.newBalanceDue)?.toFixed(2) : 0.00}</Typography>
              </Box>
              )}
              </>
              }
              </Box>
            </Grid>
            {(details?.allInstallationCompleted == 1 && !empty(invoice?.note_data)) ? (
              <>
                <Typography variant="h6" sx={{ mt: 2, mb: 1, fontWeight: 'bold' }}>Installation Notes</Typography>
                <Stack spacing={2}>
                  {invoice?.note_data?.map((val, index) => {
                    const { id, authorized_by, note, timestamp } = val;
                    return (
                      <Paper
                        key={id}
                        elevation={3}
                        sx={{ padding: 2, borderRadius: 2, backgroundColor: 'rgba(145, 158, 171, 0.16)', color: '#ffffff' }}
                      >
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={8}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                              {note}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={4} sx={{ textAlign: { xs: 'left', sm: 'right' } }}>
                            {/* <Typography variant="body2" sx={{ color: 'primary.light' }}> */}
                            <Typography variant="body2" sx={{ color: theme.palette.primary.main }}>
                              Added By: {authorized_by}
                            </Typography>
                            <Typography variant="body2" sx={{ color: theme.palette.primary.main }}>
                              {moment.unix(timestamp).format('MM-DD-YYYY hh:mm:ss A')}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Paper>
                    );
                  })}
                </Stack>
              </>
            ) : ''}
          </> :
          <>
        <Scrollbar>
          {(invoice?.cust_product?.length > 0) ? <>
            <TableContainer sx={{ minWidth: 420 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>PRODUCT & NOTE</TableCell>
                    {invoice?.cust_product?.some(item => item.product_notes) && <TableCell>SKU</TableCell>}
                    <TableCell align="center">UNIT</TableCell>
                    {/* {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3) ? <TableCell>WHOLESALE PRICE</TableCell> : ''}
                    {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3) ? <TableCell>SPLIT MARKUP</TableCell> : ''} */}
                    <TableCell>QTY</TableCell>
                    <TableCell>UNIT PRICE</TableCell>
                    <TableCell>TOTAL</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {invoice?.cust_product?.map((val) => {
                    console.log('invoice val',val);
                    const { vid,split_percentage,wholesale_price,facility_id, incoming_split_percentage, product_name,product_notes,vpt_number,actual_retail_price,install_cost, unit_qty, adjustment, product_price, material, rfp, product_retail_price, quantity, product_total, discount, unit, locationQuantity,markAdjType,services = []} = val;
                
                    // Get labor install
                    const labourService = services?.find(service => service.labour_cost_service_id === 10);
                    const minusAmountLabourInstall = (labourService?.service_original_cost * labourService?.prQty) || 0;
                    const labourQty = (labourService?.prQty || 0) * locationQuantity;
                    const labourRate = labourService?.service_original_cost || 0;
                    const labourTotal = labourQty * labourRate;
                    const labourInitial = (labourService?.prQty || 0) * labourRate;
                    
                    // Unit name logic
                    let unitData = UNITS?.filter((item) => item?.id == unit)
                    let shortUnitName = unitData[0]?.short_name || 'Unit'
                    let unitName = unitData[0]?.name
                      
                    let SPMAAmount = 0
                    if(markAdjType==2 || markAdjType==3) {
                      SPMAAmount = (actual_retail_price || product_retail_price || 0) + (adjustment ? Number(adjustment) : 0)
                    }else{
                      SPMAAmount = (actual_retail_price || product_retail_price || 0) + (((product_retail_price || 0) * (adjustment ? Number(adjustment) : 0)) / 100)
                    }
                    SPMAAmount = parseFloat(SPMAAmount)?.toFixed(2)  

                    let theSubTotalAmount =markAdjType==1?product_total: (SPMAAmount * (locationQuantity * quantity))
                    subTotal += theSubTotalAmount;
                    
                    let SPMA = 0
                    if(markAdjType==2 || markAdjType==3){
                      SPMA = (product_retail_price || 0) +  (adjustment ? Number(adjustment) : 0)
      
                    }else{

                      SPMA = (product_retail_price || 0) + (((product_retail_price || 0) * (adjustment ? Number(adjustment) : 0)) / 100)
                    }
                    SPMA = parseFloat(SPMA)?.toFixed(2)  
                    return (
                    <React.Fragment key={vid}>
                      {/* Product Row */}
                      <TableRow
                      //  sx={{
                      //   borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                      // }}
                      >
                        <TableCell width={'25%'} sx={{flexWrap:'wrap'}}>
                          {product_notes ? 
                          <Typography variant='body2' className="productName">{product_notes}</Typography> :
                          <Typography variant='body2' className="productName">{product_name}</Typography>
                          }
                          {(material === 1 && rfp===0 && details?.job_category_name != 'Time & Material') ? <Typography variant='subtitle2'>(Addl. Material)</Typography> : ''}
                          {(material === 1 && rfp===1 && details?.job_category_name != 'Time & Material') ? 
                            <Typography variant='subtitle2'>(Material)</Typography> 
                          : null}
                        </TableCell>
                        {invoice?.cust_product?.some(item => item.product_notes) ? <TableCell>{product_notes ? vpt_number : ''}</TableCell> : ''}
                        {/* <TableCell align="center">{material === 1 ? '1' : quantity}({shortUnitName})</TableCell> */}
                        <TableCell align="center">{material === 1 ? `1 (${shortUnitName})` : '-'}</TableCell>
                        <TableCell align="center">{locationQuantity}</TableCell>
                        {/* Outgoing Percentage column - only show when isSplitOrder is true */}
                        {/* {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3) ? 
                          <TableCell align="center">
                            {details?.is_split_order && facility_id != currentFacilityId ? `${wholesale_price || 0}%` : '-'}
                          </TableCell>
                          :''
                        } */}
                        {/* Incoming Percentage column - only show when isSplitOrder is true */}
                        {/* {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3) ? 
                          <TableCell align="center">
                            {details?.is_split_order && facility_id != currentFacilityId ? `${incoming_split_percentage || 0}%` : '-'}
                          </TableCell>
                          :''
                        } */}
                        {/* <TableCell>${(SPMA ? SPMA - (labourInitial || 0) : 0)?.toFixed(2)}</TableCell> */}
                        {/* <TableCell>${(Number(SPMA) || 0).toFixed(2)}</TableCell> */}
                         <TableCell>${(Number(actual_retail_price) || (Number(SPMA) || 0)).toFixed(2)}</TableCell>
                        {/* <TableCell variant="body2">{locationQuantity}</TableCell> */}
                        {/* {markAdjType==1?
                          // <TableCell>${product_total ? (product_total - labourTotal)?.toFixed(2) : 0.00}</TableCell>
                          <TableCell>${product_total ? product_total?.toFixed(2) : 0.00}</TableCell>
                        :
                          // <TableCell>${((SPMA * (locationQuantity * quantity)) - labourTotal)?.toFixed(2)}</TableCell>
                          <TableCell>${product_total ? product_total?.toFixed(2) : 0.00}</TableCell>
                        } */}
                        {markAdjType==1?
                                  // <TableCell>${product_total ? product_total?.toFixed(2) : 0.00}</TableCell>
                            <TableCell>${
                              install_cost ?
                              ((actual_retail_price * (locationQuantity * quantity)) || 0).toFixed(2) :
                              material === 1 ?
                              ((SPMA * locationQuantity ) || 0).toFixed(2) :
                              ((SPMA * (locationQuantity * quantity)) || 0).toFixed(2)
                              }</TableCell>
                          :
                            // <TableCell>${((SPMA * (locationQuantity * quantity)) - labourTotal)?.toFixed(2)}</TableCell>
                            <TableCell>${
                              install_cost ?
                              ((actual_retail_price * (locationQuantity * quantity)) || 0).toFixed(2) :
                              material === 1 ?
                              ((SPMA * locationQuantity ) || 0).toFixed(2) :
                              ((SPMA * (locationQuantity * quantity)) || 0).toFixed(2)
                              }</TableCell>
                          }
                      </TableRow>
                      {/* Labor Install Row (if exists) */}
                      {/* {labourService && (
                        <TableRow>
                          <TableCell sx={{ pl: 4 }}>{labourService?.name}</TableCell>
                          <TableCell align="center">N/A</TableCell>
                          <TableCell>${labourRate?.toFixed(2)}</TableCell>
                          <TableCell>{labourQty?.toFixed(2)}</TableCell>
                          <TableCell>${labourTotal?.toFixed(2)}</TableCell>
                        </TableRow>
                      )} */}
                      {install_cost ? (
                        <TableRow>
                          <TableCell sx={{ pl: 4 }}>Install Price</TableCell>
                          {invoice?.cust_product?.some(item => item.product_notes) ? <TableCell>-</TableCell> : ''}
                          <TableCell align="center">-</TableCell>
                          {/* Outgoing Percentage column for Install Price - only show when isSplitOrder is true */}
                          {/* {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3) ?
                            <TableCell align="center">
                              {details?.is_split_order && facility_id != currentFacilityId ? '-' : '-'}
                            </TableCell>
                            : ''
                          } */}
                          {/* Incoming Percentage column for Install Price - only show when isSplitOrder is true */}
                          {/* {(details?.is_split_order && details?.origin_facility_id == currentFacilityId && userType != 3) ?
                            <TableCell align="center">
                              {details?.is_split_order && facility_id != currentFacilityId ? '-' : '-'}
                            </TableCell>
                            : ''
                          } */}
                          <TableCell align="center">-</TableCell>
                          <TableCell align="center">${install_cost || 0}</TableCell>
                          <TableCell>
                            ${((install_cost || 0) * (locationQuantity || 1) * (quantity || 1)).toFixed(2)}
                          </TableCell>

                        </TableRow>
                      ):''}
                      {/* <TableRow>
                        <TableCell colSpan={5}>
                          <Box sx={{ borderBottom: (theme) => `solid 1px ${theme.palette.divider}` }} />
                        </TableCell>
                      </TableRow> */}
                    </React.Fragment>
                    )
                  }
                  )}

                </TableBody>
              </Table>
            </TableContainer>
          </> : null}

          {/* {(additionalSelectedServices?.length > 0 || invoiceSelectedServices?.length > 0 || cartService?.length > 0) && <Typography variant='h4' sx={{ mt: 2 }}>{(details?.job_category_name != 'Service only' && details?.job_category_name != 'Time & Material') ? "Additional Services" : 'Services'}</Typography>} */}
          {/* {(additionalSelectedServices?.length > 0 || invoiceSelectedServices?.length > 0 || cartService?.length > 0) && <Typography variant='h4' sx={{ mt: 2 }}>{(details?.job_category_name != 'Service only') ? "Additional Services" : 'Services'}</Typography>} */}
          <TableContainer sx={{ minWidth: 420, mt: 3 }}>
            <Table>
              {(additionalSelectedServices?.length > 0 || invoiceSelectedServices?.length > 0 || cartService?.length > 0) &&
                <TableHead>
                  <TableRow>
                    <TableCell>{(details?.job_category_name != 'Service only') ? "ADDITIONAL SERVICES" : 'SERVICES'}</TableCell>
                    <TableCell>COST (HOURLY)</TableCell>
                    <TableCell>HOURS</TableCell>
                    <TableCell>TOTAL COST</TableCell>
                  </TableRow>
                </TableHead>}
              <TableBody>
                {openInvoice && invoiceSelectedServices?.map((ser) => {
                  return (
                    <TableRow sx={{
                      borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                    }}>
                      <TableCell>
                        <Typography variant="subtitle2" sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                          {ser?.name}
                        </Typography>
                        {ser?.service_notes ? 
                          <Stack direction={'column'}>
                            <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography> 
                            <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' ,color: 'error.main'}}>{ser.service_notes}</Typography> 
                          </Stack>
                          : ''}
                      </TableCell>
                      <TableCell>${ser ? ser?.unit_cost?.toFixed(2) : 0}</TableCell>
                      <TableCell>{ser ? ser?.quantity?.toFixed(2) : 0}</TableCell>
                      <TableCell>${ser ? ser?.total_cost?.toFixed(2) : 0}</TableCell>
                    </TableRow>
                  )
                }
                )}
                {openInvoice && additionalSelectedServices
                ?.filter(servItem=>{
                  // if (details?.job_category_name != 'Time & Material' && servItem.labour_cost_service_id == 10) {
                  //   return false;
                  // }
                  return true;
                  })
                ?.map((ser) => {
                  console.log('additionalSelectedServices--', ser);
                  return (
                    <TableRow sx={{
                      borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                    }}>
                      <TableCell>
                        <Typography variant="subtitle2" sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                          {ser?.name}
                        </Typography>
                        {ser?.service_notes ? 
                          <Stack direction={'column'}>
                            <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography> 
                            <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' ,color: 'error.main'}}>{ser.service_notes}</Typography> 
                          </Stack>
                          : ''}
                      </TableCell>
                      <TableCell>${ser ? ser?.unit_cost?.toFixed(2) : 0}</TableCell>
                      <TableCell>{ser ? ser?.quantity?.toFixed(2) : 0}</TableCell>
                      <TableCell>${ser ? ser?.total_cost?.toFixed(2) : 0}</TableCell>
                    </TableRow>
                  )
                }
                )}
                {openInvoice && cartService?.map((ser) => {
                  console.log('cartService--', ser);
                  ser.sellingPrice = details?.project_category == 13 ? ser.unit_cost : ser.sellingPrice || ser.unit_cost
                  ser.originalMarkup = details?.project_category == 13 ? 0 :ser.originalMarkup || ser.product_markup
                  return (
                    <TableRow sx={{
                      borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                    }}>
                      <TableCell>
                        <Typography variant="subtitle2" sx={{ fontWeight: 'bold', wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                          {ser?.name}
                        </Typography>
                        {ser?.service_notes ? 
                          <Stack direction={'column'}>
                            <Typography variant='body2' sx={{textDecoration: 'underline', mt: 1, color: 'error.main' }}>Service Note : </Typography> 
                            <Typography variant='body2' sx={{ wordBreak: 'break-word', overflowWrap: 'break-word' ,color: 'error.main'}}>{ser.service_notes}</Typography> 
                          </Stack>
                          : ''}
                      </TableCell>
                      <TableCell> ${((ser.sellingPrice + (ser.sellingPrice * ser.originalMarkup / 100)))?.toFixed(2)}</TableCell>
                      <TableCell>{ser ? ser?.qty?.toFixed(2) : 0}</TableCell>
                      <TableCell> ${(ser.qty * (ser.sellingPrice + (ser.sellingPrice * ser.originalMarkup / 100)))?.toFixed(2)}</TableCell>
                    </TableRow>
                  )
                }
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Scrollbar>

        <Grid id="total" item xs={12} sm={6} >
          <Box sx={{ mb: 5, display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '8px' }}>
            <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography id="subtotal" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0,width: '300px', }}>Product Total</Typography>
              <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>
                ${invoice?.cust_product?.reduce((sum, val) => {
                  const {
                    product_retail_price = 0,material=0, adjustment = 0, markAdjType,
                    product_total = 0,actual_retail_price,install_cost, locationQuantity = 1, quantity = 1,
                    services = []
                  } = val;
    
                  const labourService = services?.find(s => s.labour_cost_service_id === 10);
                  const labourTotal = (labourService?.service_original_cost || 0) * (labourService?.prQty || 0) * locationQuantity;
    
                  // let SPMA = (markAdjType === 2 || markAdjType === 3)
                  //   ? product_retail_price + Number(adjustment)
                  //   : product_retail_price + ((product_retail_price * Number(adjustment)) / 100);
    
                  // const effectiveTotal = markAdjType === 1
                  //   // ? product_total - labourTotal
                  //   // : (SPMA * (locationQuantity * quantity)) - labourTotal;
                  //   ? product_total
                  //     : (SPMA * (locationQuantity * quantity));
                  const basePrice = actual_retail_price !== 0 && actual_retail_price != null
                    ? actual_retail_price
                    : product_retail_price;
                  let SPMA = (markAdjType === 2 || markAdjType === 3)
                    ? basePrice + Number(adjustment)
                    : basePrice + ((basePrice * Number(adjustment)) / 100);

                  const effectiveTotal = markAdjType === 1 && material === 0
                    // ? product_total
                    ? (SPMA * (locationQuantity * quantity)) :
                    material === 1 ? (SPMA * locationQuantity)
                    : (SPMA * (locationQuantity * quantity));
    
                  return sum + effectiveTotal;
                }, 0)?.toFixed(2)}
              </Typography>
            </Box>
            {(labourInstallService?.length > 0 || 
              additionalSelectedServices?.some(
                x => x.labour_cost_service_id === 10 && (x.total_cost || 0) > 0
              )||
                invoice?.cust_product?.some(
                  val => parseFloat(val.install_cost || 0) > 0
                )
            ) &&
              <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography id="subtotal" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0,width: '300px', }}>Install Total</Typography>
                {/* <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>
                  ${invoice?.cust_product?.reduce((sum, val) => {
                    const labourService = val?.services?.find(s => s.labour_cost_service_id === 10);
                    return sum + (labourService?.service_original_cost || 0) * (labourService?.prQty || 0) * (val?.locationQuantity || 1);
                  }, 0)?.toFixed(2)}
                </Typography> */}
                <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>
                      ${(
                        // (invoice?.cust_product?.reduce((sum, val) => {
                        //   const labourService = val?.services?.find(
                        //     s => s.labour_cost_service_id === 10
                        //   );
                        //   return (
                        //     sum +
                        //     (labourService?.service_original_cost || 0) *
                        //     (labourService?.prQty || 0) *
                        //     (val?.locationQuantity || 1)
                        //   );
                        // }, 0) || 0) +
                        (invoice?.cust_product?.reduce((sum, val) => {
                          const installCost = parseFloat(val?.install_cost || 0);
                          const locationQty = parseFloat(val?.locationQuantity || 1);
                          const quantity = parseFloat(val?.quantity || 1);

                          if (installCost) {
                            return sum + installCost * locationQty * quantity;
                          }
                          return sum;
                        }, 0) || 0) +
                        (additionalSelectedServices?.reduce(
                          (s, x) =>
                            x.labour_cost_service_id === 10 ? s + (x.total_cost || 0) : s,
                          0
                        ) || 0)
                      ).toFixed(2)}
                    </Typography>
              </Box>
            }
            
            <Box style={{ display: 'flex', alignItems: 'center',justifyContent:'space-between'  }}>
              <Typography id="discount" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0 }}> Additional Services Total</Typography>
              <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>
                ${(
                  (invoiceSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                  // (additionalSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                  (additionalSelectedServices?.reduce(
                        (s, x) =>
                          x.labour_cost_service_id === 10       // ⬅ skip labour install rows
                            ? s
                            : s + (x.total_cost || 0),
                        0
                    ) || 0) +
                  (cartService?.reduce((s, x) => {
                    const sp = x.sellingPrice || x.unit_cost || 0;
                    const markup = x.originalMarkup || x.product_markup || 0;
                    const final = sp + (sp * markup / 100);
                    return s + ((x.qty || 0) * final);
                  }, 0) || 0)
                )?.toFixed(2)}
              </Typography>
            </Box>
    
            <Box style={{ display: 'flex', alignItems: 'center',justifyContent:'space-between' }}>
              <Typography id="subtotal" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0,width: '300px', }}>Subtotal</Typography>
              <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>
                ${(
                  (subTotal || 0) +
                  // (invoiceSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                  (additionalSelectedServices?.reduce((s, x) => s + (x.total_cost || 0), 0) || 0) +
                  (cartService?.reduce((s, x) => {
                    const sp = x.sellingPrice || x.unit_cost || 0;
                    const markup = x.originalMarkup || x.product_markup || 0;
                    const final = sp + (sp * markup / 100);
                    return s + ((x.qty || 0) * final);
                  }, 0) || 0)
                  // (invoice?.cust_product?.reduce((sum, val) => {
                  //   const labourService = val?.services?.find(
                  //     s => s.labour_cost_service_id === 10
                  //   );
                  //   return (
                  //     sum +
                  //     (labourService?.service_original_cost || 0) *
                  //       (labourService?.prQty || 0) *
                  //       (val?.locationQuantity || 1)
                  //   )
                  // }, 0) || 0)
                )?.toFixed(2)}
              </Typography>
            </Box>
            {invoice?.extra_discount > 0 && (
            <Box style={{ display: 'flex', alignItems: 'center',justifyContent:'space-between'  }}>
              <Typography id="discount" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0 }}>Discount</Typography>
              <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>${invoice ? invoice?.extra_discount?.toFixed(2) : 0.00}</Typography>
            </Box>
            )}
            {invoice?.tax_amount > 0 && (
            <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography id="discount" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0 }}>Tax</Typography>
              <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>${invoice ? invoice?.tax_amount?.toFixed(2) : 0.00}</Typography>
            </Box>
            )}
            <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography id="totalmain" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0 }}>Total</Typography>
              <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>${invoice?.total ? invoice?.total?.toFixed(2) : 0.00}</Typography>
            </Box>
            {invoice?.project_category == 13 ? '' : 
              <>
              {
              (userType !=3 && details?.job_category_name != 'Time & Material' && details?.job_category_name != 'No Charge') ?
              (details?.billing_type ? (
              <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography id="subtotal" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0,width: '300px', }}>Billing Type</Typography>
                <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>{details?.billing_type ? `${details?.billing_type} %` :"Nil"}</Typography>
              </Box>
              ) : '')
              :""}
              {(invoice?.total && details?.billing_type) ?
                <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Typography id="subtotal" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0,width: '300px', }}>Minimum Payable Amount</Typography>
                  <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>${(invoice?.total && details?.billing_type)? parseFloat((invoice?.total *details?.billing_type) / 100).toFixed(2) :0.00}</Typography>
                </Box>
              : "" }
              
              {details?.totalPaidAmount > 0 && (
                <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Typography id="totalmain" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0 }}>Amount Paid</Typography>
                  <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>${details?.totalPaidAmount ? details?.totalPaidAmount?.toFixed(2) : 0.00}</Typography>
                </Box>
              )}
              {details?.totalPaidAmount > 0 && (
                <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Typography id="totalmain" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0 }}>Balance Due</Typography>
                  <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>${details?.dueAmount ? parseFloat(details?.dueAmount <= 0 ? 0.00 : details?.dueAmount)?.toFixed(2) : 0.00}</Typography>
                </Box>
              )}
              </>
            }
          </Box>
        </Grid>
        {/* {((details?.allInstallationCompleted == 1) && (!empty(invoice?.jobcost_product) || !empty(invoice?.jobcost_service?.filter(it=>it.total_cost == 0)))) ?
          <>
            <Typography id="discount" variant="h3" style={{ textAlign: 'left' }}>Additional Amount Details</Typography>
            {!empty(invoice?.jobcost_product) ? 
            <TableContainer sx={{ minWidth: 420 }}>
              <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>NAME</TableCell>
                      <TableCell>UNIT COST</TableCell>
                      <TableCell>QUANTITY</TableCell>
                      <TableCell>TOTAL COST</TableCell>
                    </TableRow>
                  </TableHead>
                <TableBody>
                  {invoice?.jobcost_product?.map((val,index) => {
                    const { id, product_name, unit_price, quantity, total, unit, unit_qty } = val
                    let unitName = UNITS?.filter((item) => item?.id == unit)
                    unitName = unitName[0]?.name
                    let shortUnitName = ''
                    if (unitName == 'Square feet') {
                      shortUnitName = 'Sq ft'
                    } else if (unitName == 'Lineal feet') {
                      shortUnitName = 'Lin ft'
                    } else if (unitName == 'Square Inches') {
                      shortUnitName = 'Sq Inches'
                    } else if (unitName == 'Unit') {
                      shortUnitName = 'Unit'
                    }
                    return (
                      <TableRow key={index} 
                        sx={{
                          borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                          '& .productName': {
                            fontWeight: 'bold',
                          },
                        }}
                      >
                        <TableCell width={'25%'} sx={{flexWrap:'wrap'}}>
                          <Typography variant="h4" className="productName">
                            {product_name}
                          </Typography>
                        </TableCell>
                        <TableCell variant="h4">{unit_price}</TableCell>
                        <TableCell variant="h4">{quantity}({shortUnitName})</TableCell>
                        <TableCell variant="h4"> {total}</TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            : ''}
            {!empty(invoice?.jobcost_service?.filter(it=>it.total_cost == 0)) ? 
            <TableContainer sx={{ minWidth: 420 }}>
              <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>NAME</TableCell>
                      <TableCell>HOURLY COST</TableCell>
                      <TableCell>HOURS</TableCell>
                      <TableCell>TOTAL COST</TableCell>
                    </TableRow>
                  </TableHead>
                <TableBody>
                  {invoice?.jobcost_service?.filter(it=>it.total_cost == 0)?.map((ser,index) => {
                    
                    return (
                      <TableRow key={index} 
                        sx={{
                          borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                          '& .productName': {
                            fontWeight: 'bold',
                          },
                        }}
                      >
                        <TableCell width={'25%'} sx={{flexWrap:'wrap'}}>
                          <Typography variant="h4" className="productName">
                            {ser?.name}
                          </Typography>
                        </TableCell>
                        <TableCell variant="h4">{ser ? parseFloat(ser?.service_original_cost)?.toFixed(2) : 0}</TableCell>
                        <TableCell variant="h4">{ser ? parseFloat(ser?.jobcost_quantity)?.toFixed(2) : 0}</TableCell>
                        <TableCell variant="h4">{ser ? ser?.total_service_cost : 0}</TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            : ''}
          <Grid id="total" item xs={12} sm={6} >
          <Box sx={{ mb: 5, display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap:'8px' }}>
            {!empty(invoice?.jobcost_product) ? 
            <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography id="discount" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0 }}>Additional Amount</Typography>
              <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>{invoice?.jobcostTotal ? invoice?.jobcostTotal?.toFixed(2) : 0.00}</Typography>
            </Box> : '' }
            {!empty(invoice?.jobcost_service?.filter(it=>it.total_cost == 0)) ? 
            <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography id="discount" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0 }}>Additional Service Amount</Typography>
              <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>{invoice?.jobcostServiceTotal ? invoice?.jobcostServiceTotal?.toFixed(2) : 0.00}</Typography>
            </Box> : '' }
            <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography id="totalmain" variant="h3" style={{ textAlign: 'left', margin: '4px', padding: 0 }}>Grand Total</Typography>
              <Typography variant="h3" style={{ textAlign: 'right', margin: '4px', padding: 0 }}>{invoice?.grandTotal ? invoice?.grandTotal?.toFixed(2) : 0.00}</Typography>
            </Box>
          </Box>
          </Grid>
          </>
        : ''} */}
      </>}
      </Grid>
    </Stack>
  )
})